/* eslint-disable  @typescript-eslint/no-unused-vars */
import { z } from 'zod';
import { enumSchema } from '../../schema';

/** The type of the keyboard accelerator element */
export enum AcceleratorItemTypeEnum {
/** unknown element */
	undefined = 0,
/** menu accelerator */
	menu = 1,
/** command accelerator */
	command = 2,
}

export const AcceleratorItemTypeSchema = enumSchema(AcceleratorItemTypeEnum) as unknown as z.ZodType<AcceleratorItemTypeEnum>;
export const AcceleratorItemTypeJsonSchema = enumSchema(AcceleratorItemTypeEnum).describe("The type of the keyboard accelerator element - Schema: { { k: undefined, v: 0, Description: unknown element}, { k: menu, v: 1, Description: menu accelerator}, { k: command, v: 2, Description: command accelerator} }") as unknown as z.ZodType<AcceleratorItemTypeEnum>;


/** access As Administrator */
export enum AccessAsAdministratorEnum {
/** The accessitem must be assigned */
	assigned = 0,
/** The accessitem is active when the user has administrator access */
	automatic = 1,
}

export const AccessAsAdministratorSchema = enumSchema(AccessAsAdministratorEnum) as unknown as z.ZodType<AccessAsAdministratorEnum>;
export const AccessAsAdministratorJsonSchema = enumSchema(AccessAsAdministratorEnum).describe("access As Administrator - Schema: { { k: assigned, v: 0, Description: The accessitem must be assigned}, { k: automatic, v: 1, Description: The accessitem is active when the user has administrator access} }") as unknown as z.ZodType<AccessAsAdministratorEnum>;


/** from userAccessDomains */
export enum AccessItemCategoryEnum {
/** The implementation of this access item i purely manual - what is does is 100 o/o code only */
	simple = 1,
/** The data access is granted pr orgunit. Mostly for table access */
	orgunit = 2,
/** Access follows the persongroups in the user access assignment, but the access is limited to granted periods only */
	registratioN = 3,
/** The data access is granted per persongroup - this is for persondata only */
	persongroup = 4,
}

export const AccessItemCategorySchema = enumSchema(AccessItemCategoryEnum) as unknown as z.ZodType<AccessItemCategoryEnum>;
export const AccessItemCategoryJsonSchema = enumSchema(AccessItemCategoryEnum).describe("from userAccessDomains - Schema: { { k: simple, v: 1, Description: The implementation of this access item i purely manual - what is does is 100 o/o code only}, { k: orgunit, v: 2, Description: The data access is granted pr orgunit. Mostly for table access}, { k: registratioN, v: 3, Description: Access follows the persongroups in the user access assignment, but the access is limited to granted periods only}, { k: persongroup, v: 4, Description: The data access is granted per persongroup - this is for persondata only} }") as unknown as z.ZodType<AccessItemCategoryEnum>;


/** Removed this accessitem was introduced for SD in WI 76811 / HD 39559, but SD did not want it / balancesUiEdit_AccessItem            133 "@BalancesUiEditAccess" ( "balancesUiEdit" "writeAccessOnly" "simple" "automatic" "[]" ) / old comment: Rediger personopgørelser direkte fra lister og kartotekskort. Skrivning er ekstra begrænset, da dataene oftests stammer fra eksterne systemer */
export enum AccessItemEnumEnum {
	none_AccessItem = -1,
/** Permits write access to secondary */
	shift_reg_AccessItem = 1,
/** Permits write access to secondary */
	activity_reg_AccessItem = 2,
/** Permits write access to secondary */
	availability_reg_AccessItem = 3,
	person_roster_reg_AccessItem = 4,
	person1_AccessItem = 5,
	person2_AccessItem = 6,
	person3_AccessItem = 7,
	shift_manpower_AccessItem = 8,
	activitygroup_AccessItem = 9,
	agreement_AccessItem = 12,
	occupation_AccessItem = 13,
	persongroup_AccessItem = 14,
	person_roster_def_AccessItem = 15,
	salarysort_AccessItem = 16,
	shift_def_AccessItem = 18,
	activity_def_AccessItem = 19,
	roster_def_AccessItem = 20,
	shifttype_AccessItem = 21,
	shiftcategory_AccessItem = 22,
	staffuser_AccessItem = 23,
	accessgroup_AccessItem = 24,
	useraccess_AccessItem = 25,
/** Indstil System */
	system_setup_AccessItem = 26,
/** Indstil Database */
	database_setting_AccessItem = 27,
	database_update_AccessItem = 28,
	database_import_AccessItem = 29,
	workrule_setup_AccessItem = 30,
/** Permits write access to secondary */
	shift_reg_suppl_AccessItem = 31,
	orgunit_AccessItem = 32,
	salarysortdutyproperty_AccessItem = 33,
	salary_extract_AccessItem = 34,
	serviceno_change_AccessItem = 35,
	user_log_AccessItem = 36,
	costs_AccessItem = 37,
	calcsupl_AccessItem = 38,
	web_AccessItem = 39,
	substitute_AccessItem = 40,
	planstat_AccessItem = 41,
	demand_import_AccessItem = 42,
	salary_approval_AccessItem = 43,
	batchserver_AccessItem = 44,
	holiday_AccessItem = 45,
	agreement_personal_AccessItem = 46,
	orgunit_property_holidayopen_AccessItem = 47,
	orgunit_salarysystem_AccessItem = 48,
	person_find_advanced_AccessItem = 49,
	edit_imported_fields_AccessItem = 50,
	persongroup_qualification_AccessItem = 51,
	activitygroup_qualification_requirement_AccessItem = 52,
	person_qualification_AccessItem = 53,
	qualification_definition_AccessItem = 54,
	activity_qualification_requirement_AccessItem = 55,
	activitygrouptype_AccessItem = 56,
	activitygroupmember_AccessItem = 57,
	persongroup_payer_AccessItem = 58,
	demand_calculation_AccessItem = 59,
	salary_endorse_AccessItem = 60,
/** Access to "Dan opgørelser" / autostatements (auto referring to the fact that the statement is derived from a total). DbDlg previously checked this accessitem for summary_statements on the norm shiftcounter. */
	autostatements_AccessItem = 61,
	keyFigureImport_AccessItem = 62,
	keyFigureExport_AccessItem = 63,
	keyFigureUI_AccessItem = 64,
	accountingOutside_AccessItem = 65,
	keyFigureReg1_AccessItem = 66,
	costPersonal_AccessItem = 67,
	keyFigureReg2_AccessItem = 68,
	keyFigureReg3_AccessItem = 69,
	keyFigureReg4_AccessItem = 70,
	keyFigureReg5_AccessItem = 71,
	recordrestriction_AccessItem = 72,
	orgunit_property_shop_AccessItem = 73,
	reg_person_status_operationstart_AccessItem = 74,
	reg_person_status_checkinstart_AccessItem = 75,
	reg_person_status_planningstart_AccessItem = 76,
	reg_person_status_requeststart_AccessItem = 77,
	persongroup_webstatus_AccessItem = 83,
	deputy_AccessItem = 84,
	deputy_serve_AccessItem = 85,
/** Activates the production module */
	production_AccessItem = 86,
	administrator_AccessItem = 87,
	administratoradministrator_AccessItem = 88,
	publishWorkspaceToRoles_AccessItem = 90,
	editHelp_AccessItem = 91,
/** Edit definition data for order and task */
	orderDef_AccessItem = 92,
/** Edit order */
	orderReg_AccessItem = 93,
	taskReg_AccessItem = 94,
	equipment_AccessItem = 95,
/** Assign to This Task */
	assignmentTask_AccessItem = 96,
/** manual - Assign Person to Any Task. Permits write access to secondary */
	assignmentPerson_AccessItem = 97,
/** manual - Assign Equipment to Any Task */
	assignmentEquipment_AccessItem = 98,
	taskDef_AccessItem = 99,
	equipment_Availability_AccessItem = 100,
	keyFigureReg_AccessItem = 101,
	keyFigureDef_AccessItem = 102,
	kPI_AccessItem = 103,
	variantDef_AccessItem = 104,
	baseTableDef_AccessItem = 105,
	baseTableReg_AccessItem = 106,
	deletePerson_AccessItem = 108,
	account_AccessItem = 109,
	project_AccessItem = 110,
	person_cpr_AccessItem = 111,
	publishViewToRoles_AccessItem = 112,
/** manual - assign external reference on shift_reg (fakturakontrol) */
	shiftRegSetExternalReference_AccessItem = 113,
	simulation_AccessItem = 114,
/** does the user have acces to save personal workspaces */
	publishWorkspacePersonal_AccessItem = 115,
/** does the user have acces to save personal listview */
	publishViewPersonal_AccessItem = 116,
	cloneOrgunitData_AccessItem = 117,
	deputy_person_AccessItem = 118,
/** Create, update or delete reservations including reservation members */
	reservation_AccessItem = 119,
/** Command for switching reservation members (team members) */
	reservationSwap_AccessItem = 120,
	changeVariant_AccessItem = 121,
	roleDef_AccessItem = 122,
/** Permits write access to secondary */
	paidAllowance_AccessItem = 123,
	chat_AccessItem = 125,
/** Run AutoAssign algorithm for assigning tasks to resources */
	autoAssign_AccessItem = 126,
/** Grants access to the command person1.sharePerson, which creates a persongroupmember on a foreign persongroup. Can be used as an alternative to alternativePlanningunit_AccessItem if the person is still intended to mainly work on the original planningunit */
	sharePerson_AccessItem = 127,
	kpiBaseline_AccessItem = 128,
	kpiBaselineFreeze_AccessItem = 129,
	publishWorkspaceToSystem_AccessItem = 130,
	publishViewToSystem_AccessItem = 131,
	orgunitVerifyPersonFieldList_AccessItem = 132,
	calcsuplSetup_AccessItem = 134,
	operationsAdministrator_AccessItem = 135,
	demand_AccessItem = 136,
	orgunitExtendedProperties_AccessItem = 137,
	resourceConstraintDef_AccessItem = 138,
/** To see changelog for a staffuser or person you must have access to the staffusers unitid or one of then person2.planningunitid. To see changelog data, you must have read access to the data. */
	viewChangeLog_AccessItem = 139,
/** to see auditLog for a staffuser or person you must have access to the staffusers unitid or one of then person2.planningunitid. to see auditLog for a staffusers data or persons data you must have access to the staffusers unitid or one of then person2.planningunitid. */
	viewAuditLog_AccessItem = 140,
/** Access to dataPrivacy marked fields - with access demand */
	dataPrivacy_AccessItem = 141,
	removeUserLocks_AccessItem = 142,
	location_AccessItem = 143,
	dataSubjectInformation_AccessItem = 144,
	auxPerson_AccessItem = 145,
	anonymizePerson_AccessItem = 146,
	erasePerson_AccessItem = 147,
	systemConfig_AccessItem = 148,
	anonymizeDatabase_AccessItem = 149,
	vacationProfile_AccessItem = 150,
/** Edit person1.isFictive */
	editIsFictive_AccessItem = 151,
	dimensionItem_tax_AccessItem = 152,
	staffuserExtended_AccessItem = 153,
/** access for the functionPlan app */
	functionPlanPlanning_AccessItem = 154,
/** Explicit access to payer orgunits */
	shift_reg_payer_AccessItem = 155,
/** Access to datawarehouse export */
	datawarehouse_AccessItem = 156,
/** Preference definitions. Enabling it in the installation also shows the preference_reg list */
	preferenceDef_AccessItem = 157,
/** Access to the TeamPlan web application */
	teamPlan_AccessItem = 158,
/** Preference registrations. Planners editing of emp preference_reg */
	preferenceReg_AccessItem = 159,
/** Access to edit timeAttendance Reasons */
	timeAttendanceReason_AccessItem = 160,
/** Edit Global Cost Parameters */
	socialCostAdministrator_AccessItem = 161,
/** User access in the dashboard app */
	accessInDashboard_AccessItem = 162,
/** Preference Pattern definitions. */
	preferencePatternDef_AccessItem = 163,
/** Access to the criticalChange and criticalChangeRule */
	criticalRegChange_AccessItem = 164,
/** Read/write access to production rules */
	productionRule_AccessItem = 165,
/** Read/write access to TeamView(VoresPlan) */
	teamView_AccessItem = 166,
/** Access to the staffplan program */
	staffPlan_AccessItem = 167,
/** ms365 Calendar installation active */
	ms365Calendar_AccessItem = 168,
/** Access to the ClockPoint terminal application */
	clockPoint_AccessItem = 169,
/** Access to table prd_resource_rule by orgunit */
	resourceRule_AccessItem = 170,
/** Controls write access to alternativePlanningunit (the long term lending facility) */
	alternativePlanningunit_AccessItem = 171,
/** Is the user allowed to impersonate other employees, if staffuserSupporter_AccessItem isn't active then it provides access to all staffusers */
	empuserSupporter_AccessItem = 172,
/** Is the user allowed to impersonate other staffusers */
	staffuserSupporter_AccessItem = 173,
/** Is user allowed to handle kpi_UserData_Def */
	kpiUserDataDef_AccessItem = 174,
/** Is user allowed to handle kpi_UserData_Reg */
	kpiUserDataReg_AccessItem = 175,
/** Access item for the AI Agent Widget */
	aiAgent_AccessItem = 176,
	gdprConfig_AccessItem = 177,
/** lad databasen kører database statistik på tabellerne */
	updDbTableStat_AccessItem = 178,
}

export const AccessItemEnumSchema = enumSchema(AccessItemEnumEnum) as unknown as z.ZodType<AccessItemEnumEnum>;
export const AccessItemEnumJsonSchema = enumSchema(AccessItemEnumEnum).describe("Removed this accessitem was introduced for SD in WI 76811 / HD 39559, but SD did not want it / balancesUiEdit_AccessItem            133 \"@BalancesUiEditAccess\" ( \"balancesUiEdit\" \"writeAccessOnly\" \"simple\" \"automatic\" \"[]\" ) / old comment: Rediger personopgørelser direkte fra lister og kartotekskort. Skrivning er ekstra begrænset, da dataene oftests stammer fra eksterne systemer - Schema: { { k: none_AccessItem, v: -1, Description: <empty>}, { k: shift_reg_AccessItem, v: 1, Description: Permits write access to secondary}, { k: activity_reg_AccessItem, v: 2, Description: Permits write access to secondary}, { k: availability_reg_AccessItem, v: 3, Description: Permits write access to secondary}, { k: person_roster_reg_AccessItem, v: 4, Description: <empty>}, { k: person1_AccessItem, v: 5, Description: <empty>}, { k: person2_AccessItem, v: 6, Description: <empty>}, { k: person3_AccessItem, v: 7, Description: <empty>}, { k: shift_manpower_AccessItem, v: 8, Description: <empty>}, { k: activitygroup_AccessItem, v: 9, Description: <empty>}, { k: agreement_AccessItem, v: 12, Description: <empty>}, { k: occupation_AccessItem, v: 13, Description: <empty>}, { k: persongroup_AccessItem, v: 14, Description: <empty>}, { k: person_roster_def_AccessItem, v: 15, Description: <empty>}, { k: salarysort_AccessItem, v: 16, Description: <empty>}, { k: shift_def_AccessItem, v: 18, Description: <empty>}, { k: activity_def_AccessItem, v: 19, Description: <empty>}, { k: roster_def_AccessItem, v: 20, Description: <empty>}, { k: shifttype_AccessItem, v: 21, Description: <empty>}, { k: shiftcategory_AccessItem, v: 22, Description: <empty>}, { k: staffuser_AccessItem, v: 23, Description: <empty>}, { k: accessgroup_AccessItem, v: 24, Description: <empty>}, { k: useraccess_AccessItem, v: 25, Description: <empty>}, { k: system_setup_AccessItem, v: 26, Description: Indstil System}, { k: database_setting_AccessItem, v: 27, Description: Indstil Database}, { k: database_update_AccessItem, v: 28, Description: <empty>}, { k: database_import_AccessItem, v: 29, Description: <empty>}, { k: workrule_setup_AccessItem, v: 30, Description: <empty>}, { k: shift_reg_suppl_AccessItem, v: 31, Description: Permits write access to secondary}, { k: orgunit_AccessItem, v: 32, Description: <empty>}, { k: salarysortdutyproperty_AccessItem, v: 33, Description: <empty>}, { k: salary_extract_AccessItem, v: 34, Description: <empty>}, { k: serviceno_change_AccessItem, v: 35, Description: <empty>}, { k: user_log_AccessItem, v: 36, Description: <empty>}, { k: costs_AccessItem, v: 37, Description: <empty>}, { k: calcsupl_AccessItem, v: 38, Description: <empty>}, { k: web_AccessItem, v: 39, Description: <empty>}, { k: substitute_AccessItem, v: 40, Description: <empty>}, { k: planstat_AccessItem, v: 41, Description: <empty>}, { k: demand_import_AccessItem, v: 42, Description: <empty>}, { k: salary_approval_AccessItem, v: 43, Description: <empty>}, { k: batchserver_AccessItem, v: 44, Description: <empty>}, { k: holiday_AccessItem, v: 45, Description: <empty>}, { k: agreement_personal_AccessItem, v: 46, Description: <empty>}, { k: orgunit_property_holidayopen_AccessItem, v: 47, Description: <empty>}, { k: orgunit_salarysystem_AccessItem, v: 48, Description: <empty>}, { k: person_find_advanced_AccessItem, v: 49, Description: <empty>}, { k: edit_imported_fields_AccessItem, v: 50, Description: <empty>}, { k: persongroup_qualification_AccessItem, v: 51, Description: <empty>}, { k: activitygroup_qualification_requirement_AccessItem, v: 52, Description: <empty>}, { k: person_qualification_AccessItem, v: 53, Description: <empty>}, { k: qualification_definition_AccessItem, v: 54, Description: <empty>}, { k: activity_qualification_requirement_AccessItem, v: 55, Description: <empty>}, { k: activitygrouptype_AccessItem, v: 56, Description: <empty>}, { k: activitygroupmember_AccessItem, v: 57, Description: <empty>}, { k: persongroup_payer_AccessItem, v: 58, Description: <empty>}, { k: demand_calculation_AccessItem, v: 59, Description: <empty>}, { k: salary_endorse_AccessItem, v: 60, Description: <empty>}, { k: autostatements_AccessItem, v: 61, Description: Access to \"Dan opgørelser\" / autostatements (auto referring to the fact that the statement is derived from a total). DbDlg previously checked this accessitem for summary_statements on the norm shiftcounter.}, { k: keyFigureImport_AccessItem, v: 62, Description: <empty>}, { k: keyFigureExport_AccessItem, v: 63, Description: <empty>}, { k: keyFigureUI_AccessItem, v: 64, Description: <empty>}, { k: accountingOutside_AccessItem, v: 65, Description: <empty>}, { k: keyFigureReg1_AccessItem, v: 66, Description: <empty>}, { k: costPersonal_AccessItem, v: 67, Description: <empty>}, { k: keyFigureReg2_AccessItem, v: 68, Description: <empty>}, { k: keyFigureReg3_AccessItem, v: 69, Description: <empty>}, { k: keyFigureReg4_AccessItem, v: 70, Description: <empty>}, { k: keyFigureReg5_AccessItem, v: 71, Description: <empty>}, { k: recordrestriction_AccessItem, v: 72, Description: <empty>}, { k: orgunit_property_shop_AccessItem, v: 73, Description: <empty>}, { k: reg_person_status_operationstart_AccessItem, v: 74, Description: <empty>}, { k: reg_person_status_checkinstart_AccessItem, v: 75, Description: <empty>}, { k: reg_person_status_planningstart_AccessItem, v: 76, Description: <empty>}, { k: reg_person_status_requeststart_AccessItem, v: 77, Description: <empty>}, { k: persongroup_webstatus_AccessItem, v: 83, Description: <empty>}, { k: deputy_AccessItem, v: 84, Description: <empty>}, { k: deputy_serve_AccessItem, v: 85, Description: <empty>}, { k: production_AccessItem, v: 86, Description: Activates the production module}, { k: administrator_AccessItem, v: 87, Description: <empty>}, { k: administratoradministrator_AccessItem, v: 88, Description: <empty>}, { k: publishWorkspaceToRoles_AccessItem, v: 90, Description: <empty>}, { k: editHelp_AccessItem, v: 91, Description: <empty>}, { k: orderDef_AccessItem, v: 92, Description: Edit definition data for order and task}, { k: orderReg_AccessItem, v: 93, Description: Edit order}, { k: taskReg_AccessItem, v: 94, Description: <empty>}, { k: equipment_AccessItem, v: 95, Description: <empty>}, { k: assignmentTask_AccessItem, v: 96, Description: Assign to This Task}, { k: assignmentPerson_AccessItem, v: 97, Description: manual - Assign Person to Any Task. Permits write access to secondary}, { k: assignmentEquipment_AccessItem, v: 98, Description: manual - Assign Equipment to Any Task}, { k: taskDef_AccessItem, v: 99, Description: <empty>}, { k: equipment_Availability_AccessItem, v: 100, Description: <empty>}, { k: keyFigureReg_AccessItem, v: 101, Description: <empty>}, { k: keyFigureDef_AccessItem, v: 102, Description: <empty>}, { k: kPI_AccessItem, v: 103, Description: <empty>}, { k: variantDef_AccessItem, v: 104, Description: <empty>}, { k: baseTableDef_AccessItem, v: 105, Description: <empty>}, { k: baseTableReg_AccessItem, v: 106, Description: <empty>}, { k: deletePerson_AccessItem, v: 108, Description: <empty>}, { k: account_AccessItem, v: 109, Description: <empty>}, { k: project_AccessItem, v: 110, Description: <empty>}, { k: person_cpr_AccessItem, v: 111, Description: <empty>}, { k: publishViewToRoles_AccessItem, v: 112, Description: <empty>}, { k: shiftRegSetExternalReference_AccessItem, v: 113, Description: manual - assign external reference on shift_reg (fakturakontrol)}, { k: simulation_AccessItem, v: 114, Description: <empty>}, { k: publishWorkspacePersonal_AccessItem, v: 115, Description: does the user have acces to save personal workspaces}, { k: publishViewPersonal_AccessItem, v: 116, Description: does the user have acces to save personal listview}, { k: cloneOrgunitData_AccessItem, v: 117, Description: <empty>}, { k: deputy_person_AccessItem, v: 118, Description: <empty>}, { k: reservation_AccessItem, v: 119, Description: Create, update or delete reservations including reservation members}, { k: reservationSwap_AccessItem, v: 120, Description: Command for switching reservation members (team members)}, { k: changeVariant_AccessItem, v: 121, Description: <empty>}, { k: roleDef_AccessItem, v: 122, Description: <empty>}, { k: paidAllowance_AccessItem, v: 123, Description: Permits write access to secondary}, { k: chat_AccessItem, v: 125, Description: <empty>}, { k: autoAssign_AccessItem, v: 126, Description: Run AutoAssign algorithm for assigning tasks to resources}, { k: sharePerson_AccessItem, v: 127, Description: Grants access to the command person1.sharePerson, which creates a persongroupmember on a foreign persongroup. Can be used as an alternative to alternativePlanningunit_AccessItem if the person is still intended to mainly work on the original planningunit}, { k: kpiBaseline_AccessItem, v: 128, Description: <empty>}, { k: kpiBaselineFreeze_AccessItem, v: 129, Description: <empty>}, { k: publishWorkspaceToSystem_AccessItem, v: 130, Description: <empty>}, { k: publishViewToSystem_AccessItem, v: 131, Description: <empty>}, { k: orgunitVerifyPersonFieldList_AccessItem, v: 132, Description: <empty>}, { k: calcsuplSetup_AccessItem, v: 134, Description: <empty>}, { k: operationsAdministrator_AccessItem, v: 135, Description: <empty>}, { k: demand_AccessItem, v: 136, Description: <empty>}, { k: orgunitExtendedProperties_AccessItem, v: 137, Description: <empty>}, { k: resourceConstraintDef_AccessItem, v: 138, Description: <empty>}, { k: viewChangeLog_AccessItem, v: 139, Description: To see changelog for a staffuser or person you must have access to the staffusers unitid or one of then person2.planningunitid. To see changelog data, you must have read access to the data.}, { k: viewAuditLog_AccessItem, v: 140, Description: to see auditLog for a staffuser or person you must have access to the staffusers unitid or one of then person2.planningunitid. to see auditLog for a staffusers data or persons data you must have access to the staffusers unitid or one of then person2.planningunitid.}, { k: dataPrivacy_AccessItem, v: 141, Description: Access to dataPrivacy marked fields - with access demand}, { k: removeUserLocks_AccessItem, v: 142, Description: <empty>}, { k: location_AccessItem, v: 143, Description: <empty>}, { k: dataSubjectInformation_AccessItem, v: 144, Description: <empty>}, { k: auxPerson_AccessItem, v: 145, Description: <empty>}, { k: anonymizePerson_AccessItem, v: 146, Description: <empty>}, { k: erasePerson_AccessItem, v: 147, Description: <empty>}, { k: systemConfig_AccessItem, v: 148, Description: <empty>}, { k: anonymizeDatabase_AccessItem, v: 149, Description: <empty>}, { k: vacationProfile_AccessItem, v: 150, Description: <empty>}, { k: editIsFictive_AccessItem, v: 151, Description: Edit person1.isFictive}, { k: dimensionItem_tax_AccessItem, v: 152, Description: <empty>}, { k: staffuserExtended_AccessItem, v: 153, Description: <empty>}, { k: functionPlanPlanning_AccessItem, v: 154, Description: access for the functionPlan app}, { k: shift_reg_payer_AccessItem, v: 155, Description: Explicit access to payer orgunits}, { k: datawarehouse_AccessItem, v: 156, Description: Access to datawarehouse export}, { k: preferenceDef_AccessItem, v: 157, Description: Preference definitions. Enabling it in the installation also shows the preference_reg list}, { k: teamPlan_AccessItem, v: 158, Description: Access to the TeamPlan web application}, { k: preferenceReg_AccessItem, v: 159, Description: Preference registrations. Planners editing of emp preference_reg}, { k: timeAttendanceReason_AccessItem, v: 160, Description: Access to edit timeAttendance Reasons}, { k: socialCostAdministrator_AccessItem, v: 161, Description: Edit Global Cost Parameters}, { k: accessInDashboard_AccessItem, v: 162, Description: User access in the dashboard app}, { k: preferencePatternDef_AccessItem, v: 163, Description: Preference Pattern definitions.}, { k: criticalRegChange_AccessItem, v: 164, Description: Access to the criticalChange and criticalChangeRule}, { k: productionRule_AccessItem, v: 165, Description: Read/write access to production rules}, { k: teamView_AccessItem, v: 166, Description: Read/write access to TeamView(VoresPlan)}, { k: staffPlan_AccessItem, v: 167, Description: Access to the staffplan program}, { k: ms365Calendar_AccessItem, v: 168, Description: ms365 Calendar installation active}, { k: clockPoint_AccessItem, v: 169, Description: Access to the ClockPoint terminal application}, { k: resourceRule_AccessItem, v: 170, Description: Access to table prd_resource_rule by orgunit}, { k: alternativePlanningunit_AccessItem, v: 171, Description: Controls write access to alternativePlanningunit (the long term lending facility)}, { k: empuserSupporter_AccessItem, v: 172, Description: Is the user allowed to impersonate other employees, if staffuserSupporter_AccessItem isn't active then it provides access to all staffusers}, { k: staffuserSupporter_AccessItem, v: 173, Description: Is the user allowed to impersonate other staffusers}, { k: kpiUserDataDef_AccessItem, v: 174, Description: Is user allowed to handle kpi_UserData_Def}, { k: kpiUserDataReg_AccessItem, v: 175, Description: Is user allowed to handle kpi_UserData_Reg}, { k: aiAgent_AccessItem, v: 176, Description: Access item for the AI Agent Widget}, { k: gdprConfig_AccessItem, v: 177, Description: <empty>}, { k: updDbTableStat_AccessItem, v: 178, Description: lad databasen kører database statistik på tabellerne} }") as unknown as z.ZodType<AccessItemEnumEnum>;


/** from userAccessDomains */
export enum AccessItemTypeEnum {
/** The accessright can be No/Read - this is mainly used for access to functions */
	readonly = 2,
/** The accessright can be No/Write -  This is only used for function which changes data */
	writeAccessOnly = 3,
/** The accessright can be Read/Write */
	alwaysReadable = 4,
}

export const AccessItemTypeSchema = enumSchema(AccessItemTypeEnum) as unknown as z.ZodType<AccessItemTypeEnum>;
export const AccessItemTypeJsonSchema = enumSchema(AccessItemTypeEnum).describe("from userAccessDomains - Schema: { { k: readonly, v: 2, Description: The accessright can be No/Read - this is mainly used for access to functions}, { k: writeAccessOnly, v: 3, Description: The accessright can be No/Write -  This is only used for function which changes data}, { k: alwaysReadable, v: 4, Description: The accessright can be Read/Write} }") as unknown as z.ZodType<AccessItemTypeEnum>;


/** accessRight from userAccessDomains - coded in the staffinst table key=config row */
export enum AccessRightEnum {
/** accessright_nil  coded as "0". Even less access than "no". In staffinst "invisible" means no access for all regular users, access to all pdcusers, but hide the associated commands and menus from pdcusers (cmdaccess fails, useraccs succeeds) */
	invisible = 48,
/** accessright_no  coded as "1". No access.  In staffinst "no" means no access for all regular users, but access to all pdcusers, including to commands and menus */
	no = 49,
/** accessright_read  coded as "2" */
	read = 50,
/** accessright_write  coded as "3" */
	write = 51,
}

export const AccessRightSchema = enumSchema(AccessRightEnum) as unknown as z.ZodType<AccessRightEnum>;
export const AccessRightJsonSchema = enumSchema(AccessRightEnum).describe("accessRight from userAccessDomains - coded in the staffinst table key=config row - Schema: { { k: invisible, v: 48, Description: accessright_nil  coded as \"0\". Even less access than \"no\". In staffinst \"invisible\" means no access for all regular users, access to all pdcusers, but hide the associated commands and menus from pdcusers (cmdaccess fails, useraccs succeeds)}, { k: no, v: 49, Description: accessright_no  coded as \"1\". No access.  In staffinst \"no\" means no access for all regular users, but access to all pdcusers, including to commands and menus}, { k: read, v: 50, Description: accessright_read  coded as \"2\"}, { k: write, v: 51, Description: accessright_write  coded as \"3\"} }") as unknown as z.ZodType<AccessRightEnum>;


/** Subtypes of allowanceDuty */
export enum AllowanceDutySubTypeEnum {
/** _ NUMBER SALARYSORT _ [PAYER] (prefixUnsigned) or _ _ SALARYSORT _ [PAYER] _ _ NUMBER (prefixUnsigned) */
	integerDuty = 1,
/** NUMBER _ SALARYSORT _ [PAYER] (prefixNumber) */
	durationDuty = 2,
}

export const AllowanceDutySubTypeSchema = enumSchema(AllowanceDutySubTypeEnum) as unknown as z.ZodType<AllowanceDutySubTypeEnum>;
export const AllowanceDutySubTypeJsonSchema = enumSchema(AllowanceDutySubTypeEnum).describe("Subtypes of allowanceDuty - Schema: { { k: integerDuty, v: 1, Description: _ NUMBER SALARYSORT _ [PAYER] (prefixUnsigned) or _ _ SALARYSORT _ [PAYER] _ _ NUMBER (prefixUnsigned)}, { k: durationDuty, v: 2, Description: NUMBER _ SALARYSORT _ [PAYER] (prefixNumber)} }") as unknown as z.ZodType<AllowanceDutySubTypeEnum>;


/** Is deputy position substitution allowed on (web published) exchange? */
export enum AllowOnExchangeEnum {
	never = 0,
	always = 1,
}

export const AllowOnExchangeSchema = enumSchema(AllowOnExchangeEnum) as unknown as z.ZodType<AllowOnExchangeEnum>;
export const AllowOnExchangeJsonSchema = enumSchema(AllowOnExchangeEnum).describe("Is deputy position substitution allowed on (web published) exchange? - Schema: { { k: never, v: 0, Description: <empty>}, { k: always, v: 1, Description: <empty>} }") as unknown as z.ZodType<AllowOnExchangeEnum>;


/** database state */
export enum AnonymizeEnum {
/** the database is not anonymized */
	notAnonymized = 0,
/** the database is anonymized by sql script */
	anonymizedByScript = 3,
/** person1.salaryid, initials and name are not anonymized - anonymized values in aux1-3 */
	anonymizedPartly3 = 6,
/** person1.salaryid and initials are not anonymized - anonymized values in aux1-2 */
	anonymizedPartly2 = 9,
/** every field is anonymized */
	anonymizedFully = 12,
}

export const AnonymizeSchema = enumSchema(AnonymizeEnum) as unknown as z.ZodType<AnonymizeEnum>;
export const AnonymizeJsonSchema = enumSchema(AnonymizeEnum).describe("database state - Schema: { { k: notAnonymized, v: 0, Description: the database is not anonymized}, { k: anonymizedByScript, v: 3, Description: the database is anonymized by sql script}, { k: anonymizedPartly3, v: 6, Description: person1.salaryid, initials and name are not anonymized - anonymized values in aux1-3}, { k: anonymizedPartly2, v: 9, Description: person1.salaryid and initials are not anonymized - anonymized values in aux1-2}, { k: anonymizedFully, v: 12, Description: every field is anonymized} }") as unknown as z.ZodType<AnonymizeEnum>;


/** how was what anonymized */
export enum AnonymizeStatusEnum {
/** Special Logic */
	anonymizedBySpecialLogic = 0,
/** Anonymized by read/write */
	anonymizedByReadWrite = 1,
/** Anonymized by update */
	anonymizedByUpdateSql = 2,
/** Truncated */
	anonymizedByTruncation = 3,
/** not anonymized */
	notAnonymized = 4,
}

export const AnonymizeStatusSchema = enumSchema(AnonymizeStatusEnum) as unknown as z.ZodType<AnonymizeStatusEnum>;
export const AnonymizeStatusJsonSchema = enumSchema(AnonymizeStatusEnum).describe("how was what anonymized - Schema: { { k: anonymizedBySpecialLogic, v: 0, Description: Special Logic}, { k: anonymizedByReadWrite, v: 1, Description: Anonymized by read/write}, { k: anonymizedByUpdateSql, v: 2, Description: Anonymized by update}, { k: anonymizedByTruncation, v: 3, Description: Truncated}, { k: notAnonymized, v: 4, Description: not anonymized} }") as unknown as z.ZodType<AnonymizeStatusEnum>;


/** any kind of applications in the staff system. Both enduser recognisable and internal system. Same program can be different application. Name must not start with PDC. */
export enum ApplicationEnum {
/** staff windows application */
	staff = 0,
/** staff windows application - in appserver mode */
	appServer = 1,
/** staff windows application - in batchserver mode */
	batchServer = 2,
/** Staff webservice */
	httpServer = 7,
/** staff windows application - in systembridge mode */
	systembridge = 8,
/** OBSOLETE HON Jan 2018: the staffweb dot net application */
	staffWeb = 10,
/** the dot net based AvailabilityService */
	availabilityService = 20,
/** Webservice for e.g. creating new staff users */
	transactionService = 21,
/** Proxy to MyPlan webservice */
	myPlanProxy = 29,
/** MyPlan webservice */
	myPlanService = 30,
/** MyPlan employee-facing application */
	myPlan = 31,
/** OBSOLETE HON Jan 2018: iPhoneApp */
	iphoneApp = 32,
/** Monitor watching the batchloader jobs */
	batchMonitor = 40,
/** Administrating schema and applications */
	administrator = 41,
/** Service for updating webuserschema */
	staffAdmService = 42,
/** Configuration of SD loaders */
	sdLoaderManager = 43,
/** Console program to manage applicationSetting(s) */
	settingsManager = 44,
/** generic loader - jobLoader and personLoader adn clockingLoader */
	loader = 50,
/** loader for SD primary loading persons */
	sdLoader = 51,
/** JobLoader */
	jobLoader = 52,
/** ClockingLoader - loading clockings */
	clockingLoader = 53,
/** Messagingservice */
	messagingService = 60,
/** Messagingservice inbound */
	messagingServiceIn = 61,
/** Messagingservice outbound */
	messagingServiceOut = 62,
/** Service for sending messages */
	messageSender = 63,
/** script written in sql */
	sqlScript = 70,
/** special upgrade DB program */
	upgradeDB = 71,
/** Service for updating Exchange Server */
	staffEWS = 80,
/** Testprogram for testing appserver queues */
	queueTester = 90,
/** Utility for extracting Staff Web Service performance test data */
	perfTestExtract = 91,
/** Windows service sending tracing log info to external webservice */
	tracingService = 100,
/** Webservice and -application for function planning */
	functionPlan = 110,
/** Webservice for Ella */
	ellaService = 120,
/** Perform certain operations on MSMQ queues */
	vipExecute = 130,
/** Manage and view log for MSMQ appservers */
	vipMonitor = 131,
/** Get when the persons are available for work  (see also availabilityService 20) */
	vipAvailabilty = 140,
/** Booking ? */
	vipBooking = 141,
/** Registration of checkin */
	vipCheckin = 142,
/** Get organisational structure (see also availabilityService 20) */
	vipOrgunit = 143,
/** Get person information (see also availabilityService 20) */
	vipPerson = 144,
/** Get person qualifications */
	vipQualification = 145,
/** Salary ? */
	vipSalary = 146,
/** ? */
	vipStaff = 147,
/** Work planning for groups */
	eWorkPlan = 150,
/** Common Authentication Service */
	authenticationService = 151,
/** Shell App Dispatch Service */
	dispatchService = 152,
/** Manager app webservice */
	teamPlan = 201,
/** ClockPoint terminal app */
	clockPoint = 210,
/** MyPlan app */
	pdcShell = 250,
/** External integration webservice */
	external = 300,
/** TeamView web application */
	teamView = 301,
/** Airline CrewConnex app */
	crewConnex = 2000,
}

export const ApplicationSchema = enumSchema(ApplicationEnum) as unknown as z.ZodType<ApplicationEnum>;
export const ApplicationJsonSchema = enumSchema(ApplicationEnum).describe("any kind of applications in the staff system. Both enduser recognisable and internal system. Same program can be different application. Name must not start with PDC. - Schema: { { k: staff, v: 0, Description: staff windows application}, { k: appServer, v: 1, Description: staff windows application - in appserver mode}, { k: batchServer, v: 2, Description: staff windows application - in batchserver mode}, { k: httpServer, v: 7, Description: Staff webservice}, { k: systembridge, v: 8, Description: staff windows application - in systembridge mode}, { k: staffWeb, v: 10, Description: OBSOLETE HON Jan 2018: the staffweb dot net application}, { k: availabilityService, v: 20, Description: the dot net based AvailabilityService}, { k: transactionService, v: 21, Description: Webservice for e.g. creating new staff users}, { k: myPlanProxy, v: 29, Description: Proxy to MyPlan webservice}, { k: myPlanService, v: 30, Description: MyPlan webservice}, { k: myPlan, v: 31, Description: MyPlan employee-facing application}, { k: iphoneApp, v: 32, Description: OBSOLETE HON Jan 2018: iPhoneApp}, { k: batchMonitor, v: 40, Description: Monitor watching the batchloader jobs}, { k: administrator, v: 41, Description: Administrating schema and applications}, { k: staffAdmService, v: 42, Description: Service for updating webuserschema}, { k: sdLoaderManager, v: 43, Description: Configuration of SD loaders}, { k: settingsManager, v: 44, Description: Console program to manage applicationSetting(s)}, { k: loader, v: 50, Description: generic loader - jobLoader and personLoader adn clockingLoader}, { k: sdLoader, v: 51, Description: loader for SD primary loading persons}, { k: jobLoader, v: 52, Description: JobLoader}, { k: clockingLoader, v: 53, Description: ClockingLoader - loading clockings}, { k: messagingService, v: 60, Description: Messagingservice}, { k: messagingServiceIn, v: 61, Description: Messagingservice inbound}, { k: messagingServiceOut, v: 62, Description: Messagingservice outbound}, { k: messageSender, v: 63, Description: Service for sending messages}, { k: sqlScript, v: 70, Description: script written in sql}, { k: upgradeDB, v: 71, Description: special upgrade DB program}, { k: staffEWS, v: 80, Description: Service for updating Exchange Server}, { k: queueTester, v: 90, Description: Testprogram for testing appserver queues}, { k: perfTestExtract, v: 91, Description: Utility for extracting Staff Web Service performance test data}, { k: tracingService, v: 100, Description: Windows service sending tracing log info to external webservice}, { k: functionPlan, v: 110, Description: Webservice and -application for function planning}, { k: ellaService, v: 120, Description: Webservice for Ella}, { k: vipExecute, v: 130, Description: Perform certain operations on MSMQ queues}, { k: vipMonitor, v: 131, Description: Manage and view log for MSMQ appservers}, { k: vipAvailabilty, v: 140, Description: Get when the persons are available for work  (see also availabilityService 20)}, { k: vipBooking, v: 141, Description: Booking ?}, { k: vipCheckin, v: 142, Description: Registration of checkin}, { k: vipOrgunit, v: 143, Description: Get organisational structure (see also availabilityService 20)}, { k: vipPerson, v: 144, Description: Get person information (see also availabilityService 20)}, { k: vipQualification, v: 145, Description: Get person qualifications}, { k: vipSalary, v: 146, Description: Salary ?}, { k: vipStaff, v: 147, Description: ?}, { k: eWorkPlan, v: 150, Description: Work planning for groups}, { k: authenticationService, v: 151, Description: Common Authentication Service}, { k: dispatchService, v: 152, Description: Shell App Dispatch Service}, { k: teamPlan, v: 201, Description: Manager app webservice}, { k: clockPoint, v: 210, Description: ClockPoint terminal app}, { k: pdcShell, v: 250, Description: MyPlan app}, { k: external, v: 300, Description: External integration webservice}, { k: teamView, v: 301, Description: TeamView web application}, { k: crewConnex, v: 2000, Description: Airline CrewConnex app} }") as unknown as z.ZodType<ApplicationEnum>;


/** Type of application, e.g. app or browser */
export enum ApplicationTypeEnum {
	app = 1,
	browser = 2,
}

export const ApplicationTypeSchema = enumSchema(ApplicationTypeEnum) as unknown as z.ZodType<ApplicationTypeEnum>;
export const ApplicationTypeJsonSchema = enumSchema(ApplicationTypeEnum).describe("Type of application, e.g. app or browser - Schema: { { k: app, v: 1, Description: <empty>}, { k: browser, v: 2, Description: <empty>} }") as unknown as z.ZodType<ApplicationTypeEnum>;


/** Type of approval */
export enum ApprovalTypeEnum {
/** Used for approvals from before the types were introduced. */
	oldApproval = -1,
	salary = 1,
	absence = 2,
}

export const ApprovalTypeSchema = enumSchema(ApprovalTypeEnum) as unknown as z.ZodType<ApprovalTypeEnum>;
export const ApprovalTypeJsonSchema = enumSchema(ApprovalTypeEnum).describe("Type of approval - Schema: { { k: oldApproval, v: -1, Description: Used for approvals from before the types were introduced.}, { k: salary, v: 1, Description: <empty>}, { k: absence, v: 2, Description: <empty>} }") as unknown as z.ZodType<ApprovalTypeEnum>;


/** status for a request */
export enum AppServiceRequestStatusEnum {
/** (nontaken) */
	waiting = 1,
	success = 2,
	failed = 3,
}

export const AppServiceRequestStatusSchema = enumSchema(AppServiceRequestStatusEnum) as unknown as z.ZodType<AppServiceRequestStatusEnum>;
export const AppServiceRequestStatusJsonSchema = enumSchema(AppServiceRequestStatusEnum).describe("status for a request - Schema: { { k: waiting, v: 1, Description: (nontaken)}, { k: success, v: 2, Description: <empty>}, { k: failed, v: 3, Description: <empty>} }") as unknown as z.ZodType<AppServiceRequestStatusEnum>;


/** Category of the applicationSetting */
export enum AppSettingCategoryEnum {
/** MyPlan employees request, checkin, and self planning */
	functionality = 1,
/** MyPlan settings which are just sent to frontend and the backend does not use for anything. */
	webClient = 2,
/** MyPlan plan display */
	plans = 3,
/** The timings */
	timings = 4,
/** MyPlan orgunit, groups etc. */
	organisation = 5,
/** MyPlan Totals */
	totals = 6,
/** MyPlan shift exchange (employee swaps and planner offers) */
	exchange = 7,
/** MyPlan support and systems administration */
	support = 8,
/** MyPlan registration sorts */
	sorts = 9,
/** MyPlan colleagues */
	colleagues = 10,
/** Validating the user identity using OpenID Connect */
	authentication_openID = 11,
/** Validating the user identity */
	authentication = 12,
/** What does the user have access to? */
	authorization = 13,
/** MyPlan controlling task behaviour */
	tasks = 14,
}

export const AppSettingCategorySchema = enumSchema(AppSettingCategoryEnum) as unknown as z.ZodType<AppSettingCategoryEnum>;
export const AppSettingCategoryJsonSchema = enumSchema(AppSettingCategoryEnum).describe("Category of the applicationSetting - Schema: { { k: functionality, v: 1, Description: MyPlan employees request, checkin, and self planning}, { k: webClient, v: 2, Description: MyPlan settings which are just sent to frontend and the backend does not use for anything.}, { k: plans, v: 3, Description: MyPlan plan display}, { k: timings, v: 4, Description: The timings}, { k: organisation, v: 5, Description: MyPlan orgunit, groups etc.}, { k: totals, v: 6, Description: MyPlan Totals}, { k: exchange, v: 7, Description: MyPlan shift exchange (employee swaps and planner offers)}, { k: support, v: 8, Description: MyPlan support and systems administration}, { k: sorts, v: 9, Description: MyPlan registration sorts}, { k: colleagues, v: 10, Description: MyPlan colleagues}, { k: authentication_openID, v: 11, Description: Validating the user identity using OpenID Connect}, { k: authentication, v: 12, Description: Validating the user identity}, { k: authorization, v: 13, Description: What does the user have access to?}, { k: tasks, v: 14, Description: MyPlan controlling task behaviour} }") as unknown as z.ZodType<AppSettingCategoryEnum>;


/** Defines type of attendance event */
export enum AttendanceClockInOutEnum {
/** Attendance start */
	clockIn = 0,
/** Attendance end */
	clockOut = 1,
/** Full registration of attendance with both start and end */
	clockInOut = 2,
}

export const AttendanceClockInOutSchema = enumSchema(AttendanceClockInOutEnum) as unknown as z.ZodType<AttendanceClockInOutEnum>;
export const AttendanceClockInOutJsonSchema = enumSchema(AttendanceClockInOutEnum).describe("Defines type of attendance event - Schema: { { k: clockIn, v: 0, Description: Attendance start}, { k: clockOut, v: 1, Description: Attendance end}, { k: clockInOut, v: 2, Description: Full registration of attendance with both start and end} }") as unknown as z.ZodType<AttendanceClockInOutEnum>;


/** Status of an attendance person day */
export enum AttendanceStatusEnum {
/** Planned shift, but analysis time doesn't require checkin yet. Blue */
	planned = 1,
/** Planned shift and person has checked in. Green */
	onTime = 2,
/** Person has checked in but no shift is planned.  Green */
	extra = 3,
/** Planned shift and person has checked earlier than planned. Light Green */
	tooEarly = 4,
/** Planned shift and person has checked later than planned. Dark Green */
	tooLate = 5,
/** Planned shift,  analysis time doesn't require checkin yet, but very soon. Yellow */
	critical = 6,
/** Planned shift, but person hasn't checked in. Red */
	notAttending = 7,
/** Planned shift, but person isn't available due to illness, leave, ... No work checkin registered. Grey */
	unavailable = 8,
}

export const AttendanceStatusSchema = enumSchema(AttendanceStatusEnum) as unknown as z.ZodType<AttendanceStatusEnum>;
export const AttendanceStatusJsonSchema = enumSchema(AttendanceStatusEnum).describe("Status of an attendance person day - Schema: { { k: planned, v: 1, Description: Planned shift, but analysis time doesn't require checkin yet. Blue}, { k: onTime, v: 2, Description: Planned shift and person has checked in. Green}, { k: extra, v: 3, Description: Person has checked in but no shift is planned.  Green}, { k: tooEarly, v: 4, Description: Planned shift and person has checked earlier than planned. Light Green}, { k: tooLate, v: 5, Description: Planned shift and person has checked later than planned. Dark Green}, { k: critical, v: 6, Description: Planned shift,  analysis time doesn't require checkin yet, but very soon. Yellow}, { k: notAttending, v: 7, Description: Planned shift, but person hasn't checked in. Red}, { k: unavailable, v: 8, Description: Planned shift, but person isn't available due to illness, leave, ... No work checkin registered. Grey} }") as unknown as z.ZodType<AttendanceStatusEnum>;


/** functions auditet explicit an example could be "registerindsigt" */
export enum AuditFunctionEnum {
	noFunction = 0,
	listView = 1,
	listViewCopy = 2,
	listViewTable = 3,
	listViewPrint = 4,
	listViewMail = 5,
	listViewEmbedded = 6,
	listViewEmbeddedCopy = 7,
	listViewEmbeddedPrint = 8,
	listViewEmbeddedMail = 9,
	objDialog = 10,
	objDialogViewCopy = 11,
	objDialogPrint = 12,
	objDialogMail = 13,
	objDialogViewCopyMulti = 14,
	objDialogPrintMulti = 15,
	workspace = 20,
	workspaceCopy = 21,
	workspacePrint = 22,
	workspaceMail = 23,
	advancedFindPerson = 40,
	classicDialog = 50,
	cardexDialog = 55,
	classicList = 60,
	browseListView = 70,
	checkInMonitor = 80,
	workplanSortedCallinList = 90,
	planStat = 100,
	actWizardFindCandidates = 110,
	userLocks = 120,
	exchangePerson = 130,
	rosterrowRollout = 140,
	showLog = 150,
	workplanShiftSwap = 160,
	totalRecalculate = 170,
	shiftQualification = 180,
	reports = 190,
	datawarehouseClassic = 200,
	datawarehouseClassicStaffuser = 201,
	snapshotExport = 202,
	dutyAdjustments = 210,
	messageWithOptionalGDPR = 220,
	logWithOptionalGDPR = 230,
	ruleViolations = 240,
	actShiftSync = 250,
	webApproveWorkflow = 251,
	webServiceMethod = 300,
	dataSubjectInformation = 400,
	changeDBPassword = 500,
	temporaryFunctionName__NOT_permanent = 1000,
	stopStaff = 9999,
}

export const AuditFunctionSchema = enumSchema(AuditFunctionEnum) as unknown as z.ZodType<AuditFunctionEnum>;
export const AuditFunctionJsonSchema = enumSchema(AuditFunctionEnum).describe("functions auditet explicit an example could be \"registerindsigt\" - Schema: { { k: noFunction, v: 0, Description: <empty>}, { k: listView, v: 1, Description: <empty>}, { k: listViewCopy, v: 2, Description: <empty>}, { k: listViewTable, v: 3, Description: <empty>}, { k: listViewPrint, v: 4, Description: <empty>}, { k: listViewMail, v: 5, Description: <empty>}, { k: listViewEmbedded, v: 6, Description: <empty>}, { k: listViewEmbeddedCopy, v: 7, Description: <empty>}, { k: listViewEmbeddedPrint, v: 8, Description: <empty>}, { k: listViewEmbeddedMail, v: 9, Description: <empty>}, { k: objDialog, v: 10, Description: <empty>}, { k: objDialogViewCopy, v: 11, Description: <empty>}, { k: objDialogPrint, v: 12, Description: <empty>}, { k: objDialogMail, v: 13, Description: <empty>}, { k: objDialogViewCopyMulti, v: 14, Description: <empty>}, { k: objDialogPrintMulti, v: 15, Description: <empty>}, { k: workspace, v: 20, Description: <empty>}, { k: workspaceCopy, v: 21, Description: <empty>}, { k: workspacePrint, v: 22, Description: <empty>}, { k: workspaceMail, v: 23, Description: <empty>}, { k: advancedFindPerson, v: 40, Description: <empty>}, { k: classicDialog, v: 50, Description: <empty>}, { k: cardexDialog, v: 55, Description: <empty>}, { k: classicList, v: 60, Description: <empty>}, { k: browseListView, v: 70, Description: <empty>}, { k: checkInMonitor, v: 80, Description: <empty>}, { k: workplanSortedCallinList, v: 90, Description: <empty>}, { k: planStat, v: 100, Description: <empty>}, { k: actWizardFindCandidates, v: 110, Description: <empty>}, { k: userLocks, v: 120, Description: <empty>}, { k: exchangePerson, v: 130, Description: <empty>}, { k: rosterrowRollout, v: 140, Description: <empty>}, { k: showLog, v: 150, Description: <empty>}, { k: workplanShiftSwap, v: 160, Description: <empty>}, { k: totalRecalculate, v: 170, Description: <empty>}, { k: shiftQualification, v: 180, Description: <empty>}, { k: reports, v: 190, Description: <empty>}, { k: datawarehouseClassic, v: 200, Description: <empty>}, { k: datawarehouseClassicStaffuser, v: 201, Description: <empty>}, { k: snapshotExport, v: 202, Description: <empty>}, { k: dutyAdjustments, v: 210, Description: <empty>}, { k: messageWithOptionalGDPR, v: 220, Description: <empty>}, { k: logWithOptionalGDPR, v: 230, Description: <empty>}, { k: ruleViolations, v: 240, Description: <empty>}, { k: actShiftSync, v: 250, Description: <empty>}, { k: webApproveWorkflow, v: 251, Description: <empty>}, { k: webServiceMethod, v: 300, Description: <empty>}, { k: dataSubjectInformation, v: 400, Description: <empty>}, { k: changeDBPassword, v: 500, Description: <empty>}, { k: temporaryFunctionName__NOT_permanent, v: 1000, Description: <empty>}, { k: stopStaff, v: 9999, Description: <empty>} }") as unknown as z.ZodType<AuditFunctionEnum>;


/** status for the content of the logAudit table */
export enum AuditLogNormalizedEnum {
	notNormalized = 0,
	normalized = 1,
	processing = 2,
}

export const AuditLogNormalizedSchema = enumSchema(AuditLogNormalizedEnum) as unknown as z.ZodType<AuditLogNormalizedEnum>;
export const AuditLogNormalizedJsonSchema = enumSchema(AuditLogNormalizedEnum).describe("status for the content of the logAudit table - Schema: { { k: notNormalized, v: 0, Description: <empty>}, { k: normalized, v: 1, Description: <empty>}, { k: processing, v: 2, Description: <empty>} }") as unknown as z.ZodType<AuditLogNormalizedEnum>;


/** availabilityOpenHandling */
export enum AvailabilityOpenHandlingEnum {
/** default. Availability is always closed */
	disabled = 0,
/** Availability may be open, this is default for this shifttype when new availability made by the userinterface */
	defaultOpen = 1,
/** Availability may be open, closed is default for this shifttype when new availability made by the userinterface */
	defaultClosed = 2,
}

export const AvailabilityOpenHandlingSchema = enumSchema(AvailabilityOpenHandlingEnum) as unknown as z.ZodType<AvailabilityOpenHandlingEnum>;
export const AvailabilityOpenHandlingJsonSchema = enumSchema(AvailabilityOpenHandlingEnum).describe("availabilityOpenHandling - Schema: { { k: disabled, v: 0, Description: default. Availability is always closed}, { k: defaultOpen, v: 1, Description: Availability may be open, this is default for this shifttype when new availability made by the userinterface}, { k: defaultClosed, v: 2, Description: Availability may be open, closed is default for this shifttype when new availability made by the userinterface} }") as unknown as z.ZodType<AvailabilityOpenHandlingEnum>;


/** If absence starts on or after shift-start the exact part of shift overlapping absence is converted O.w. The whole shift is converted if shift-start truely overlaps absence AND. change_overlap_intersect_intersecting */
export enum AvailabilityShiftconvertEnum {
/** The exact part of shift overlapping absence is converted change_intersecting_shifts */
	intersectingShifts = 1,
/** The whole shift is converted if shift-start truely overlaps absence  change_overlap_shiftsstart */
	overlapShiftsstart = 2,
/** The whole shift is converted if shift-start truely overlaps absence AND O.w.: The exact part of shift overlapping absence is converted. change_overlap_intersecting */
	overlapIntersecting = 3,
	overlapIntersectIntersecting = 4,
/** If shift is contaqined in absence period */
	shiftconvertContained = 5,
/** The whole shift is converted if majority (>=50 PCT) overlaps whole-day absence, O.w. only part overlapping absence */
	majorityOverlapWholeDay = 6,
/** No shift conversion */
	doNotConvert = 7,
/** A full-day (00-24) absence converts the whole shift that starts on that day and leaves a shift only crossing into the day unconverted (day intention); a part-day absence converts only the overlapping part */
	dayIntentOrOverlapped = 8,
}

export const AvailabilityShiftconvertSchema = enumSchema(AvailabilityShiftconvertEnum) as unknown as z.ZodType<AvailabilityShiftconvertEnum>;
export const AvailabilityShiftconvertJsonSchema = enumSchema(AvailabilityShiftconvertEnum).describe("If absence starts on or after shift-start the exact part of shift overlapping absence is converted O.w. The whole shift is converted if shift-start truely overlaps absence AND. change_overlap_intersect_intersecting - Schema: { { k: intersectingShifts, v: 1, Description: The exact part of shift overlapping absence is converted change_intersecting_shifts}, { k: overlapShiftsstart, v: 2, Description: The whole shift is converted if shift-start truely overlaps absence  change_overlap_shiftsstart}, { k: overlapIntersecting, v: 3, Description: The whole shift is converted if shift-start truely overlaps absence AND O.w.: The exact part of shift overlapping absence is converted. change_overlap_intersecting}, { k: overlapIntersectIntersecting, v: 4, Description: <empty>}, { k: shiftconvertContained, v: 5, Description: If shift is contaqined in absence period}, { k: majorityOverlapWholeDay, v: 6, Description: The whole shift is converted if majority (>=50 PCT) overlaps whole-day absence, O.w. only part overlapping absence}, { k: doNotConvert, v: 7, Description: No shift conversion}, { k: dayIntentOrOverlapped, v: 8, Description: A full-day (00-24) absence converts the whole shift that starts on that day and leaves a shift only crossing into the day unconverted (day intention); a part-day absence converts only the overlapping part} }") as unknown as z.ZodType<AvailabilityShiftconvertEnum>;


/** properties on a orgunit */
export enum BardrawPropertyEnum {
	bar_not_in_filter = -2,
	invalid = -1,
	normal = 0,
	remark = 1,
}

export const BardrawPropertySchema = enumSchema(BardrawPropertyEnum) as unknown as z.ZodType<BardrawPropertyEnum>;
export const BardrawPropertyJsonSchema = enumSchema(BardrawPropertyEnum).describe("properties on a orgunit - Schema: { { k: bar_not_in_filter, v: -2, Description: <empty>}, { k: invalid, v: -1, Description: <empty>}, { k: normal, v: 0, Description: <empty>}, { k: remark, v: 1, Description: <empty>} }") as unknown as z.ZodType<BardrawPropertyEnum>;


/** encoding batchjob.executionstatus */
export enum BatchJobExecutionResultEnum {
	ready = 0,
	endedOK = 1,
	running = 2,
	stoppedUserIntervention = 3,
	endedWarning = 4,
	stoppedFail = 5,
	stoppedError = 6,
	endedError = 7,
	rescheduled = 8,
}

export const BatchJobExecutionResultSchema = enumSchema(BatchJobExecutionResultEnum) as unknown as z.ZodType<BatchJobExecutionResultEnum>;
export const BatchJobExecutionResultJsonSchema = enumSchema(BatchJobExecutionResultEnum).describe("encoding batchjob.executionstatus - Schema: { { k: ready, v: 0, Description: <empty>}, { k: endedOK, v: 1, Description: <empty>}, { k: running, v: 2, Description: <empty>}, { k: stoppedUserIntervention, v: 3, Description: <empty>}, { k: endedWarning, v: 4, Description: <empty>}, { k: stoppedFail, v: 5, Description: <empty>}, { k: stoppedError, v: 6, Description: <empty>}, { k: endedError, v: 7, Description: <empty>}, { k: rescheduled, v: 8, Description: <empty>} }") as unknown as z.ZodType<BatchJobExecutionResultEnum>;


/** encoding batchjob.status */
export enum BatchJobStatusEnum {
	ready = 1,
	finished = 2,
	cancelled = 3,
	running = 4,
}

export const BatchJobStatusSchema = enumSchema(BatchJobStatusEnum) as unknown as z.ZodType<BatchJobStatusEnum>;
export const BatchJobStatusJsonSchema = enumSchema(BatchJobStatusEnum).describe("encoding batchjob.status - Schema: { { k: ready, v: 1, Description: <empty>}, { k: finished, v: 2, Description: <empty>}, { k: cancelled, v: 3, Description: <empty>}, { k: running, v: 4, Description: <empty>} }") as unknown as z.ZodType<BatchJobStatusEnum>;


/** job types. Note the enum values are handled Case Sensitive by the loader, så you are NOT allowed to change the casing */
export enum BatchJobTypeEnum {
	unknownJobType = 0,
	personUpdate = 1,
	salaryJob = 2,
	orgUnitImport = 3,
	userImport = 4,
	setUserAccess = 5,
	updateUser = 6,
	clocking = 7,
	rosterDemand = 8,
	planDemand = 9,
	keyFigure = 10,
/** Generic transaction file in xml format */
	transaction = 11,
/** Generic transaction file in csv format */
	transactionCsv = 12,
/** Will usually be converted to one of the other types during load */
	job = 13,
	qualification = 14,
/** For many customers, balance statements are imported as personupdate */
	balanceImport = 15,
	personDelete = 16,
/** Just split lines */
	splitStream = 17,
/** Check person field, and split lines */
	personLine = 18,
	upsertUser = 19,
/** SD tjenestenummerkonvertering */
	salaryIdConversion = 20,
}

export const BatchJobTypeSchema = enumSchema(BatchJobTypeEnum) as unknown as z.ZodType<BatchJobTypeEnum>;
export const BatchJobTypeJsonSchema = enumSchema(BatchJobTypeEnum).describe("job types. Note the enum values are handled Case Sensitive by the loader, så you are NOT allowed to change the casing - Schema: { { k: unknownJobType, v: 0, Description: <empty>}, { k: personUpdate, v: 1, Description: <empty>}, { k: salaryJob, v: 2, Description: <empty>}, { k: orgUnitImport, v: 3, Description: <empty>}, { k: userImport, v: 4, Description: <empty>}, { k: setUserAccess, v: 5, Description: <empty>}, { k: updateUser, v: 6, Description: <empty>}, { k: clocking, v: 7, Description: <empty>}, { k: rosterDemand, v: 8, Description: <empty>}, { k: planDemand, v: 9, Description: <empty>}, { k: keyFigure, v: 10, Description: <empty>}, { k: transaction, v: 11, Description: Generic transaction file in xml format}, { k: transactionCsv, v: 12, Description: Generic transaction file in csv format}, { k: job, v: 13, Description: Will usually be converted to one of the other types during load}, { k: qualification, v: 14, Description: <empty>}, { k: balanceImport, v: 15, Description: For many customers, balance statements are imported as personupdate}, { k: personDelete, v: 16, Description: <empty>}, { k: splitStream, v: 17, Description: Just split lines}, { k: personLine, v: 18, Description: Check person field, and split lines}, { k: upsertUser, v: 19, Description: <empty>}, { k: salaryIdConversion, v: 20, Description: SD tjenestenummerkonvertering} }") as unknown as z.ZodType<BatchJobTypeEnum>;


/** encoding batchtaskexecution.resultx */
export enum BatchTaskExecutionResultEnum {
	resultNil = 0,
	endedOK = 1,
	running = 2,
	stoppedUserIntervention = 3,
	endedWarning = 4,
	stoppedFail = 5,
	stoppedError = 6,
	endedError = 7,
	rescheduled = 8,
}

export const BatchTaskExecutionResultSchema = enumSchema(BatchTaskExecutionResultEnum) as unknown as z.ZodType<BatchTaskExecutionResultEnum>;
export const BatchTaskExecutionResultJsonSchema = enumSchema(BatchTaskExecutionResultEnum).describe("encoding batchtaskexecution.resultx - Schema: { { k: resultNil, v: 0, Description: <empty>}, { k: endedOK, v: 1, Description: <empty>}, { k: running, v: 2, Description: <empty>}, { k: stoppedUserIntervention, v: 3, Description: <empty>}, { k: endedWarning, v: 4, Description: <empty>}, { k: stoppedFail, v: 5, Description: <empty>}, { k: stoppedError, v: 6, Description: <empty>}, { k: endedError, v: 7, Description: <empty>}, { k: rescheduled, v: 8, Description: <empty>} }") as unknown as z.ZodType<BatchTaskExecutionResultEnum>;


/** encoding batchtask.status */
export enum BatchTaskStatusEnum {
	ready = 1,
	finished = 2,
	cancelled = 3,
/** move to batchjob table */
	moved = 4,
}

export const BatchTaskStatusSchema = enumSchema(BatchTaskStatusEnum) as unknown as z.ZodType<BatchTaskStatusEnum>;
export const BatchTaskStatusJsonSchema = enumSchema(BatchTaskStatusEnum).describe("encoding batchtask.status - Schema: { { k: ready, v: 1, Description: <empty>}, { k: finished, v: 2, Description: <empty>}, { k: cancelled, v: 3, Description: <empty>}, { k: moved, v: 4, Description: move to batchjob table} }") as unknown as z.ZodType<BatchTaskStatusEnum>;


/** Type of data in stringblob table */
export enum BlobTypeEnum {
/** nil */
	nil = 0,
/** log */
	log = 1,
/** salary */
	salary = 2,
/** printerConfig */
	printerConfig = 3,
/** batchExecution */
	batchExecution = 4,
}

export const BlobTypeSchema = enumSchema(BlobTypeEnum) as unknown as z.ZodType<BlobTypeEnum>;
export const BlobTypeJsonSchema = enumSchema(BlobTypeEnum).describe("Type of data in stringblob table - Schema: { { k: nil, v: 0, Description: nil}, { k: log, v: 1, Description: log}, { k: salary, v: 2, Description: salary}, { k: printerConfig, v: 3, Description: printerConfig}, { k: batchExecution, v: 4, Description: batchExecution} }") as unknown as z.ZodType<BlobTypeEnum>;


/** When shiftcounter_def.shiftRegField is put into shift_reg.shiftvalues */
export enum CalculationOrderEnum {
/** shiftcounter_def.shiftRegField is not put into shift_reg.shiftvalues */
	disabled = 0,
/** shiftcounter_def.shiftRegField is put into shift_reg.shiftvalues before regular calcsupl calculations, so it can be modified by shiftcounter_rules */
	beforeCalcsupl = 1,
/** shiftcounter_def.shiftRegField is put into shift_reg.shiftvalues after regular calcsupl calculations, so it can modify the calculations from calcsupl */
	afterCalcsupl = 2,
}

export const CalculationOrderSchema = enumSchema(CalculationOrderEnum) as unknown as z.ZodType<CalculationOrderEnum>;
export const CalculationOrderJsonSchema = enumSchema(CalculationOrderEnum).describe("When shiftcounter_def.shiftRegField is put into shift_reg.shiftvalues - Schema: { { k: disabled, v: 0, Description: shiftcounter_def.shiftRegField is not put into shift_reg.shiftvalues}, { k: beforeCalcsupl, v: 1, Description: shiftcounter_def.shiftRegField is put into shift_reg.shiftvalues before regular calcsupl calculations, so it can be modified by shiftcounter_rules}, { k: afterCalcsupl, v: 2, Description: shiftcounter_def.shiftRegField is put into shift_reg.shiftvalues after regular calcsupl calculations, so it can modify the calculations from calcsupl} }") as unknown as z.ZodType<CalculationOrderEnum>;


/** How to compute qualification capacity */
export enum CapacityAggOpEnum {
/** Only Items that begin within slot are counted */
	countFirst = 1,
/** Only Items that end within slot are counted */
	countLast = 2,
/** Items intersecting slot are counted */
	count = 3,
/** Minimum count for 5 minut slots */
	countMin = 4,
/** Maximum count for 5 minut slots */
	countMax = 5,
/** Average count for 5 minut slots */
	countAverage = 6,
/** Man hour sum of slot, ie area duration * height in hours */
	area = 7,
}

export const CapacityAggOpSchema = enumSchema(CapacityAggOpEnum) as unknown as z.ZodType<CapacityAggOpEnum>;
export const CapacityAggOpJsonSchema = enumSchema(CapacityAggOpEnum).describe("How to compute qualification capacity - Schema: { { k: countFirst, v: 1, Description: Only Items that begin within slot are counted}, { k: countLast, v: 2, Description: Only Items that end within slot are counted}, { k: count, v: 3, Description: Items intersecting slot are counted}, { k: countMin, v: 4, Description: Minimum count for 5 minut slots}, { k: countMax, v: 5, Description: Maximum count for 5 minut slots}, { k: countAverage, v: 6, Description: Average count for 5 minut slots}, { k: area, v: 7, Description: Man hour sum of slot, ie area duration * height in hours} }") as unknown as z.ZodType<CapacityAggOpEnum>;


/** Which kind of demand */
export enum CapacityCategoryEnum {
	act = 1,
	actGrp = 2,
	shift = 3,
	shiftType = 4,
	shiftCategory = 5,
	shiftCounter = 6,
	qualification = 7,
	disposal = 8,
	absence = 9,
	account = 10,
}

export const CapacityCategorySchema = enumSchema(CapacityCategoryEnum) as unknown as z.ZodType<CapacityCategoryEnum>;
export const CapacityCategoryJsonSchema = enumSchema(CapacityCategoryEnum).describe("Which kind of demand - Schema: { { k: act, v: 1, Description: <empty>}, { k: actGrp, v: 2, Description: <empty>}, { k: shift, v: 3, Description: <empty>}, { k: shiftType, v: 4, Description: <empty>}, { k: shiftCategory, v: 5, Description: <empty>}, { k: shiftCounter, v: 6, Description: <empty>}, { k: qualification, v: 7, Description: <empty>}, { k: disposal, v: 8, Description: <empty>}, { k: absence, v: 9, Description: <empty>}, { k: account, v: 10, Description: <empty>} }") as unknown as z.ZodType<CapacityCategoryEnum>;


/** How to compute qualification capacity */
export enum CapacityQualificationBaseEnum {
/** Shifts are used for computing qualification capacity */
	base_shift = 1,
/** Dispositions (positive avails) are used for computing qualification capacity */
	base_disposition = 2,
/** Task RCs are used for computing qualification capacity */
	base_taskResourceConstraints = 3,
}

export const CapacityQualificationBaseSchema = enumSchema(CapacityQualificationBaseEnum) as unknown as z.ZodType<CapacityQualificationBaseEnum>;
export const CapacityQualificationBaseJsonSchema = enumSchema(CapacityQualificationBaseEnum).describe("How to compute qualification capacity - Schema: { { k: base_shift, v: 1, Description: Shifts are used for computing qualification capacity}, { k: base_disposition, v: 2, Description: Dispositions (positive avails) are used for computing qualification capacity}, { k: base_taskResourceConstraints, v: 3, Description: Task RCs are used for computing qualification capacity} }") as unknown as z.ZodType<CapacityQualificationBaseEnum>;


/** used by myPlan */
export enum ChatMessageTypeEnum {
	undefined = 0,
/** Simple table */
	simple = 1,
/** [Obsolete] */
	group = 2,
/** Boardnote */
	personal = 3,
/** Emp_day */
	day = 4,
/** Swap messages */
	swap = 7,
/** Deputy messages */
	deputy = 8,
/** Union of Group and Personal */
	colleague = 9,
/** FunctionPlan message */
	functionPlan = 10,
}

export const ChatMessageTypeSchema = enumSchema(ChatMessageTypeEnum) as unknown as z.ZodType<ChatMessageTypeEnum>;
export const ChatMessageTypeJsonSchema = enumSchema(ChatMessageTypeEnum).describe("used by myPlan - Schema: { { k: undefined, v: 0, Description: <empty>}, { k: simple, v: 1, Description: Simple table}, { k: group, v: 2, Description: [Obsolete]}, { k: personal, v: 3, Description: Boardnote}, { k: day, v: 4, Description: Emp_day}, { k: swap, v: 7, Description: Swap messages}, { k: deputy, v: 8, Description: Deputy messages}, { k: colleague, v: 9, Description: Union of Group and Personal}, { k: functionPlan, v: 10, Description: FunctionPlan message} }") as unknown as z.ZodType<ChatMessageTypeEnum>;


/** used by myPlan */
export enum ChatTypesEnum {
	undefined = 0,
/** Simple table */
	simple = 1,
/** Emp_day */
	day = 4,
/** Instant Messages */
	instant = 5,
/** Swap messages */
	swap = 7,
/** Deputy messages */
	deputy = 8,
/** Union of Group and Personal */
	colleague = 9,
}

export const ChatTypesSchema = enumSchema(ChatTypesEnum) as unknown as z.ZodType<ChatTypesEnum>;
export const ChatTypesJsonSchema = enumSchema(ChatTypesEnum).describe("used by myPlan - Schema: { { k: undefined, v: 0, Description: <empty>}, { k: simple, v: 1, Description: Simple table}, { k: day, v: 4, Description: Emp_day}, { k: instant, v: 5, Description: Instant Messages}, { k: swap, v: 7, Description: Swap messages}, { k: deputy, v: 8, Description: Deputy messages}, { k: colleague, v: 9, Description: Union of Group and Personal} }") as unknown as z.ZodType<ChatTypesEnum>;


/** Is it a time registration or an actual clocking and in that case is it time-true or a manual clocking */
export enum ClockingPrecisionEnum {
/** Clocking made through time registration in MyPlan */
	timeRegistration = 0,
/** Clocking true to time. When we recieve clockings from thirdparty the clockedAt and created will most likely not match. */
	clocking = 1,
/** Clocking entered late and manually by the employee through MyPlan. */
	userInput = 2,
}

export const ClockingPrecisionSchema = enumSchema(ClockingPrecisionEnum) as unknown as z.ZodType<ClockingPrecisionEnum>;
export const ClockingPrecisionJsonSchema = enumSchema(ClockingPrecisionEnum).describe("Is it a time registration or an actual clocking and in that case is it time-true or a manual clocking - Schema: { { k: timeRegistration, v: 0, Description: Clocking made through time registration in MyPlan}, { k: clocking, v: 1, Description: Clocking true to time. When we recieve clockings from thirdparty the clockedAt and created will most likely not match.}, { k: userInput, v: 2, Description: Clocking entered late and manually by the employee through MyPlan.} }") as unknown as z.ZodType<ClockingPrecisionEnum>;


/** configModule - to group setting */
export enum ConfigModuleEnum {
/** nothing set */
	noModule = -1,
/** costModule */
	costModule = 100,
/** costModule */
	datawareHouseClassicModule = 110,
}

export const ConfigModuleSchema = enumSchema(ConfigModuleEnum) as unknown as z.ZodType<ConfigModuleEnum>;
export const ConfigModuleJsonSchema = enumSchema(ConfigModuleEnum).describe("configModule - to group setting - Schema: { { k: noModule, v: -1, Description: nothing set}, { k: costModule, v: 100, Description: costModule}, { k: datawareHouseClassicModule, v: 110, Description: costModule} }") as unknown as z.ZodType<ConfigModuleEnum>;


/** statusType */
export enum ContactFormTypeEnum {
	nil = -1,
	sms = 1,
	mail = 2,
	telephone = 3,
	face_face = 4,
	web = 5,
	other = 6,
}

export const ContactFormTypeSchema = enumSchema(ContactFormTypeEnum) as unknown as z.ZodType<ContactFormTypeEnum>;
export const ContactFormTypeJsonSchema = enumSchema(ContactFormTypeEnum).describe("statusType - Schema: { { k: nil, v: -1, Description: <empty>}, { k: sms, v: 1, Description: <empty>}, { k: mail, v: 2, Description: <empty>}, { k: telephone, v: 3, Description: <empty>}, { k: face_face, v: 4, Description: <empty>}, { k: web, v: 5, Description: <empty>}, { k: other, v: 6, Description: <empty>} }") as unknown as z.ZodType<ContactFormTypeEnum>;


/** is the shift converted by availabilities */
export enum ConvertedByAvailabilityEnum {
/** AvailConverted has not been evaluated yet */
	nilAvailConverted_SH = 0,
/** No overlapping availability_reg */
	notAvailConverted_SH = 1,
/** Overlapping availability_reg */
	availConverted_SH = 2,
/** AvailConverted has not been evaluated yet – sh de-selected */
	nilAvailConverted_noSH = 3,
/** No overlapping availability_reg – sh de-selected */
	notAvailConverted_noSH = 4,
/** Overlapping availability_reg – sh de-selected */
	availConverted_noSH = 5,
}

export const ConvertedByAvailabilitySchema = enumSchema(ConvertedByAvailabilityEnum) as unknown as z.ZodType<ConvertedByAvailabilityEnum>;
export const ConvertedByAvailabilityJsonSchema = enumSchema(ConvertedByAvailabilityEnum).describe("is the shift converted by availabilities - Schema: { { k: nilAvailConverted_SH, v: 0, Description: AvailConverted has not been evaluated yet}, { k: notAvailConverted_SH, v: 1, Description: No overlapping availability_reg}, { k: availConverted_SH, v: 2, Description: Overlapping availability_reg}, { k: nilAvailConverted_noSH, v: 3, Description: AvailConverted has not been evaluated yet – sh de-selected}, { k: notAvailConverted_noSH, v: 4, Description: No overlapping availability_reg – sh de-selected}, { k: availConverted_noSH, v: 5, Description: Overlapping availability_reg – sh de-selected} }") as unknown as z.ZodType<ConvertedByAvailabilityEnum>;


/** how use to compute cost for this counter */
export enum CostComputeTypeEnum {
/** The counter is not a part of the cost computation */
	noCost = 0,
/** The counter is a part of the cost computation */
	withCost = 1,
/** The counter is a part of the cost computation or a detailcostcounter. Overhead is not applied */
	withoutOverhead = 2,
/** The counter is a detailcostcounter with overhead */
	costDetailsWithOverhead = 3,
}

export const CostComputeTypeSchema = enumSchema(CostComputeTypeEnum) as unknown as z.ZodType<CostComputeTypeEnum>;
export const CostComputeTypeJsonSchema = enumSchema(CostComputeTypeEnum).describe("how use to compute cost for this counter - Schema: { { k: noCost, v: 0, Description: The counter is not a part of the cost computation}, { k: withCost, v: 1, Description: The counter is a part of the cost computation}, { k: withoutOverhead, v: 2, Description: The counter is a part of the cost computation or a detailcostcounter. Overhead is not applied}, { k: costDetailsWithOverhead, v: 3, Description: The counter is a detailcostcounter with overhead} }") as unknown as z.ZodType<CostComputeTypeEnum>;


/** How to compute cost hours used in steps */
export enum CostHourComputationEnum {
/** occupationDecimal * 4.3333 * 37. 37 er antal timer pr. uge - BROM har givet mig formlen 2024.06.11 */
	normHourPrMonth = 1,
/** The sum of costNormCounter for the period */
	normHourSumInPeriod = 2,
/** The occupationDecimal is multiplied to the Rate, there may be different rates for different steps. See agreement.effPeriodCostList.data.cost */
	occupationDecimalFactor = 3,
/** The sum of costNormCounter for the period is multiplied to the Rate, there may be different rates for different steps See agreement.effPeriodCostList.data.cost */
	normHourSumFactor = 4,
}

export const CostHourComputationSchema = enumSchema(CostHourComputationEnum) as unknown as z.ZodType<CostHourComputationEnum>;
export const CostHourComputationJsonSchema = enumSchema(CostHourComputationEnum).describe("How to compute cost hours used in steps - Schema: { { k: normHourPrMonth, v: 1, Description: occupationDecimal * 4.3333 * 37. 37 er antal timer pr. uge - BROM har givet mig formlen 2024.06.11}, { k: normHourSumInPeriod, v: 2, Description: The sum of costNormCounter for the period}, { k: occupationDecimalFactor, v: 3, Description: The occupationDecimal is multiplied to the Rate, there may be different rates for different steps. See agreement.effPeriodCostList.data.cost}, { k: normHourSumFactor, v: 4, Description: The sum of costNormCounter for the period is multiplied to the Rate, there may be different rates for different steps See agreement.effPeriodCostList.data.cost} }") as unknown as z.ZodType<CostHourComputationEnum>;


/** cost module */
export enum CostPriceUnitEnum {
/** 123,33   cost_priceunit_amount */
	amount = 0,
/** 89 o/o P cost_priceunit_pctPersonal */
	pctPersonal = 1,
/** 89 o/o   cost_priceunit_pctNormal */
	pctNormal = 2,
/** 10 o/o E cost_priceunit_pctPersonalExtra */
	pctPersonalExtra = 3,
/** price for one hour work for persons with fixed pay */
	pctFixedSalary = 4,
}

export const CostPriceUnitSchema = enumSchema(CostPriceUnitEnum) as unknown as z.ZodType<CostPriceUnitEnum>;
export const CostPriceUnitJsonSchema = enumSchema(CostPriceUnitEnum).describe("cost module - Schema: { { k: amount, v: 0, Description: 123,33   cost_priceunit_amount}, { k: pctPersonal, v: 1, Description: 89 o/o P cost_priceunit_pctPersonal}, { k: pctNormal, v: 2, Description: 89 o/o   cost_priceunit_pctNormal}, { k: pctPersonalExtra, v: 3, Description: 10 o/o E cost_priceunit_pctPersonalExtra}, { k: pctFixedSalary, v: 4, Description: price for one hour work for persons with fixed pay} }") as unknown as z.ZodType<CostPriceUnitEnum>;


/** the type of the trip */
export enum CoTransportTypeEnum {
	trip = 1,
	return = 2,
	tripReturn = 3,
	mixed = 4,
}

export const CoTransportTypeSchema = enumSchema(CoTransportTypeEnum) as unknown as z.ZodType<CoTransportTypeEnum>;
export const CoTransportTypeJsonSchema = enumSchema(CoTransportTypeEnum).describe("the type of the trip - Schema: { { k: trip, v: 1, Description: <empty>}, { k: return, v: 2, Description: <empty>}, { k: tripReturn, v: 3, Description: <empty>}, { k: mixed, v: 4, Description: <empty>} }") as unknown as z.ZodType<CoTransportTypeEnum>;


/** For shift_regs covering multiple days, specifies which days this shiftcounter’s shiftvalues apply to */
export enum CounterValOnDayEnum {
/** Shiftvalues apply to the first day in the shift */
	valOnFirstShiftDay = 0,
/** Shiftvalues apply to the last day in the shift */
	valOnLastShiftDay = 1,
/** Shiftvalues apply to the day in the shift with the most coverage */
	valOnLongestShiftDay = 2,
/** Shiftvalues are split across the shift's days */
	valOnSplitShiftDays = 4,
}

export const CounterValOnDaySchema = enumSchema(CounterValOnDayEnum) as unknown as z.ZodType<CounterValOnDayEnum>;
export const CounterValOnDayJsonSchema = enumSchema(CounterValOnDayEnum).describe("For shift_regs covering multiple days, specifies which days this shiftcounter’s shiftvalues apply to - Schema: { { k: valOnFirstShiftDay, v: 0, Description: Shiftvalues apply to the first day in the shift}, { k: valOnLastShiftDay, v: 1, Description: Shiftvalues apply to the last day in the shift}, { k: valOnLongestShiftDay, v: 2, Description: Shiftvalues apply to the day in the shift with the most coverage}, { k: valOnSplitShiftDays, v: 4, Description: Shiftvalues are split across the shift's days} }") as unknown as z.ZodType<CounterValOnDayEnum>;


/** DATABASE */
export enum DatabaseObjectTypeEnum {
/** function - the @sqlBody consist of the part after 'create function' including parameter declaration */
	dboFunction = 4,
/** procedure - the @sqlBody consist of the part after 'create procedure'  including parameter declaration */
	dboProcedure = 3,
/** the @sqlBody consist of the part after 'create type as' */
	dboType = 6,
/** the @sqlBody consist of the part after 'create table as' */
	dboTable = 2,
/** the @sqlBody consist of the part after 'create view as' */
	dboView = 1,
/** Seperate Database Index */
	dboIndex = 5,
/** defines a synonym */
	dboSynonym = 9,
/** tableFunction - the @sqlBody consist of the part after 'create function' including parameter declaration */
	dboTableFunction = 11,
}

export const DatabaseObjectTypeSchema = enumSchema(DatabaseObjectTypeEnum) as unknown as z.ZodType<DatabaseObjectTypeEnum>;
export const DatabaseObjectTypeJsonSchema = enumSchema(DatabaseObjectTypeEnum).describe("DATABASE - Schema: { { k: dboFunction, v: 4, Description: function - the @sqlBody consist of the part after 'create function' including parameter declaration}, { k: dboProcedure, v: 3, Description: procedure - the @sqlBody consist of the part after 'create procedure'  including parameter declaration}, { k: dboType, v: 6, Description: the @sqlBody consist of the part after 'create type as'}, { k: dboTable, v: 2, Description: the @sqlBody consist of the part after 'create table as'}, { k: dboView, v: 1, Description: the @sqlBody consist of the part after 'create view as'}, { k: dboIndex, v: 5, Description: Seperate Database Index}, { k: dboSynonym, v: 9, Description: defines a synonym}, { k: dboTableFunction, v: 11, Description: tableFunction - the @sqlBody consist of the part after 'create function' including parameter declaration} }") as unknown as z.ZodType<DatabaseObjectTypeEnum>;


/** catalog of database object types - not to be used */
export enum DatabaseObjTypeCatalogEnum {
/** the @sqlBody consist of the part after 'create view as' */
	dboView = 1,
/** the @sqlBody consist of the part after 'create table as' */
	dboTable = 2,
/** procedure - the @sqlBody consist of the part after 'create procedure'  including parameter declaration */
	dboProcedure = 3,
/** function - the @sqlBody consist of the part after 'create function' including parameter declaration */
	dboFunction = 4,
/** Seperate Database Index */
	dboIndex = 5,
/** the @sqlBody consist of the part after 'create type as' */
	dboType = 6,
/** Script block */
	dboScript = 7,
/** defines view AND table. The @sqlBody consist of the part after 'create view/table as', only the table is added to the DashBoard Entity Model */
	dboTableAndView = 8,
/** defines a synonym */
	dboSynonym = 9,
/** extra columns for a table. A view @sqlObjectName is created reference all fields from @sqlTableName and the extra fields. @sqlTableName is replaced with @sqlObjectName int the DashBoard Entity Model. The @sqlBody consist of the view fields */
	dboTableExtension = 10,
/** tableFunction - the @sqlBody consist of the part after 'create function' including parameter declaration */
	dboTableFunction = 11,
}

export const DatabaseObjTypeCatalogSchema = enumSchema(DatabaseObjTypeCatalogEnum) as unknown as z.ZodType<DatabaseObjTypeCatalogEnum>;
export const DatabaseObjTypeCatalogJsonSchema = enumSchema(DatabaseObjTypeCatalogEnum).describe("catalog of database object types - not to be used - Schema: { { k: dboView, v: 1, Description: the @sqlBody consist of the part after 'create view as'}, { k: dboTable, v: 2, Description: the @sqlBody consist of the part after 'create table as'}, { k: dboProcedure, v: 3, Description: procedure - the @sqlBody consist of the part after 'create procedure'  including parameter declaration}, { k: dboFunction, v: 4, Description: function - the @sqlBody consist of the part after 'create function' including parameter declaration}, { k: dboIndex, v: 5, Description: Seperate Database Index}, { k: dboType, v: 6, Description: the @sqlBody consist of the part after 'create type as'}, { k: dboScript, v: 7, Description: Script block}, { k: dboTableAndView, v: 8, Description: defines view AND table. The @sqlBody consist of the part after 'create view/table as', only the table is added to the DashBoard Entity Model}, { k: dboSynonym, v: 9, Description: defines a synonym}, { k: dboTableExtension, v: 10, Description: extra columns for a table. A view @sqlObjectName is created reference all fields from @sqlTableName and the extra fields. @sqlTableName is replaced with @sqlObjectName int the DashBoard Entity Model. The @sqlBody consist of the view fields}, { k: dboTableFunction, v: 11, Description: tableFunction - the @sqlBody consist of the part after 'create function' including parameter declaration} }") as unknown as z.ZodType<DatabaseObjTypeCatalogEnum>;


/** dataguards events that are not changes to data in tables */
export enum DataGuardEventEnum {
/** new user in context */
	userChange = 0,
/** relevance changed */
	relevanceChange = 1,
/** Global planstatus setting changed */
	globalPlanstatusChange = 2,
/** change current role */
	roleChange = 3,
/** a datamodel based metatable is created. Used for computed properties */
	dataModelMetaTableCreate = 4,
/** the app changes current language */
	languageChange = 5,
/** a new date (in one of the time zones). Called when idle */
	dateChange = 6,
/** a completely new database has been loaded. Everything should be reinitialized */
	reinitializeAppStateFromMockDB = 7,
}

export const DataGuardEventSchema = enumSchema(DataGuardEventEnum) as unknown as z.ZodType<DataGuardEventEnum>;
export const DataGuardEventJsonSchema = enumSchema(DataGuardEventEnum).describe("dataguards events that are not changes to data in tables - Schema: { { k: userChange, v: 0, Description: new user in context}, { k: relevanceChange, v: 1, Description: relevance changed}, { k: globalPlanstatusChange, v: 2, Description: Global planstatus setting changed}, { k: roleChange, v: 3, Description: change current role}, { k: dataModelMetaTableCreate, v: 4, Description: a datamodel based metatable is created. Used for computed properties}, { k: languageChange, v: 5, Description: the app changes current language}, { k: dateChange, v: 6, Description: a new date (in one of the time zones). Called when idle}, { k: reinitializeAppStateFromMockDB, v: 7, Description: a completely new database has been loaded. Everything should be reinitialized} }") as unknown as z.ZodType<DataGuardEventEnum>;


/** used by myPlan */
export enum DataKindEnum {
/** Aggregrate from across all the persons employments. Intended for StaffWeb only */
	crossMix = 22,
/** Aggregrate the Kinds list into one row. Intended for StaffWeb only */
	mix = 21,
/** Table availability_reg where shifttype.present = 0 */
	absence = 0,
/** Table activity_reg */
	activity = 1,
/** Table availability_reg */
	availability = 2,
/** Table demand */
	demand = 3,
/** Table deputy_reg */
	deputy = 4,
/** Table availability_reg where shifttype.present = 1 */
	presence = 5,
/** Tabel shift_reg which is not swappable */
	shift = 6,
/** Exchange table objects */
	swap = 7,
/** Table DeputyRequest that is published for exchange */
	request = 8,
/** Artificial "Planning" planstatus hidden period place holders */
	planStatus = 9,
/** Table prd_task_def (and emp ditto) */
	task = 10,
/** Table shift_reg where planid = master && shifttype.present = 1 && start in swapPeriod && exchange_reg inprogress with the same start */
	swappable = 11,
/** Artificial; represents activities used for functions (cf. activity_shift_assignment) */
	function = 12,
/** Allowance from table availability_reg */
	allowance = 13,
/** Transportation from table shift_reg */
	transportation = 14,
/** Negative preference from table preference_reg */
	negativePreference = 15,
/** Positive preference from table preference_reg */
	positivePreference = 16,
}

export const DataKindSchema = enumSchema(DataKindEnum) as unknown as z.ZodType<DataKindEnum>;
export const DataKindJsonSchema = enumSchema(DataKindEnum).describe("used by myPlan - Schema: { { k: crossMix, v: 22, Description: Aggregrate from across all the persons employments. Intended for StaffWeb only}, { k: mix, v: 21, Description: Aggregrate the Kinds list into one row. Intended for StaffWeb only}, { k: absence, v: 0, Description: Table availability_reg where shifttype.present = 0}, { k: activity, v: 1, Description: Table activity_reg}, { k: availability, v: 2, Description: Table availability_reg}, { k: demand, v: 3, Description: Table demand}, { k: deputy, v: 4, Description: Table deputy_reg}, { k: presence, v: 5, Description: Table availability_reg where shifttype.present = 1}, { k: shift, v: 6, Description: Tabel shift_reg which is not swappable}, { k: swap, v: 7, Description: Exchange table objects}, { k: request, v: 8, Description: Table DeputyRequest that is published for exchange}, { k: planStatus, v: 9, Description: Artificial \"Planning\" planstatus hidden period place holders}, { k: task, v: 10, Description: Table prd_task_def (and emp ditto)}, { k: swappable, v: 11, Description: Table shift_reg where planid = master && shifttype.present = 1 && start in swapPeriod && exchange_reg inprogress with the same start}, { k: function, v: 12, Description: Artificial; represents activities used for functions (cf. activity_shift_assignment)}, { k: allowance, v: 13, Description: Allowance from table availability_reg}, { k: transportation, v: 14, Description: Transportation from table shift_reg}, { k: negativePreference, v: 15, Description: Negative preference from table preference_reg}, { k: positivePreference, v: 16, Description: Positive preference from table preference_reg} }") as unknown as z.ZodType<DataKindEnum>;


/** Defines users need for privay for a field in datamodel - altså virtual fields. The access has an numeric order, so that extra access may be added between existing access - setting dataPrivacy controls the active values */
export enum DataPrivacyEnum {
/** No data privacy defined - value used for implementation purposes */
	undefined = 0,
/** No restrictions. Even people employed at other institutions can see the data. */
	anyone = 10,
/** Planner and all coworkers (same institution) can see the data. */
	coworker = 20,
/** Planner, and group co-members can see the data. */
	groupColleague = 30,
/** Only planner's with access to the person */
	planner = 40,
/** Only planner's with special accessitem privacy */
	plannerAccess = 50,
/** Only planner can see the data, and only by explicit (and logged) request). Data is hidden in lists */
	restricted = 60,
/** Only system can see the data, fx, use email to send new password, but no person shall see it. */
	system = 70,
}

export const DataPrivacySchema = enumSchema(DataPrivacyEnum) as unknown as z.ZodType<DataPrivacyEnum>;
export const DataPrivacyJsonSchema = enumSchema(DataPrivacyEnum).describe("Defines users need for privay for a field in datamodel - altså virtual fields. The access has an numeric order, so that extra access may be added between existing access - setting dataPrivacy controls the active values - Schema: { { k: undefined, v: 0, Description: No data privacy defined - value used for implementation purposes}, { k: anyone, v: 10, Description: No restrictions. Even people employed at other institutions can see the data.}, { k: coworker, v: 20, Description: Planner and all coworkers (same institution) can see the data.}, { k: groupColleague, v: 30, Description: Planner, and group co-members can see the data.}, { k: planner, v: 40, Description: Only planner's with access to the person}, { k: plannerAccess, v: 50, Description: Only planner's with special accessitem privacy}, { k: restricted, v: 60, Description: Only planner can see the data, and only by explicit (and logged) request). Data is hidden in lists}, { k: system, v: 70, Description: Only system can see the data, fx, use email to send new password, but no person shall see it.} }") as unknown as z.ZodType<DataPrivacyEnum>;


/** parameter used to configure the datawarehouse */
export enum DatawarehouseParameterEnum {
/** datawarehouseMode */
	dwMode = 10,
/** interval::intv */
	dwPeriod = 20,
/** the first used (full) - in incrementalmode this is moved when the incremental phase succeds */
	dwCurrentCommitId = 30,
/** in incrementalmode this was the last succesfull state */
	dwLastCommitId = 40,
/** isodatetime - time for last success */
	dwLastSuccess = 50,
/** isodatetime */
	dwCreated = 60,
/** isodatetime */
	dwUpdated = 70,
/** isodatetime */
	dwDone = 80,
/** Text */
	dwStatus = 90,
/** Text */
	dwSubStatus = 100,
/** Program Version */
	dwProgramVersion = 120,
/** Database Version */
	dwDatabaseVersion = 130,
/** Source Database */
	dwSourceDatabase = 140,
/** Creator info */
	dwCreator = 150,
/** Readonly */
	dwReadonly = 160,
/** dashBoard used */
	dwDashBoard = 170,
/** datawarehouseFlagList */
	dwFlagList = 180,
}

export const DatawarehouseParameterSchema = enumSchema(DatawarehouseParameterEnum) as unknown as z.ZodType<DatawarehouseParameterEnum>;
export const DatawarehouseParameterJsonSchema = enumSchema(DatawarehouseParameterEnum).describe("parameter used to configure the datawarehouse - Schema: { { k: dwMode, v: 10, Description: datawarehouseMode}, { k: dwPeriod, v: 20, Description: interval::intv}, { k: dwCurrentCommitId, v: 30, Description: the first used (full) - in incrementalmode this is moved when the incremental phase succeds}, { k: dwLastCommitId, v: 40, Description: in incrementalmode this was the last succesfull state}, { k: dwLastSuccess, v: 50, Description: isodatetime - time for last success}, { k: dwCreated, v: 60, Description: isodatetime}, { k: dwUpdated, v: 70, Description: isodatetime}, { k: dwDone, v: 80, Description: isodatetime}, { k: dwStatus, v: 90, Description: Text}, { k: dwSubStatus, v: 100, Description: Text}, { k: dwProgramVersion, v: 120, Description: Program Version}, { k: dwDatabaseVersion, v: 130, Description: Database Version}, { k: dwSourceDatabase, v: 140, Description: Source Database}, { k: dwCreator, v: 150, Description: Creator info}, { k: dwReadonly, v: 160, Description: Readonly}, { k: dwDashBoard, v: 170, Description: dashBoard used}, { k: dwFlagList, v: 180, Description: datawarehouseFlagList} }") as unknown as z.ZodType<DatawarehouseParameterEnum>;


/** paramter used to configure the datawarehouse */
export enum DatawarehouseProgressEnum {
/** datawarehouseMode */
	dwStart = 1,
/** table name and position in relative count */
	dwCurrentTable = 2,
/** phase for the table 1/1, 4/23, 7/108 */
	dwCurrentTablePhase = 3,
/** isodatetime */
	dwRowCount = 4,
/** Text */
	dwExpectedEnd = 5,
}

export const DatawarehouseProgressSchema = enumSchema(DatawarehouseProgressEnum) as unknown as z.ZodType<DatawarehouseProgressEnum>;
export const DatawarehouseProgressJsonSchema = enumSchema(DatawarehouseProgressEnum).describe("paramter used to configure the datawarehouse - Schema: { { k: dwStart, v: 1, Description: datawarehouseMode}, { k: dwCurrentTable, v: 2, Description: table name and position in relative count}, { k: dwCurrentTablePhase, v: 3, Description: phase for the table 1/1, 4/23, 7/108}, { k: dwRowCount, v: 4, Description: isodatetime}, { k: dwExpectedEnd, v: 5, Description: Text} }") as unknown as z.ZodType<DatawarehouseProgressEnum>;


/** The calendar day of week (absolute, culture independent). */
export enum DayOfWeekNameEnum {
	monday = 1,
	tuesday = 2,
	wednesday = 3,
	thursday = 4,
	friday = 5,
	saturday = 6,
	sunday = 7,
	holiday = 10,
}

export const DayOfWeekNameSchema = enumSchema(DayOfWeekNameEnum) as unknown as z.ZodType<DayOfWeekNameEnum>;
export const DayOfWeekNameJsonSchema = enumSchema(DayOfWeekNameEnum).describe("The calendar day of week (absolute, culture independent). - Schema: { { k: monday, v: 1, Description: <empty>}, { k: tuesday, v: 2, Description: <empty>}, { k: wednesday, v: 3, Description: <empty>}, { k: thursday, v: 4, Description: <empty>}, { k: friday, v: 5, Description: <empty>}, { k: saturday, v: 6, Description: <empty>}, { k: sunday, v: 7, Description: <empty>}, { k: holiday, v: 10, Description: <empty>} }") as unknown as z.ZodType<DayOfWeekNameEnum>;


/** default - On or OFf */
export enum DefaultOnOffEnum {
/** use the system default value */
	default = 2,
	on = 1,
	off = 0,
}

export const DefaultOnOffSchema = enumSchema(DefaultOnOffEnum) as unknown as z.ZodType<DefaultOnOffEnum>;
export const DefaultOnOffJsonSchema = enumSchema(DefaultOnOffEnum).describe("default - On or OFf - Schema: { { k: default, v: 2, Description: use the system default value}, { k: on, v: 1, Description: <empty>}, { k: off, v: 0, Description: <empty>} }") as unknown as z.ZodType<DefaultOnOffEnum>;


/** Types of messages sent to temps via MessagingService. The non-hidden types have a template oer unit edited via StaffPlan temps service dialog. */
export enum DeputyMessageTypeEnum {
/** No changes, nothing sent */
	deputyUnChanged = -2,
/** MessagingService internal value meaning type not yet computed, never saved. */
	deputyInternalUndefined = 0,
/** The shift assigned to you has a change. */
	deputyChangeAssigned = 1,
/** The shift has been assigned to you. */
	deputyAssign = 2,
/** The shift assigned to you has been cancelled. */
	deputyCancel = 3,
/** You have been planned to take shift. Please respond if you accept. */
	deputyPlan = 4,
/** Never saved. Instead, each submessage is saved with its individual message type. */
	deputySummary = 5,
/** Reject response to take planned shift: another has taken it, it was cancelled, other causes (expressed in msgsys.text). */
	deputyReject = 6,
/** Accept response to take planned shift (accepted, or you already has been assigned). */
	deputyAccept = 7,
/** A host of errors, mainly some error happened (such as appserver), and response not understood. */
	deputyError = 8,
/** Assigned to another; unused in code */
	deputyAssignedOther = 9,
/** Cancel of message that has not been sent, maybe because it was accepted from web; seemingly stored version of InternalIgnoreCancelPlanned. */
	deputyIgnoreCancelPlanned = 10,
/** Accepted via web (not sms); USED in code (NOT replaced by IgnoreCancelPlanned) */
	deputyWebAccept = 12,
/** The shift inquired (not yet assigned) for you has a change. */
	deputyChangePlanned = 13,
}

export const DeputyMessageTypeSchema = enumSchema(DeputyMessageTypeEnum) as unknown as z.ZodType<DeputyMessageTypeEnum>;
export const DeputyMessageTypeJsonSchema = enumSchema(DeputyMessageTypeEnum).describe("Types of messages sent to temps via MessagingService. The non-hidden types have a template oer unit edited via StaffPlan temps service dialog. - Schema: { { k: deputyUnChanged, v: -2, Description: No changes, nothing sent}, { k: deputyInternalUndefined, v: 0, Description: MessagingService internal value meaning type not yet computed, never saved.}, { k: deputyChangeAssigned, v: 1, Description: The shift assigned to you has a change.}, { k: deputyAssign, v: 2, Description: The shift has been assigned to you.}, { k: deputyCancel, v: 3, Description: The shift assigned to you has been cancelled.}, { k: deputyPlan, v: 4, Description: You have been planned to take shift. Please respond if you accept.}, { k: deputySummary, v: 5, Description: Never saved. Instead, each submessage is saved with its individual message type.}, { k: deputyReject, v: 6, Description: Reject response to take planned shift: another has taken it, it was cancelled, other causes (expressed in msgsys.text).}, { k: deputyAccept, v: 7, Description: Accept response to take planned shift (accepted, or you already has been assigned).}, { k: deputyError, v: 8, Description: A host of errors, mainly some error happened (such as appserver), and response not understood.}, { k: deputyAssignedOther, v: 9, Description: Assigned to another; unused in code}, { k: deputyIgnoreCancelPlanned, v: 10, Description: Cancel of message that has not been sent, maybe because it was accepted from web; seemingly stored version of InternalIgnoreCancelPlanned.}, { k: deputyWebAccept, v: 12, Description: Accepted via web (not sms); USED in code (NOT replaced by IgnoreCancelPlanned)}, { k: deputyChangePlanned, v: 13, Description: The shift inquired (not yet assigned) for you has a change.} }") as unknown as z.ZodType<DeputyMessageTypeEnum>;


/** statusType. */
export enum DeputyRegistrationStatusEnum {
/** Aflyst */
	cancelled = 3,
/** Forespurgt */
	inquired = 1,
/** Accepteret */
	accepted = 2,
}

export const DeputyRegistrationStatusSchema = enumSchema(DeputyRegistrationStatusEnum) as unknown as z.ZodType<DeputyRegistrationStatusEnum>;
export const DeputyRegistrationStatusJsonSchema = enumSchema(DeputyRegistrationStatusEnum).describe("statusType. - Schema: { { k: cancelled, v: 3, Description: Aflyst}, { k: inquired, v: 1, Description: Forespurgt}, { k: accepted, v: 2, Description: Accepteret} }") as unknown as z.ZodType<DeputyRegistrationStatusEnum>;


/** Why the deputyregistration was cancelled. Only used if status = cancelled */
export enum DeputyRegistrationStatusCauseEnum {
/** Not cancelled */
	undefined = -1,
/** Cancelled */
	cancelled = 1,
/** The deputyrequest was assigned another person */
	cancelledInquiry = 2,
/** The person rejected the deputyrequest */
	cancelledDeputy = 3,
/** The department cancelled the deputyrequest */
	cancelledRequester = 4,
/** The planner cancelled the deputyrequest after the person was assigned, possibly because the deputy did not show up */
	failedDeputy = 5,
}

export const DeputyRegistrationStatusCauseSchema = enumSchema(DeputyRegistrationStatusCauseEnum) as unknown as z.ZodType<DeputyRegistrationStatusCauseEnum>;
export const DeputyRegistrationStatusCauseJsonSchema = enumSchema(DeputyRegistrationStatusCauseEnum).describe("Why the deputyregistration was cancelled. Only used if status = cancelled - Schema: { { k: undefined, v: -1, Description: Not cancelled}, { k: cancelled, v: 1, Description: Cancelled}, { k: cancelledInquiry, v: 2, Description: The deputyrequest was assigned another person}, { k: cancelledDeputy, v: 3, Description: The person rejected the deputyrequest}, { k: cancelledRequester, v: 4, Description: The department cancelled the deputyrequest}, { k: failedDeputy, v: 5, Description: The planner cancelled the deputyrequest after the person was assigned, possibly because the deputy did not show up} }") as unknown as z.ZodType<DeputyRegistrationStatusCauseEnum>;


/** The additional states are for cases where all deputies turn down the request (reunassigned), the provider refuses to take the request (turnedDown), the requester no longer wants the request fulfilled (deleteRequest) */
export enum DeputyRequestStatusEnum {
/** The deputy request has been created by the requester, waiting for the provider, no deputies have been inquired */
	unassigned = 1,
/** All inquired deputies cancelled their deputy_reg's or the are no inquired deputies, but some deputies were previously inquired */
	reunassigned = 4,
/** Some deputies inquired */
	inprogress = 3,
/** Has been assigned. The deputy has a copy of the shift. The deputy, provider, and requester can still cancel the request */
	assigned = 2,
/** The provider does not want to handle the request, it is turnedDown */
	turnedDown = 5,
/** The requester has requested to cancel the request */
	deleteRequest = 6,
}

export const DeputyRequestStatusSchema = enumSchema(DeputyRequestStatusEnum) as unknown as z.ZodType<DeputyRequestStatusEnum>;
export const DeputyRequestStatusJsonSchema = enumSchema(DeputyRequestStatusEnum).describe("The additional states are for cases where all deputies turn down the request (reunassigned), the provider refuses to take the request (turnedDown), the requester no longer wants the request fulfilled (deleteRequest) - Schema: { { k: unassigned, v: 1, Description: The deputy request has been created by the requester, waiting for the provider, no deputies have been inquired}, { k: reunassigned, v: 4, Description: All inquired deputies cancelled their deputy_reg's or the are no inquired deputies, but some deputies were previously inquired}, { k: inprogress, v: 3, Description: Some deputies inquired}, { k: assigned, v: 2, Description: Has been assigned. The deputy has a copy of the shift. The deputy, provider, and requester can still cancel the request}, { k: turnedDown, v: 5, Description: The provider does not want to handle the request, it is turnedDown}, { k: deleteRequest, v: 6, Description: The requester has requested to cancel the request} }") as unknown as z.ZodType<DeputyRequestStatusEnum>;


/** requestType deputy is from deputy service; substitute is another person in my team */
export enum DeputyRequestTypeEnum {
	substitute = 0,
	deputy = 1,
}

export const DeputyRequestTypeSchema = enumSchema(DeputyRequestTypeEnum) as unknown as z.ZodType<DeputyRequestTypeEnum>;
export const DeputyRequestTypeJsonSchema = enumSchema(DeputyRequestTypeEnum).describe("requestType deputy is from deputy service; substitute is another person in my team - Schema: { { k: substitute, v: 0, Description: <empty>}, { k: deputy, v: 1, Description: <empty>} }") as unknown as z.ZodType<DeputyRequestTypeEnum>;


/** Possible values for orgunit_property.propertyid when propertytype=deputyService */
export enum DeputyServicePropertyIdEnum {
/** Deputy service functionality: propertycode : List<timeoffset>, when deputy_reg message summaries are sent out */
	summaryHours = 1,
/** Deputy service functionality: propertylong : integer Minutes. Deputy messages regarding deputy_regs within #acuteLimit minutes are sent immediately. As a special case, #acuteLimit=0 means no messages are sent immediately, they are only sent out according to #summaryHours */
	acuteLimit = 2,
}

export const DeputyServicePropertyIdSchema = enumSchema(DeputyServicePropertyIdEnum) as unknown as z.ZodType<DeputyServicePropertyIdEnum>;
export const DeputyServicePropertyIdJsonSchema = enumSchema(DeputyServicePropertyIdEnum).describe("Possible values for orgunit_property.propertyid when propertytype=deputyService - Schema: { { k: summaryHours, v: 1, Description: Deputy service functionality: propertycode : List<timeoffset>, when deputy_reg message summaries are sent out}, { k: acuteLimit, v: 2, Description: Deputy service functionality: propertylong : integer Minutes. Deputy messages regarding deputy_regs within #acuteLimit minutes are sent immediately. As a special case, #acuteLimit=0 means no messages are sent immediately, they are only sent out according to #summaryHours} }") as unknown as z.ZodType<DeputyServicePropertyIdEnum>;


/** used by myplan */
export enum DeputyStatusEnum {
/** Undefined      Undefined */
	undefined = -1,
/** Inquired       Unassigned, Inprogress, Reunassigned */
	inprogress = 1,
/** Accepted       Assigned */
	assigned = 2,
/** Cancelled      TurnedDown, DeleteRequest */
	cancelled = 3,
}

export const DeputyStatusSchema = enumSchema(DeputyStatusEnum) as unknown as z.ZodType<DeputyStatusEnum>;
export const DeputyStatusJsonSchema = enumSchema(DeputyStatusEnum).describe("used by myplan - Schema: { { k: undefined, v: -1, Description: Undefined      Undefined}, { k: inprogress, v: 1, Description: Inquired       Unassigned, Inprogress, Reunassigned}, { k: assigned, v: 2, Description: Accepted       Assigned}, { k: cancelled, v: 3, Description: Cancelled      TurnedDown, DeleteRequest} }") as unknown as z.ZodType<DeputyStatusEnum>;


/** Dimensions defined - some generic dimensions may be created for general use */
export enum DimensionEnumEnum {
/** the old payer dimension */
	payer = 1,
/** the old account dimension */
	account = 2,
/** the old project dimension */
	project = 3,
/** the first new dimension */
	tax = 4,
}

export const DimensionEnumSchema = enumSchema(DimensionEnumEnum) as unknown as z.ZodType<DimensionEnumEnum>;
export const DimensionEnumJsonSchema = enumSchema(DimensionEnumEnum).describe("Dimensions defined - some generic dimensions may be created for general use - Schema: { { k: payer, v: 1, Description: the old payer dimension}, { k: account, v: 2, Description: the old account dimension}, { k: project, v: 3, Description: the old project dimension}, { k: tax, v: 4, Description: the first new dimension} }") as unknown as z.ZodType<DimensionEnumEnum>;


/** How to use account on person */
export enum DimensionUsageEnum {
	never = 0,
	always = 1,
	possible = 2,
}

export const DimensionUsageSchema = enumSchema(DimensionUsageEnum) as unknown as z.ZodType<DimensionUsageEnum>;
export const DimensionUsageJsonSchema = enumSchema(DimensionUsageEnum).describe("How to use account on person - Schema: { { k: never, v: 0, Description: <empty>}, { k: always, v: 1, Description: <empty>}, { k: possible, v: 2, Description: <empty>} }") as unknown as z.ZodType<DimensionUsageEnum>;


/** When shiftcounter_def's are shown in the UI */
export enum DisplayCounterInShiftEnum {
/** shiftcounter_def is hidden in the UI */
	hideCounter = 0,
/** shiftcounter_def is show in the UI */
	showCounter = 1,
/** shiftcounter_def is shown in the StaffPlan UI, but hidden in MyPlan UI (reg4total) */
	hideCounterForEmpuser = 2,
}

export const DisplayCounterInShiftSchema = enumSchema(DisplayCounterInShiftEnum) as unknown as z.ZodType<DisplayCounterInShiftEnum>;
export const DisplayCounterInShiftJsonSchema = enumSchema(DisplayCounterInShiftEnum).describe("When shiftcounter_def's are shown in the UI - Schema: { { k: hideCounter, v: 0, Description: shiftcounter_def is hidden in the UI}, { k: showCounter, v: 1, Description: shiftcounter_def is show in the UI}, { k: hideCounterForEmpuser, v: 2, Description: shiftcounter_def is shown in the StaffPlan UI, but hidden in MyPlan UI (reg4total)} }") as unknown as z.ZodType<DisplayCounterInShiftEnum>;


/** properties on a disposition */
export enum DispositionStatusEnum {
	ok = 1,
	warning = 2,
	error = 3,
}

export const DispositionStatusSchema = enumSchema(DispositionStatusEnum) as unknown as z.ZodType<DispositionStatusEnum>;
export const DispositionStatusJsonSchema = enumSchema(DispositionStatusEnum).describe("properties on a disposition - Schema: { { k: ok, v: 1, Description: <empty>}, { k: warning, v: 2, Description: <empty>}, { k: error, v: 3, Description: <empty>} }") as unknown as z.ZodType<DispositionStatusEnum>;


/** Type of adjustment */
export enum DutyAdjustmentTypeEnum {
/** Erase adjustment */
	erase = 1,
/** Add adjustment */
	add = 2,
/** Availability Erase adjustment */
	avail_erase = 3,
/** Availability Add adjustment */
	avail_add = 4,
/** Shiftcounter Values adjustment due to recalculation */
	shiftValuesAdjust = 5,
/** Availability Shiftcounter Values adjustment due to recalculation */
	avail_shiftValuesAdjust = 6,
/** Allowance Erase adjustment */
	allowance_erase = 7,
/** Allowance Add adjustment */
	allowance_add = 8,
/** Allowance Shiftcounter Values adjustment due to recalculation */
	allowance_shiftValuesAdjust = 9,
}

export const DutyAdjustmentTypeSchema = enumSchema(DutyAdjustmentTypeEnum) as unknown as z.ZodType<DutyAdjustmentTypeEnum>;
export const DutyAdjustmentTypeJsonSchema = enumSchema(DutyAdjustmentTypeEnum).describe("Type of adjustment - Schema: { { k: erase, v: 1, Description: Erase adjustment}, { k: add, v: 2, Description: Add adjustment}, { k: avail_erase, v: 3, Description: Availability Erase adjustment}, { k: avail_add, v: 4, Description: Availability Add adjustment}, { k: shiftValuesAdjust, v: 5, Description: Shiftcounter Values adjustment due to recalculation}, { k: avail_shiftValuesAdjust, v: 6, Description: Availability Shiftcounter Values adjustment due to recalculation}, { k: allowance_erase, v: 7, Description: Allowance Erase adjustment}, { k: allowance_add, v: 8, Description: Allowance Add adjustment}, { k: allowance_shiftValuesAdjust, v: 9, Description: Allowance Shiftcounter Values adjustment due to recalculation} }") as unknown as z.ZodType<DutyAdjustmentTypeEnum>;


/** See also duty_calcSuplDuty (mapping from duty to calcSuplDuty) and prefix_postfix_for_duty (mapping from calcSuplDuty to prefix, postfix) */
export enum DutyTypeEnum {
/** dutyhp: START END SALARYSORT _ [PAYER] (prefixNone, prefixFullDayShift, prefixAvailableShift, prefixAvail). Normally uses prefixNone. Uses prefixAvail if calculationType = avail (availability_reg). Uses prefixAvailableShift if it's a call in that is shorter than 24 hours. Uses prefixFullDayShift if it's a call in that is 24 hours or longerand Start <> End. It's a call in if its preceded by an overlapping dutyline with lartgrp = datamodelTypes::avail. */
	timedDuty = 1,
/** dutysp: NUMBER _ SALARYSORT _ [PAYER] (prefixNumber / durationDuty), or _ NUMBER SALARYSORT _ [PAYER] (prefixUnsigned / integerDuty), or _ _ SALARYSORT _ [PAYER] _ _ NUMBER (prefixUnsigned / integerDuty) */
	allowanceDuty = 2,
/** dutyc: CC _ SALARYSORT (prefixNone) */
	clockcodeDuty = 3,
/** dutyep: _ _ SALARYSORT _ [PAYER] (prefixWithoutTime) */
	emptyDuty = 4,
/** dutysch: _ _ SALARYSORT [DAY] (prefixWithoutTime). DAY is stored in salarycode. SALARYSORT has lartgrp = datamodelTypes::shiftchange (24) */
	changeDuty = 5,
}

export const DutyTypeSchema = enumSchema(DutyTypeEnum) as unknown as z.ZodType<DutyTypeEnum>;
export const DutyTypeJsonSchema = enumSchema(DutyTypeEnum).describe("See also duty_calcSuplDuty (mapping from duty to calcSuplDuty) and prefix_postfix_for_duty (mapping from calcSuplDuty to prefix, postfix) - Schema: { { k: timedDuty, v: 1, Description: dutyhp: START END SALARYSORT _ [PAYER] (prefixNone, prefixFullDayShift, prefixAvailableShift, prefixAvail). Normally uses prefixNone. Uses prefixAvail if calculationType = avail (availability_reg). Uses prefixAvailableShift if it's a call in that is shorter than 24 hours. Uses prefixFullDayShift if it's a call in that is 24 hours or longerand Start <> End. It's a call in if its preceded by an overlapping dutyline with lartgrp = datamodelTypes::avail.}, { k: allowanceDuty, v: 2, Description: dutysp: NUMBER _ SALARYSORT _ [PAYER] (prefixNumber / durationDuty), or _ NUMBER SALARYSORT _ [PAYER] (prefixUnsigned / integerDuty), or _ _ SALARYSORT _ [PAYER] _ _ NUMBER (prefixUnsigned / integerDuty)}, { k: clockcodeDuty, v: 3, Description: dutyc: CC _ SALARYSORT (prefixNone)}, { k: emptyDuty, v: 4, Description: dutyep: _ _ SALARYSORT _ [PAYER] (prefixWithoutTime)}, { k: changeDuty, v: 5, Description: dutysch: _ _ SALARYSORT [DAY] (prefixWithoutTime). DAY is stored in salarycode. SALARYSORT has lartgrp = datamodelTypes::shiftchange (24)} }") as unknown as z.ZodType<DutyTypeEnum>;


/** dwShowUI */
export enum DwShowUIEnum {
	show = 1,
	hide = 2,
	showAndSyncronize = 3,
}

export const DwShowUISchema = enumSchema(DwShowUIEnum) as unknown as z.ZodType<DwShowUIEnum>;
export const DwShowUIJsonSchema = enumSchema(DwShowUIEnum).describe("dwShowUI - Schema: { { k: show, v: 1, Description: <empty>}, { k: hide, v: 2, Description: <empty>}, { k: showAndSyncronize, v: 3, Description: <empty>} }") as unknown as z.ZodType<DwShowUIEnum>;


/** used by myPlan */
export enum EmpPlanEnum {
	undefined = -1,
	plan = 1,
/** Registrations that can be recreated by the user */
	original = 2,
/** Registrations that cannot be merged automatically by the appserver */
	unmerged = 3,
/** Registrations that were rejected by the planner */
	rejected = 4,
/** Registrations (requests) that are in planperiod - prevent a change message in Frontend */
	request = 5,
}

export const EmpPlanSchema = enumSchema(EmpPlanEnum) as unknown as z.ZodType<EmpPlanEnum>;
export const EmpPlanJsonSchema = enumSchema(EmpPlanEnum).describe("used by myPlan - Schema: { { k: undefined, v: -1, Description: <empty>}, { k: plan, v: 1, Description: <empty>}, { k: original, v: 2, Description: Registrations that can be recreated by the user}, { k: unmerged, v: 3, Description: Registrations that cannot be merged automatically by the appserver}, { k: rejected, v: 4, Description: Registrations that were rejected by the planner}, { k: request, v: 5, Description: Registrations (requests) that are in planperiod - prevent a change message in Frontend} }") as unknown as z.ZodType<EmpPlanEnum>;


export enum EmpPlanRegGroupByTypeEnum {
/** shift_reg source */
	shiftEmpPlan = 1,
/** availability_reg source, either with or without some duty */
	availabilityEmpPlan = 11,
/** activity_reg source */
	activityEmpPlan = 21,
}

export const EmpPlanRegGroupByTypeSchema = enumSchema(EmpPlanRegGroupByTypeEnum) as unknown as z.ZodType<EmpPlanRegGroupByTypeEnum>;
export const EmpPlanRegGroupByTypeJsonSchema = enumSchema(EmpPlanRegGroupByTypeEnum).describe("Schema: { { k: shiftEmpPlan, v: 1, Description: shift_reg source}, { k: availabilityEmpPlan, v: 11, Description: availability_reg source, either with or without some duty}, { k: activityEmpPlan, v: 21, Description: activity_reg source} }") as unknown as z.ZodType<EmpPlanRegGroupByTypeEnum>;


/** Entitiy Source */
export enum EmpPlanRegTypeEnum {
/** shift_reg source */
	shiftEmpPlan = 1,
/** duty source */
	dutyEmpPlan = 6,
/** availability_reg source, either with or without some duty */
	availabilityEmpPlan = 11,
/** activity_reg source */
	activityEmpPlan = 21,
/** prd_assign_reg source */
	assignEmpPlan = 26,
}

export const EmpPlanRegTypeSchema = enumSchema(EmpPlanRegTypeEnum) as unknown as z.ZodType<EmpPlanRegTypeEnum>;
export const EmpPlanRegTypeJsonSchema = enumSchema(EmpPlanRegTypeEnum).describe("Entitiy Source - Schema: { { k: shiftEmpPlan, v: 1, Description: shift_reg source}, { k: dutyEmpPlan, v: 6, Description: duty source}, { k: availabilityEmpPlan, v: 11, Description: availability_reg source, either with or without some duty}, { k: activityEmpPlan, v: 21, Description: activity_reg source}, { k: assignEmpPlan, v: 26, Description: prd_assign_reg source} }") as unknown as z.ZodType<EmpPlanRegTypeEnum>;


/** Status of workdays */
export enum EmpPreferenceStatusEnum {
/** Employee has not explicitly defined any preferences for this day. Preference Pattern should be shown/used */
	noRegistrations = 0,
/** Employee has actively expressed preferences for this day...which may be nothing (=no registrations=empty day) */
	registered = 1,
}

export const EmpPreferenceStatusSchema = enumSchema(EmpPreferenceStatusEnum) as unknown as z.ZodType<EmpPreferenceStatusEnum>;
export const EmpPreferenceStatusJsonSchema = enumSchema(EmpPreferenceStatusEnum).describe("Status of workdays - Schema: { { k: noRegistrations, v: 0, Description: Employee has not explicitly defined any preferences for this day. Preference Pattern should be shown/used}, { k: registered, v: 1, Description: Employee has actively expressed preferences for this day...which may be nothing (=no registrations=empty day)} }") as unknown as z.ZodType<EmpPreferenceStatusEnum>;


/** Which field from person1 should be used for username on empuser */
export enum EmpUserNameFieldEnum {
/** Don't use a person1 field for empuser username. Either the empuser is not created automatically, or it is done by the person import. */
	nil = 0,
/** Use person1.cpr for empuser username */
	cpr = 1,
/** Use person1.salaryid for empuser username */
	salaryid = 2,
/** Use person1.email for empuser username */
	email = 3,
/** Use person1.global_personid for empuser username */
	global_personid = 4,
}

export const EmpUserNameFieldSchema = enumSchema(EmpUserNameFieldEnum) as unknown as z.ZodType<EmpUserNameFieldEnum>;
export const EmpUserNameFieldJsonSchema = enumSchema(EmpUserNameFieldEnum).describe("Which field from person1 should be used for username on empuser - Schema: { { k: nil, v: 0, Description: Don't use a person1 field for empuser username. Either the empuser is not created automatically, or it is done by the person import.}, { k: cpr, v: 1, Description: Use person1.cpr for empuser username}, { k: salaryid, v: 2, Description: Use person1.salaryid for empuser username}, { k: email, v: 3, Description: Use person1.email for empuser username}, { k: global_personid, v: 4, Description: Use person1.global_personid for empuser username} }") as unknown as z.ZodType<EmpUserNameFieldEnum>;


/** Status of workdays */
export enum EmpWorkdayStatusEnum {
/** Employee has nothing to say about this day. Masterplan should always be used. This status is equivalent to NO empWorkdayStatusReg record */
	noRegistrations = 0,
/** Employee has actively expressed something about this day...which may be nothing (=no registrations=empty day) */
	registered = 1,
/** Employee has either been granted or rejected day, but wants to re-negotiate day. If planner accepts this invitation then workday status returns to preApproved and employee can request/register again */
	reNegotiate = 2,
}

export const EmpWorkdayStatusSchema = enumSchema(EmpWorkdayStatusEnum) as unknown as z.ZodType<EmpWorkdayStatusEnum>;
export const EmpWorkdayStatusJsonSchema = enumSchema(EmpWorkdayStatusEnum).describe("Status of workdays - Schema: { { k: noRegistrations, v: 0, Description: Employee has nothing to say about this day. Masterplan should always be used. This status is equivalent to NO empWorkdayStatusReg record}, { k: registered, v: 1, Description: Employee has actively expressed something about this day...which may be nothing (=no registrations=empty day)}, { k: reNegotiate, v: 2, Description: Employee has either been granted or rejected day, but wants to re-negotiate day. If planner accepts this invitation then workday status returns to preApproved and employee can request/register again} }") as unknown as z.ZodType<EmpWorkdayStatusEnum>;


/** enumDoc */
export enum EnumDocEnum {
	d1 = 1,
	d2 = 2,
}

export const EnumDocSchema = enumSchema(EnumDocEnum) as unknown as z.ZodType<EnumDocEnum>;
export const EnumDocJsonSchema = enumSchema(EnumDocEnum).describe("enumDoc - Schema: { { k: d1, v: 1, Description: <empty>}, { k: d2, v: 2, Description: <empty>} }") as unknown as z.ZodType<EnumDocEnum>;


/** Phases in the erasejob cycle */
export enum EraseJobPhaseEnum {
/** start/default */
	ejpNoPhase = 0,
/** erase dates are computed */
	ejpLockEraseDates = 1,
/** check that all pdcdeleted is 0 and 1 */
	ejpCheckPDCDeleted = 5,
/** check intersection cards in person2 and person3 */
	ejpCheckPerson23 = 8,
/** Delete old pdcdeleted=1 rows */
	ejpPDCDeleted = 10,
/** delete records with no person1 card */
	ejpNonPerson1 = 15,
/** delete old timing entries */
	ejpTiming = 20,
/** rosters - done first */
	ejpRosterDef = 30,
/** filter by dateTime field - no eraseModuleKeepOne, no cascading data */
	ejpDateTime = 50,
/** delete records with no person1 card after deleting person1 */
	ejpNonPerson1Again = 55,
/** filter by dateTime field - eraseModuleKeepOne */
	ejpDateTimeKeepOne = 60,
/** filter by dateTime field - cascading data */
	ejpCascading = 70,
/** delete old unused orgunits */
	ejpComplex = 80,
/** The referenced uses does not exists */
	ejpNoUserReference = 90,
/** filter by dateTime field - delete data with no references left */
	ejpNoReferenceExDate = 100,
/** filter by boolean field - delete data with no references left */
	ejpNoReferenceBoolean = 110,
/** filter by enum field - delete data with no references left */
	ejpNoReferenceEnum = 115,
/** delete data with no references left */
	ejpNoReference = 120,
/** delete old log entries */
	ejpLog = 130,
/** hand pdcdeleted between 2 and 9 */
	ejpPDCDeleted2_9 = 135,
/** last phase - nothing is done */
	ejpDone = 140,
/** delete data marked for erase */
	ejpPurge = 145,
/** the restore job has been executed. */
	ejpAbort = 150,
}

export const EraseJobPhaseSchema = enumSchema(EraseJobPhaseEnum) as unknown as z.ZodType<EraseJobPhaseEnum>;
export const EraseJobPhaseJsonSchema = enumSchema(EraseJobPhaseEnum).describe("Phases in the erasejob cycle - Schema: { { k: ejpNoPhase, v: 0, Description: start/default}, { k: ejpLockEraseDates, v: 1, Description: erase dates are computed}, { k: ejpCheckPDCDeleted, v: 5, Description: check that all pdcdeleted is 0 and 1}, { k: ejpCheckPerson23, v: 8, Description: check intersection cards in person2 and person3}, { k: ejpPDCDeleted, v: 10, Description: Delete old pdcdeleted=1 rows}, { k: ejpNonPerson1, v: 15, Description: delete records with no person1 card}, { k: ejpTiming, v: 20, Description: delete old timing entries}, { k: ejpRosterDef, v: 30, Description: rosters - done first}, { k: ejpDateTime, v: 50, Description: filter by dateTime field - no eraseModuleKeepOne, no cascading data}, { k: ejpNonPerson1Again, v: 55, Description: delete records with no person1 card after deleting person1}, { k: ejpDateTimeKeepOne, v: 60, Description: filter by dateTime field - eraseModuleKeepOne}, { k: ejpCascading, v: 70, Description: filter by dateTime field - cascading data}, { k: ejpComplex, v: 80, Description: delete old unused orgunits}, { k: ejpNoUserReference, v: 90, Description: The referenced uses does not exists}, { k: ejpNoReferenceExDate, v: 100, Description: filter by dateTime field - delete data with no references left}, { k: ejpNoReferenceBoolean, v: 110, Description: filter by boolean field - delete data with no references left}, { k: ejpNoReferenceEnum, v: 115, Description: filter by enum field - delete data with no references left}, { k: ejpNoReference, v: 120, Description: delete data with no references left}, { k: ejpLog, v: 130, Description: delete old log entries}, { k: ejpPDCDeleted2_9, v: 135, Description: hand pdcdeleted between 2 and 9}, { k: ejpDone, v: 140, Description: last phase - nothing is done}, { k: ejpPurge, v: 145, Description: delete data marked for erase}, { k: ejpAbort, v: 150, Description: the restore job has been executed.} }") as unknown as z.ZodType<EraseJobPhaseEnum>;


/** erase Tidy */
export enum EraseOrTidyEnum {
/** Record are handled by erase */
	erase = 0,
/** Record are handled by tidy */
	tidy = 1,
}

export const EraseOrTidySchema = enumSchema(EraseOrTidyEnum) as unknown as z.ZodType<EraseOrTidyEnum>;
export const EraseOrTidyJsonSchema = enumSchema(EraseOrTidyEnum).describe("erase Tidy - Schema: { { k: erase, v: 0, Description: Record are handled by erase}, { k: tidy, v: 1, Description: Record are handled by tidy} }") as unknown as z.ZodType<EraseOrTidyEnum>;


/** Errors with codes and name */
export enum ErrorCodeEnum {
/** The record cannot be locked */
	unableToLock = 1000,
/** The person can not be identified by the information provided */
	personNotResolved = 20000,
/** ChangedAfter time is old than 24 hours */
	oldChangedAfterTime = 20001,
/** It is necessary to authenticate again */
	reauthenticationNeeded = 30000,
}

export const ErrorCodeSchema = enumSchema(ErrorCodeEnum) as unknown as z.ZodType<ErrorCodeEnum>;
export const ErrorCodeJsonSchema = enumSchema(ErrorCodeEnum).describe("Errors with codes and name - Schema: { { k: unableToLock, v: 1000, Description: The record cannot be locked}, { k: personNotResolved, v: 20000, Description: The person can not be identified by the information provided}, { k: oldChangedAfterTime, v: 20001, Description: ChangedAfter time is old than 24 hours}, { k: reauthenticationNeeded, v: 30000, Description: It is necessary to authenticate again} }") as unknown as z.ZodType<ErrorCodeEnum>;


/** Modules by errorcodes perspective */
export enum ErrorModuleEnum {
	core = 1,
	registration = 2,
	production = 3,
	consolidation = 4,
	salary = 5,
	login = 6,
	myPlan = 7,
	teamPlan = 8,
	functionPlan = 9,
	webService = 10,
}

export const ErrorModuleSchema = enumSchema(ErrorModuleEnum) as unknown as z.ZodType<ErrorModuleEnum>;
export const ErrorModuleJsonSchema = enumSchema(ErrorModuleEnum).describe("Modules by errorcodes perspective - Schema: { { k: core, v: 1, Description: <empty>}, { k: registration, v: 2, Description: <empty>}, { k: production, v: 3, Description: <empty>}, { k: consolidation, v: 4, Description: <empty>}, { k: salary, v: 5, Description: <empty>}, { k: login, v: 6, Description: <empty>}, { k: myPlan, v: 7, Description: <empty>}, { k: teamPlan, v: 8, Description: <empty>}, { k: functionPlan, v: 9, Description: <empty>}, { k: webService, v: 10, Description: <empty>} }") as unknown as z.ZodType<ErrorModuleEnum>;


/** onStart, onEnd */
export enum EventTypeEnum {
/** on start time */
	onStart = 1,
/** on end time */
	onEnd = 2,
/** is a transition point between start and end time events */
	onTransition = 3,
}

export const EventTypeSchema = enumSchema(EventTypeEnum) as unknown as z.ZodType<EventTypeEnum>;
export const EventTypeJsonSchema = enumSchema(EventTypeEnum).describe("onStart, onEnd - Schema: { { k: onStart, v: 1, Description: on start time}, { k: onEnd, v: 2, Description: on end time}, { k: onTransition, v: 3, Description: is a transition point between start and end time events} }") as unknown as z.ZodType<EventTypeEnum>;


/** Only used by myplan GetExchange_12 */
export enum ExchangeActionEnum {
	cancel = 0,
	reject = 1,
	accept = 2,
	take = 3,
	findSwaps = 6,
}

export const ExchangeActionSchema = enumSchema(ExchangeActionEnum) as unknown as z.ZodType<ExchangeActionEnum>;
export const ExchangeActionJsonSchema = enumSchema(ExchangeActionEnum).describe("Only used by myplan GetExchange_12 - Schema: { { k: cancel, v: 0, Description: <empty>}, { k: reject, v: 1, Description: <empty>}, { k: accept, v: 2, Description: <empty>}, { k: take, v: 3, Description: <empty>}, { k: findSwaps, v: 6, Description: <empty>} }") as unknown as z.ZodType<ExchangeActionEnum>;


/** Who has or why is it cancelled */
export enum ExchangeCancelledByEnum {
/** Exchange is not cancelled */
	notCancelled = 0,
/** Cancelled by Swapper */
	bySwapper = 1,
/** Cancelled by Requester */
	byRequester = 2,
/** Cancelled by Planner */
	byPlanner = 3,
/** This surgestion is cancelled due to other surgestion is accepted */
	byOther = 4,
/** Cancelled due to no Candidates */
	noCandidates = 5,
}

export const ExchangeCancelledBySchema = enumSchema(ExchangeCancelledByEnum) as unknown as z.ZodType<ExchangeCancelledByEnum>;
export const ExchangeCancelledByJsonSchema = enumSchema(ExchangeCancelledByEnum).describe("Who has or why is it cancelled - Schema: { { k: notCancelled, v: 0, Description: Exchange is not cancelled}, { k: bySwapper, v: 1, Description: Cancelled by Swapper}, { k: byRequester, v: 2, Description: Cancelled by Requester}, { k: byPlanner, v: 3, Description: Cancelled by Planner}, { k: byOther, v: 4, Description: This surgestion is cancelled due to other surgestion is accepted}, { k: noCandidates, v: 5, Description: Cancelled due to no Candidates} }") as unknown as z.ZodType<ExchangeCancelledByEnum>;


/** Which kinds of overlapping absence and shifts are permitted on exchange candidates. Used by swapCandidateFilter and handoverCandidateFilter */
export enum ExchangeCandidateFilterEnum {
/** No overlapping shifts, no overlapping availaiblity_reg's with present = 0 */
	classic = 1,
/** No overlapping work shifts, no overlapping availaiblity_reg's with present = 0 and unavailbilitydegree = 2 (noCallin). This is fairly similar to the sortedCallinList behavior */
	callinEsque = 2,
/** No overlapping no availaiblity_reg's with present = 0 and unavailbilitydegree = 2 (noCallin). */
	noCallin = 3,
}

export const ExchangeCandidateFilterSchema = enumSchema(ExchangeCandidateFilterEnum) as unknown as z.ZodType<ExchangeCandidateFilterEnum>;
export const ExchangeCandidateFilterJsonSchema = enumSchema(ExchangeCandidateFilterEnum).describe("Which kinds of overlapping absence and shifts are permitted on exchange candidates. Used by swapCandidateFilter and handoverCandidateFilter - Schema: { { k: classic, v: 1, Description: No overlapping shifts, no overlapping availaiblity_reg's with present = 0}, { k: callinEsque, v: 2, Description: No overlapping work shifts, no overlapping availaiblity_reg's with present = 0 and unavailbilitydegree = 2 (noCallin). This is fairly similar to the sortedCallinList behavior}, { k: noCallin, v: 3, Description: No overlapping no availaiblity_reg's with present = 0 and unavailbilitydegree = 2 (noCallin).} }") as unknown as z.ZodType<ExchangeCandidateFilterEnum>;


/** Only used by myPlan */
export enum ExchangeKindEnum {
/** Deputy exchanges */
	deputy = 4,
/** Swap exchanges */
	swap = 7,
/** Request exchanges ??? */
	request = 8,
}

export const ExchangeKindSchema = enumSchema(ExchangeKindEnum) as unknown as z.ZodType<ExchangeKindEnum>;
export const ExchangeKindJsonSchema = enumSchema(ExchangeKindEnum).describe("Only used by myPlan - Schema: { { k: deputy, v: 4, Description: Deputy exchanges}, { k: swap, v: 7, Description: Swap exchanges}, { k: request, v: 8, Description: Request exchanges ???} }") as unknown as z.ZodType<ExchangeKindEnum>;


/** shift/activity/task */
export enum ExchangePartEnumEnum {
/** shiftPart */
	shiftPart = 1,
/** requester */
	activityPart = 2,
/** taskPart */
	taskPart = 3,
}

export const ExchangePartEnumSchema = enumSchema(ExchangePartEnumEnum) as unknown as z.ZodType<ExchangePartEnumEnum>;
export const ExchangePartEnumJsonSchema = enumSchema(ExchangePartEnumEnum).describe("shift/activity/task - Schema: { { k: shiftPart, v: 1, Description: shiftPart}, { k: activityPart, v: 2, Description: requester}, { k: taskPart, v: 3, Description: taskPart} }") as unknown as z.ZodType<ExchangePartEnumEnum>;


/** Also used by myplan */
export enum ExchangeRoleEnum {
/** swapper */
	swapper = 1,
/** requester */
	requester = 2,
/** planner */
	planner = 3,
/** otherswapper */
	other = 4,
}

export const ExchangeRoleSchema = enumSchema(ExchangeRoleEnum) as unknown as z.ZodType<ExchangeRoleEnum>;
export const ExchangeRoleJsonSchema = enumSchema(ExchangeRoleEnum).describe("Also used by myplan - Schema: { { k: swapper, v: 1, Description: swapper}, { k: requester, v: 2, Description: requester}, { k: planner, v: 3, Description: planner}, { k: other, v: 4, Description: otherswapper} }") as unknown as z.ZodType<ExchangeRoleEnum>;


/** Also used by myplan */
export enum ExchangeStatusEnum {
/** This exchange can be accepted or cancelled */
	inProgress = 1,
/** Accepted */
	accepted = 2,
/** Cancelled */
	cancelled = 3,
/** The appserver idlelistener will create candidates for this exchange request. Can be cancelled by the planner */
	lookingForCandidates = 4,
/** This exchange request had status = LookingForCandidates, but the appserver found no candidates. Behaves like it is cancelled */
	noCandidates = 5,
}

export const ExchangeStatusSchema = enumSchema(ExchangeStatusEnum) as unknown as z.ZodType<ExchangeStatusEnum>;
export const ExchangeStatusJsonSchema = enumSchema(ExchangeStatusEnum).describe("Also used by myplan - Schema: { { k: inProgress, v: 1, Description: This exchange can be accepted or cancelled}, { k: accepted, v: 2, Description: Accepted}, { k: cancelled, v: 3, Description: Cancelled}, { k: lookingForCandidates, v: 4, Description: The appserver idlelistener will create candidates for this exchange request. Can be cancelled by the planner}, { k: noCandidates, v: 5, Description: This exchange request had status = LookingForCandidates, but the appserver found no candidates. Behaves like it is cancelled} }") as unknown as z.ZodType<ExchangeStatusEnum>;


/** Used by exchange_reg.statusUI in the Staff dialog, which combines the .status and .responsible fields */
export enum ExchangeStatusUIEnum {
/** status = inProgress and responsible = swapper */
	awaitsAnswers = 6,
/** status = inProgress and responsible = planner. Swappers can still apply */
	awaitsPlanner = 1,
/** status = inProgress and responsible = requester (or responsible = other, but that should never happen) */
	awaitsRequester = 7,
/** Accepted */
	accepted = 2,
/** Cancelled */
	cancelled = 3,
/** The appserver idlelistener will create candidates for this exchange request. Can be cancelled */
	lookingForCandidates = 4,
/** This exchange request had status = LookingForCandidates, but the appserver found no candidates. Behaves like it is cancelled */
	noCandidates = 5,
}

export const ExchangeStatusUISchema = enumSchema(ExchangeStatusUIEnum) as unknown as z.ZodType<ExchangeStatusUIEnum>;
export const ExchangeStatusUIJsonSchema = enumSchema(ExchangeStatusUIEnum).describe("Used by exchange_reg.statusUI in the Staff dialog, which combines the .status and .responsible fields - Schema: { { k: awaitsAnswers, v: 6, Description: status = inProgress and responsible = swapper}, { k: awaitsPlanner, v: 1, Description: status = inProgress and responsible = planner. Swappers can still apply}, { k: awaitsRequester, v: 7, Description: status = inProgress and responsible = requester (or responsible = other, but that should never happen)}, { k: accepted, v: 2, Description: Accepted}, { k: cancelled, v: 3, Description: Cancelled}, { k: lookingForCandidates, v: 4, Description: The appserver idlelistener will create candidates for this exchange request. Can be cancelled}, { k: noCandidates, v: 5, Description: This exchange request had status = LookingForCandidates, but the appserver found no candidates. Behaves like it is cancelled} }") as unknown as z.ZodType<ExchangeStatusUIEnum>;


/** udbyd/overtag/udbydBytte/bytte udbydBytte */
export enum ExchangeTypeEnum {
/** A swapper accepts a swapRequest: Accepting to get a shift in exchange for another shift. Paired with a swapRequest. */
	swapOffer = 1,
/** A requester or planner wants to exchange a shift. Initiates the swap. Paired with a swapOffer. */
	swapRequest = 2,
/** A requester or planner wants to give a shift away. Paired with a takeOffer. */
	handoverRequest = 3,
/** A swapper accepts a handoverRequest, dutyRequest, or copyRequest: Accepting to get a shift. */
	takeOffer = 4,
/** A planner wants to give away tasks. Resembles handoverRequest, but always initiated by a planner, and always regarding tasks. has personId = -1. Paired with a takeOffer. */
	dutyRequest = 5,
/** A planner wants to copy a shift, for instance because the requester is ill. Resembles handoverRequest, but the original shift is copied rather than moved, and the request is always initiated by a planner. Paired with a takeOffer. */
	copyRequest = 6,
/** A planner have desided that the illness-effected-shift need no futher handling. I.e. no one need to cover this shift. */
	handledOmitted = 7,
/** A planner has handled the swap through the call-in functionality. This is very much like the copyRequest, where the shift is copied. This request is always paired with a callinOffer. */
	callinInjunctionRequest = 8,
/** A planner has found someone to call-in as a match for the callinRequest. */
	callinInjunctionOffer = 9,
}

export const ExchangeTypeSchema = enumSchema(ExchangeTypeEnum) as unknown as z.ZodType<ExchangeTypeEnum>;
export const ExchangeTypeJsonSchema = enumSchema(ExchangeTypeEnum).describe("udbyd/overtag/udbydBytte/bytte udbydBytte - Schema: { { k: swapOffer, v: 1, Description: A swapper accepts a swapRequest: Accepting to get a shift in exchange for another shift. Paired with a swapRequest.}, { k: swapRequest, v: 2, Description: A requester or planner wants to exchange a shift. Initiates the swap. Paired with a swapOffer.}, { k: handoverRequest, v: 3, Description: A requester or planner wants to give a shift away. Paired with a takeOffer.}, { k: takeOffer, v: 4, Description: A swapper accepts a handoverRequest, dutyRequest, or copyRequest: Accepting to get a shift.}, { k: dutyRequest, v: 5, Description: A planner wants to give away tasks. Resembles handoverRequest, but always initiated by a planner, and always regarding tasks. has personId = -1. Paired with a takeOffer.}, { k: copyRequest, v: 6, Description: A planner wants to copy a shift, for instance because the requester is ill. Resembles handoverRequest, but the original shift is copied rather than moved, and the request is always initiated by a planner. Paired with a takeOffer.}, { k: handledOmitted, v: 7, Description: A planner have desided that the illness-effected-shift need no futher handling. I.e. no one need to cover this shift.}, { k: callinInjunctionRequest, v: 8, Description: A planner has handled the swap through the call-in functionality. This is very much like the copyRequest, where the shift is copied. This request is always paired with a callinOffer.}, { k: callinInjunctionOffer, v: 9, Description: A planner has found someone to call-in as a match for the callinRequest.} }") as unknown as z.ZodType<ExchangeTypeEnum>;


/** scope for export */
export enum ExporterScopeEnum {
	system = 1,
	storedlist = 2,
	allRoles = 3,
	currentRole = 4,
	allUsers = 5,
	currentUser = 6,
}

export const ExporterScopeSchema = enumSchema(ExporterScopeEnum) as unknown as z.ZodType<ExporterScopeEnum>;
export const ExporterScopeJsonSchema = enumSchema(ExporterScopeEnum).describe("scope for export - Schema: { { k: system, v: 1, Description: <empty>}, { k: storedlist, v: 2, Description: <empty>}, { k: allRoles, v: 3, Description: <empty>}, { k: currentRole, v: 4, Description: <empty>}, { k: allUsers, v: 5, Description: <empty>}, { k: currentUser, v: 6, Description: <empty>} }") as unknown as z.ZodType<ExporterScopeEnum>;


/** 2 norm periods option */
export enum ExtraNormPeriodEnum {
/** person2.effPeriodWithDefault */
	personal = 1,
/** Both person2.effPeriodWithDefault AND agreement.effNormAtDate */
	agreementAndPersonal = 2,
}

export const ExtraNormPeriodSchema = enumSchema(ExtraNormPeriodEnum) as unknown as z.ZodType<ExtraNormPeriodEnum>;
export const ExtraNormPeriodJsonSchema = enumSchema(ExtraNormPeriodEnum).describe("2 norm periods option - Schema: { { k: personal, v: 1, Description: person2.effPeriodWithDefault}, { k: agreementAndPersonal, v: 2, Description: Both person2.effPeriodWithDefault AND agreement.effNormAtDate} }") as unknown as z.ZodType<ExtraNormPeriodEnum>;


/** DATAWAREHOUSE */
export enum ExtraObjectTypeEnum {
/** procedure - the @sqlBody consist of the part after 'create procedure'  including parameter declaration */
	dboProcedure = 3,
/** the @sqlBody consist of the part after 'create type as' */
	dboType = 6,
/** the @sqlBody consist of the part after 'create view as' */
	dboView = 1,
/** the @sqlBody consist of the part after 'create table as' */
	dboTable = 2,
/** Seperate Database Index */
	dboIndex = 5,
/** Script block */
	dboScript = 7,
/** defines view AND table. The @sqlBody consist of the part after 'create view/table as', only the table is added to the DashBoard Entity Model */
	dboTableAndView = 8,
/** defines a synonym */
	dboSynonym = 9,
/** extra columns for a table. A view @sqlObjectName is created reference all fields from @sqlTableName and the extra fields. @sqlTableName is replaced with @sqlObjectName int the DashBoard Entity Model. The @sqlBody consist of the view fields */
	dboTableExtension = 10,
/** tableFunction - the @sqlBody consist of the part after 'create function' including parameter declaration */
	dboTableFunction = 11,
}

export const ExtraObjectTypeSchema = enumSchema(ExtraObjectTypeEnum) as unknown as z.ZodType<ExtraObjectTypeEnum>;
export const ExtraObjectTypeJsonSchema = enumSchema(ExtraObjectTypeEnum).describe("DATAWAREHOUSE - Schema: { { k: dboProcedure, v: 3, Description: procedure - the @sqlBody consist of the part after 'create procedure'  including parameter declaration}, { k: dboType, v: 6, Description: the @sqlBody consist of the part after 'create type as'}, { k: dboView, v: 1, Description: the @sqlBody consist of the part after 'create view as'}, { k: dboTable, v: 2, Description: the @sqlBody consist of the part after 'create table as'}, { k: dboIndex, v: 5, Description: Seperate Database Index}, { k: dboScript, v: 7, Description: Script block}, { k: dboTableAndView, v: 8, Description: defines view AND table. The @sqlBody consist of the part after 'create view/table as', only the table is added to the DashBoard Entity Model}, { k: dboSynonym, v: 9, Description: defines a synonym}, { k: dboTableExtension, v: 10, Description: extra columns for a table. A view @sqlObjectName is created reference all fields from @sqlTableName and the extra fields. @sqlTableName is replaced with @sqlObjectName int the DashBoard Entity Model. The @sqlBody consist of the view fields}, { k: dboTableFunction, v: 11, Description: tableFunction - the @sqlBody consist of the part after 'create function' including parameter declaration} }") as unknown as z.ZodType<ExtraObjectTypeEnum>;


/** UI-only! Factor types */
export enum FactortypeEnum {
/** Counter factortype */
	caf = 0,
/** List factortype */
	clf = 1,
/** Avail Counter factortype */
	ca = 2,
}

export const FactortypeSchema = enumSchema(FactortypeEnum) as unknown as z.ZodType<FactortypeEnum>;
export const FactortypeJsonSchema = enumSchema(FactortypeEnum).describe("UI-only! Factor types - Schema: { { k: caf, v: 0, Description: Counter factortype}, { k: clf, v: 1, Description: List factortype}, { k: ca, v: 2, Description: Avail Counter factortype} }") as unknown as z.ZodType<FactortypeEnum>;


/** Level for favorite groups */
export enum FavoriteLevelEnum {
/** Equivalent to no row in userFavoritePersonGroup. Group may still be accessible via access rights. */
	notFavorite = 0,
/** Data fetched and group on top of lists */
	favorite = 1,
/** As favorite, but TeamPlan users will get notifications also */
	favoriteWithNotification = 2,
}

export const FavoriteLevelSchema = enumSchema(FavoriteLevelEnum) as unknown as z.ZodType<FavoriteLevelEnum>;
export const FavoriteLevelJsonSchema = enumSchema(FavoriteLevelEnum).describe("Level for favorite groups - Schema: { { k: notFavorite, v: 0, Description: Equivalent to no row in userFavoritePersonGroup. Group may still be accessible via access rights.}, { k: favorite, v: 1, Description: Data fetched and group on top of lists}, { k: favoriteWithNotification, v: 2, Description: As favorite, but TeamPlan users will get notifications also} }") as unknown as z.ZodType<FavoriteLevelEnum>;


/** synthesized from followLevel */
export enum FavoriteStatusEnum {
/** Nothing registered. followLevel=notFollowing */
	nothing = 1,
/** Team shift is a favorite. followLevel in [following,followingWithNotifications] */
	favorite = 2,
}

export const FavoriteStatusSchema = enumSchema(FavoriteStatusEnum) as unknown as z.ZodType<FavoriteStatusEnum>;
export const FavoriteStatusJsonSchema = enumSchema(FavoriteStatusEnum).describe("synthesized from followLevel - Schema: { { k: nothing, v: 1, Description: Nothing registered. followLevel=notFollowing}, { k: favorite, v: 2, Description: Team shift is a favorite. followLevel in [following,followingWithNotifications]} }") as unknown as z.ZodType<FavoriteStatusEnum>;


/** Visible on days in FP and as Day messages in MP (cannot be replied to). */
export enum FctplanMsgScopeEnum {
/** Created by planner in FP via top level/general messages to the groups of the plan */
	functionPlanTop = 1,
/** Created in FP via days in the calendar. */
	functionPlanDate = 2,
}

export const FctplanMsgScopeSchema = enumSchema(FctplanMsgScopeEnum) as unknown as z.ZodType<FctplanMsgScopeEnum>;
export const FctplanMsgScopeJsonSchema = enumSchema(FctplanMsgScopeEnum).describe("Visible on days in FP and as Day messages in MP (cannot be replied to). - Schema: { { k: functionPlanTop, v: 1, Description: Created by planner in FP via top level/general messages to the groups of the plan}, { k: functionPlanDate, v: 2, Description: Created in FP via days in the calendar.} }") as unknown as z.ZodType<FctplanMsgScopeEnum>;


/** parameters for field compression of large data fields - highCompression is default */
export enum FieldCompressionEnum {
	noCompression = 1,
	lowCompression = 2,
/** windows8+ */
	highCompression = 3,
/** Compress by third party zLib */
	zlibCompression = 4,
}

export const FieldCompressionSchema = enumSchema(FieldCompressionEnum) as unknown as z.ZodType<FieldCompressionEnum>;
export const FieldCompressionJsonSchema = enumSchema(FieldCompressionEnum).describe("parameters for field compression of large data fields - highCompression is default - Schema: { { k: noCompression, v: 1, Description: <empty>}, { k: lowCompression, v: 2, Description: <empty>}, { k: highCompression, v: 3, Description: windows8+}, { k: zlibCompression, v: 4, Description: Compress by third party zLib} }") as unknown as z.ZodType<FieldCompressionEnum>;


/** match rule */
export enum FieldNameMatchEnum {
/** All of fieldNameList must be bound and no fields fieldNameList may be bound (except for pdcdeleted). */
	exact = 1,
/** All of fieldNameList must be bound / fieldNameList is a subset of the bound fields. */
	subset = 2,
/** no fieldNameList filter - all syncronization selects */
	syncMatch = 3,
}

export const FieldNameMatchSchema = enumSchema(FieldNameMatchEnum) as unknown as z.ZodType<FieldNameMatchEnum>;
export const FieldNameMatchJsonSchema = enumSchema(FieldNameMatchEnum).describe("match rule - Schema: { { k: exact, v: 1, Description: All of fieldNameList must be bound and no fields fieldNameList may be bound (except for pdcdeleted).}, { k: subset, v: 2, Description: All of fieldNameList must be bound / fieldNameList is a subset of the bound fields.}, { k: syncMatch, v: 3, Description: no fieldNameList filter - all syncronization selects} }") as unknown as z.ZodType<FieldNameMatchEnum>;


/** fieldTypes */
export enum FieldTypeEnum {
	databaseField = 1,
	virtualField = 2,
}

export const FieldTypeSchema = enumSchema(FieldTypeEnum) as unknown as z.ZodType<FieldTypeEnum>;
export const FieldTypeJsonSchema = enumSchema(FieldTypeEnum).describe("fieldTypes - Schema: { { k: databaseField, v: 1, Description: <empty>}, { k: virtualField, v: 2, Description: <empty>} }") as unknown as z.ZodType<FieldTypeEnum>;


/** file encoding type */
export enum FileEncodingTypeEnum {
/** UTF8 */
	utf8 = 0,
/** ASNI */
	ansi = 1,
}

export const FileEncodingTypeSchema = enumSchema(FileEncodingTypeEnum) as unknown as z.ZodType<FileEncodingTypeEnum>;
export const FileEncodingTypeJsonSchema = enumSchema(FileEncodingTypeEnum).describe("file encoding type - Schema: { { k: utf8, v: 0, Description: UTF8}, { k: ansi, v: 1, Description: ASNI} }") as unknown as z.ZodType<FileEncodingTypeEnum>;


/** foDayType */
export enum FoDayEnumEnum {
	save = 1,
	use = 2,
}

export const FoDayEnumSchema = enumSchema(FoDayEnumEnum) as unknown as z.ZodType<FoDayEnumEnum>;
export const FoDayEnumJsonSchema = enumSchema(FoDayEnumEnum).describe("foDayType - Schema: { { k: save, v: 1, Description: <empty>}, { k: use, v: 2, Description: <empty>} }") as unknown as z.ZodType<FoDayEnumEnum>;


/** where to store output */
export enum FolderTypeEnum {
/** userWorkingFolder */
	userWorkingFolder = 1,
/** global Folder */
	globalFolder = 2,
/** browse Folder */
	browseFolder = 3,
}

export const FolderTypeSchema = enumSchema(FolderTypeEnum) as unknown as z.ZodType<FolderTypeEnum>;
export const FolderTypeJsonSchema = enumSchema(FolderTypeEnum).describe("where to store output - Schema: { { k: userWorkingFolder, v: 1, Description: userWorkingFolder}, { k: globalFolder, v: 2, Description: global Folder}, { k: browseFolder, v: 3, Description: browse Folder} }") as unknown as z.ZodType<FolderTypeEnum>;


/** is the roster a function planning roster */
export enum FunctionPlanningTypeEnum {
/** An ordinary StaffPlan roster */
	standardRoster = 0,
/** An ordinary Functionplan roster */
	functionPlanRoster = 1,
/** A FunctionPlan places template */
	functionPlanTemplate = 2,
}

export const FunctionPlanningTypeSchema = enumSchema(FunctionPlanningTypeEnum) as unknown as z.ZodType<FunctionPlanningTypeEnum>;
export const FunctionPlanningTypeJsonSchema = enumSchema(FunctionPlanningTypeEnum).describe("is the roster a function planning roster - Schema: { { k: standardRoster, v: 0, Description: An ordinary StaffPlan roster}, { k: functionPlanRoster, v: 1, Description: An ordinary Functionplan roster}, { k: functionPlanTemplate, v: 2, Description: A FunctionPlan places template} }") as unknown as z.ZodType<FunctionPlanningTypeEnum>;


/** functionType */
export enum FunctionTypeEnum {
	activity = 1,
	availability = 2,
	shift = 3,
}

export const FunctionTypeSchema = enumSchema(FunctionTypeEnum) as unknown as z.ZodType<FunctionTypeEnum>;
export const FunctionTypeJsonSchema = enumSchema(FunctionTypeEnum).describe("functionType - Schema: { { k: activity, v: 1, Description: <empty>}, { k: availability, v: 2, Description: <empty>}, { k: shift, v: 3, Description: <empty>} }") as unknown as z.ZodType<FunctionTypeEnum>;


/** Which person types does exists */
export enum GdprPersonTypeEnum {
/** person1 user */
	employee = 1,
/** staffuser user */
	planner = 2,
/** auxPerson */
	auxPerson = 10,
}

export const GdprPersonTypeSchema = enumSchema(GdprPersonTypeEnum) as unknown as z.ZodType<GdprPersonTypeEnum>;
export const GdprPersonTypeJsonSchema = enumSchema(GdprPersonTypeEnum).describe("Which person types does exists - Schema: { { k: employee, v: 1, Description: person1 user}, { k: planner, v: 2, Description: staffuser user}, { k: auxPerson, v: 10, Description: auxPerson} }") as unknown as z.ZodType<GdprPersonTypeEnum>;


/** used by myPlan */
export enum GlobalPersonIdEnum {
	nil = 0,
/** person1.Cpr */
	cpr = 1,
/** person1.Global_PersonId */
	global_PersonId = 2,
}

export const GlobalPersonIdSchema = enumSchema(GlobalPersonIdEnum) as unknown as z.ZodType<GlobalPersonIdEnum>;
export const GlobalPersonIdJsonSchema = enumSchema(GlobalPersonIdEnum).describe("used by myPlan - Schema: { { k: nil, v: 0, Description: <empty>}, { k: cpr, v: 1, Description: person1.Cpr}, { k: global_PersonId, v: 2, Description: person1.Global_PersonId} }") as unknown as z.ZodType<GlobalPersonIdEnum>;


/** The domain of the setting storeHelpInDatabase */
export enum HelpInDatabaseEnum {
/** help is only stored in files, like Da_Silkl.txt */
	noHelpInDatabase = 0,
/** help is stored in files and in the tables customer_help and customer_command, with unitid=1 */
	globalHelpInDatabase = 1,
/** help is stored in files and in the tables customer_help and customer_command, with any unitid */
	hierarchicalHelpInDatabase = 2,
}

export const HelpInDatabaseSchema = enumSchema(HelpInDatabaseEnum) as unknown as z.ZodType<HelpInDatabaseEnum>;
export const HelpInDatabaseJsonSchema = enumSchema(HelpInDatabaseEnum).describe("The domain of the setting storeHelpInDatabase - Schema: { { k: noHelpInDatabase, v: 0, Description: help is only stored in files, like Da_Silkl.txt}, { k: globalHelpInDatabase, v: 1, Description: help is stored in files and in the tables customer_help and customer_command, with unitid=1}, { k: hierarchicalHelpInDatabase, v: 2, Description: help is stored in files and in the tables customer_help and customer_command, with any unitid} }") as unknown as z.ZodType<HelpInDatabaseEnum>;


/** type of inserted hint */
export enum HintTypeEnum {
/** named index hint index(<table> <table_index>) */
	idx = 1,
/** Currently only supported for sync and syncPart and always with cardinality = 2 and only on Oracle and only with syncMatch */
	cardinality = 2,
}

export const HintTypeSchema = enumSchema(HintTypeEnum) as unknown as z.ZodType<HintTypeEnum>;
export const HintTypeJsonSchema = enumSchema(HintTypeEnum).describe("type of inserted hint - Schema: { { k: idx, v: 1, Description: named index hint index(<table> <table_index>)}, { k: cardinality, v: 2, Description: Currently only supported for sync and syncPart and always with cardinality = 2 and only on Oracle and only with syncMatch} }") as unknown as z.ZodType<HintTypeEnum>;


/** CBJ ?????? */
export enum HolidaySaveTypeEnum {
/** CBJ ?????? */
	nil = 0,
/** Den nye ferielov 2020 */
	dk2020 = 1,
/** Den nye ferielov 2020 variant 2 dec. proportional oprunding i august */
	dk20202dec = 2,
/** Den nye ferielov 2020 variant 2 dec. kun oprunding i august hvis full ansættelse */
	dk20202decfull = 3,
}

export const HolidaySaveTypeSchema = enumSchema(HolidaySaveTypeEnum) as unknown as z.ZodType<HolidaySaveTypeEnum>;
export const HolidaySaveTypeJsonSchema = enumSchema(HolidaySaveTypeEnum).describe("CBJ ?????? - Schema: { { k: nil, v: 0, Description: CBJ ??????}, { k: dk2020, v: 1, Description: Den nye ferielov 2020}, { k: dk20202dec, v: 2, Description: Den nye ferielov 2020 variant 2 dec. proportional oprunding i august}, { k: dk20202decfull, v: 3, Description: Den nye ferielov 2020 variant 2 dec. kun oprunding i august hvis full ansættelse} }") as unknown as z.ZodType<HolidaySaveTypeEnum>;


/** only relevant for Oracle */
export enum IndexOrganizedTypeEnum {
/** ordinary or not Oracle */
	ordinary = 1,
/** index-organized table */
	iot = 2,
/** IOT_OVERFLOW */
	iotOverflow = 3,
/** IOT_MAPPING */
	iotMapping = 4,
}

export const IndexOrganizedTypeSchema = enumSchema(IndexOrganizedTypeEnum) as unknown as z.ZodType<IndexOrganizedTypeEnum>;
export const IndexOrganizedTypeJsonSchema = enumSchema(IndexOrganizedTypeEnum).describe("only relevant for Oracle - Schema: { { k: ordinary, v: 1, Description: ordinary or not Oracle}, { k: iot, v: 2, Description: index-organized table}, { k: iotOverflow, v: 3, Description: IOT_OVERFLOW}, { k: iotMapping, v: 4, Description: IOT_MAPPING} }") as unknown as z.ZodType<IndexOrganizedTypeEnum>;


/** What to do on days without any shifts */
export enum InsEmptyDaysEnum {
/** Do not do anything */
	nothing = 0,
/** Insert a shift containing an empty duty, during the salary process */
	mkEmptyDuty = 1,
/** Insert a shift containing a duty of norm length */
	mkNormDuty = 2,
}

export const InsEmptyDaysSchema = enumSchema(InsEmptyDaysEnum) as unknown as z.ZodType<InsEmptyDaysEnum>;
export const InsEmptyDaysJsonSchema = enumSchema(InsEmptyDaysEnum).describe("What to do on days without any shifts - Schema: { { k: nothing, v: 0, Description: Do not do anything}, { k: mkEmptyDuty, v: 1, Description: Insert a shift containing an empty duty, during the salary process}, { k: mkNormDuty, v: 2, Description: Insert a shift containing a duty of norm length} }") as unknown as z.ZodType<InsEmptyDaysEnum>;


/** used by myPlan */
export enum ItemTypeEnum {
/** The person is supposed to be at work */
	work = 1,
/** The person is absent */
	absence = 2,
/** Item is not related to working hours (so don't display in work plan) */
	other = 3,
/** Item is a role (activity, allowance, or transportation) */
	role = 4,
/** Item is a preference, either positive (want to work) or negative (wants absence) */
	preference = 5,
/** Item is an availability (employee may be set to work here) */
	task = 6,
/** The person is on call */
	onCall = 7,
/** For showing phoneGapCalendar events */
	calendarEvent = 8,
}

export const ItemTypeSchema = enumSchema(ItemTypeEnum) as unknown as z.ZodType<ItemTypeEnum>;
export const ItemTypeJsonSchema = enumSchema(ItemTypeEnum).describe("used by myPlan - Schema: { { k: work, v: 1, Description: The person is supposed to be at work}, { k: absence, v: 2, Description: The person is absent}, { k: other, v: 3, Description: Item is not related to working hours (so don't display in work plan)}, { k: role, v: 4, Description: Item is a role (activity, allowance, or transportation)}, { k: preference, v: 5, Description: Item is a preference, either positive (want to work) or negative (wants absence)}, { k: task, v: 6, Description: Item is an availability (employee may be set to work here)}, { k: onCall, v: 7, Description: The person is on call}, { k: calendarEvent, v: 8, Description: For showing phoneGapCalendar events} }") as unknown as z.ZodType<ItemTypeEnum>;


/** used by myPlan. Update also empWorkdayStatusEnum in legacy.ts */
export enum ItemWorkdayStatusEnum {
/** Means no emp-workday. Similar to no workdaystatus though emp may have registered and unregigistered only if workdaystatus is present. */
	noRegistrations = -1,
/** Registrations not processed - if invalid and not checkinNoConsol, the baseline will likely become the plan */
	unprocessed = 0,
/** Registrations approved by planner */
	approved = 1,
/** Registrations approved by auto-consolidation (appserver) */
	preapproved = 2,
/** Registrations rejected by planner */
	rejected = 3,
/** Processing of workday failed. Cause of problem stated in remark field of workdayStatus_reg */
	error = 4,
/** Planner has finally approved availability request. Not applicable to Checkin regs */
	vacationApproved = 5,
/** Planner has previously approved availability request, but has now compromised day-off with planned work. Not applicable to Checkin regs */
	vacationConflict = 6,
/** Planner has revoked a previously approved availability request, because work is required after all. Not applicable to Checkin regs */
	vacationRevoked = 7,
/** No emp-workday, but workdaystatus and invalid. Means emp has registered, but cancelled afterwards. */
	unprocessedUnregistered = 101,
/** Emp-workday, presence of invalidation and workday unknown, used in select of Iwebworkday */
	empRegistered = 102,
/** Status must not be displayed */
	hidden = 208,
/** Roster item status not set (status is unknown or irrelevant) */
	unset = 209,
}

export const ItemWorkdayStatusSchema = enumSchema(ItemWorkdayStatusEnum) as unknown as z.ZodType<ItemWorkdayStatusEnum>;
export const ItemWorkdayStatusJsonSchema = enumSchema(ItemWorkdayStatusEnum).describe("used by myPlan. Update also empWorkdayStatusEnum in legacy.ts - Schema: { { k: noRegistrations, v: -1, Description: Means no emp-workday. Similar to no workdaystatus though emp may have registered and unregigistered only if workdaystatus is present.}, { k: unprocessed, v: 0, Description: Registrations not processed - if invalid and not checkinNoConsol, the baseline will likely become the plan}, { k: approved, v: 1, Description: Registrations approved by planner}, { k: preapproved, v: 2, Description: Registrations approved by auto-consolidation (appserver)}, { k: rejected, v: 3, Description: Registrations rejected by planner}, { k: error, v: 4, Description: Processing of workday failed. Cause of problem stated in remark field of workdayStatus_reg}, { k: vacationApproved, v: 5, Description: Planner has finally approved availability request. Not applicable to Checkin regs}, { k: vacationConflict, v: 6, Description: Planner has previously approved availability request, but has now compromised day-off with planned work. Not applicable to Checkin regs}, { k: vacationRevoked, v: 7, Description: Planner has revoked a previously approved availability request, because work is required after all. Not applicable to Checkin regs}, { k: unprocessedUnregistered, v: 101, Description: No emp-workday, but workdaystatus and invalid. Means emp has registered, but cancelled afterwards.}, { k: empRegistered, v: 102, Description: Emp-workday, presence of invalidation and workday unknown, used in select of Iwebworkday}, { k: hidden, v: 208, Description: Status must not be displayed}, { k: unset, v: 209, Description: Roster item status not set (status is unknown or irrelevant)} }") as unknown as z.ZodType<ItemWorkdayStatusEnum>;


/** How sampling resolution (5min) slots should be combined to achieve output resolution slots. */
export enum KfCompositionOpEnum {
/** Average of sub slots is KF Value of output slot */
	kfCompositionOp_average = 0,
/** Minimum of sub slots is KF Value of output slot */
	kfCompositionOp_min = 1,
/** Maximum of sub slots is KF Value of output slot */
	kfCompositionOp_max = 2,
}

export const KfCompositionOpSchema = enumSchema(KfCompositionOpEnum) as unknown as z.ZodType<KfCompositionOpEnum>;
export const KfCompositionOpJsonSchema = enumSchema(KfCompositionOpEnum).describe("How sampling resolution (5min) slots should be combined to achieve output resolution slots. - Schema: { { k: kfCompositionOp_average, v: 0, Description: Average of sub slots is KF Value of output slot}, { k: kfCompositionOp_min, v: 1, Description: Minimum of sub slots is KF Value of output slot}, { k: kfCompositionOp_max, v: 2, Description: Maximum of sub slots is KF Value of output slot} }") as unknown as z.ZodType<KfCompositionOpEnum>;


/** Keyfigure type enumeration. Defines semantics of KF */
export enum KfTypeEnum {
/** Type is unspecified and KF uncharacterized. No system semantics can be associated with KFs of this type */
	kfType_unspecified = 0,
/** KF semantics resembles that of CAPACITY numbers, e.g available emp hours or total working trucks */
	kfType_capacity = 1,
/** KF semantics resembles that of DEMAND numbers, e.g demanded emp hours or total trucks demanded */
	kfType_demand = 2,
/** KF semantics resembles that of CAPACITY-DEMAND numbers, e.g balance of emp hours or trucks */
	kfType_difference = 3,
}

export const KfTypeSchema = enumSchema(KfTypeEnum) as unknown as z.ZodType<KfTypeEnum>;
export const KfTypeJsonSchema = enumSchema(KfTypeEnum).describe("Keyfigure type enumeration. Defines semantics of KF - Schema: { { k: kfType_unspecified, v: 0, Description: Type is unspecified and KF uncharacterized. No system semantics can be associated with KFs of this type}, { k: kfType_capacity, v: 1, Description: KF semantics resembles that of CAPACITY numbers, e.g available emp hours or total working trucks}, { k: kfType_demand, v: 2, Description: KF semantics resembles that of DEMAND numbers, e.g demanded emp hours or total trucks demanded}, { k: kfType_difference, v: 3, Description: KF semantics resembles that of CAPACITY-DEMAND numbers, e.g balance of emp hours or trucks} }") as unknown as z.ZodType<KfTypeEnum>;


/** KPI formulas may operate on different sources and produce various results */
export enum KpiFormulaTypeEnum {
/** Measure Formula based on datasource record. */
	measure = 1,
/** Dimension Formula based on datasource record. */
	dimension = 2,
/** Measure Formula based on aggregated KPIcube node */
	aggregate = 3,
}

export const KpiFormulaTypeSchema = enumSchema(KpiFormulaTypeEnum) as unknown as z.ZodType<KpiFormulaTypeEnum>;
export const KpiFormulaTypeJsonSchema = enumSchema(KpiFormulaTypeEnum).describe("KPI formulas may operate on different sources and produce various results - Schema: { { k: measure, v: 1, Description: Measure Formula based on datasource record.}, { k: dimension, v: 2, Description: Dimension Formula based on datasource record.}, { k: aggregate, v: 3, Description: Measure Formula based on aggregated KPIcube node} }") as unknown as z.ZodType<KpiFormulaTypeEnum>;


/** KPI measure aggreation method */
export enum KpiMeasureAggMethodEnum {
	sum = 1,
	countOnce = 2,
	count = 3,
	countN = 4,
}

export const KpiMeasureAggMethodSchema = enumSchema(KpiMeasureAggMethodEnum) as unknown as z.ZodType<KpiMeasureAggMethodEnum>;
export const KpiMeasureAggMethodJsonSchema = enumSchema(KpiMeasureAggMethodEnum).describe("KPI measure aggreation method - Schema: { { k: sum, v: 1, Description: <empty>}, { k: countOnce, v: 2, Description: <empty>}, { k: count, v: 3, Description: <empty>}, { k: countN, v: 4, Description: <empty>} }") as unknown as z.ZodType<KpiMeasureAggMethodEnum>;


/** KPI measure aggregation only include slots of this type */
export enum KpiMeasureAggSlotTypeEnum {
	all = 1,
	first = 2,
	last = 3,
}

export const KpiMeasureAggSlotTypeSchema = enumSchema(KpiMeasureAggSlotTypeEnum) as unknown as z.ZodType<KpiMeasureAggSlotTypeEnum>;
export const KpiMeasureAggSlotTypeJsonSchema = enumSchema(KpiMeasureAggSlotTypeEnum).describe("KPI measure aggregation only include slots of this type - Schema: { { k: all, v: 1, Description: <empty>}, { k: first, v: 2, Description: <empty>}, { k: last, v: 3, Description: <empty>} }") as unknown as z.ZodType<KpiMeasureAggSlotTypeEnum>;


/** An enum over tables supporting RegChanges */
export enum KpiRegChangeTableEnum {
	kpiReg_Shift = 0,
	kpiReg_Avail = 1,
	kpiReg_Activity = 2,
	kpiReg_Assignment = 3,
}

export const KpiRegChangeTableSchema = enumSchema(KpiRegChangeTableEnum) as unknown as z.ZodType<KpiRegChangeTableEnum>;
export const KpiRegChangeTableJsonSchema = enumSchema(KpiRegChangeTableEnum).describe("An enum over tables supporting RegChanges - Schema: { { k: kpiReg_Shift, v: 0, Description: <empty>}, { k: kpiReg_Avail, v: 1, Description: <empty>}, { k: kpiReg_Activity, v: 2, Description: <empty>}, { k: kpiReg_Assignment, v: 3, Description: <empty>} }") as unknown as z.ZodType<KpiRegChangeTableEnum>;


/** Type of timeOff: request or preference */
export enum KpiTimeOffTypeEnum {
	request = 1,
	preference = 2,
}

export const KpiTimeOffTypeSchema = enumSchema(KpiTimeOffTypeEnum) as unknown as z.ZodType<KpiTimeOffTypeEnum>;
export const KpiTimeOffTypeJsonSchema = enumSchema(KpiTimeOffTypeEnum).describe("Type of timeOff: request or preference - Schema: { { k: request, v: 1, Description: <empty>}, { k: preference, v: 2, Description: <empty>} }") as unknown as z.ZodType<KpiTimeOffTypeEnum>;


/** generated from the language files */
export enum LangCustomerEnum {
/** Numbers may NOT be used for serializing. */
	noCustomer = 0,
/** Numbers may NOT be used for serializing. */
	airTransat = 16465,
/** Numbers may NOT be used for serializing. */
	appTest = 21011,
/** Numbers may NOT be used for serializing. */
	argo = 18649,
/** Numbers may NOT be used for serializing. */
	coopDK = 4244,
/** Numbers may NOT be used for serializing. */
	coopSE = 4703,
/** Numbers may NOT be used for serializing. */
	danPilot = 9671,
/** Numbers may NOT be used for serializing. */
	danskeDiakonhjem = 25748,
/** Numbers may NOT be used for serializing. */
	dsb = 2451,
/** Numbers may NOT be used for serializing. */
	euroMaint = 24302,
/** Numbers may NOT be used for serializing. */
	falckES = 17799,
/** Numbers may NOT be used for serializing. */
	falckSE = 18219,
/** Numbers may NOT be used for serializing. */
	finavia = 31352,
/** Numbers may NOT be used for serializing. */
	flugger = 10844,
/** Numbers may NOT be used for serializing. */
	gjaldstovan = 11115,
/** Numbers may NOT be used for serializing. */
	kriminalforsorgen = 18152,
/** Numbers may NOT be used for serializing. */
	lindex = 32742,
/** Numbers may NOT be used for serializing. */
	mariehjem = 14084,
/** Numbers may NOT be used for serializing. */
	molslinjen = 26187,
/** Numbers may NOT be used for serializing. */
	osloKommune = 13313,
/** Numbers may NOT be used for serializing. */
	pdc = 13519,
/** Numbers may NOT be used for serializing. */
	peqqik = 4791,
/** Numbers may NOT be used for serializing. */
	pht = 13660,
/** Numbers may NOT be used for serializing. */
	postenNO = 19658,
/** Numbers may NOT be used for serializing. */
	regionHovedstaden = 6407,
/** Numbers may NOT be used for serializing. */
	regionMidt = 7200,
/** Numbers may NOT be used for serializing. */
	silk = 22101,
/** Numbers may NOT be used for serializing. */
	stElizabeth = 25439,
/** Numbers may NOT be used for serializing. */
	strategicAviation = 28129,
/** Numbers may NOT be used for serializing. */
	test = 15506,
/** Numbers may NOT be used for serializing. */
	toldstyrelsen = 7528,
/** Numbers may NOT be used for serializing. */
	tv2 = 17904,
/** Numbers may NOT be used for serializing. */
	tV2Kosmopol = 12588,
}

export const LangCustomerSchema = enumSchema(LangCustomerEnum) as unknown as z.ZodType<LangCustomerEnum>;
export const LangCustomerJsonSchema = enumSchema(LangCustomerEnum).describe("generated from the language files - Schema: { { k: noCustomer, v: 0, Description: Numbers may NOT be used for serializing.}, { k: airTransat, v: 16465, Description: Numbers may NOT be used for serializing.}, { k: appTest, v: 21011, Description: Numbers may NOT be used for serializing.}, { k: argo, v: 18649, Description: Numbers may NOT be used for serializing.}, { k: coopDK, v: 4244, Description: Numbers may NOT be used for serializing.}, { k: coopSE, v: 4703, Description: Numbers may NOT be used for serializing.}, { k: danPilot, v: 9671, Description: Numbers may NOT be used for serializing.}, { k: danskeDiakonhjem, v: 25748, Description: Numbers may NOT be used for serializing.}, { k: dsb, v: 2451, Description: Numbers may NOT be used for serializing.}, { k: euroMaint, v: 24302, Description: Numbers may NOT be used for serializing.}, { k: falckES, v: 17799, Description: Numbers may NOT be used for serializing.}, { k: falckSE, v: 18219, Description: Numbers may NOT be used for serializing.}, { k: finavia, v: 31352, Description: Numbers may NOT be used for serializing.}, { k: flugger, v: 10844, Description: Numbers may NOT be used for serializing.}, { k: gjaldstovan, v: 11115, Description: Numbers may NOT be used for serializing.}, { k: kriminalforsorgen, v: 18152, Description: Numbers may NOT be used for serializing.}, { k: lindex, v: 32742, Description: Numbers may NOT be used for serializing.}, { k: mariehjem, v: 14084, Description: Numbers may NOT be used for serializing.}, { k: molslinjen, v: 26187, Description: Numbers may NOT be used for serializing.}, { k: osloKommune, v: 13313, Description: Numbers may NOT be used for serializing.}, { k: pdc, v: 13519, Description: Numbers may NOT be used for serializing.}, { k: peqqik, v: 4791, Description: Numbers may NOT be used for serializing.}, { k: pht, v: 13660, Description: Numbers may NOT be used for serializing.}, { k: postenNO, v: 19658, Description: Numbers may NOT be used for serializing.}, { k: regionHovedstaden, v: 6407, Description: Numbers may NOT be used for serializing.}, { k: regionMidt, v: 7200, Description: Numbers may NOT be used for serializing.}, { k: silk, v: 22101, Description: Numbers may NOT be used for serializing.}, { k: stElizabeth, v: 25439, Description: Numbers may NOT be used for serializing.}, { k: strategicAviation, v: 28129, Description: Numbers may NOT be used for serializing.}, { k: test, v: 15506, Description: Numbers may NOT be used for serializing.}, { k: toldstyrelsen, v: 7528, Description: Numbers may NOT be used for serializing.}, { k: tv2, v: 17904, Description: Numbers may NOT be used for serializing.}, { k: tV2Kosmopol, v: 12588, Description: Numbers may NOT be used for serializing.} }") as unknown as z.ZodType<LangCustomerEnum>;


/** generated from the language files */
export enum LangLanguageEnum {
/** Numbers may NOT be used for serializing. */
	ar = 17,
/** Numbers may NOT be used for serializing. */
	da = 90,
/** Numbers may NOT be used for serializing. */
	de = 94,
/** Numbers may NOT be used for serializing. */
	en = 133,
/** Numbers may NOT be used for serializing. */
	es = 138,
/** Numbers may NOT be used for serializing. */
	fo = 164,
/** Numbers may NOT be used for serializing. */
	fr = 167,
/** Numbers may NOT be used for serializing. */
	no = 404,
/** Numbers may NOT be used for serializing. */
	pl = 461,
/** Numbers may NOT be used for serializing. */
	ru = 530,
/** Numbers may NOT be used for serializing. */
	se = 544,
}

export const LangLanguageSchema = enumSchema(LangLanguageEnum) as unknown as z.ZodType<LangLanguageEnum>;
export const LangLanguageJsonSchema = enumSchema(LangLanguageEnum).describe("generated from the language files - Schema: { { k: ar, v: 17, Description: Numbers may NOT be used for serializing.}, { k: da, v: 90, Description: Numbers may NOT be used for serializing.}, { k: de, v: 94, Description: Numbers may NOT be used for serializing.}, { k: en, v: 133, Description: Numbers may NOT be used for serializing.}, { k: es, v: 138, Description: Numbers may NOT be used for serializing.}, { k: fo, v: 164, Description: Numbers may NOT be used for serializing.}, { k: fr, v: 167, Description: Numbers may NOT be used for serializing.}, { k: no, v: 404, Description: Numbers may NOT be used for serializing.}, { k: pl, v: 461, Description: Numbers may NOT be used for serializing.}, { k: ru, v: 530, Description: Numbers may NOT be used for serializing.}, { k: se, v: 544, Description: Numbers may NOT be used for serializing.} }") as unknown as z.ZodType<LangLanguageEnum>;


/** generated from the language files */
export enum LangSolutionEnum {
/** Numbers may NOT be used for serializing. */
	noSolution = 0,
/** Numbers may NOT be used for serializing. */
	airport = 26795,
/** Numbers may NOT be used for serializing. */
	health = 30300,
/** Numbers may NOT be used for serializing. */
	industry = 12766,
/** Numbers may NOT be used for serializing. */
	media = 30660,
/** Numbers may NOT be used for serializing. */
	rescue = 31123,
/** Numbers may NOT be used for serializing. */
	retail = 25859,
/** Numbers may NOT be used for serializing. */
	test = 15506,
}

export const LangSolutionSchema = enumSchema(LangSolutionEnum) as unknown as z.ZodType<LangSolutionEnum>;
export const LangSolutionJsonSchema = enumSchema(LangSolutionEnum).describe("generated from the language files - Schema: { { k: noSolution, v: 0, Description: Numbers may NOT be used for serializing.}, { k: airport, v: 26795, Description: Numbers may NOT be used for serializing.}, { k: health, v: 30300, Description: Numbers may NOT be used for serializing.}, { k: industry, v: 12766, Description: Numbers may NOT be used for serializing.}, { k: media, v: 30660, Description: Numbers may NOT be used for serializing.}, { k: rescue, v: 31123, Description: Numbers may NOT be used for serializing.}, { k: retail, v: 25859, Description: Numbers may NOT be used for serializing.}, { k: test, v: 15506, Description: Numbers may NOT be used for serializing.} }") as unknown as z.ZodType<LangSolutionEnum>;


/** Fraværsgrader */
export enum LegitimationEnum {
	undecided = 0,
	legitimate = 1,
/** not legitimate if in use (see shifttype) */
	notLegitimate = 2,
}

export const LegitimationSchema = enumSchema(LegitimationEnum) as unknown as z.ZodType<LegitimationEnum>;
export const LegitimationJsonSchema = enumSchema(LegitimationEnum).describe("Fraværsgrader - Schema: { { k: undecided, v: 0, Description: <empty>}, { k: legitimate, v: 1, Description: <empty>}, { k: notLegitimate, v: 2, Description: not legitimate if in use (see shifttype)} }") as unknown as z.ZodType<LegitimationEnum>;


/** ep_Def/dump.pro license_nd() hjælpetekst help(["license"], */
export enum LicenseEnum {
	license_staff = 1,
	license_web = 3,
	license_capacity = 4,
	license_substitute = 6,
	license_checkIn = 7,
	license_activity_shift_link = 8,
	license_batchserver = 9,
	license_external_password = 10,
	license_automatic_planning = 11,
	license_demand_calculation = 13,
	license_keyfigures = 14,
	license_all_staffTest7Only = 16,
}

export const LicenseSchema = enumSchema(LicenseEnum) as unknown as z.ZodType<LicenseEnum>;
export const LicenseJsonSchema = enumSchema(LicenseEnum).describe("ep_Def/dump.pro license_nd() hjælpetekst help([\"license\"], - Schema: { { k: license_staff, v: 1, Description: <empty>}, { k: license_web, v: 3, Description: <empty>}, { k: license_capacity, v: 4, Description: <empty>}, { k: license_substitute, v: 6, Description: <empty>}, { k: license_checkIn, v: 7, Description: <empty>}, { k: license_activity_shift_link, v: 8, Description: <empty>}, { k: license_batchserver, v: 9, Description: <empty>}, { k: license_external_password, v: 10, Description: <empty>}, { k: license_automatic_planning, v: 11, Description: <empty>}, { k: license_demand_calculation, v: 13, Description: <empty>}, { k: license_keyfigures, v: 14, Description: <empty>}, { k: license_all_staffTest7Only, v: 16, Description: <empty>} }") as unknown as z.ZodType<LicenseEnum>;


/** Do we limit the send availability within the send interval */
export enum LimitTransmitIntvOfAvailabilityEnum {
/** Transmit the full interval */
	sendFull = 0,
/** Truncate absences as if they end after end of transmit interval */
	truncate = 1,
/** Inherit the limitation. */
	inherit = 2,
/** Transmit avails as full, exept the open, which are truncated by end af transmit interval */
	truncateWhenOpen = 3,
/** Absence ending after processed end are sent as open */
	sendAsOpenOnLaterEnd = 4,
}

export const LimitTransmitIntvOfAvailabilitySchema = enumSchema(LimitTransmitIntvOfAvailabilityEnum) as unknown as z.ZodType<LimitTransmitIntvOfAvailabilityEnum>;
export const LimitTransmitIntvOfAvailabilityJsonSchema = enumSchema(LimitTransmitIntvOfAvailabilityEnum).describe("Do we limit the send availability within the send interval - Schema: { { k: sendFull, v: 0, Description: Transmit the full interval}, { k: truncate, v: 1, Description: Truncate absences as if they end after end of transmit interval}, { k: inherit, v: 2, Description: Inherit the limitation.}, { k: truncateWhenOpen, v: 3, Description: Transmit avails as full, exept the open, which are truncated by end af transmit interval}, { k: sendAsOpenOnLaterEnd, v: 4, Description: Absence ending after processed end are sent as open} }") as unknown as z.ZodType<LimitTransmitIntvOfAvailabilityEnum>;


/** Status for batchload.result / whether any warnings or errors occurred */
export enum LoadResultEnum {
	nil = 0,
	ok = 1,
	warning = 2,
	error = 3,
}

export const LoadResultSchema = enumSchema(LoadResultEnum) as unknown as z.ZodType<LoadResultEnum>;
export const LoadResultJsonSchema = enumSchema(LoadResultEnum).describe("Status for batchload.result / whether any warnings or errors occurred - Schema: { { k: nil, v: 0, Description: <empty>}, { k: ok, v: 1, Description: <empty>}, { k: warning, v: 2, Description: <empty>}, { k: error, v: 3, Description: <empty>} }") as unknown as z.ZodType<LoadResultEnum>;


/** only relevant for Oracle */
export enum LobCacheTypeEnum {
/** ordinary or not Oracle */
	noLobCache = 1,
/** cache reads and writes */
	lobCache = 2,
/** cache reads */
	lobCacheRead = 3,
}

export const LobCacheTypeSchema = enumSchema(LobCacheTypeEnum) as unknown as z.ZodType<LobCacheTypeEnum>;
export const LobCacheTypeJsonSchema = enumSchema(LobCacheTypeEnum).describe("only relevant for Oracle - Schema: { { k: noLobCache, v: 1, Description: ordinary or not Oracle}, { k: lobCache, v: 2, Description: cache reads and writes}, { k: lobCacheRead, v: 3, Description: cache reads} }") as unknown as z.ZodType<LobCacheTypeEnum>;


/** which kind off logoperation */
export enum LogChangeTypeEnum {
/** nil */
	nil = 0,
/** insert */
	insert = 1,
/** delete */
	delete = 2,
/** update */
	update = 3,
}

export const LogChangeTypeSchema = enumSchema(LogChangeTypeEnum) as unknown as z.ZodType<LogChangeTypeEnum>;
export const LogChangeTypeJsonSchema = enumSchema(LogChangeTypeEnum).describe("which kind off logoperation - Schema: { { k: nil, v: 0, Description: nil}, { k: insert, v: 1, Description: insert}, { k: delete, v: 2, Description: delete}, { k: update, v: 3, Description: update} }") as unknown as z.ZodType<LogChangeTypeEnum>;


/** Module where logging can be enabled runtime */
export enum LoggingModuleEnum {
/** cost */
	logCost = 1,
/** cost person detail */
	logCostPerson = 2,
/** cost orgunit detail */
	logCostOrgunit = 3,
/** cost overhead person detail */
	logCostOverheadPerson = 4,
/** jSon obj Serializing */
	logJSonObjSerializing = 5,
/** jSon obj DeSerializing */
	logJSonObjDeSerializing = 6,
}

export const LoggingModuleSchema = enumSchema(LoggingModuleEnum) as unknown as z.ZodType<LoggingModuleEnum>;
export const LoggingModuleJsonSchema = enumSchema(LoggingModuleEnum).describe("Module where logging can be enabled runtime - Schema: { { k: logCost, v: 1, Description: cost}, { k: logCostPerson, v: 2, Description: cost person detail}, { k: logCostOrgunit, v: 3, Description: cost orgunit detail}, { k: logCostOverheadPerson, v: 4, Description: cost overhead person detail}, { k: logJSonObjSerializing, v: 5, Description: jSon obj Serializing}, { k: logJSonObjDeSerializing, v: 6, Description: jSon obj DeSerializing} }") as unknown as z.ZodType<LoggingModuleEnum>;


/** Category of log messages */
export enum LogMessageTypeEnum {
	undefined = 0,
	success = 1,
	informational = 2,
	warning = 3,
	user_error = 4,
	error = 5,
	fatal_error = 6,
}

export const LogMessageTypeSchema = enumSchema(LogMessageTypeEnum) as unknown as z.ZodType<LogMessageTypeEnum>;
export const LogMessageTypeJsonSchema = enumSchema(LogMessageTypeEnum).describe("Category of log messages - Schema: { { k: undefined, v: 0, Description: <empty>}, { k: success, v: 1, Description: <empty>}, { k: informational, v: 2, Description: <empty>}, { k: warning, v: 3, Description: <empty>}, { k: user_error, v: 4, Description: <empty>}, { k: error, v: 5, Description: <empty>}, { k: fatal_error, v: 6, Description: <empty>} }") as unknown as z.ZodType<LogMessageTypeEnum>;


export enum LogMiscellaneousTypeEnum {
	adHoc = -1,
	syncronization = 1,
	odbcConnection = 2,
	dbUpgrade = 3,
	dbSyncSliceFieldChange = 4,
	logEraseModule = 5,
	datawarehouseLogFile = 6,
}

export const LogMiscellaneousTypeSchema = enumSchema(LogMiscellaneousTypeEnum) as unknown as z.ZodType<LogMiscellaneousTypeEnum>;
export const LogMiscellaneousTypeJsonSchema = enumSchema(LogMiscellaneousTypeEnum).describe("Schema: { { k: adHoc, v: -1, Description: <empty>}, { k: syncronization, v: 1, Description: <empty>}, { k: odbcConnection, v: 2, Description: <empty>}, { k: dbUpgrade, v: 3, Description: <empty>}, { k: dbSyncSliceFieldChange, v: 4, Description: <empty>}, { k: logEraseModule, v: 5, Description: <empty>}, { k: datawarehouseLogFile, v: 6, Description: <empty>} }") as unknown as z.ZodType<LogMiscellaneousTypeEnum>;


/** How did the empuser log on */
export enum LogonTypeEnum {
/** User/password from StaffPlan database, input via form */
	staffWebUser = 0,
/** Username is Windows identity, check if it is in StaffPlan database with empty password */
	windows = 1,
/** Login with OpenId Connect */
	openId = 8,
/** AD username and password */
	basic = 9,
/** Biometric logon from mobile device. Note, biometric logon require non-biometric logon every 90 days, by default (applicationsetting.biometricAuthFallbackTimeoutDays) */
	biometric = 11,
/** Not an empuser */
	undefined = 10,
}

export const LogonTypeSchema = enumSchema(LogonTypeEnum) as unknown as z.ZodType<LogonTypeEnum>;
export const LogonTypeJsonSchema = enumSchema(LogonTypeEnum).describe("How did the empuser log on - Schema: { { k: staffWebUser, v: 0, Description: User/password from StaffPlan database, input via form}, { k: windows, v: 1, Description: Username is Windows identity, check if it is in StaffPlan database with empty password}, { k: openId, v: 8, Description: Login with OpenId Connect}, { k: basic, v: 9, Description: AD username and password}, { k: biometric, v: 11, Description: Biometric logon from mobile device. Note, biometric logon require non-biometric logon every 90 days, by default (applicationsetting.biometricAuthFallbackTimeoutDays)}, { k: undefined, v: 10, Description: Not an empuser} }") as unknown as z.ZodType<LogonTypeEnum>;


/** which kind of a logoperation for logRecord */
export enum LogRecordChangeTypeEnum {
/** nil */
	nil = 0,
/** insert */
	insert = 1,
/** delete */
	delete = 2,
/** update */
	update = 3,
/** minorInsert + minorDelete -> update. 2 operations are merged into an update */
	minorInsert = 4,
/** minorInsert + minorDelete -> update. 2 operations are merged into an update */
	minorDelete = 5,
}

export const LogRecordChangeTypeSchema = enumSchema(LogRecordChangeTypeEnum) as unknown as z.ZodType<LogRecordChangeTypeEnum>;
export const LogRecordChangeTypeJsonSchema = enumSchema(LogRecordChangeTypeEnum).describe("which kind of a logoperation for logRecord - Schema: { { k: nil, v: 0, Description: nil}, { k: insert, v: 1, Description: insert}, { k: delete, v: 2, Description: delete}, { k: update, v: 3, Description: update}, { k: minorInsert, v: 4, Description: minorInsert + minorDelete -> update. 2 operations are merged into an update}, { k: minorDelete, v: 5, Description: minorInsert + minorDelete -> update. 2 operations are merged into an update} }") as unknown as z.ZodType<LogRecordChangeTypeEnum>;


/** which kind of LogRegistration */
export enum LogRegistration_TypeEnum {
/** shift */
	shift = 0,
/** availability */
	availability = 1,
}

export const LogRegistration_TypeSchema = enumSchema(LogRegistration_TypeEnum) as unknown as z.ZodType<LogRegistration_TypeEnum>;
export const LogRegistration_TypeJsonSchema = enumSchema(LogRegistration_TypeEnum).describe("which kind of LogRegistration - Schema: { { k: shift, v: 0, Description: shift}, { k: availability, v: 1, Description: availability} }") as unknown as z.ZodType<LogRegistration_TypeEnum>;


/** which kind off logoperation */
export enum LogRegistrationChangeTypeEnum {
/** nil */
	nil = 0,
/** insert */
	insert = 1,
/** delete */
	delete = 2,
/** update */
	update = 3,
/** synchronize */
	synchronize = 4,
/** used during synchronize insert for performance purposes - and immediately changed to syncronize after commit  by direct sql */
	temporarySynchronize = 99,
}

export const LogRegistrationChangeTypeSchema = enumSchema(LogRegistrationChangeTypeEnum) as unknown as z.ZodType<LogRegistrationChangeTypeEnum>;
export const LogRegistrationChangeTypeJsonSchema = enumSchema(LogRegistrationChangeTypeEnum).describe("which kind off logoperation - Schema: { { k: nil, v: 0, Description: nil}, { k: insert, v: 1, Description: insert}, { k: delete, v: 2, Description: delete}, { k: update, v: 3, Description: update}, { k: synchronize, v: 4, Description: synchronize}, { k: temporarySynchronize, v: 99, Description: used during synchronize insert for performance purposes - and immediately changed to syncronize after commit  by direct sql} }") as unknown as z.ZodType<LogRegistrationChangeTypeEnum>;


/** how to log the operation */
export enum LogTypeEnum {
	logTypeNil = 0,
	logTypeNone = 1,
	logTypeDiff = 2,
	logTypeAll = 3,
}

export const LogTypeSchema = enumSchema(LogTypeEnum) as unknown as z.ZodType<LogTypeEnum>;
export const LogTypeJsonSchema = enumSchema(LogTypeEnum).describe("how to log the operation - Schema: { { k: logTypeNil, v: 0, Description: <empty>}, { k: logTypeNone, v: 1, Description: <empty>}, { k: logTypeDiff, v: 2, Description: <empty>}, { k: logTypeAll, v: 3, Description: <empty>} }") as unknown as z.ZodType<LogTypeEnum>;


/** mandatoryUI */
export enum MandatoryUIEnum {
	mandatory = 1,
	free = 2,
/** only used in system tables */
	null = 3,
/** caseinsensitive - field value is unique in the entire system */
	systemUnique = 4,
/** caseinsensitive - field value is unique at the orgunit - table must have orgunit field */
	orgunitUnique = 5,
/** caseinsensitive - field value is unique at the orgunit and it's decenders and predecessors - table must have orgunit field */
	orgunitTreeUnique = 6,
/** caseinsensitive - must be unique within orgunit modulo validity, ie same name can be reused as long as validity intervals doesn't intersect - table must have orgunit field */
	orgunitValidityUnique = 7,
/** caseinsensitive - field value is unique at the orgunit and it's decenders and predecessors -  modulo validity, ie same name can be reused as long as validity intervals doesn't intersect - table must have orgunit field */
	orgunitTreeValidityUnique = 8,
/** caseinsensitive - field value is unique at the father node - table must have field with father property */
	fatherUnique = 9,
/** caseinsensitive - field value is unique at the father node and it's decenders and predecessors  - table must have field with father property */
	fatherTreeUnique = 10,
/** caseinsensitive - must be unique within father node modulo validity, ie same name can be reused as long as validity intervals doesn't intersect  - table must have field with father property */
	fatherValidityUnique = 11,
/** caseinsensitive - field value is unique at the father node and it's decenders and predecessors -  modulo validity, ie same name can be reused as long as validity intervals doesn't intersect  - table must have field with father property */
	fatherTreeValidityUnique = 12,
/** custom rule for field/object */
	custom = 20,
/** date or minut offset field cannot be blank */
	nonBlankDate = 30,
}

export const MandatoryUISchema = enumSchema(MandatoryUIEnum) as unknown as z.ZodType<MandatoryUIEnum>;
export const MandatoryUIJsonSchema = enumSchema(MandatoryUIEnum).describe("mandatoryUI - Schema: { { k: mandatory, v: 1, Description: <empty>}, { k: free, v: 2, Description: <empty>}, { k: null, v: 3, Description: only used in system tables}, { k: systemUnique, v: 4, Description: caseinsensitive - field value is unique in the entire system}, { k: orgunitUnique, v: 5, Description: caseinsensitive - field value is unique at the orgunit - table must have orgunit field}, { k: orgunitTreeUnique, v: 6, Description: caseinsensitive - field value is unique at the orgunit and it's decenders and predecessors - table must have orgunit field}, { k: orgunitValidityUnique, v: 7, Description: caseinsensitive - must be unique within orgunit modulo validity, ie same name can be reused as long as validity intervals doesn't intersect - table must have orgunit field}, { k: orgunitTreeValidityUnique, v: 8, Description: caseinsensitive - field value is unique at the orgunit and it's decenders and predecessors -  modulo validity, ie same name can be reused as long as validity intervals doesn't intersect - table must have orgunit field}, { k: fatherUnique, v: 9, Description: caseinsensitive - field value is unique at the father node - table must have field with father property}, { k: fatherTreeUnique, v: 10, Description: caseinsensitive - field value is unique at the father node and it's decenders and predecessors  - table must have field with father property}, { k: fatherValidityUnique, v: 11, Description: caseinsensitive - must be unique within father node modulo validity, ie same name can be reused as long as validity intervals doesn't intersect  - table must have field with father property}, { k: fatherTreeValidityUnique, v: 12, Description: caseinsensitive - field value is unique at the father node and it's decenders and predecessors -  modulo validity, ie same name can be reused as long as validity intervals doesn't intersect  - table must have field with father property}, { k: custom, v: 20, Description: custom rule for field/object}, { k: nonBlankDate, v: 30, Description: date or minut offset field cannot be blank} }") as unknown as z.ZodType<MandatoryUIEnum>;


/** how to match deputies */
export enum MatchLevelEnum {
/** The parties prefer never to be matched */
	poorest = 1,
/** The parties prefer seldom to be matched */
	poor = 2,
/** It is ok to match the parties */
	neutral = 3,
/** The parties like to be matched */
	good = 4,
/** The parties like very much to be matched */
	best = 5,
}

export const MatchLevelSchema = enumSchema(MatchLevelEnum) as unknown as z.ZodType<MatchLevelEnum>;
export const MatchLevelJsonSchema = enumSchema(MatchLevelEnum).describe("how to match deputies - Schema: { { k: poorest, v: 1, Description: The parties prefer never to be matched}, { k: poor, v: 2, Description: The parties prefer seldom to be matched}, { k: neutral, v: 3, Description: It is ok to match the parties}, { k: good, v: 4, Description: The parties like to be matched}, { k: best, v: 5, Description: The parties like very much to be matched} }") as unknown as z.ZodType<MatchLevelEnum>;


/** Months of the year */
export enum MonthEnum {
	january = 1,
	february = 2,
	march = 3,
	april = 4,
	may = 5,
	june = 6,
	july = 7,
	august = 8,
	september = 9,
	october = 10,
	november = 11,
	december = 12,
}

export const MonthSchema = enumSchema(MonthEnum) as unknown as z.ZodType<MonthEnum>;
export const MonthJsonSchema = enumSchema(MonthEnum).describe("Months of the year - Schema: { { k: january, v: 1, Description: <empty>}, { k: february, v: 2, Description: <empty>}, { k: march, v: 3, Description: <empty>}, { k: april, v: 4, Description: <empty>}, { k: may, v: 5, Description: <empty>}, { k: june, v: 6, Description: <empty>}, { k: july, v: 7, Description: <empty>}, { k: august, v: 8, Description: <empty>}, { k: september, v: 9, Description: <empty>}, { k: october, v: 10, Description: <empty>}, { k: november, v: 11, Description: <empty>}, { k: december, v: 12, Description: <empty>} }") as unknown as z.ZodType<MonthEnum>;


/** display status */
export enum MsgDisplayStatusEnum {
/** No information about display status */
	noStatus = 0,
/** Message has been seen/read by the user in-app, hence no notification will be sent */
	seen = 1,
/** The user has explicitly acknowledged the message, in-app or via channel. */
	acknowledged = 2,
}

export const MsgDisplayStatusSchema = enumSchema(MsgDisplayStatusEnum) as unknown as z.ZodType<MsgDisplayStatusEnum>;
export const MsgDisplayStatusJsonSchema = enumSchema(MsgDisplayStatusEnum).describe("display status - Schema: { { k: noStatus, v: 0, Description: No information about display status}, { k: seen, v: 1, Description: Message has been seen/read by the user in-app, hence no notification will be sent}, { k: acknowledged, v: 2, Description: The user has explicitly acknowledged the message, in-app or via channel.} }") as unknown as z.ZodType<MsgDisplayStatusEnum>;


/** Handling status */
export enum MsgHandlingEnum {
/** Initial value, and no further handling required */
	noHandling = 0,
/** May be set by the user, and displayed to the user similar to unread */
	followup = 1,
}

export const MsgHandlingSchema = enumSchema(MsgHandlingEnum) as unknown as z.ZodType<MsgHandlingEnum>;
export const MsgHandlingJsonSchema = enumSchema(MsgHandlingEnum).describe("Handling status - Schema: { { k: noHandling, v: 0, Description: Initial value, and no further handling required}, { k: followup, v: 1, Description: May be set by the user, and displayed to the user similar to unread} }") as unknown as z.ZodType<MsgHandlingEnum>;


/** Defines how the message is handled and which biz tables are related, if any. */
export enum MsgKindEnum {
/** Messages from one employee to other employees or persongroups. Messages grouped in threads, where the participants in a thread are locked in when created. Previously msgBoardNote/msgSysBoard without msgFctBoard */
	chat = 0,
/** Messages from the planner to persongroups and employees. Expands persongroups to employees when message is created. Previously msgBoardNote/msgSysBoard without msgFctBoard or with msgFctBoard.scope=functionPlanTop. */
	info = 1,
/** Messages on a day for an employee and the planner. References person1. Previously msgDay (created from MyPlan, StaffPlan, TeamPlan, FunctionPlan). */
	day = 2,
/** Autogenerated messages about approved/rejected work and absence requests. Previously msgDay. */
	request = 3,
/** Push messages about exchange offers. References exchange_reg. Previously msgSysSwap. */
	exchange = 4,
/** Autogenerated messages about critical changes to the workplan relevant for an employee. */
	criticalChange = 5,
/** Note for a period (default one day) to persongroups (originally made for FunctionPlan). Marks unread for employees when message is created (TODO_LABO ???? All messages are unread when created, so what does this comment mean??). References fctPlanLayout. Accessed via msgPersonGroup. Previously msgBoardNote via msgFctBoard with msgFctBoard.scope=functionPlanDate. */
	persongroupNote = 6,
/** Note for a period (default one day) for an employee (originally made for FunctionPlan). Accessible for everyone who can see the person eg. via colleagueplan in MyPlan. References fctPlanLayout. Previously msgBoardNote via msgFctBoard with msgFctBoard.scope=functionPlanDate. */
	personNote = 7,
}

export const MsgKindSchema = enumSchema(MsgKindEnum) as unknown as z.ZodType<MsgKindEnum>;
export const MsgKindJsonSchema = enumSchema(MsgKindEnum).describe("Defines how the message is handled and which biz tables are related, if any. - Schema: { { k: chat, v: 0, Description: Messages from one employee to other employees or persongroups. Messages grouped in threads, where the participants in a thread are locked in when created. Previously msgBoardNote/msgSysBoard without msgFctBoard}, { k: info, v: 1, Description: Messages from the planner to persongroups and employees. Expands persongroups to employees when message is created. Previously msgBoardNote/msgSysBoard without msgFctBoard or with msgFctBoard.scope=functionPlanTop.}, { k: day, v: 2, Description: Messages on a day for an employee and the planner. References person1. Previously msgDay (created from MyPlan, StaffPlan, TeamPlan, FunctionPlan).}, { k: request, v: 3, Description: Autogenerated messages about approved/rejected work and absence requests. Previously msgDay.}, { k: exchange, v: 4, Description: Push messages about exchange offers. References exchange_reg. Previously msgSysSwap.}, { k: criticalChange, v: 5, Description: Autogenerated messages about critical changes to the workplan relevant for an employee.}, { k: persongroupNote, v: 6, Description: Note for a period (default one day) to persongroups (originally made for FunctionPlan). Marks unread for employees when message is created (TODO_LABO ???? All messages are unread when created, so what does this comment mean??). References fctPlanLayout. Accessed via msgPersonGroup. Previously msgBoardNote via msgFctBoard with msgFctBoard.scope=functionPlanDate.}, { k: personNote, v: 7, Description: Note for a period (default one day) for an employee (originally made for FunctionPlan). Accessible for everyone who can see the person eg. via colleagueplan in MyPlan. References fctPlanLayout. Previously msgBoardNote via msgFctBoard with msgFctBoard.scope=functionPlanDate.} }") as unknown as z.ZodType<MsgKindEnum>;


/** notification status */
export enum MsgNotificationStatusEnum {
/** Configured channels without a msgNotification exist */
	unsent = 0,
/** All configured channels have been tried */
	sent = 1,
/** Sending ended with error */
	sentError = 2,
/** The message ends up not being sent. Still */
	notSending = 3,
}

export const MsgNotificationStatusSchema = enumSchema(MsgNotificationStatusEnum) as unknown as z.ZodType<MsgNotificationStatusEnum>;
export const MsgNotificationStatusJsonSchema = enumSchema(MsgNotificationStatusEnum).describe("notification status - Schema: { { k: unsent, v: 0, Description: Configured channels without a msgNotification exist}, { k: sent, v: 1, Description: All configured channels have been tried}, { k: sentError, v: 2, Description: Sending ended with error}, { k: notSending, v: 3, Description: The message ends up not being sent. Still} }") as unknown as z.ZodType<MsgNotificationStatusEnum>;


/** Causes for msgNotificationStatus notSending */
export enum MsgNotSendingCauseEnum {
/** No status, notificationStatus is not notSending. Default value. Set by creation code. */
	noStatus = 0,
/** Seen in app before notification got sent */
	seenInApp = 1,
/** No device registered for recipient. Set by MessageSender. */
	noPushRegistration = 2,
/** Unsent message is no longer visible. Set by MessageSender. */
	visibleEnded = 3,
/** User is removed for whatever reason (missing, deleted, inactivated, erased, ...). Set by MessageSender. */
	userRemoved = 4,
/** when now > attachedToPlanStart, do not send, except for kind=day. */
	afterAttachement = 6,
/** msg does not exist or is deleted - data error that should not happen. */
	msgNotFound = 7,
/** MessageSender is not configured (in applicationSetting MsgNotificationKinds) to send messages of this kind. */
	notConfigured = 8,
}

export const MsgNotSendingCauseSchema = enumSchema(MsgNotSendingCauseEnum) as unknown as z.ZodType<MsgNotSendingCauseEnum>;
export const MsgNotSendingCauseJsonSchema = enumSchema(MsgNotSendingCauseEnum).describe("Causes for msgNotificationStatus notSending - Schema: { { k: noStatus, v: 0, Description: No status, notificationStatus is not notSending. Default value. Set by creation code.}, { k: seenInApp, v: 1, Description: Seen in app before notification got sent}, { k: noPushRegistration, v: 2, Description: No device registered for recipient. Set by MessageSender.}, { k: visibleEnded, v: 3, Description: Unsent message is no longer visible. Set by MessageSender.}, { k: userRemoved, v: 4, Description: User is removed for whatever reason (missing, deleted, inactivated, erased, ...). Set by MessageSender.}, { k: afterAttachement, v: 6, Description: when now > attachedToPlanStart, do not send, except for kind=day.}, { k: msgNotFound, v: 7, Description: msg does not exist or is deleted - data error that should not happen.}, { k: notConfigured, v: 8, Description: MessageSender is not configured (in applicationSetting MsgNotificationKinds) to send messages of this kind.} }") as unknown as z.ZodType<MsgNotSendingCauseEnum>;


/** Cause of the role of participant */
export enum MsgParticipantCauseEnum {
/** The message is from this user */
	creator = 0,
/** The message is to this user */
	recipient = 1,
/** The participant is added because of group */
	group = 2,
}

export const MsgParticipantCauseSchema = enumSchema(MsgParticipantCauseEnum) as unknown as z.ZodType<MsgParticipantCauseEnum>;
export const MsgParticipantCauseJsonSchema = enumSchema(MsgParticipantCauseEnum).describe("Cause of the role of participant - Schema: { { k: creator, v: 0, Description: The message is from this user}, { k: recipient, v: 1, Description: The message is to this user}, { k: group, v: 2, Description: The participant is added because of group} }") as unknown as z.ZodType<MsgParticipantCauseEnum>;


/** Which user types of participants does exists in the message system */
export enum MsgParticipantTypeEnum {
/** person1 user */
	employee = 1,
/** staffuser user */
	planner = 2,
/** Any staffuser user, used in msgParticipantType */
	plannerGroup = 30,
}

export const MsgParticipantTypeSchema = enumSchema(MsgParticipantTypeEnum) as unknown as z.ZodType<MsgParticipantTypeEnum>;
export const MsgParticipantTypeJsonSchema = enumSchema(MsgParticipantTypeEnum).describe("Which user types of participants does exists in the message system - Schema: { { k: employee, v: 1, Description: person1 user}, { k: planner, v: 2, Description: staffuser user}, { k: plannerGroup, v: 30, Description: Any staffuser user, used in msgParticipantType} }") as unknown as z.ZodType<MsgParticipantTypeEnum>;


/** message priority */
export enum MsgPriorityEnum {
/** Send now. Block user GUI until acknowledged. At logon, when authenticated (note diff to setting BlockAccess which is meant to be shown before logon ) */
	asap = 0,
/** Send out normally, usually now, but non-blocking */
	standard = 1,
/** Notifications may be sent later and as summary messages */
	low = 2,
}

export const MsgPrioritySchema = enumSchema(MsgPriorityEnum) as unknown as z.ZodType<MsgPriorityEnum>;
export const MsgPriorityJsonSchema = enumSchema(MsgPriorityEnum).describe("message priority - Schema: { { k: asap, v: 0, Description: Send now. Block user GUI until acknowledged. At logon, when authenticated (note diff to setting BlockAccess which is meant to be shown before logon )}, { k: standard, v: 1, Description: Send out normally, usually now, but non-blocking}, { k: low, v: 2, Description: Notifications may be sent later and as summary messages} }") as unknown as z.ZodType<MsgPriorityEnum>;


/** sent status */
export enum MsgSentStatusEnum {
/** Message not attempted sent */
	noStatus = 0,
/** Notification sent ok */
	ok = 1,
/** Channel responded with error */
	channelError = 2,
/** Other errors, notification not sent */
	otherError = 3,
}

export const MsgSentStatusSchema = enumSchema(MsgSentStatusEnum) as unknown as z.ZodType<MsgSentStatusEnum>;
export const MsgSentStatusJsonSchema = enumSchema(MsgSentStatusEnum).describe("sent status - Schema: { { k: noStatus, v: 0, Description: Message not attempted sent}, { k: ok, v: 1, Description: Notification sent ok}, { k: channelError, v: 2, Description: Channel responded with error}, { k: otherError, v: 3, Description: Other errors, notification not sent} }") as unknown as z.ZodType<MsgSentStatusEnum>;


/** Status for the message */
export enum MsgSimpleStatusEnum {
/** Not all msgSimpleUser have been handled */
	unhandled = 0,
/** All msgSimpleUser have been handled */
	handled = 1,
}

export const MsgSimpleStatusSchema = enumSchema(MsgSimpleStatusEnum) as unknown as z.ZodType<MsgSimpleStatusEnum>;
export const MsgSimpleStatusJsonSchema = enumSchema(MsgSimpleStatusEnum).describe("Status for the message - Schema: { { k: unhandled, v: 0, Description: Not all msgSimpleUser have been handled}, { k: handled, v: 1, Description: All msgSimpleUser have been handled} }") as unknown as z.ZodType<MsgSimpleStatusEnum>;


/** Status for the record (pk: user and message) */
export enum MsgSimpleUserStatusEnum {
/** Message not handled for this user */
	unhandled = 0,
/** Message sent to this user */
	sent = 1,
/** Message not sent because user has no mobile registered */
	cancelledNoPhone = 100,
/** Message for uset who is not found */
	cancelledNoSuchUser = 101,
/** Message for user with no valid planning card */
	cancelledNoValidP2 = 102,
/** Message for user on unit not SMS enabled */
	cancelledNotSmsEnabled = 103,
/** Message for user with no valid unit */
	cancelledNoValidUnit = 104,
/** Message sending ended in unexpected error (in parenthesis put error.message) */
	cancelledSystemError = 105,
}

export const MsgSimpleUserStatusSchema = enumSchema(MsgSimpleUserStatusEnum) as unknown as z.ZodType<MsgSimpleUserStatusEnum>;
export const MsgSimpleUserStatusJsonSchema = enumSchema(MsgSimpleUserStatusEnum).describe("Status for the record (pk: user and message) - Schema: { { k: unhandled, v: 0, Description: Message not handled for this user}, { k: sent, v: 1, Description: Message sent to this user}, { k: cancelledNoPhone, v: 100, Description: Message not sent because user has no mobile registered}, { k: cancelledNoSuchUser, v: 101, Description: Message for uset who is not found}, { k: cancelledNoValidP2, v: 102, Description: Message for user with no valid planning card}, { k: cancelledNotSmsEnabled, v: 103, Description: Message for user on unit not SMS enabled}, { k: cancelledNoValidUnit, v: 104, Description: Message for user with no valid unit}, { k: cancelledSystemError, v: 105, Description: Message sending ended in unexpected error (in parenthesis put error.message)} }") as unknown as z.ZodType<MsgSimpleUserStatusEnum>;


/** Who can view the message, only relevant for msgKind day */
export enum MsgVisibilityEnum {
/** Those with msgParticipant can view the message */
	participant = 0,
/** Only planners can view the message (even if there is a messageparticipant referring to a person, that person cannot read the message, except through dataSubjectInformation). */
	planner = 2,
}

export const MsgVisibilitySchema = enumSchema(MsgVisibilityEnum) as unknown as z.ZodType<MsgVisibilityEnum>;
export const MsgVisibilityJsonSchema = enumSchema(MsgVisibilityEnum).describe("Who can view the message, only relevant for msgKind day - Schema: { { k: participant, v: 0, Description: Those with msgParticipant can view the message}, { k: planner, v: 2, Description: Only planners can view the message (even if there is a messageparticipant referring to a person, that person cannot read the message, except through dataSubjectInformation).} }") as unknown as z.ZodType<MsgVisibilityEnum>;


/** Who can view the message; the employee, planners, everybody */
export enum MsgVisibilityOldEnum {
/** Planners and the employee can view the message */
	employee = 0,
/** Only planners can view the message */
	planner = 1,
/** Everyone can view the message */
	public = 2,
}

export const MsgVisibilityOldSchema = enumSchema(MsgVisibilityOldEnum) as unknown as z.ZodType<MsgVisibilityOldEnum>;
export const MsgVisibilityOldJsonSchema = enumSchema(MsgVisibilityOldEnum).describe("Who can view the message; the employee, planners, everybody - Schema: { { k: employee, v: 0, Description: Planners and the employee can view the message}, { k: planner, v: 1, Description: Only planners can view the message}, { k: public, v: 2, Description: Everyone can view the message} }") as unknown as z.ZodType<MsgVisibilityOldEnum>;


/** synthesized from followLevel */
export enum NotificationStatusEnum {
/** Show no notifications. followLevel in [notFollowing,following] */
	noNotifications = 1,
/** Show all notifications. followLevel=followingWithNotifications */
	allNotifications = 2,
}

export const NotificationStatusSchema = enumSchema(NotificationStatusEnum) as unknown as z.ZodType<NotificationStatusEnum>;
export const NotificationStatusJsonSchema = enumSchema(NotificationStatusEnum).describe("synthesized from followLevel - Schema: { { k: noNotifications, v: 1, Description: Show no notifications. followLevel in [notFollowing,following]}, { k: allNotifications, v: 2, Description: Show all notifications. followLevel=followingWithNotifications} }") as unknown as z.ZodType<NotificationStatusEnum>;


/** OpenID authorization code status */
export enum OpenIdAuthCodeStatusEnum {
/** Waiting to receive an authorization code from OpenID provider */
	awaiting_code = 0,
/** Authorization code received and stored in openIdAuthCode.code */
	code_received = 1,
}

export const OpenIdAuthCodeStatusSchema = enumSchema(OpenIdAuthCodeStatusEnum) as unknown as z.ZodType<OpenIdAuthCodeStatusEnum>;
export const OpenIdAuthCodeStatusJsonSchema = enumSchema(OpenIdAuthCodeStatusEnum).describe("OpenID authorization code status - Schema: { { k: awaiting_code, v: 0, Description: Waiting to receive an authorization code from OpenID provider}, { k: code_received, v: 1, Description: Authorization code received and stored in openIdAuthCode.code} }") as unknown as z.ZodType<OpenIdAuthCodeStatusEnum>;


/** onStart, onEnd */
export enum OpenStateEnum {
/** start and end is known */
	closed = 0,
/** Start missing */
	openStart = 1,
/** End missing */
	openEnd = 2,
}

export const OpenStateSchema = enumSchema(OpenStateEnum) as unknown as z.ZodType<OpenStateEnum>;
export const OpenStateJsonSchema = enumSchema(OpenStateEnum).describe("onStart, onEnd - Schema: { { k: closed, v: 0, Description: start and end is known}, { k: openStart, v: 1, Description: Start missing}, { k: openEnd, v: 2, Description: End missing} }") as unknown as z.ZodType<OpenStateEnum>;


/** Opt Boolean */
export enum OptBooleanEnumEnum {
/** false */
	bFalse = 0,
/** true */
	bTrue = 1,
/** none */
	bNone = 2,
}

export const OptBooleanEnumSchema = enumSchema(OptBooleanEnumEnum) as unknown as z.ZodType<OptBooleanEnumEnum>;
export const OptBooleanEnumJsonSchema = enumSchema(OptBooleanEnumEnum).describe("Opt Boolean - Schema: { { k: bFalse, v: 0, Description: false}, { k: bTrue, v: 1, Description: true}, { k: bNone, v: 2, Description: none} }") as unknown as z.ZodType<OptBooleanEnumEnum>;


/** how to fetch CLOB/BLOB in Oracle */
export enum OracleFetchStrategyEnum {
/** fetch then first 4000 characters, and the length of every lob field - patch the record if the field is to long */
	simple = 0,
/** fetch then first 4000-32000 characters, and the length of every lob field - patch the record if the field is to long */
	advanced = 1,
/** handle lob as long varchar - rerun the sql if the buffersize is to small - has bad oracle performance - is the MsSqlServer way */
	oldSchool = 2,
}

export const OracleFetchStrategySchema = enumSchema(OracleFetchStrategyEnum) as unknown as z.ZodType<OracleFetchStrategyEnum>;
export const OracleFetchStrategyJsonSchema = enumSchema(OracleFetchStrategyEnum).describe("how to fetch CLOB/BLOB in Oracle - Schema: { { k: simple, v: 0, Description: fetch then first 4000 characters, and the length of every lob field - patch the record if the field is to long}, { k: advanced, v: 1, Description: fetch then first 4000-32000 characters, and the length of every lob field - patch the record if the field is to long}, { k: oldSchool, v: 2, Description: handle lob as long varchar - rerun the sql if the buffersize is to small - has bad oracle performance - is the MsSqlServer way} }") as unknown as z.ZodType<OracleFetchStrategyEnum>;


/** swapCounterNeutralized        40 "@OrgunitProperty.swapCounterNeutralized" (true orgunit_AccessItem)                            / SwapRequest and SwapOffers preserve some counters via neutralizing paidAllowance. See also swapNormNeutral and  wi 163107 / */
export enum OrgunitPropertyEnum {
/** Unit is a planning unit. */
	section = 1,
/** Unit is a payer. */
	payer = 2,
/** Unit is a firm/institution */
	institution = 5,
/** Are the employees allowed to make requests */
	usesEmployeeRequesting = 7,
	isDeputyService = 8,
	usesSimpleMessages = 9,
/** Push notifications allowed, controlled via web setting NotificationDimensions. */
	usesSMS = 10,
	usesProductionRules = 11,
	productionDepartment = 13,
	productionUnit = 14,
/** FunctionPlan enabled */
	functionPlanning = 15,
/** Unit has activated automatic planning */
	automaticPlanning = 17,
/** Determines if task status feature is enabled for sub-hierarchy. Setting 'taskStatus' must be enabled for entire installation for this property to have effect. */
	productionTaskStatus = 18,
/** Determines if long term planning is used for sub-hierarchy, ie long term planned tasks are converted to reservations */
	productionLongTermPlanning = 19,
/** the department og subdepartments uses person workflow (MiF) */
	usesPersonWorkflow = 20,
/** Unit and all subunits allow synchronization of Shifts from Tasks during PlanStatus Planning period. All operations are legal: creation, deletion, extension and shrinkage */
	taskShiftSyncPlanning = 21,
/** Unit and all subunits allow synchronization of Shifts from Tasks during PlanStatus Operation period. All operations are legal: creation, deletion, extension and shrinkage */
	taskShiftSyncOperation = 22,
/** Unit and all subunits only allow extension of shifts and new Shifts during PlanStatus Operation period. This property requires productionTaskShiftSyncPlanStatusOperation is defined. Legal operations: creation and extension */
	taskShiftSyncOp_ExtendOnly = 23,
/** Are the employees allowed to make time reporting */
	usesTimeReporting = 24,
/** Are the employees allowed to make time-attendance clocking through the MyPlan-app */
	usesTimeAttendance = 25,
/** Are the employees allowed to do selfplanning through the MyPlan-app */
	usesEmployeeSelfplanning = 26,
/** Does the unit use TeamPlan */
	usesTeamPlan = 27,
/** Only allow swaps if the shifts contain the same amount of norm hours */
	swapNormNeutral = 28,
/** Only allow exchange_reg candidates which cause no new ruleviolation (for all exchangeTypes). Fallback (when false) to setting.swapRulecheck and setting.handoverRulecheck. Even when the rulecheck is disabled, the planner is still presented with the ruleviolations when accepting an offer. */
	exchangeRuleCheck = 29,
/** Are the employees allowed to use time registration */
	usesTimeRegistration = 30,
/** Are the employees allowed to use preferences */
	usesPreferences = 31,
/** Cooperation point for the units below - attachment to any unit below gives cooperation with all other units below */
	cooperation = 33,
/** Unit is a physical building can consist of other buildings */
	building = 34,
/** Unit is a physical plot and can consist of other plots and buildings */
	plot = 35,
/** Unit is a physical site and can consist of other sites,plots and buildings */
	site = 36,
/** Unit is a physical area that can contain other areas,sites, plots and buildings */
	area = 37,
/** Unit is a logical structuring element. No constraints */
	division = 38,
/** Unit is a logical structuring element. No constraints */
	entity = 39,
}

export const OrgunitPropertySchema = enumSchema(OrgunitPropertyEnum) as unknown as z.ZodType<OrgunitPropertyEnum>;
export const OrgunitPropertyJsonSchema = enumSchema(OrgunitPropertyEnum).describe("swapCounterNeutralized        40 \"@OrgunitProperty.swapCounterNeutralized\" (true orgunit_AccessItem)                            / SwapRequest and SwapOffers preserve some counters via neutralizing paidAllowance. See also swapNormNeutral and  wi 163107 / - Schema: { { k: section, v: 1, Description: Unit is a planning unit.}, { k: payer, v: 2, Description: Unit is a payer.}, { k: institution, v: 5, Description: Unit is a firm/institution}, { k: usesEmployeeRequesting, v: 7, Description: Are the employees allowed to make requests}, { k: isDeputyService, v: 8, Description: <empty>}, { k: usesSimpleMessages, v: 9, Description: <empty>}, { k: usesSMS, v: 10, Description: Push notifications allowed, controlled via web setting NotificationDimensions.}, { k: usesProductionRules, v: 11, Description: <empty>}, { k: productionDepartment, v: 13, Description: <empty>}, { k: productionUnit, v: 14, Description: <empty>}, { k: functionPlanning, v: 15, Description: FunctionPlan enabled}, { k: automaticPlanning, v: 17, Description: Unit has activated automatic planning}, { k: productionTaskStatus, v: 18, Description: Determines if task status feature is enabled for sub-hierarchy. Setting 'taskStatus' must be enabled for entire installation for this property to have effect.}, { k: productionLongTermPlanning, v: 19, Description: Determines if long term planning is used for sub-hierarchy, ie long term planned tasks are converted to reservations}, { k: usesPersonWorkflow, v: 20, Description: the department og subdepartments uses person workflow (MiF)}, { k: taskShiftSyncPlanning, v: 21, Description: Unit and all subunits allow synchronization of Shifts from Tasks during PlanStatus Planning period. All operations are legal: creation, deletion, extension and shrinkage}, { k: taskShiftSyncOperation, v: 22, Description: Unit and all subunits allow synchronization of Shifts from Tasks during PlanStatus Operation period. All operations are legal: creation, deletion, extension and shrinkage}, { k: taskShiftSyncOp_ExtendOnly, v: 23, Description: Unit and all subunits only allow extension of shifts and new Shifts during PlanStatus Operation period. This property requires productionTaskShiftSyncPlanStatusOperation is defined. Legal operations: creation and extension}, { k: usesTimeReporting, v: 24, Description: Are the employees allowed to make time reporting}, { k: usesTimeAttendance, v: 25, Description: Are the employees allowed to make time-attendance clocking through the MyPlan-app}, { k: usesEmployeeSelfplanning, v: 26, Description: Are the employees allowed to do selfplanning through the MyPlan-app}, { k: usesTeamPlan, v: 27, Description: Does the unit use TeamPlan}, { k: swapNormNeutral, v: 28, Description: Only allow swaps if the shifts contain the same amount of norm hours}, { k: exchangeRuleCheck, v: 29, Description: Only allow exchange_reg candidates which cause no new ruleviolation (for all exchangeTypes). Fallback (when false) to setting.swapRulecheck and setting.handoverRulecheck. Even when the rulecheck is disabled, the planner is still presented with the ruleviolations when accepting an offer.}, { k: usesTimeRegistration, v: 30, Description: Are the employees allowed to use time registration}, { k: usesPreferences, v: 31, Description: Are the employees allowed to use preferences}, { k: cooperation, v: 33, Description: Cooperation point for the units below - attachment to any unit below gives cooperation with all other units below}, { k: building, v: 34, Description: Unit is a physical building can consist of other buildings}, { k: plot, v: 35, Description: Unit is a physical plot and can consist of other plots and buildings}, { k: site, v: 36, Description: Unit is a physical site and can consist of other sites,plots and buildings}, { k: area, v: 37, Description: Unit is a physical area that can contain other areas,sites, plots and buildings}, { k: division, v: 38, Description: Unit is a logical structuring element. No constraints}, { k: entity, v: 39, Description: Unit is a logical structuring element. No constraints} }") as unknown as z.ZodType<OrgunitPropertyEnum>;


/** which rule should be enforces for the orgunit field */
export enum OrgunitPropertyPropertyEnum {
/** no change for the orgunit field */
	noRule = 0,
/** only select payers for this field */
	payerUnitOnly = 1,
/** only select sections for this field */
	planningUnitOnly = 2,
/** only select production department for this field */
	productionDepartmentOnly = 3,
/** only select production unit for this field */
	productionUnitOnly = 4,
}

export const OrgunitPropertyPropertySchema = enumSchema(OrgunitPropertyPropertyEnum) as unknown as z.ZodType<OrgunitPropertyPropertyEnum>;
export const OrgunitPropertyPropertyJsonSchema = enumSchema(OrgunitPropertyPropertyEnum).describe("which rule should be enforces for the orgunit field - Schema: { { k: noRule, v: 0, Description: no change for the orgunit field}, { k: payerUnitOnly, v: 1, Description: only select payers for this field}, { k: planningUnitOnly, v: 2, Description: only select sections for this field}, { k: productionDepartmentOnly, v: 3, Description: only select production department for this field}, { k: productionUnitOnly, v: 4, Description: only select production unit for this field} }") as unknown as z.ZodType<OrgunitPropertyPropertyEnum>;


/** this enum replaces table orgunit_property_type */
export enum OrgunitPropertyTypeEnum {
/** Days where the store open or closed. orgunit_property.propertyid is dateoffset. propertylong=0 means closed, propertylong=1 means open */
	closedDays = 1,
/** orgunit_property.propertyid=1: propertylong=0 means the store is closed on holydays; propertylong=1 means the store is open all days */
	storeProperty = 2,
/** Deputy service functionality. See deputyServicePropertyId for the possible values of orgunit_property.propertyid */
	deputyService = 3,
}

export const OrgunitPropertyTypeSchema = enumSchema(OrgunitPropertyTypeEnum) as unknown as z.ZodType<OrgunitPropertyTypeEnum>;
export const OrgunitPropertyTypeJsonSchema = enumSchema(OrgunitPropertyTypeEnum).describe("this enum replaces table orgunit_property_type - Schema: { { k: closedDays, v: 1, Description: Days where the store open or closed. orgunit_property.propertyid is dateoffset. propertylong=0 means closed, propertylong=1 means open}, { k: storeProperty, v: 2, Description: orgunit_property.propertyid=1: propertylong=0 means the store is closed on holydays; propertylong=1 means the store is open all days}, { k: deputyService, v: 3, Description: Deputy service functionality. See deputyServicePropertyId for the possible values of orgunit_property.propertyid} }") as unknown as z.ZodType<OrgunitPropertyTypeEnum>;


/** Defines origin of data */
export enum OriginEnum {
/** Manually and explicitly constructed by user */
	user = 0,
/** Rolled out from Roster Template */
	roster = 1,
/** Instantiated from Definition/Template */
	definition = 2,
/** Automatic computation caused entity */
	computed = 3,
/** Entity is derived from other records */
	derived = 4,
/** Decision engine inferred entity */
	decisionRule = 5,
/** External system owns entity */
	external = 6,
/** Consolidation caused entity */
	consolidation = 7,
/** Employee caused entity */
	employee = 8,
}

export const OriginSchema = enumSchema(OriginEnum) as unknown as z.ZodType<OriginEnum>;
export const OriginJsonSchema = enumSchema(OriginEnum).describe("Defines origin of data - Schema: { { k: user, v: 0, Description: Manually and explicitly constructed by user}, { k: roster, v: 1, Description: Rolled out from Roster Template}, { k: definition, v: 2, Description: Instantiated from Definition/Template}, { k: computed, v: 3, Description: Automatic computation caused entity}, { k: derived, v: 4, Description: Entity is derived from other records}, { k: decisionRule, v: 5, Description: Decision engine inferred entity}, { k: external, v: 6, Description: External system owns entity}, { k: consolidation, v: 7, Description: Consolidation caused entity}, { k: employee, v: 8, Description: Employee caused entity} }") as unknown as z.ZodType<OriginEnum>;


/** the registration originates from */
export enum OriginReasonEnum {
/** the registration doesnt originates from any specific registration */
	noOrigin = 1,
/** the registration originates from a specific registration */
	otherRegistration = 2,
}

export const OriginReasonSchema = enumSchema(OriginReasonEnum) as unknown as z.ZodType<OriginReasonEnum>;
export const OriginReasonJsonSchema = enumSchema(OriginReasonEnum).describe("the registration originates from - Schema: { { k: noOrigin, v: 1, Description: the registration doesnt originates from any specific registration}, { k: otherRegistration, v: 2, Description: the registration originates from a specific registration} }") as unknown as z.ZodType<OriginReasonEnum>;


/** used by outlook to determine whether a timeblock is taken and how it should be drawn. Additionally affects things like available status on teams */
export enum OutlookBusyStatusEnum {
/** block invitations teams: green */
	tentative = 2,
/** block invitations teams: red */
	busy = 3,
/** block invitations teams: small green (text: available, Out Of office) */
	oof = 4,
/** block invitations teams: green */
	workingElsewhere = 5,
}

export const OutlookBusyStatusSchema = enumSchema(OutlookBusyStatusEnum) as unknown as z.ZodType<OutlookBusyStatusEnum>;
export const OutlookBusyStatusJsonSchema = enumSchema(OutlookBusyStatusEnum).describe("used by outlook to determine whether a timeblock is taken and how it should be drawn. Additionally affects things like available status on teams - Schema: { { k: tentative, v: 2, Description: block invitations teams: green}, { k: busy, v: 3, Description: block invitations teams: red}, { k: oof, v: 4, Description: block invitations teams: small green (text: available, Out Of office)}, { k: workingElsewhere, v: 5, Description: block invitations teams: green} }") as unknown as z.ZodType<OutlookBusyStatusEnum>;


/** paidAllowanceUsability: What type of paidAllowance is this, and can it be modified by planners */
export enum PaidAllowanceUsabilityEnum {
/** Ordinary paidallowance modifyable by any user */
	ordinary = 0,
/** swapNeutralizing paidallowance. Cannot be modified by regular planners */
	swapNeutralizing = 1,
}

export const PaidAllowanceUsabilitySchema = enumSchema(PaidAllowanceUsabilityEnum) as unknown as z.ZodType<PaidAllowanceUsabilityEnum>;
export const PaidAllowanceUsabilityJsonSchema = enumSchema(PaidAllowanceUsabilityEnum).describe("paidAllowanceUsability: What type of paidAllowance is this, and can it be modified by planners - Schema: { { k: ordinary, v: 0, Description: Ordinary paidallowance modifyable by any user}, { k: swapNeutralizing, v: 1, Description: swapNeutralizing paidallowance. Cannot be modified by regular planners} }") as unknown as z.ZodType<PaidAllowanceUsabilityEnum>;


/** how often to change password */
export enum PasswordChangeFrequenceEnum {
/** newer */
	never = 0,
/** Month */
	month = 30,
/** SecondMonth */
	secondMonth = 60,
/** ThirdMonth */
	thirdMonth = 90,
/** halfYear */
	halfYear = 180,
/** year */
	year = 360,
/** 2 years */
	twoYears = 730,
}

export const PasswordChangeFrequenceSchema = enumSchema(PasswordChangeFrequenceEnum) as unknown as z.ZodType<PasswordChangeFrequenceEnum>;
export const PasswordChangeFrequenceJsonSchema = enumSchema(PasswordChangeFrequenceEnum).describe("how often to change password - Schema: { { k: never, v: 0, Description: newer}, { k: month, v: 30, Description: Month}, { k: secondMonth, v: 60, Description: SecondMonth}, { k: thirdMonth, v: 90, Description: ThirdMonth}, { k: halfYear, v: 180, Description: halfYear}, { k: year, v: 360, Description: year}, { k: twoYears, v: 730, Description: 2 years} }") as unknown as z.ZodType<PasswordChangeFrequenceEnum>;


/** used by myPlan */
export enum PasswordChangeReqEnum {
/** Password OK */
	noChangeRequired = 0,
/** passwordExpired */
	passwordExpired = 1,
/** temporaryPasswordUsed */
	temporaryPasswordUsed = 2,
}

export const PasswordChangeReqSchema = enumSchema(PasswordChangeReqEnum) as unknown as z.ZodType<PasswordChangeReqEnum>;
export const PasswordChangeReqJsonSchema = enumSchema(PasswordChangeReqEnum).describe("used by myPlan - Schema: { { k: noChangeRequired, v: 0, Description: Password OK}, { k: passwordExpired, v: 1, Description: passwordExpired}, { k: temporaryPasswordUsed, v: 2, Description: temporaryPasswordUsed} }") as unknown as z.ZodType<PasswordChangeReqEnum>;


/** Status of a salary approval */
export enum PayPeriodTypeEnum {
	all = -1,
	monthly = 1,
	hourly = 0,
}

export const PayPeriodTypeSchema = enumSchema(PayPeriodTypeEnum) as unknown as z.ZodType<PayPeriodTypeEnum>;
export const PayPeriodTypeJsonSchema = enumSchema(PayPeriodTypeEnum).describe("Status of a salary approval - Schema: { { k: all, v: -1, Description: <empty>}, { k: monthly, v: 1, Description: <empty>}, { k: hourly, v: 0, Description: <empty>} }") as unknown as z.ZodType<PayPeriodTypeEnum>;


/** 9, 8, 7, 6, 5, 4, 3 */
export enum PdcDeletedValuesEnum {
/** Rows temporary deleted - usually for analysis - every value >1 */
	temporaryMarkedDeleted = 2,
/** Rows deleted by buisness logic */
	rowsMarkedDeleted = 1,
/** Rows deleted by erase module */
	rowsMarkedErase = -6,
}

export const PdcDeletedValuesSchema = enumSchema(PdcDeletedValuesEnum) as unknown as z.ZodType<PdcDeletedValuesEnum>;
export const PdcDeletedValuesJsonSchema = enumSchema(PdcDeletedValuesEnum).describe("9, 8, 7, 6, 5, 4, 3 - Schema: { { k: temporaryMarkedDeleted, v: 2, Description: Rows temporary deleted - usually for analysis - every value >1}, { k: rowsMarkedDeleted, v: 1, Description: Rows deleted by buisness logic}, { k: rowsMarkedErase, v: -6, Description: Rows deleted by erase module} }") as unknown as z.ZodType<PdcDeletedValuesEnum>;


/** Period Cost Principle */
export enum PeriodCostPrincipleEnum {
/** hour and monthly paided for all working hours */
	timeBased = 0,
/** fixed salary, some supplement may accour. The fixed salary is based on norm - the cost depends on the normhpurs in the period */
	fixedSalaryNorm = 1,
/** fixed salary, some supplement may accour. The fixed salary on based on days/weeks - the cost is the same every calendar day */
	fixedSalaryDay = 2,
/** fixed salary, some supplement may accour. The fixed salary on based on month - the cost is the same every calendar month, so the day cost depends on the month length */
	fixedSalaryMonth = 3,
}

export const PeriodCostPrincipleSchema = enumSchema(PeriodCostPrincipleEnum) as unknown as z.ZodType<PeriodCostPrincipleEnum>;
export const PeriodCostPrincipleJsonSchema = enumSchema(PeriodCostPrincipleEnum).describe("Period Cost Principle - Schema: { { k: timeBased, v: 0, Description: hour and monthly paided for all working hours}, { k: fixedSalaryNorm, v: 1, Description: fixed salary, some supplement may accour. The fixed salary is based on norm - the cost depends on the normhpurs in the period}, { k: fixedSalaryDay, v: 2, Description: fixed salary, some supplement may accour. The fixed salary on based on days/weeks - the cost is the same every calendar day}, { k: fixedSalaryMonth, v: 3, Description: fixed salary, some supplement may accour. The fixed salary on based on month - the cost is the same every calendar month, so the day cost depends on the month length} }") as unknown as z.ZodType<PeriodCostPrincipleEnum>;


/** parameters for field compression of large data fields - highCompression is default */
export enum PeriodCostTypeEnum {
	periodMonth = 1,
}

export const PeriodCostTypeSchema = enumSchema(PeriodCostTypeEnum) as unknown as z.ZodType<PeriodCostTypeEnum>;
export const PeriodCostTypeJsonSchema = enumSchema(PeriodCostTypeEnum).describe("parameters for field compression of large data fields - highCompression is default - Schema: { { k: periodMonth, v: 1, Description: <empty>} }") as unknown as z.ZodType<PeriodCostTypeEnum>;


/** Person Checkin Status */
export enum PersonCheckInStatusEnum {
/** Person has not checked in */
	notPresent = 0,
/** Person has checked in */
	present = 1,
/** CheckIn state does not make sense, typically because item is historic or planned in future */
	undefined = 2,
}

export const PersonCheckInStatusSchema = enumSchema(PersonCheckInStatusEnum) as unknown as z.ZodType<PersonCheckInStatusEnum>;
export const PersonCheckInStatusJsonSchema = enumSchema(PersonCheckInStatusEnum).describe("Person Checkin Status - Schema: { { k: notPresent, v: 0, Description: Person has not checked in}, { k: present, v: 1, Description: Person has checked in}, { k: undefined, v: 2, Description: CheckIn state does not make sense, typically because item is historic or planned in future} }") as unknown as z.ZodType<PersonCheckInStatusEnum>;


/** used by myPlan. "personDataPrivacy" indicates the field appears in that object */
export enum PersonDataEnum {
/** use person1.name */
	name = 0,
/** use person1.address and personDataPrivacy */
	address = 1,
/** use person1.address2 and personDataPrivacy - and missing in myPlan */
	address2 = 2,
/** use person1.zipcode and personDataPrivacy */
	zipcode = 3,
/** use person1.city and personDataPrivacy */
	city = 4,
/** use person1.phone and personDataPrivacy */
	phone1 = 5,
/** use person1.altphone and personDataPrivacy */
	phone2 = 6,
/** use person1.mobilphone and personDataPrivacy and editable */
	phone3 = 7,
/** use person1.email and personDataPrivacy and editable */
	email = 8,
/** use person1.birthdate and personDataPrivacy - and missing in myPlan */
	birthdate = 9,
/** use person1.salaryid */
	salaryid = 20,
/** use person1.validitystart */
	empstart = 21,
/** use person1.validityend */
	empend = 22,
/** use person1.relativeList */
	relatives = 23,
/** use person2.Title */
	title = 100,
/** use orgunit intitution */
	institution = 200,
/** use orgunit unit */
	unit = 201,
}

export const PersonDataSchema = enumSchema(PersonDataEnum) as unknown as z.ZodType<PersonDataEnum>;
export const PersonDataJsonSchema = enumSchema(PersonDataEnum).describe("used by myPlan. \"personDataPrivacy\" indicates the field appears in that object - Schema: { { k: name, v: 0, Description: use person1.name}, { k: address, v: 1, Description: use person1.address and personDataPrivacy}, { k: address2, v: 2, Description: use person1.address2 and personDataPrivacy - and missing in myPlan}, { k: zipcode, v: 3, Description: use person1.zipcode and personDataPrivacy}, { k: city, v: 4, Description: use person1.city and personDataPrivacy}, { k: phone1, v: 5, Description: use person1.phone and personDataPrivacy}, { k: phone2, v: 6, Description: use person1.altphone and personDataPrivacy}, { k: phone3, v: 7, Description: use person1.mobilphone and personDataPrivacy and editable}, { k: email, v: 8, Description: use person1.email and personDataPrivacy and editable}, { k: birthdate, v: 9, Description: use person1.birthdate and personDataPrivacy - and missing in myPlan}, { k: salaryid, v: 20, Description: use person1.salaryid}, { k: empstart, v: 21, Description: use person1.validitystart}, { k: empend, v: 22, Description: use person1.validityend}, { k: relatives, v: 23, Description: use person1.relativeList}, { k: title, v: 100, Description: use person2.Title}, { k: institution, v: 200, Description: use orgunit intitution}, { k: unit, v: 201, Description: use orgunit unit} }") as unknown as z.ZodType<PersonDataEnum>;


/** Extra person1 are allowed for special purposes */
export enum PersonFictiveEnum {
/** ordinary person1 */
	normal = 0,
/** person is fictive */
	fictive = 1,
/** old record compute whether person is real */
	compute = 2,
}

export const PersonFictiveSchema = enumSchema(PersonFictiveEnum) as unknown as z.ZodType<PersonFictiveEnum>;
export const PersonFictiveJsonSchema = enumSchema(PersonFictiveEnum).describe("Extra person1 are allowed for special purposes - Schema: { { k: normal, v: 0, Description: ordinary person1}, { k: fictive, v: 1, Description: person is fictive}, { k: compute, v: 2, Description: old record compute whether person is real} }") as unknown as z.ZodType<PersonFictiveEnum>;


/** Type that defines person genders - rather traditionally, but with the option of future extensions :) */
export enum PersonGenderTypeEnum {
/** Gender is not known - or both */
	notKnown = 0,
/** Female gender */
	female = 1,
/** Male gender */
	male = 2,
}

export const PersonGenderTypeSchema = enumSchema(PersonGenderTypeEnum) as unknown as z.ZodType<PersonGenderTypeEnum>;
export const PersonGenderTypeJsonSchema = enumSchema(PersonGenderTypeEnum).describe("Type that defines person genders - rather traditionally, but with the option of future extensions :) - Schema: { { k: notKnown, v: 0, Description: Gender is not known - or both}, { k: female, v: 1, Description: Female gender}, { k: male, v: 2, Description: Male gender} }") as unknown as z.ZodType<PersonGenderTypeEnum>;


/** properties on a persongroup */
export enum PersongroupPropertyEnum {
/** may the members of this group swap shifts between each other */
	shiftSwap = 2,
/** this persongroup uses function planning */
	functionPlanning = 3,
/** employee created exchange_regs on this persongroup do not require planner approval, regardless of orgunit.swapPolicy */
	exchangeAutoApprove = 4,
}

export const PersongroupPropertySchema = enumSchema(PersongroupPropertyEnum) as unknown as z.ZodType<PersongroupPropertyEnum>;
export const PersongroupPropertyJsonSchema = enumSchema(PersongroupPropertyEnum).describe("properties on a persongroup - Schema: { { k: shiftSwap, v: 2, Description: may the members of this group swap shifts between each other}, { k: functionPlanning, v: 3, Description: this persongroup uses function planning}, { k: exchangeAutoApprove, v: 4, Description: employee created exchange_regs on this persongroup do not require planner approval, regardless of orgunit.swapPolicy} }") as unknown as z.ZodType<PersongroupPropertyEnum>;


/** Type that defines relation between two persons */
export enum PersonRelationTypeEnum {
/** Person is Child of related person */
	childOf = 0,
/** Person is Spouse of related person */
	spouseOf = 1,
/** Person is Parent of related person */
	parentOf = 2,
/** Person is Friend of related person */
	friendOf = 3,
}

export const PersonRelationTypeSchema = enumSchema(PersonRelationTypeEnum) as unknown as z.ZodType<PersonRelationTypeEnum>;
export const PersonRelationTypeJsonSchema = enumSchema(PersonRelationTypeEnum).describe("Type that defines relation between two persons - Schema: { { k: childOf, v: 0, Description: Person is Child of related person}, { k: spouseOf, v: 1, Description: Person is Spouse of related person}, { k: parentOf, v: 2, Description: Person is Parent of related person}, { k: friendOf, v: 3, Description: Person is Friend of related person} }") as unknown as z.ZodType<PersonRelationTypeEnum>;


/** Extra person1 are allowed for special purposes */
export enum PersonTypeEnum {
/** ordinary person1 (default) */
	normal = 0,
/** May be used in web. Depending on the item type, it is computed if the item has hours (valid HHmm.minuteoffset value 0-1439, or 9999 if empty) and if the user may edit them. not used by activity_period_def */
	fictive = 1,
}

export const PersonTypeSchema = enumSchema(PersonTypeEnum) as unknown as z.ZodType<PersonTypeEnum>;
export const PersonTypeJsonSchema = enumSchema(PersonTypeEnum).describe("Extra person1 are allowed for special purposes - Schema: { { k: normal, v: 0, Description: ordinary person1 (default)}, { k: fictive, v: 1, Description: May be used in web. Depending on the item type, it is computed if the item has hours (valid HHmm.minuteoffset value 0-1439, or 9999 if empty) and if the user may edit them. not used by activity_period_def} }") as unknown as z.ZodType<PersonTypeEnum>;


/** Defines the options when split/move validity of person2 and person3 reg */
export enum PersonValidityPeriodTypeEnum {
/** Split only person2 */
	planningPeriod = 0,
/** Split only person3 */
	payerPeriod = 1,
/** Split person2 and person3 */
	bothPeriods = 2,
}

export const PersonValidityPeriodTypeSchema = enumSchema(PersonValidityPeriodTypeEnum) as unknown as z.ZodType<PersonValidityPeriodTypeEnum>;
export const PersonValidityPeriodTypeJsonSchema = enumSchema(PersonValidityPeriodTypeEnum).describe("Defines the options when split/move validity of person2 and person3 reg - Schema: { { k: planningPeriod, v: 0, Description: Split only person2}, { k: payerPeriod, v: 1, Description: Split only person3}, { k: bothPeriods, v: 2, Description: Split person2 and person3} }") as unknown as z.ZodType<PersonValidityPeriodTypeEnum>;


/** Is the picture approved */
export enum PictureApprovalEnum {
/** noApproval */
	noApproval = 0,
/** internalUse */
	internalUse = 10,
/** publicUse */
	publicUse = 20,
}

export const PictureApprovalSchema = enumSchema(PictureApprovalEnum) as unknown as z.ZodType<PictureApprovalEnum>;
export const PictureApprovalJsonSchema = enumSchema(PictureApprovalEnum).describe("Is the picture approved - Schema: { { k: noApproval, v: 0, Description: noApproval}, { k: internalUse, v: 10, Description: internalUse}, { k: publicUse, v: 20, Description: publicUse} }") as unknown as z.ZodType<PictureApprovalEnum>;


/** kind of registration. Used to scope the registration. planDimension::usedPlanList defines the planid used in the installation */
export enum PlanEnum {
/** used in program call only - not stored */
	nil = -1,
/** The plan for real registrations used for producing salaryinfo */
	master = 1,
/** The registration in this plan is the official planned data - used when alternating from the original plan is importent */
	planned = 2,
/** employee request for registrations */
	request = 3,
/** employee time checkins */
	checkin = 4,
/** Copy of master, used to restore if consolidated request/checkin is rejected */
	baseline = 5,
/** DEPRECATED, removed from c# code. Planner registrations, will be consolidated but not baselined. They usually have a reduced level of sorts and rights. */
	intermediate = 6,
/** not used in the tables, but for completeness */
	roster = 100,
}

export const PlanSchema = enumSchema(PlanEnum) as unknown as z.ZodType<PlanEnum>;
export const PlanJsonSchema = enumSchema(PlanEnum).describe("kind of registration. Used to scope the registration. planDimension::usedPlanList defines the planid used in the installation - Schema: { { k: nil, v: -1, Description: used in program call only - not stored}, { k: master, v: 1, Description: The plan for real registrations used for producing salaryinfo}, { k: planned, v: 2, Description: The registration in this plan is the official planned data - used when alternating from the original plan is importent}, { k: request, v: 3, Description: employee request for registrations}, { k: checkin, v: 4, Description: employee time checkins}, { k: baseline, v: 5, Description: Copy of master, used to restore if consolidated request/checkin is rejected}, { k: intermediate, v: 6, Description: DEPRECATED, removed from c# code. Planner registrations, will be consolidated but not baselined. They usually have a reduced level of sorts and rights.}, { k: roster, v: 100, Description: not used in the tables, but for completeness} }") as unknown as z.ZodType<PlanEnum>;


/** accurate and will eventually change when start time approached. Fine-grained intervals on the other hand are more certain to be executed at start time. Automatic WorkLoad analysis and other auto scheduling functions only operate on coarse-grained tasks while fine-grained tasks are unaltered */
export enum PlanningGranularityEnum {
/** fine */
	fine = 1,
/** coarse */
	coarse = 2,
}

export const PlanningGranularitySchema = enumSchema(PlanningGranularityEnum) as unknown as z.ZodType<PlanningGranularityEnum>;
export const PlanningGranularityJsonSchema = enumSchema(PlanningGranularityEnum).describe("accurate and will eventually change when start time approached. Fine-grained intervals on the other hand are more certain to be executed at start time. Automatic WorkLoad analysis and other auto scheduling functions only operate on coarse-grained tasks while fine-grained tasks are unaltered - Schema: { { k: fine, v: 1, Description: fine}, { k: coarse, v: 2, Description: coarse} }") as unknown as z.ZodType<PlanningGranularityEnum>;


/** used by myPlan */
export enum PlanStatusEnum {
/** Unknown planstatus */
	mp_unknown = 0,
/** Before any available Staff data */
	closed = 1,
/** Data sent to salary systems */
	realized = 2,
/** The planner has approved the plan for the salary system */
	approved = 3,
/** The planner makes final adjustments for the salary system */
	adjustment = 4,
/** Users have reported, planner may take over */
	userApproved = 5,
/** Users may report in this period */
	checkIn = 6,
/** The plan is known, daily operation takes place */
	operation = 7,
/** In this period the user may normally not see data */
	planning = 8,
/** Uses may request (wish) here */
	request = 9,
/** After any available Staff data */
	future = 10,
}

export const PlanStatusSchema = enumSchema(PlanStatusEnum) as unknown as z.ZodType<PlanStatusEnum>;
export const PlanStatusJsonSchema = enumSchema(PlanStatusEnum).describe("used by myPlan - Schema: { { k: mp_unknown, v: 0, Description: Unknown planstatus}, { k: closed, v: 1, Description: Before any available Staff data}, { k: realized, v: 2, Description: Data sent to salary systems}, { k: approved, v: 3, Description: The planner has approved the plan for the salary system}, { k: adjustment, v: 4, Description: The planner makes final adjustments for the salary system}, { k: userApproved, v: 5, Description: Users have reported, planner may take over}, { k: checkIn, v: 6, Description: Users may report in this period}, { k: operation, v: 7, Description: The plan is known, daily operation takes place}, { k: planning, v: 8, Description: In this period the user may normally not see data}, { k: request, v: 9, Description: Uses may request (wish) here}, { k: future, v: 10, Description: After any available Staff data} }") as unknown as z.ZodType<PlanStatusEnum>;


/** userid builint in the program */
export enum PredefinedUserEnum {
/** System */
	sys = -4,
/** pdc online user */
	pdc = -5,
/** httpserver */
	httpserver = -7,
/** systembridge */
	systembridge = -8,
/** appserver */
	appserver = -9,
/** batch */
	batch = -10,
/** script */
	script = -12,
/** before login */
	beforelogin = -20,
/** User with a one day password */
	temporary = -100,
/** these userids are reserved for pdc supporters */
	pdcBase = -1000,
/** these userids are reserved for sd supporters */
	sdBase = -2000,
}

export const PredefinedUserSchema = enumSchema(PredefinedUserEnum) as unknown as z.ZodType<PredefinedUserEnum>;
export const PredefinedUserJsonSchema = enumSchema(PredefinedUserEnum).describe("userid builint in the program - Schema: { { k: sys, v: -4, Description: System}, { k: pdc, v: -5, Description: pdc online user}, { k: httpserver, v: -7, Description: httpserver}, { k: systembridge, v: -8, Description: systembridge}, { k: appserver, v: -9, Description: appserver}, { k: batch, v: -10, Description: batch}, { k: script, v: -12, Description: script}, { k: beforelogin, v: -20, Description: before login}, { k: temporary, v: -100, Description: User with a one day password}, { k: pdcBase, v: -1000, Description: these userids are reserved for pdc supporters}, { k: sdBase, v: -2000, Description: these userids are reserved for sd supporters} }") as unknown as z.ZodType<PredefinedUserEnum>;


/** Determines interpretation of preference_reg */
export enum PreferenceDefTypeEnum {
/** The employee can only opt into this */
	negativePreferenceOnly = 1,
/** The employee can only opt out of this */
	positivePreferenceOnly = 2,
/** The employee can both opt into and out of this */
	bothPreferencesPossible = 3,
}

export const PreferenceDefTypeSchema = enumSchema(PreferenceDefTypeEnum) as unknown as z.ZodType<PreferenceDefTypeEnum>;
export const PreferenceDefTypeJsonSchema = enumSchema(PreferenceDefTypeEnum).describe("Determines interpretation of preference_reg - Schema: { { k: negativePreferenceOnly, v: 1, Description: The employee can only opt into this}, { k: positivePreferenceOnly, v: 2, Description: The employee can only opt out of this}, { k: bothPreferencesPossible, v: 3, Description: The employee can both opt into and out of this} }") as unknown as z.ZodType<PreferenceDefTypeEnum>;


/** May a person use preferences */
export enum PreferencesAllowedEnum {
/** Can not use any preferences at all */
	noPreferences = 0,
/** The person may perform what ever is the deafult for the planning unit */
	followsPlanningUnit = 1,
/** May use preferences */
	preferencesAllowed = 2,
}

export const PreferencesAllowedSchema = enumSchema(PreferencesAllowedEnum) as unknown as z.ZodType<PreferencesAllowedEnum>;
export const PreferencesAllowedJsonSchema = enumSchema(PreferencesAllowedEnum).describe("May a person use preferences - Schema: { { k: noPreferences, v: 0, Description: Can not use any preferences at all}, { k: followsPlanningUnit, v: 1, Description: The person may perform what ever is the deafult for the planning unit}, { k: preferencesAllowed, v: 2, Description: May use preferences} }") as unknown as z.ZodType<PreferencesAllowedEnum>;


/** Determines interpretation of preference_reg */
export enum PreferenceTypeEnum {
/** The employee does not want this */
	negativePreference = 1,
/** The employee wants this */
	positivePreference = 2,
}

export const PreferenceTypeSchema = enumSchema(PreferenceTypeEnum) as unknown as z.ZodType<PreferenceTypeEnum>;
export const PreferenceTypeJsonSchema = enumSchema(PreferenceTypeEnum).describe("Determines interpretation of preference_reg - Schema: { { k: negativePreference, v: 1, Description: The employee does not want this}, { k: positivePreference, v: 2, Description: The employee wants this} }") as unknown as z.ZodType<PreferenceTypeEnum>;


/** hourlyPrice; piecePrice */
export enum PriceUnitEnum {
/** HourlyPrice */
	hourlyPrice = 1,
/** PiecePrice */
	piecePrice = 2,
}

export const PriceUnitSchema = enumSchema(PriceUnitEnum) as unknown as z.ZodType<PriceUnitEnum>;
export const PriceUnitJsonSchema = enumSchema(PriceUnitEnum).describe("hourlyPrice; piecePrice - Schema: { { k: hourlyPrice, v: 1, Description: HourlyPrice}, { k: piecePrice, v: 2, Description: PiecePrice} }") as unknown as z.ZodType<PriceUnitEnum>;


/** parameters for program version check */
export enum ProgramVersionCheckEnum {
	noCheck = 1,
	programVersionWarningOnOther = 2,
	programVersionDisableOldVersions = 3,
	programVersionDisableOtherVersions = 4,
}

export const ProgramVersionCheckSchema = enumSchema(ProgramVersionCheckEnum) as unknown as z.ZodType<ProgramVersionCheckEnum>;
export const ProgramVersionCheckJsonSchema = enumSchema(ProgramVersionCheckEnum).describe("parameters for program version check - Schema: { { k: noCheck, v: 1, Description: <empty>}, { k: programVersionWarningOnOther, v: 2, Description: <empty>}, { k: programVersionDisableOldVersions, v: 3, Description: <empty>}, { k: programVersionDisableOtherVersions, v: 4, Description: <empty>} }") as unknown as z.ZodType<ProgramVersionCheckEnum>;


/** publish */
export enum PublishableEnum {
	isPublishable = 0,
	isAnonymous = 1,
	isHidden = 2,
}

export const PublishableSchema = enumSchema(PublishableEnum) as unknown as z.ZodType<PublishableEnum>;
export const PublishableJsonSchema = enumSchema(PublishableEnum).describe("publish - Schema: { { k: isPublishable, v: 0, Description: <empty>}, { k: isAnonymous, v: 1, Description: <empty>}, { k: isHidden, v: 2, Description: <empty>} }") as unknown as z.ZodType<PublishableEnum>;


/** which kind push service provider */
export enum PushProviderTypeEnum {
/** OBSOLETE  Apple Push Notification Services */
	apns = 0,
/** Google Firebase Messaging */
	fcm = 1,
}

export const PushProviderTypeSchema = enumSchema(PushProviderTypeEnum) as unknown as z.ZodType<PushProviderTypeEnum>;
export const PushProviderTypeJsonSchema = enumSchema(PushProviderTypeEnum).describe("which kind push service provider - Schema: { { k: apns, v: 0, Description: OBSOLETE  Apple Push Notification Services}, { k: fcm, v: 1, Description: Google Firebase Messaging} }") as unknown as z.ZodType<PushProviderTypeEnum>;


/** Function of planqualityReg */
export enum QualityFunctionEnum {
	releasePlan = 0,
	acceptPeriod = 1,
	adhoc = 2,
}

export const QualityFunctionSchema = enumSchema(QualityFunctionEnum) as unknown as z.ZodType<QualityFunctionEnum>;
export const QualityFunctionJsonSchema = enumSchema(QualityFunctionEnum).describe("Function of planqualityReg - Schema: { { k: releasePlan, v: 0, Description: <empty>}, { k: acceptPeriod, v: 1, Description: <empty>}, { k: adhoc, v: 2, Description: <empty>} }") as unknown as z.ZodType<QualityFunctionEnum>;


export enum QualityPeriodEnum {
	week = 1,
	month = 2,
	year = 3,
}

export const QualityPeriodSchema = enumSchema(QualityPeriodEnum) as unknown as z.ZodType<QualityPeriodEnum>;
export const QualityPeriodJsonSchema = enumSchema(QualityPeriodEnum).describe("Schema: { { k: week, v: 1, Description: <empty>}, { k: month, v: 2, Description: <empty>}, { k: year, v: 3, Description: <empty>} }") as unknown as z.ZodType<QualityPeriodEnum>;


/** readonlyUI */
export enum ReadonlyUIEnum {
	readonly = 1,
	updateable = 2,
}

export const ReadonlyUISchema = enumSchema(ReadonlyUIEnum) as unknown as z.ZodType<ReadonlyUIEnum>;
export const ReadonlyUIJsonSchema = enumSchema(ReadonlyUIEnum).describe("readonlyUI - Schema: { { k: readonly, v: 1, Description: <empty>}, { k: updateable, v: 2, Description: <empty>} }") as unknown as z.ZodType<ReadonlyUIEnum>;


/** How much (self) registration and planning can a person do */
export enum RegistrationAllowedEnum {
/** The person may perform what ever is the deafult for the planning unit */
	followsPlanningUnit = 0,
/** Can not make any registrations at all */
	nothing = 10,
/** May use the punch-clock interface functionality - only if planning unit is using this facility though. */
	timeAttendance = 20,
/** May use the punch-clock interface functionality, even on unplanned days - only if planning unit is using this facility though. */
	unplannedTimeAttendance = 30,
/** May make time attendance registrations in the past check-in interval. */
	timeRegistration = 40,
/** May make all types of registrations in the past check-in interval. */
	timeReporting = 50,
/** May make registrations in the past check-in interval and future operations interval. */
	selfPlanning = 60,
}

export const RegistrationAllowedSchema = enumSchema(RegistrationAllowedEnum) as unknown as z.ZodType<RegistrationAllowedEnum>;
export const RegistrationAllowedJsonSchema = enumSchema(RegistrationAllowedEnum).describe("How much (self) registration and planning can a person do - Schema: { { k: followsPlanningUnit, v: 0, Description: The person may perform what ever is the deafult for the planning unit}, { k: nothing, v: 10, Description: Can not make any registrations at all}, { k: timeAttendance, v: 20, Description: May use the punch-clock interface functionality - only if planning unit is using this facility though.}, { k: unplannedTimeAttendance, v: 30, Description: May use the punch-clock interface functionality, even on unplanned days - only if planning unit is using this facility though.}, { k: timeRegistration, v: 40, Description: May make time attendance registrations in the past check-in interval.}, { k: timeReporting, v: 50, Description: May make all types of registrations in the past check-in interval.}, { k: selfPlanning, v: 60, Description: May make registrations in the past check-in interval and future operations interval.} }") as unknown as z.ZodType<RegistrationAllowedEnum>;


/** name of periodinterval as defined by reg_person_status. Useraccess and loaderjobs. */
export enum RegistrationCategoryEnum {
/** used in program call only - not stored */
	nil = 0,
/** data stored in roster "dimension/encoding" */
	roster = 1,
/** . - reg_person_status.realizationstart */
	closedHistoric = 5,
/** reg_person_status.realizationstart - reg_person_status.approvalstart */
	realised = 2,
/** reg_person_status.approvalstart - reg_person_status.operationstart */
	approved = 9,
/** reg_person_status.operationstart - reg_person_status.checkinstart */
	actual = 3,
/** reg_person_status.checkinstart - person_status.planningstart */
	checkin = 10,
/** reg_person_status.planningstart - futureStart */
	planning = 4,
/** futureStart - . */
	closedFuture = 13,
/** reg_person_status.productionPlanningStart - futureStart */
	productionPlanning = 12,
/** reg_person_status.operationstart - reg_person_status.planningstart */
	planned = 6,
/** reg_person_status.requeststart - futureStart */
	request = 7,
/** reg_person_status.vacationrequeststart - reg_person_status.planningend */
	vacationRequest = 14,
/** person is hidden via person2.personIsPlanned=0 or alternativePlanningUnit or no relevant ordinary persongroupmemberships */
	dontShow = 15,
/** person has no person2 in this period */
	noPerson2 = 16,
}

export const RegistrationCategorySchema = enumSchema(RegistrationCategoryEnum) as unknown as z.ZodType<RegistrationCategoryEnum>;
export const RegistrationCategoryJsonSchema = enumSchema(RegistrationCategoryEnum).describe("name of periodinterval as defined by reg_person_status. Useraccess and loaderjobs. - Schema: { { k: nil, v: 0, Description: used in program call only - not stored}, { k: roster, v: 1, Description: data stored in roster \"dimension/encoding\"}, { k: closedHistoric, v: 5, Description: . - reg_person_status.realizationstart}, { k: realised, v: 2, Description: reg_person_status.realizationstart - reg_person_status.approvalstart}, { k: approved, v: 9, Description: reg_person_status.approvalstart - reg_person_status.operationstart}, { k: actual, v: 3, Description: reg_person_status.operationstart - reg_person_status.checkinstart}, { k: checkin, v: 10, Description: reg_person_status.checkinstart - person_status.planningstart}, { k: planning, v: 4, Description: reg_person_status.planningstart - futureStart}, { k: closedFuture, v: 13, Description: futureStart - .}, { k: productionPlanning, v: 12, Description: reg_person_status.productionPlanningStart - futureStart}, { k: planned, v: 6, Description: reg_person_status.operationstart - reg_person_status.planningstart}, { k: request, v: 7, Description: reg_person_status.requeststart - futureStart}, { k: vacationRequest, v: 14, Description: reg_person_status.vacationrequeststart - reg_person_status.planningend}, { k: dontShow, v: 15, Description: person is hidden via person2.personIsPlanned=0 or alternativePlanningUnit or no relevant ordinary persongroupmemberships}, { k: noPerson2, v: 16, Description: person has no person2 in this period} }") as unknown as z.ZodType<RegistrationCategoryEnum>;


/** Indicates who made the most recent change relative to planned */
export enum RegistrationForTotalchangedByEnum {
/** Everything is approved (wrt checkin) */
	employee = 1,
/** Something is not approved (wrt checkin) */
	planner = 2,
}

export const RegistrationForTotalchangedBySchema = enumSchema(RegistrationForTotalchangedByEnum) as unknown as z.ZodType<RegistrationForTotalchangedByEnum>;
export const RegistrationForTotalchangedByJsonSchema = enumSchema(RegistrationForTotalchangedByEnum).describe("Indicates who made the most recent change relative to planned - Schema: { { k: employee, v: 1, Description: Everything is approved (wrt checkin)}, { k: planner, v: 2, Description: Something is not approved (wrt checkin)} }") as unknown as z.ZodType<RegistrationForTotalchangedByEnum>;


/** Whether the registration existed in the plan, and whether it exists now */
export enum RegistrationForTotalchangeTypeEnum {
/** The registration in its current (master) state, the registration was not planned. The registration is new wrt planid = planned. */
	insert = 1,
/** Deprecated. The registration in its current (master) state, it existed previously, but with different countervalues or period: The registration in the current (master) plan overlaps with an originally planned registration, but it has different countervalues or period. */
	update = 2,
/** The registration in its planned state, it is no longer current (master). The registration is in planid = planned but not in planid = master. */
	delete = 3,
/** The registration is planned and has not changed its countervalues or period since planning. */
	noopr = 4,
}

export const RegistrationForTotalchangeTypeSchema = enumSchema(RegistrationForTotalchangeTypeEnum) as unknown as z.ZodType<RegistrationForTotalchangeTypeEnum>;
export const RegistrationForTotalchangeTypeJsonSchema = enumSchema(RegistrationForTotalchangeTypeEnum).describe("Whether the registration existed in the plan, and whether it exists now - Schema: { { k: insert, v: 1, Description: The registration in its current (master) state, the registration was not planned. The registration is new wrt planid = planned.}, { k: update, v: 2, Description: Deprecated. The registration in its current (master) state, it existed previously, but with different countervalues or period: The registration in the current (master) plan overlaps with an originally planned registration, but it has different countervalues or period.}, { k: delete, v: 3, Description: The registration in its planned state, it is no longer current (master). The registration is in planid = planned but not in planid = master.}, { k: noopr, v: 4, Description: The registration is planned and has not changed its countervalues or period since planning.} }") as unknown as z.ZodType<RegistrationForTotalchangeTypeEnum>;


/** types of registrations with countervalues */
export enum RegistrationWithCountersTypeEnum {
	shift = 1,
	availability = 2,
	allowance = 3,
}

export const RegistrationWithCountersTypeSchema = enumSchema(RegistrationWithCountersTypeEnum) as unknown as z.ZodType<RegistrationWithCountersTypeEnum>;
export const RegistrationWithCountersTypeJsonSchema = enumSchema(RegistrationWithCountersTypeEnum).describe("types of registrations with countervalues - Schema: { { k: shift, v: 1, Description: <empty>}, { k: availability, v: 2, Description: <empty>}, { k: allowance, v: 3, Description: <empty>} }") as unknown as z.ZodType<RegistrationWithCountersTypeEnum>;


/** parameters for program version check */
export enum RegStatusCodeEnum {
	regstatusCodeNil = 0,
	shift_calc = 1,
	summary_sum = 2,
	shift_repair = 3,
}

export const RegStatusCodeSchema = enumSchema(RegStatusCodeEnum) as unknown as z.ZodType<RegStatusCodeEnum>;
export const RegStatusCodeJsonSchema = enumSchema(RegStatusCodeEnum).describe("parameters for program version check - Schema: { { k: regstatusCodeNil, v: 0, Description: <empty>}, { k: shift_calc, v: 1, Description: <empty>}, { k: summary_sum, v: 2, Description: <empty>}, { k: shift_repair, v: 3, Description: <empty>} }") as unknown as z.ZodType<RegStatusCodeEnum>;


/** Users of the moduleReport Table */
export enum ReportOwnerEnum {
	eraseReport = 1,
	validateReport = 2,
}

export const ReportOwnerSchema = enumSchema(ReportOwnerEnum) as unknown as z.ZodType<ReportOwnerEnum>;
export const ReportOwnerJsonSchema = enumSchema(ReportOwnerEnum).describe("Users of the moduleReport Table - Schema: { { k: eraseReport, v: 1, Description: <empty>}, { k: validateReport, v: 2, Description: <empty>} }") as unknown as z.ZodType<ReportOwnerEnum>;


/** May a person make requests */
export enum RequestAllowedEnum {
/** The person may perform what ever is the deafult for the planning unit */
	followsPlanningUnit = 0,
/** Can not make any requests at all */
	nothing = 1,
/** May make requests */
	requestAllowed = 2,
}

export const RequestAllowedSchema = enumSchema(RequestAllowedEnum) as unknown as z.ZodType<RequestAllowedEnum>;
export const RequestAllowedJsonSchema = enumSchema(RequestAllowedEnum).describe("May a person make requests - Schema: { { k: followsPlanningUnit, v: 0, Description: The person may perform what ever is the deafult for the planning unit}, { k: nothing, v: 1, Description: Can not make any requests at all}, { k: requestAllowed, v: 2, Description: May make requests} }") as unknown as z.ZodType<RequestAllowedEnum>;


/** Resource Kind */
export enum ResourceKindEnum {
	person = 1,
	team = 2,
	equipment = 3,
}

export const ResourceKindSchema = enumSchema(ResourceKindEnum) as unknown as z.ZodType<ResourceKindEnum>;
export const ResourceKindJsonSchema = enumSchema(ResourceKindEnum).describe("Resource Kind - Schema: { { k: person, v: 1, Description: <empty>}, { k: team, v: 2, Description: <empty>}, { k: equipment, v: 3, Description: <empty>} }") as unknown as z.ZodType<ResourceKindEnum>;


/** Type of rules supported. Must match functors of RuleExpr domain */
export enum ResourceRuleTypeEnum {
/** Share */
	share = 1,
}

export const ResourceRuleTypeSchema = enumSchema(ResourceRuleTypeEnum) as unknown as z.ZodType<ResourceRuleTypeEnum>;
export const ResourceRuleTypeJsonSchema = enumSchema(ResourceRuleTypeEnum).describe("Type of rules supported. Must match functors of RuleExpr domain - Schema: { { k: share, v: 1, Description: Share} }") as unknown as z.ZodType<ResourceRuleTypeEnum>;


/** The number of elements (shift/absence/activities) that the rule compares at a time */
export enum RuleArityEnum {
	definition_rule = 0,
	one_element_rule = 1,
	two_element_rule = 2,
	multiple_element_rule = 100,
}

export const RuleAritySchema = enumSchema(RuleArityEnum) as unknown as z.ZodType<RuleArityEnum>;
export const RuleArityJsonSchema = enumSchema(RuleArityEnum).describe("The number of elements (shift/absence/activities) that the rule compares at a time - Schema: { { k: definition_rule, v: 0, Description: <empty>}, { k: one_element_rule, v: 1, Description: <empty>}, { k: two_element_rule, v: 2, Description: <empty>}, { k: multiple_element_rule, v: 100, Description: <empty>} }") as unknown as z.ZodType<RuleArityEnum>;


/** Used by myPlan to determine the persongroups available to persons, possibly based on Original Orgunits (OO), which are derived with ruleOriginalOrgunit. */
export enum RuleCurrentPersonGroupsEnum {
/** The person's persongroups which are on non-obsolete orgunits in OO, or their ancestors or children. This setting is the default for ruleCurrentPersonGroups, which is used in most cases. */
	compatible = 0,
/** Persongroups (regardless of person group memberships) matching ruleIncludeGroup which are on or below the orgunits O. The orgunits O are OO plus those with info2 <> "" and info2 in OO.info2. This setting is currently unused and it is not supported by the Prolog backend. */
	workplace = 1,
/** Persongroups (regardless of person group memberships) matching ruleIncludeGroup at or below the orgunits orgunits O. The orgunits O are the "firstOrSelf" ancestor of each orgunit in OO with property applicationsetting.rootProperty. This setting is currently only used by PDC */
	propertyRoot = 2,
/** Persongroups (regardless of person group memberships) matching ruleIncludeGroup at or below OO. This setting is the default for ruleBoardGroups, which is used for message groups. */
	subtree = 3,
/** Persongroups (regardless of person group memberships) matching ruleIncludeGroup at or below the orgunits orgunits O. The orgunits O are OO plus each orgunits parent, unless the orgunit or its parent is an institution. This setting is currently unused. */
	extendedTree = 4,
/** The person's persongroups. This setting is currently unused. */
	all = 5,
/** Like "all" but only groups for which there are no other persongroups below the persongroup's orgunit. This setting is currently unused and it is not supported by the Prolog backend */
	mostSpecific = 6,
}

export const RuleCurrentPersonGroupsSchema = enumSchema(RuleCurrentPersonGroupsEnum) as unknown as z.ZodType<RuleCurrentPersonGroupsEnum>;
export const RuleCurrentPersonGroupsJsonSchema = enumSchema(RuleCurrentPersonGroupsEnum).describe("Used by myPlan to determine the persongroups available to persons, possibly based on Original Orgunits (OO), which are derived with ruleOriginalOrgunit. - Schema: { { k: compatible, v: 0, Description: The person's persongroups which are on non-obsolete orgunits in OO, or their ancestors or children. This setting is the default for ruleCurrentPersonGroups, which is used in most cases.}, { k: workplace, v: 1, Description: Persongroups (regardless of person group memberships) matching ruleIncludeGroup which are on or below the orgunits O. The orgunits O are OO plus those with info2 <> \"\" and info2 in OO.info2. This setting is currently unused and it is not supported by the Prolog backend.}, { k: propertyRoot, v: 2, Description: Persongroups (regardless of person group memberships) matching ruleIncludeGroup at or below the orgunits orgunits O. The orgunits O are the \"firstOrSelf\" ancestor of each orgunit in OO with property applicationsetting.rootProperty. This setting is currently only used by PDC}, { k: subtree, v: 3, Description: Persongroups (regardless of person group memberships) matching ruleIncludeGroup at or below OO. This setting is the default for ruleBoardGroups, which is used for message groups.}, { k: extendedTree, v: 4, Description: Persongroups (regardless of person group memberships) matching ruleIncludeGroup at or below the orgunits orgunits O. The orgunits O are OO plus each orgunits parent, unless the orgunit or its parent is an institution. This setting is currently unused.}, { k: all, v: 5, Description: The person's persongroups. This setting is currently unused.}, { k: mostSpecific, v: 6, Description: Like \"all\" but only groups for which there are no other persongroups below the persongroup's orgunit. This setting is currently unused and it is not supported by the Prolog backend} }") as unknown as z.ZodType<RuleCurrentPersonGroupsEnum>;


/** We previously had the following enum, which has been replaced by protectedDayOff  absence           2 "@Absence" */
export enum RuleidgroupEnum {
	error = 0,
	restingTime = 1,
	protectedDayOff = 3,
	freeWeekend = 4,
	other = 5,
	shiftRules = 6,
	activities = 7,
	fortyEightHours = 8,
}

export const RuleidgroupSchema = enumSchema(RuleidgroupEnum) as unknown as z.ZodType<RuleidgroupEnum>;
export const RuleidgroupJsonSchema = enumSchema(RuleidgroupEnum).describe("We previously had the following enum, which has been replaced by protectedDayOff  absence           2 \"@Absence\" - Schema: { { k: error, v: 0, Description: <empty>}, { k: restingTime, v: 1, Description: <empty>}, { k: protectedDayOff, v: 3, Description: <empty>}, { k: freeWeekend, v: 4, Description: <empty>}, { k: other, v: 5, Description: <empty>}, { k: shiftRules, v: 6, Description: <empty>}, { k: activities, v: 7, Description: <empty>}, { k: fortyEightHours, v: 8, Description: <empty>} }") as unknown as z.ZodType<RuleidgroupEnum>;


/** used by myPlan */
export enum RuleIncludeGroupEnum {
/** Include only person groups that are also orgunits */
	onlyOrgUnit = 0,
/** Include any kind of group */
	any = 1,
}

export const RuleIncludeGroupSchema = enumSchema(RuleIncludeGroupEnum) as unknown as z.ZodType<RuleIncludeGroupEnum>;
export const RuleIncludeGroupJsonSchema = enumSchema(RuleIncludeGroupEnum).describe("used by myPlan - Schema: { { k: onlyOrgUnit, v: 0, Description: Include only person groups that are also orgunits}, { k: any, v: 1, Description: Include any kind of group} }") as unknown as z.ZodType<RuleIncludeGroupEnum>;


/** used by myPlan */
export enum RuleIncludeGroupMembersEnum {
/** Include only members from the first group in recipient list. This represents legacy behavior and is consequently the default. */
	first = 0,
/** Include memebers of all groups in recipient list. */
	all = 1,
}

export const RuleIncludeGroupMembersSchema = enumSchema(RuleIncludeGroupMembersEnum) as unknown as z.ZodType<RuleIncludeGroupMembersEnum>;
export const RuleIncludeGroupMembersJsonSchema = enumSchema(RuleIncludeGroupMembersEnum).describe("used by myPlan - Schema: { { k: first, v: 0, Description: Include only members from the first group in recipient list. This represents legacy behavior and is consequently the default.}, { k: all, v: 1, Description: Include memebers of all groups in recipient list.} }") as unknown as z.ZodType<RuleIncludeGroupMembersEnum>;


/** Used by myPlan to determine the coworker persongroups. See ruleCurrentPersonGroups */
export enum RuleOriginalOrgunitEnum {
/** First valid p3 intersecting period */
	compatible = 0,
/** All valid p2s intersecting current period */
	p2 = 1,
/** All valid p3s intersecting current period */
	p3 = 2,
}

export const RuleOriginalOrgunitSchema = enumSchema(RuleOriginalOrgunitEnum) as unknown as z.ZodType<RuleOriginalOrgunitEnum>;
export const RuleOriginalOrgunitJsonSchema = enumSchema(RuleOriginalOrgunitEnum).describe("Used by myPlan to determine the coworker persongroups. See ruleCurrentPersonGroups - Schema: { { k: compatible, v: 0, Description: First valid p3 intersecting period}, { k: p2, v: 1, Description: All valid p2s intersecting current period}, { k: p3, v: 2, Description: All valid p3s intersecting current period} }") as unknown as z.ZodType<RuleOriginalOrgunitEnum>;


/** Enum for which rule applies */
export enum RuleTableIdEnum {
/** shift_reg table number */
	shift_reg = 39,
/** availability_reg table number */
	availability_reg = 25,
/** activity_reg table number */
	activity_reg = 22,
/** prd_assignment_reg table number */
	prd_assignment_reg = 162,
}

export const RuleTableIdSchema = enumSchema(RuleTableIdEnum) as unknown as z.ZodType<RuleTableIdEnum>;
export const RuleTableIdJsonSchema = enumSchema(RuleTableIdEnum).describe("Enum for which rule applies - Schema: { { k: shift_reg, v: 39, Description: shift_reg table number}, { k: availability_reg, v: 25, Description: availability_reg table number}, { k: activity_reg, v: 22, Description: activity_reg table number}, { k: prd_assignment_reg, v: 162, Description: prd_assignment_reg table number} }") as unknown as z.ZodType<RuleTableIdEnum>;


/** How web and consolidation coordinate. Specified in by applicationsetting.RuleWorkday */
export enum RuleWorkdayEnum {
/** Status stored on registrations */
	registration = 0,
/** Status in workdayStatus_reg, assumes copy of plan to registration dimension on web logon */
	autoCopy = 1,
/** Record changes per day in emp_workday_status, and set invalidation of day */
	invalidation = 2,
}

export const RuleWorkdaySchema = enumSchema(RuleWorkdayEnum) as unknown as z.ZodType<RuleWorkdayEnum>;
export const RuleWorkdayJsonSchema = enumSchema(RuleWorkdayEnum).describe("How web and consolidation coordinate. Specified in by applicationsetting.RuleWorkday - Schema: { { k: registration, v: 0, Description: Status stored on registrations}, { k: autoCopy, v: 1, Description: Status in workdayStatus_reg, assumes copy of plan to registration dimension on web logon}, { k: invalidation, v: 2, Description: Record changes per day in emp_workday_status, and set invalidation of day} }") as unknown as z.ZodType<RuleWorkdayEnum>;


/** --> merged */
export enum SalaryApprovalStatusEnum {
	test = 0,
/** Approved and ready to be endorsed */
	approved = 5,
	disapproved = 2,
/** Endorsed and ready to be processed */
	endorsed = 1,
/** Salary data has been processed and file(s) are ready to be extracted */
	processed = 6,
/** File(s) have been extracted */
	extracted = 7,
/** File(s) have been acknowledged by the recieving system. In most implementations acknowledge is auto set when extracted */
	acknowledged = 3,
/** File(s) have not been acknowledged */
	unacknowledged = 8,
/** This approval has been merged into another approval, which then is overlapping. */
	merged = 4,
}

export const SalaryApprovalStatusSchema = enumSchema(SalaryApprovalStatusEnum) as unknown as z.ZodType<SalaryApprovalStatusEnum>;
export const SalaryApprovalStatusJsonSchema = enumSchema(SalaryApprovalStatusEnum).describe("--> merged - Schema: { { k: test, v: 0, Description: <empty>}, { k: approved, v: 5, Description: Approved and ready to be endorsed}, { k: disapproved, v: 2, Description: <empty>}, { k: endorsed, v: 1, Description: Endorsed and ready to be processed}, { k: processed, v: 6, Description: Salary data has been processed and file(s) are ready to be extracted}, { k: extracted, v: 7, Description: File(s) have been extracted}, { k: acknowledged, v: 3, Description: File(s) have been acknowledged by the recieving system. In most implementations acknowledge is auto set when extracted}, { k: unacknowledged, v: 8, Description: File(s) have not been acknowledged}, { k: merged, v: 4, Description: This approval has been merged into another approval, which then is overlapping.} }") as unknown as z.ZodType<SalaryApprovalStatusEnum>;


/** salaryfiletypes */
export enum SalaryfileTypeEnum {
	salary = 1,
	adjustment = 4,
	absence = 2,
	tias = 3,
	bookkeeping = 5,
	kmdVacation = 6,
}

export const SalaryfileTypeSchema = enumSchema(SalaryfileTypeEnum) as unknown as z.ZodType<SalaryfileTypeEnum>;
export const SalaryfileTypeJsonSchema = enumSchema(SalaryfileTypeEnum).describe("salaryfiletypes - Schema: { { k: salary, v: 1, Description: <empty>}, { k: adjustment, v: 4, Description: <empty>}, { k: absence, v: 2, Description: <empty>}, { k: tias, v: 3, Description: <empty>}, { k: bookkeeping, v: 5, Description: <empty>}, { k: kmdVacation, v: 6, Description: <empty>} }") as unknown as z.ZodType<SalaryfileTypeEnum>;


/** lønartgruppe */
export enum SalarysortGroupEnum {
	nil = 0,
/** rådighed/døgnvagt */
	avail = 1,
/** opkald/udkald i forb. m. 1 */
	call = 2,
/** arbejde */
	work = 3,
/** omlagt arbejde */
	change = 4,
/** afspadsering */
	timeoff = 5,
/** ferie */
	holiday = 6,
/** andet fravær */
	absence = 7,
	signal = 8,
/** ikke-tidsafhængige tillæg */
	special = 9,
/** flyttet arbejde - brug ikke mere */
	change2 = 14,
/** omlagt arbejde annulleret del */
	change_off = 17,
/** vagtændring */
	shiftchange = 24,
/** vagtændring annulleret del */
	shiftchange_off = 27,
/** vagtbytte */
	shiftswap = 34,
/** vagtbytte annulleret del */
	shiftswap_off = 37,
/** bytbart fravær, f.eks. pauser */
	pause = 73,
/** bytbart fravær/tillæg med tider som ikke korrigerer ovenstående tj.linies tider */
	pauseOverlapped = 74,
/** afspadsering på døgn/rådighedsvagt */
	avail_timeoff = 81,
/** fravær på døgn/rådighedsvagt */
	avail_absence = 82,
/** Diæt lønart - til brug i rejseafregning dialog, ikke i vagt */
	paidAllowance = 101,
}

export const SalarysortGroupSchema = enumSchema(SalarysortGroupEnum) as unknown as z.ZodType<SalarysortGroupEnum>;
export const SalarysortGroupJsonSchema = enumSchema(SalarysortGroupEnum).describe("lønartgruppe - Schema: { { k: nil, v: 0, Description: <empty>}, { k: avail, v: 1, Description: rådighed/døgnvagt}, { k: call, v: 2, Description: opkald/udkald i forb. m. 1}, { k: work, v: 3, Description: arbejde}, { k: change, v: 4, Description: omlagt arbejde}, { k: timeoff, v: 5, Description: afspadsering}, { k: holiday, v: 6, Description: ferie}, { k: absence, v: 7, Description: andet fravær}, { k: signal, v: 8, Description: <empty>}, { k: special, v: 9, Description: ikke-tidsafhængige tillæg}, { k: change2, v: 14, Description: flyttet arbejde - brug ikke mere}, { k: change_off, v: 17, Description: omlagt arbejde annulleret del}, { k: shiftchange, v: 24, Description: vagtændring}, { k: shiftchange_off, v: 27, Description: vagtændring annulleret del}, { k: shiftswap, v: 34, Description: vagtbytte}, { k: shiftswap_off, v: 37, Description: vagtbytte annulleret del}, { k: pause, v: 73, Description: bytbart fravær, f.eks. pauser}, { k: pauseOverlapped, v: 74, Description: bytbart fravær/tillæg med tider som ikke korrigerer ovenstående tj.linies tider}, { k: avail_timeoff, v: 81, Description: afspadsering på døgn/rådighedsvagt}, { k: avail_absence, v: 82, Description: fravær på døgn/rådighedsvagt}, { k: paidAllowance, v: 101, Description: Diæt lønart - til brug i rejseafregning dialog, ikke i vagt} }") as unknown as z.ZodType<SalarysortGroupEnum>;


/** See also dutyType, duty_calcSuplDuty (mapping from duty to calcSuplDuty) and prefix_postfix_for_duty (mapping from calcSuplDuty to prefix, postfix) */
export enum SalarysortPrefixEnum {
/** timed duty on shift_reg not affected by salarysortGroup.avail or clockcode / timedDuty / dutyhp */
	prefixNone = 0,
/** timed duty on shift_reg of at least 24 hours affected by salarysortGroup.avail / timedDuty / dutyhp */
	prefixFullDayShift = 1,
/** timed duty on shift_reg of less than 24 hours affected by salarysortGroup.avail / timedDuty / dutyhp */
	prefixAvailableShift = 2,
/** empty duty: salarysort and optionally payer : if lartgrp <> shiftchange then emptyDuty / dutyep (written as _ _ SALARYSORT _ [PAYER]): if lartgrp = shiftchange then changeDuty / dutchsc (written as _ _ SALARYSORT [DAY]) */
	prefixWithoutTime = 3,
/** timed duty on availability_reg / timedDuty / dutyhp */
	prefixAvail = 4,
/** allowance where the number is specified in the start field / allowanceDuty / dutysp (written as NUMBER _ SALARYSORT _ [PAYER]) */
	prefixNumber = 5,
/** allowance where the number is specified in the end field or the number field / allowanceDuty / dutysp (written as _ _ SALARYSORT NUMBER [PAYER] or _ NUMBER SALARYSORT _ [PAYER]) */
	prefixUnsigned = 6,
}

export const SalarysortPrefixSchema = enumSchema(SalarysortPrefixEnum) as unknown as z.ZodType<SalarysortPrefixEnum>;
export const SalarysortPrefixJsonSchema = enumSchema(SalarysortPrefixEnum).describe("See also dutyType, duty_calcSuplDuty (mapping from duty to calcSuplDuty) and prefix_postfix_for_duty (mapping from calcSuplDuty to prefix, postfix) - Schema: { { k: prefixNone, v: 0, Description: timed duty on shift_reg not affected by salarysortGroup.avail or clockcode / timedDuty / dutyhp}, { k: prefixFullDayShift, v: 1, Description: timed duty on shift_reg of at least 24 hours affected by salarysortGroup.avail / timedDuty / dutyhp}, { k: prefixAvailableShift, v: 2, Description: timed duty on shift_reg of less than 24 hours affected by salarysortGroup.avail / timedDuty / dutyhp}, { k: prefixWithoutTime, v: 3, Description: empty duty: salarysort and optionally payer : if lartgrp <> shiftchange then emptyDuty / dutyep (written as _ _ SALARYSORT _ [PAYER]): if lartgrp = shiftchange then changeDuty / dutchsc (written as _ _ SALARYSORT [DAY])}, { k: prefixAvail, v: 4, Description: timed duty on availability_reg / timedDuty / dutyhp}, { k: prefixNumber, v: 5, Description: allowance where the number is specified in the start field / allowanceDuty / dutysp (written as NUMBER _ SALARYSORT _ [PAYER])}, { k: prefixUnsigned, v: 6, Description: allowance where the number is specified in the end field or the number field / allowanceDuty / dutysp (written as _ _ SALARYSORT NUMBER [PAYER] or _ NUMBER SALARYSORT _ [PAYER])} }") as unknown as z.ZodType<SalarysortPrefixEnum>;


/** salarySystem */
export enum SalarySystemEnum {
/** SamTeld old salarysystem (Sam~teld HP3000) - no longer in use */
	salarySystem_samteldLon = 5,
	salarySystem_silkLon2 = 9,
	salarySystem_samteldXMLLon = 10,
/** For COOP SE */
	salarySystem_HR_PLUS8 = 11,
/** For Lindex, the system is also known as Personec */
	salarySystem_TietoEnator = 13,
/** Used by Lindex FI */
	salarySystem_LindexFI = 15,
	salarySystem_PDC = 16,
/** Used by Lindex SE */
	salarySystem_SvenskLön = 18,
/** No longer in use - was used by DSB */
	salarySystem_PDCXML = 19,
/** Bluegarden Norway Posten */
	salarySystem_Pagalon_2 = 21,
/** Used by e.g. MolsLinien */
	salarySystem_PDC_Absencehours = 22,
	salarySystem_agDA = 23,
/** No longer in use */
	salarySystem_Boryspil = 24,
	salarySystem_Wisma = 25,
/** Variant of agDA used by Flügger */
	salarySystem_agDA_2 = 26,
/** TV2 - Dynamics AX (Axapta) */
	salarySystem_TV2Dynamics = 27,
	salarySystem_KMDperspektiv = 28,
/** DSB : SAP */
	salarySystem_DSB = 29,
/** Used by ? */
	salarySystem_ASPECT4 = 30,
/** PeopleSoft/St. Elizabeth (Canada) */
	salarySystem_PeopleSoft = 31,
/** Lessor 5 (PDC variant) (Mariehjem) */
	salarySystem_Lessor5 = 33,
/** KMD OPUS - Used by Argo & DDH. Udfases d. 1/10-2024 */
	salarySystem_kmdOpus = 34,
/** Variant of agDA used by Falck SE, but will be phased out, and replaced by HR+ */
	salarySystem_agDA_3 = 35,
/** SLS (Statens Løn System), used by Kriminalforsorgen */
	salarySystem_SLS = 36,
/** KMD Payroll Cloud (SAP), used by Flügger DK and SE */
	salarySystem_KmdPayrollCloud = 37,
/** TietoEVRY variant used by Posten No */
	salarySystem_TietoEVRY_Posten = 38,
/** For Falck SE */
	salarySystem_HR_PLUS8_ext = 39,
/** KMD OPUS Web - Used by Argo & DDH */
	salarySystem_kmdOpusWeb = 40,
}

export const SalarySystemSchema = enumSchema(SalarySystemEnum) as unknown as z.ZodType<SalarySystemEnum>;
export const SalarySystemJsonSchema = enumSchema(SalarySystemEnum).describe("salarySystem - Schema: { { k: salarySystem_samteldLon, v: 5, Description: SamTeld old salarysystem (Sam~teld HP3000) - no longer in use}, { k: salarySystem_silkLon2, v: 9, Description: <empty>}, { k: salarySystem_samteldXMLLon, v: 10, Description: <empty>}, { k: salarySystem_HR_PLUS8, v: 11, Description: For COOP SE}, { k: salarySystem_TietoEnator, v: 13, Description: For Lindex, the system is also known as Personec}, { k: salarySystem_LindexFI, v: 15, Description: Used by Lindex FI}, { k: salarySystem_PDC, v: 16, Description: <empty>}, { k: salarySystem_SvenskLön, v: 18, Description: Used by Lindex SE}, { k: salarySystem_PDCXML, v: 19, Description: No longer in use - was used by DSB}, { k: salarySystem_Pagalon_2, v: 21, Description: Bluegarden Norway Posten}, { k: salarySystem_PDC_Absencehours, v: 22, Description: Used by e.g. MolsLinien}, { k: salarySystem_agDA, v: 23, Description: <empty>}, { k: salarySystem_Boryspil, v: 24, Description: No longer in use}, { k: salarySystem_Wisma, v: 25, Description: <empty>}, { k: salarySystem_agDA_2, v: 26, Description: Variant of agDA used by Flügger}, { k: salarySystem_TV2Dynamics, v: 27, Description: TV2 - Dynamics AX (Axapta)}, { k: salarySystem_KMDperspektiv, v: 28, Description: <empty>}, { k: salarySystem_DSB, v: 29, Description: DSB : SAP}, { k: salarySystem_ASPECT4, v: 30, Description: Used by ?}, { k: salarySystem_PeopleSoft, v: 31, Description: PeopleSoft/St. Elizabeth (Canada)}, { k: salarySystem_Lessor5, v: 33, Description: Lessor 5 (PDC variant) (Mariehjem)}, { k: salarySystem_kmdOpus, v: 34, Description: KMD OPUS - Used by Argo & DDH. Udfases d. 1/10-2024}, { k: salarySystem_agDA_3, v: 35, Description: Variant of agDA used by Falck SE, but will be phased out, and replaced by HR+}, { k: salarySystem_SLS, v: 36, Description: SLS (Statens Løn System), used by Kriminalforsorgen}, { k: salarySystem_KmdPayrollCloud, v: 37, Description: KMD Payroll Cloud (SAP), used by Flügger DK and SE}, { k: salarySystem_TietoEVRY_Posten, v: 38, Description: TietoEVRY variant used by Posten No}, { k: salarySystem_HR_PLUS8_ext, v: 39, Description: For Falck SE}, { k: salarySystem_kmdOpusWeb, v: 40, Description: KMD OPUS Web - Used by Argo & DDH} }") as unknown as z.ZodType<SalarySystemEnum>;


/** reserved scheduledjob.id - negative number make scheduledjob.script readonly for non pdc users - enum er hide, så der genereres ikke enum indgange i vagtplan */
export enum ScheduledjobidEnum {
/** 1000-2021-09-30_total_hd62207_scheduledjob_Koncern_Regnskab_ms */
	concern_accounting_hours = -11,
/** SystemValidation */
	systemValidation = -99,
/** 1000-2021-11-29_def_wi122033_48t_scheduledjob.sql */
	hour_48_concern_view = -100,
/** wi140153 */
	tidyAgent = -101,
/** wi140153 */
	statisticsAgent = -102,
/** wi165802 AbsenceExtractSalary Scheduledjob */
	absenceExtractSalary = -103,
/** wi140153 */
	eraseAgent = -104,
/** Sætter global planstatus (Realiseret start, Drift start) til 3 måneder før indeværende måned */
	set_Planstatus_Start_period = -105,
/** Sætter global planstatus (planlægning start og lukket periode) til hhv. 3 og 37 måneder frem fra indeværende måned */
	set_Planstatus_End_period = -106,
/** wi167228 Toldst */
	invalidateWorkRule = -107,
/** wi157832 MS365 Calendar - daily full sync of all employees' calendars to Outlook */
	ms365CalendarFullSync = -108,
/** wi157832 MS365 Calendar - incremental sync of changed calendars, every 5 min before noon */
	ms365CalendarUpdateBeforeNoon = -109,
/** wi157832 MS365 Calendar - incremental sync of changed calendars, every 5 min after noon */
	ms365CalendarUpdateAfterNoon = -110,
}

export const ScheduledjobidSchema = enumSchema(ScheduledjobidEnum) as unknown as z.ZodType<ScheduledjobidEnum>;
export const ScheduledjobidJsonSchema = enumSchema(ScheduledjobidEnum).describe("reserved scheduledjob.id - negative number make scheduledjob.script readonly for non pdc users - enum er hide, så der genereres ikke enum indgange i vagtplan - Schema: { { k: concern_accounting_hours, v: -11, Description: 1000-2021-09-30_total_hd62207_scheduledjob_Koncern_Regnskab_ms}, { k: systemValidation, v: -99, Description: SystemValidation}, { k: hour_48_concern_view, v: -100, Description: 1000-2021-11-29_def_wi122033_48t_scheduledjob.sql}, { k: tidyAgent, v: -101, Description: wi140153}, { k: statisticsAgent, v: -102, Description: wi140153}, { k: absenceExtractSalary, v: -103, Description: wi165802 AbsenceExtractSalary Scheduledjob}, { k: eraseAgent, v: -104, Description: wi140153}, { k: set_Planstatus_Start_period, v: -105, Description: Sætter global planstatus (Realiseret start, Drift start) til 3 måneder før indeværende måned}, { k: set_Planstatus_End_period, v: -106, Description: Sætter global planstatus (planlægning start og lukket periode) til hhv. 3 og 37 måneder frem fra indeværende måned}, { k: invalidateWorkRule, v: -107, Description: wi167228 Toldst}, { k: ms365CalendarFullSync, v: -108, Description: wi157832 MS365 Calendar - daily full sync of all employees' calendars to Outlook}, { k: ms365CalendarUpdateBeforeNoon, v: -109, Description: wi157832 MS365 Calendar - incremental sync of changed calendars, every 5 min before noon}, { k: ms365CalendarUpdateAfterNoon, v: -110, Description: wi157832 MS365 Calendar - incremental sync of changed calendars, every 5 min after noon} }") as unknown as z.ZodType<ScheduledjobidEnum>;


/** file encoding type */
export enum ScheduledJobTypeEnum {
	normalJob = 1,
/** systemJob = id <0 scheduledjob.script is readonly for non pdc users */
	systemJob = 2,
}

export const ScheduledJobTypeSchema = enumSchema(ScheduledJobTypeEnum) as unknown as z.ZodType<ScheduledJobTypeEnum>;
export const ScheduledJobTypeJsonSchema = enumSchema(ScheduledJobTypeEnum).describe("file encoding type - Schema: { { k: normalJob, v: 1, Description: <empty>}, { k: systemJob, v: 2, Description: systemJob = id <0 scheduledjob.script is readonly for non pdc users} }") as unknown as z.ZodType<ScheduledJobTypeEnum>;


/** Status of job execution */
export enum ScheduleJobStatusTypeEnum {
/** Job executed succesfully (default) */
	success = 0,
/** Job failed */
	failed = 1,
/** Job status is undefined, ie not executed */
	undefined = 3,
/** Job is queued for execution */
	queued = 4,
/** Job is currently running */
	running = 5,
}

export const ScheduleJobStatusTypeSchema = enumSchema(ScheduleJobStatusTypeEnum) as unknown as z.ZodType<ScheduleJobStatusTypeEnum>;
export const ScheduleJobStatusTypeJsonSchema = enumSchema(ScheduleJobStatusTypeEnum).describe("Status of job execution - Schema: { { k: success, v: 0, Description: Job executed succesfully (default)}, { k: failed, v: 1, Description: Job failed}, { k: undefined, v: 3, Description: Job status is undefined, ie not executed}, { k: queued, v: 4, Description: Job is queued for execution}, { k: running, v: 5, Description: Job is currently running} }") as unknown as z.ZodType<ScheduleJobStatusTypeEnum>;


/** sql type or sql part */
export enum SelectTypeEnum {
/** hints on ordinary table select - usually selects based on sectors */
	select = 1,
/** hints for transactioncommit when synchronizing any table (#tableName must be transactioncommit, can be overridden by syncPart) select. built in is index(<table> il_<table>) */
	sync = 2,
/** hints for transactioncommit when synchronizing #tableName (only supports cardinality hints) */
	syncPart = 3,
}

export const SelectTypeSchema = enumSchema(SelectTypeEnum) as unknown as z.ZodType<SelectTypeEnum>;
export const SelectTypeJsonSchema = enumSchema(SelectTypeEnum).describe("sql type or sql part - Schema: { { k: select, v: 1, Description: hints on ordinary table select - usually selects based on sectors}, { k: sync, v: 2, Description: hints for transactioncommit when synchronizing any table (#tableName must be transactioncommit, can be overridden by syncPart) select. built in is index(<table> il_<table>)}, { k: syncPart, v: 3, Description: hints for transactioncommit when synchronizing #tableName (only supports cardinality hints)} }") as unknown as z.ZodType<SelectTypeEnum>;


/** Associated Order events results in a Sequence of Orders. This enum is used to describe both an entire sequence and the individual parts (=Orders) */
export enum SeqTypeEnum {
/** When orders aren't event-based the sequence type is NONE */
	seqType_none = 0,
/** Start event is left end of seq part */
	seqType_start = 1,
/** End event is right end of seq part */
	seqType_end = 2,
/** Both start and end event are boundries of seq part */
	seqType_return = 3,
/** Seq part is a movement from A to B */
	seqType_transition = 4,
/** An in-between seq part, neither start nor end nor movement */
	seqType_intermediate = 5,
}

export const SeqTypeSchema = enumSchema(SeqTypeEnum) as unknown as z.ZodType<SeqTypeEnum>;
export const SeqTypeJsonSchema = enumSchema(SeqTypeEnum).describe("Associated Order events results in a Sequence of Orders. This enum is used to describe both an entire sequence and the individual parts (=Orders) - Schema: { { k: seqType_none, v: 0, Description: When orders aren't event-based the sequence type is NONE}, { k: seqType_start, v: 1, Description: Start event is left end of seq part}, { k: seqType_end, v: 2, Description: End event is right end of seq part}, { k: seqType_return, v: 3, Description: Both start and end event are boundries of seq part}, { k: seqType_transition, v: 4, Description: Seq part is a movement from A to B}, { k: seqType_intermediate, v: 5, Description: An in-between seq part, neither start nor end nor movement} }") as unknown as z.ZodType<SeqTypeEnum>;


/** setting types */
export enum SettingTypeEnum {
/** Must be set explicitly in database */
	mandatory = 1,
/** Mandatory values with a default in the program */
	default = 2,
/** Optional values */
	optional = 3,
/** Recursive settings used via predicate setting_prefix_nd */
	recursive = 4,
}

export const SettingTypeSchema = enumSchema(SettingTypeEnum) as unknown as z.ZodType<SettingTypeEnum>;
export const SettingTypeJsonSchema = enumSchema(SettingTypeEnum).describe("setting types - Schema: { { k: mandatory, v: 1, Description: Must be set explicitly in database}, { k: default, v: 2, Description: Mandatory values with a default in the program}, { k: optional, v: 3, Description: Optional values}, { k: recursive, v: 4, Description: Recursive settings used via predicate setting_prefix_nd} }") as unknown as z.ZodType<SettingTypeEnum>;


/** What occured the last time an update was attempted, used by the web service and cleanup jobs. Negative values represent erroneous states which should be handled by a scheduled job. values at or below -1000000 represents errors which probably indicate the entire calendar sharing functionality is falling apart */
export enum SharedCalendarUpdateStatusEnum {
/** Calendar file does not exist and we could not create it. */
	calendarCreationFailed = -10000,
/** The calendar has failed enough times to require notification, it has been sent and should not be re-sent */
	calendarUpdateFailedNotified = -2,
/** Calendar file exists but we could not update it ,  Should be included in some cleanup/reattempt/maintenance job. implement more fine-toothed error enums in space -1 to -99 */
	calendarUpdateFailed = -1,
/** Nothing went wrong, calendar was created or updated succesfully */
	calendarUpdated = 0,
/** The relevant calendar file has been deleted. Either because the user manually requested it, or the business logic mandated it, This should always be the case for pdcdeleted != 0 */
	calendarDeleted = 1,
/** The calendar has been activated but not yet generated , used to remove responsibility for generating calendars from the web service to the batch job. */
	calendarCreationPending = 2,
}

export const SharedCalendarUpdateStatusSchema = enumSchema(SharedCalendarUpdateStatusEnum) as unknown as z.ZodType<SharedCalendarUpdateStatusEnum>;
export const SharedCalendarUpdateStatusJsonSchema = enumSchema(SharedCalendarUpdateStatusEnum).describe("What occured the last time an update was attempted, used by the web service and cleanup jobs. Negative values represent erroneous states which should be handled by a scheduled job. values at or below -1000000 represents errors which probably indicate the entire calendar sharing functionality is falling apart - Schema: { { k: calendarCreationFailed, v: -10000, Description: Calendar file does not exist and we could not create it.}, { k: calendarUpdateFailedNotified, v: -2, Description: The calendar has failed enough times to require notification, it has been sent and should not be re-sent}, { k: calendarUpdateFailed, v: -1, Description: Calendar file exists but we could not update it ,  Should be included in some cleanup/reattempt/maintenance job. implement more fine-toothed error enums in space -1 to -99}, { k: calendarUpdated, v: 0, Description: Nothing went wrong, calendar was created or updated succesfully}, { k: calendarDeleted, v: 1, Description: The relevant calendar file has been deleted. Either because the user manually requested it, or the business logic mandated it, This should always be the case for pdcdeleted != 0}, { k: calendarCreationPending, v: 2, Description: The calendar has been activated but not yet generated , used to remove responsibility for generating calendars from the web service to the batch job.} }") as unknown as z.ZodType<SharedCalendarUpdateStatusEnum>;


/** The users wishes whether the shared calendar should be available */
export enum SharedCalendarWebserviceDisplayStatusEnum {
/** The toggle is not available to the user, this is usually dictated by settings in the server, or user information */
	notAvailable = 0,
/** default value if shared calendar is available */
	isNotShared = 1,
/** the user has elected to make their shared calendar available as an ics file */
	isShared = 2,
/** Murphy's enum, if for one reason or another the calendar becomes invalid and the user needs to be notified. This status only changes if the user manually disables the calendar or some recovery service fixes it. */
	calendarDamaged = 3,
}

export const SharedCalendarWebserviceDisplayStatusSchema = enumSchema(SharedCalendarWebserviceDisplayStatusEnum) as unknown as z.ZodType<SharedCalendarWebserviceDisplayStatusEnum>;
export const SharedCalendarWebserviceDisplayStatusJsonSchema = enumSchema(SharedCalendarWebserviceDisplayStatusEnum).describe("The users wishes whether the shared calendar should be available - Schema: { { k: notAvailable, v: 0, Description: The toggle is not available to the user, this is usually dictated by settings in the server, or user information}, { k: isNotShared, v: 1, Description: default value if shared calendar is available}, { k: isShared, v: 2, Description: the user has elected to make their shared calendar available as an ics file}, { k: calendarDamaged, v: 3, Description: Murphy's enum, if for one reason or another the calendar becomes invalid and the user needs to be notified. This status only changes if the user manually disables the calendar or some recovery service fixes it.} }") as unknown as z.ZodType<SharedCalendarWebserviceDisplayStatusEnum>;


/** Fixed type for shift add def */
export enum ShiftAddDefFixedTypeEnum {
/** Proportional. Count the number of hours */
	proportional = 0,
/** Fast: Count as 1 regardless of the number of hours */
	fixed = 1,
/** Fast besk.dec.afh.: Count as occupation decimal (0..1) regardless of the number of hours */
	fixedoccdec = 2,
/** Ugenorm: Count as weeknorm regardless of the number of hours */
	weeknorm = 3,
/** Fast besk.dec.afh.*Ugenorm: Count as weeknorm * occupation decimal regardless of the number of hours */
	fixedoccdecweeknorm = 4,
/** Variabel besk.dec.afh.*Ugenorm: Count as weeknorm * occupation decimal using number of hours as factor */
	variableoccdecweeknorm = 5,
/** Variabel Full Ugenorm: Count as weeknorm decimal using number of hours as factor */
	variableweeknorm = 6,
/** Variabel Ugenorm/besk.dec.afh.: Count as weeknorm / occupation decimal using number of hours as factor */
	variableinverseoccdecweeknorm = 7,
/** Fixed Ugenorm/besk.dec.afh.: Count as weeknorm / occupation decimal regardless of the number of hours */
	fixedinverseoccdecweeknorm = 8,
/** Variabel Ugenorm/besk.dec.afh.: Count as weeknorm / occupation decimal using number of hours as factor */
	variableinverseoccdecdaynormwithmax = 9,
}

export const ShiftAddDefFixedTypeSchema = enumSchema(ShiftAddDefFixedTypeEnum) as unknown as z.ZodType<ShiftAddDefFixedTypeEnum>;
export const ShiftAddDefFixedTypeJsonSchema = enumSchema(ShiftAddDefFixedTypeEnum).describe("Fixed type for shift add def - Schema: { { k: proportional, v: 0, Description: Proportional. Count the number of hours}, { k: fixed, v: 1, Description: Fast: Count as 1 regardless of the number of hours}, { k: fixedoccdec, v: 2, Description: Fast besk.dec.afh.: Count as occupation decimal (0..1) regardless of the number of hours}, { k: weeknorm, v: 3, Description: Ugenorm: Count as weeknorm regardless of the number of hours}, { k: fixedoccdecweeknorm, v: 4, Description: Fast besk.dec.afh.*Ugenorm: Count as weeknorm * occupation decimal regardless of the number of hours}, { k: variableoccdecweeknorm, v: 5, Description: Variabel besk.dec.afh.*Ugenorm: Count as weeknorm * occupation decimal using number of hours as factor}, { k: variableweeknorm, v: 6, Description: Variabel Full Ugenorm: Count as weeknorm decimal using number of hours as factor}, { k: variableinverseoccdecweeknorm, v: 7, Description: Variabel Ugenorm/besk.dec.afh.: Count as weeknorm / occupation decimal using number of hours as factor}, { k: fixedinverseoccdecweeknorm, v: 8, Description: Fixed Ugenorm/besk.dec.afh.: Count as weeknorm / occupation decimal regardless of the number of hours}, { k: variableinverseoccdecdaynormwithmax, v: 9, Description: Variabel Ugenorm/besk.dec.afh.: Count as weeknorm / occupation decimal using number of hours as factor} }") as unknown as z.ZodType<ShiftAddDefFixedTypeEnum>;


/** Whether shiftadd_def's start, min, and max apply per duty or per shift. */
export enum ShiftaddLimitConfigEnum {
/** 'addstart','addmin' og 'addmax' apply per dutyline */
	perDuty = 0,
/** 'addstart','addmin' og 'addmax' apply per shift */
	perShift = 1,
/** specified in the setting shiftaddstartminmax, by default its perDuty */
	useSetting = 2,
}

export const ShiftaddLimitConfigSchema = enumSchema(ShiftaddLimitConfigEnum) as unknown as z.ZodType<ShiftaddLimitConfigEnum>;
export const ShiftaddLimitConfigJsonSchema = enumSchema(ShiftaddLimitConfigEnum).describe("Whether shiftadd_def's start, min, and max apply per duty or per shift. - Schema: { { k: perDuty, v: 0, Description: 'addstart','addmin' og 'addmax' apply per dutyline}, { k: perShift, v: 1, Description: 'addstart','addmin' og 'addmax' apply per shift}, { k: useSetting, v: 2, Description: specified in the setting shiftaddstartminmax, by default its perDuty} }") as unknown as z.ZodType<ShiftaddLimitConfigEnum>;


/** The calculation type: shift or availability */
export enum ShiftCounterCalcTypeEnum {
	shiftCalc = 1,
	availCalc = 2,
}

export const ShiftCounterCalcTypeSchema = enumSchema(ShiftCounterCalcTypeEnum) as unknown as z.ZodType<ShiftCounterCalcTypeEnum>;
export const ShiftCounterCalcTypeJsonSchema = enumSchema(ShiftCounterCalcTypeEnum).describe("The calculation type: shift or availability - Schema: { { k: shiftCalc, v: 1, Description: <empty>}, { k: availCalc, v: 2, Description: <empty>} }") as unknown as z.ZodType<ShiftCounterCalcTypeEnum>;


/** shiftCounterSettling */
export enum ShiftCounterSettlingEnum {
/** Settling is undefined */
	shiftCounterSettlingNil = 0,
/** This counter is payed */
	cash = 1,
/** This counter is used for time off in lieu (afspadsering) */
	timeoff = 2,
/** Til afspadsering, indgår i beregningen af maks. */
	timeoff_nonpayable = 3,
/** Til afspadsering, indgår i beregning af maks. og udbetal over maks. SD */
	timeoff_payable = 4,
/** For pooling counters on certain reports */
	pool = 5,
}

export const ShiftCounterSettlingSchema = enumSchema(ShiftCounterSettlingEnum) as unknown as z.ZodType<ShiftCounterSettlingEnum>;
export const ShiftCounterSettlingJsonSchema = enumSchema(ShiftCounterSettlingEnum).describe("shiftCounterSettling - Schema: { { k: shiftCounterSettlingNil, v: 0, Description: Settling is undefined}, { k: cash, v: 1, Description: This counter is payed}, { k: timeoff, v: 2, Description: This counter is used for time off in lieu (afspadsering)}, { k: timeoff_nonpayable, v: 3, Description: Til afspadsering, indgår i beregningen af maks.}, { k: timeoff_payable, v: 4, Description: Til afspadsering, indgår i beregning af maks. og udbetal over maks. SD}, { k: pool, v: 5, Description: For pooling counters on certain reports} }") as unknown as z.ZodType<ShiftCounterSettlingEnum>;


/** shiftCounterType. A terrible combination of behaviors in one field. Controls: (1) cTotal::totalplanhours, (2) inclusion in the vacation summary statements, (3) whether it can be used in shiftcounter_def.costdetails, (4) whether shiftcounter_def.costdetails can be set, (5) ignores shiftcounter_def.displayInShift, (6) special read access checks for cost shiftcountes, (7) handling wrt clockcodes, (8) the format of the hr_plus salarylines used by CoopSE */
export enum ShiftCounterTypeEnum {
	shiftCounterTypeNil = 0,
/** Normtime. Usually with shiftcounterUnit.hourUnit. Included in totalplanhours. Can be used for cost details. Behaves as if shiftcounter_def.displayInShift = true */
	norm = 1,
/** Holiday. Usually with shiftcounterUnit.hourUnit or shiftcounterUnit.dayUnit. Included in the vacation summary statements. Can be used for cost details. */
	holi = 2,
/** Supplement. Usually with shiftcounterUnit.hourUnit or shiftcounterUnit.dayUnit. */
	supp = 3,
/** Number. Usually with currencyUnit. Can be used for cost details. */
	numb = 4,
/** Cost. Usually with currencyUnit. Can set shiftcounter_def.costdetails. Behaves as if shiftcounter_def.displayInShift = true. Subjected to special read access checks. */
	cost = 7,
/** Statistical. Usually with shiftcounterUnit.hourUnit, but not always. Handled specially wrt clockcodes (and differently again if the shiftcounterid = 0 or the factor is negative). */
	shiftCounterTypeElse = 9,
}

export const ShiftCounterTypeSchema = enumSchema(ShiftCounterTypeEnum) as unknown as z.ZodType<ShiftCounterTypeEnum>;
export const ShiftCounterTypeJsonSchema = enumSchema(ShiftCounterTypeEnum).describe("shiftCounterType. A terrible combination of behaviors in one field. Controls: (1) cTotal::totalplanhours, (2) inclusion in the vacation summary statements, (3) whether it can be used in shiftcounter_def.costdetails, (4) whether shiftcounter_def.costdetails can be set, (5) ignores shiftcounter_def.displayInShift, (6) special read access checks for cost shiftcountes, (7) handling wrt clockcodes, (8) the format of the hr_plus salarylines used by CoopSE - Schema: { { k: shiftCounterTypeNil, v: 0, Description: <empty>}, { k: norm, v: 1, Description: Normtime. Usually with shiftcounterUnit.hourUnit. Included in totalplanhours. Can be used for cost details. Behaves as if shiftcounter_def.displayInShift = true}, { k: holi, v: 2, Description: Holiday. Usually with shiftcounterUnit.hourUnit or shiftcounterUnit.dayUnit. Included in the vacation summary statements. Can be used for cost details.}, { k: supp, v: 3, Description: Supplement. Usually with shiftcounterUnit.hourUnit or shiftcounterUnit.dayUnit.}, { k: numb, v: 4, Description: Number. Usually with currencyUnit. Can be used for cost details.}, { k: cost, v: 7, Description: Cost. Usually with currencyUnit. Can set shiftcounter_def.costdetails. Behaves as if shiftcounter_def.displayInShift = true. Subjected to special read access checks.}, { k: shiftCounterTypeElse, v: 9, Description: Statistical. Usually with shiftcounterUnit.hourUnit, but not always. Handled specially wrt clockcodes (and differently again if the shiftcounterid = 0 or the factor is negative).} }") as unknown as z.ZodType<ShiftCounterTypeEnum>;


/** shiftCounterUnit */
export enum ShiftCounterUnitEnum {
/** shiftcounter unit is unknown – should never be the case – not alloved for new shiftcounters */
	unknownUnit = 0,
/** Hours */
	hourUnit = 1,
/** Days */
	dayUnit = 2,
/** Currency */
	currencyUnit = 3,
/** Minutes */
	minutUnit = 4,
/** 0 or 1 */
	booleanUnit = 5,
/** Absolute amount of something which has no specific kind of unit */
	quantityUnit = 6,
/** Unitless. Having no units of measurement, such as a ratio or percentage of two numbers which have the same unit */
	fractionUnit = 7,
}

export const ShiftCounterUnitSchema = enumSchema(ShiftCounterUnitEnum) as unknown as z.ZodType<ShiftCounterUnitEnum>;
export const ShiftCounterUnitJsonSchema = enumSchema(ShiftCounterUnitEnum).describe("shiftCounterUnit - Schema: { { k: unknownUnit, v: 0, Description: shiftcounter unit is unknown – should never be the case – not alloved for new shiftcounters}, { k: hourUnit, v: 1, Description: Hours}, { k: dayUnit, v: 2, Description: Days}, { k: currencyUnit, v: 3, Description: Currency}, { k: minutUnit, v: 4, Description: Minutes}, { k: booleanUnit, v: 5, Description: 0 or 1}, { k: quantityUnit, v: 6, Description: Absolute amount of something which has no specific kind of unit}, { k: fractionUnit, v: 7, Description: Unitless. Having no units of measurement, such as a ratio or percentage of two numbers which have the same unit} }") as unknown as z.ZodType<ShiftCounterUnitEnum>;


/** shiftTypeUsability: May this shifttype be used for registrations */
export enum ShiftTypeUsabilityEnum {
/** Ordinary shifttype/availabilitytype selectable by any user */
	ordinary = 0,
/** Shifttype/Availabilitytype may only be used through external input, or by admin users */
	externalUse = 1,
/** Shifttype/Availabilitytype may not be used. It is only for internal use */
	internalUse = 2,
/** Like ordinary, but the absence is not ended by TeamPlan.endAbsence (at some point we would also want this value to prevent teamplan from creating such absence, but that will require a frontend change, see teamplan.getAllShiftTypes). */
	noTeamPlanUse = 3,
}

export const ShiftTypeUsabilitySchema = enumSchema(ShiftTypeUsabilityEnum) as unknown as z.ZodType<ShiftTypeUsabilityEnum>;
export const ShiftTypeUsabilityJsonSchema = enumSchema(ShiftTypeUsabilityEnum).describe("shiftTypeUsability: May this shifttype be used for registrations - Schema: { { k: ordinary, v: 0, Description: Ordinary shifttype/availabilitytype selectable by any user}, { k: externalUse, v: 1, Description: Shifttype/Availabilitytype may only be used through external input, or by admin users}, { k: internalUse, v: 2, Description: Shifttype/Availabilitytype may not be used. It is only for internal use}, { k: noTeamPlanUse, v: 3, Description: Like ordinary, but the absence is not ended by TeamPlan.endAbsence (at some point we would also want this value to prevent teamplan from creating such absence, but that will require a frontend change, see teamplan.getAllShiftTypes).} }") as unknown as z.ZodType<ShiftTypeUsabilityEnum>;


/** The calculation scope: workplan or roster */
export enum ShiftvalueRuleRegScopeEnum {
	workplan = 1,
	roster = 2,
}

export const ShiftvalueRuleRegScopeSchema = enumSchema(ShiftvalueRuleRegScopeEnum) as unknown as z.ZodType<ShiftvalueRuleRegScopeEnum>;
export const ShiftvalueRuleRegScopeJsonSchema = enumSchema(ShiftvalueRuleRegScopeEnum).describe("The calculation scope: workplan or roster - Schema: { { k: workplan, v: 1, Description: <empty>}, { k: roster, v: 2, Description: <empty>} }") as unknown as z.ZodType<ShiftvalueRuleRegScopeEnum>;


/** showUI */
export enum ShowUIEnum {
	hide = 2,
}

export const ShowUISchema = enumSchema(ShowUIEnum) as unknown as z.ZodType<ShowUIEnum>;
export const ShowUIJsonSchema = enumSchema(ShowUIEnum).describe("showUI - Schema: { { k: hide, v: 2, Description: <empty>} }") as unknown as z.ZodType<ShowUIEnum>;


/** Which pdcdeleted rows to export */
export enum SnapshotDeletedEnum {
/** Export every row, no matter what pdcdeleted says */
	allRows = 1,
/** Export rows with pdcdeleted = 0 or pdcdeleted>1 and include rows which have been pdcdeleted in the last 90 days */
	last90Days = 2,
/** Only export rows with pdcdeleted = 0 */
	no = 3,
/** Only export rows with pdcdeleted = 0, and clear pdcsession and pdclasttrans */
	noAndClearPdcSession = 4,
}

export const SnapshotDeletedSchema = enumSchema(SnapshotDeletedEnum) as unknown as z.ZodType<SnapshotDeletedEnum>;
export const SnapshotDeletedJsonSchema = enumSchema(SnapshotDeletedEnum).describe("Which pdcdeleted rows to export - Schema: { { k: allRows, v: 1, Description: Export every row, no matter what pdcdeleted says}, { k: last90Days, v: 2, Description: Export rows with pdcdeleted = 0 or pdcdeleted>1 and include rows which have been pdcdeleted in the last 90 days}, { k: no, v: 3, Description: Only export rows with pdcdeleted = 0}, { k: noAndClearPdcSession, v: 4, Description: Only export rows with pdcdeleted = 0, and clear pdcsession and pdclasttrans} }") as unknown as z.ZodType<SnapshotDeletedEnum>;


/** Special columns used in user interface, also on WEB - Special predefined functioncolumns */
export enum SpecialColumnEnum {
/** Ikke tilstede */
	notPresent = 1,
/** Ikke planlagt */
	notPlanned = 2,
/** Andet arbejde */
	otherWork = 3,
/** Andet fravær */
	otherAbsence = 4,
/** Anden funktion */
	otherFunction = 5,
}

export const SpecialColumnSchema = enumSchema(SpecialColumnEnum) as unknown as z.ZodType<SpecialColumnEnum>;
export const SpecialColumnJsonSchema = enumSchema(SpecialColumnEnum).describe("Special columns used in user interface, also on WEB - Special predefined functioncolumns - Schema: { { k: notPresent, v: 1, Description: Ikke tilstede}, { k: notPlanned, v: 2, Description: Ikke planlagt}, { k: otherWork, v: 3, Description: Andet arbejde}, { k: otherAbsence, v: 4, Description: Andet fravær}, { k: otherFunction, v: 5, Description: Anden funktion} }") as unknown as z.ZodType<SpecialColumnEnum>;


/** Algorithm for earning special vacation */
export enum SpecialVacationEarningTypeEnum {
/** Nothing earned */
	nil = 0,
/** Proportionally month by month, rounded to two dec. Max. full amount during one year */
	proportional2dec = 1,
/** Proportionally month by month full amount during one year */
	proportional = 2,
}

export const SpecialVacationEarningTypeSchema = enumSchema(SpecialVacationEarningTypeEnum) as unknown as z.ZodType<SpecialVacationEarningTypeEnum>;
export const SpecialVacationEarningTypeJsonSchema = enumSchema(SpecialVacationEarningTypeEnum).describe("Algorithm for earning special vacation - Schema: { { k: nil, v: 0, Description: Nothing earned}, { k: proportional2dec, v: 1, Description: Proportionally month by month, rounded to two dec. Max. full amount during one year}, { k: proportional, v: 2, Description: Proportionally month by month full amount during one year} }") as unknown as z.ZodType<SpecialVacationEarningTypeEnum>;


/** account status */
export enum StaffuserAccountStatusEnum {
/** account is open */
	normal = 0,
/** account is deleted and can never be reused - data is keept for logging purposes */
	deleted = 1,
/** account is closed/paused and can be reactivated */
	paused = 2,
}

export const StaffuserAccountStatusSchema = enumSchema(StaffuserAccountStatusEnum) as unknown as z.ZodType<StaffuserAccountStatusEnum>;
export const StaffuserAccountStatusJsonSchema = enumSchema(StaffuserAccountStatusEnum).describe("account status - Schema: { { k: normal, v: 0, Description: account is open}, { k: deleted, v: 1, Description: account is deleted and can never be reused - data is keept for logging purposes}, { k: paused, v: 2, Description: account is closed/paused and can be reactivated} }") as unknown as z.ZodType<StaffuserAccountStatusEnum>;


/** user type */
export enum StaffUserTypeEnum {
/** Normal users. In systems where users are loaded from external system, they are loaded as defaultUser */
	defaultUser = 0,
/** The user is NOT administered by external system, the value is only enabled when there are no integration to external systems */
	localUser = 1,
/** this user is built in Staffplan user, which is used by supporters only */
	builtInUser = 2,
/** The user can be ONLY used to login webservices. Authentication is done via windows AD */
	serviceUser = 3,
/** Used to login to web applications that run in kiosk mode. These users will in general have access to a large set of orgunits, and cannot login to the client. */
	kioskUser = 4,
}

export const StaffUserTypeSchema = enumSchema(StaffUserTypeEnum) as unknown as z.ZodType<StaffUserTypeEnum>;
export const StaffUserTypeJsonSchema = enumSchema(StaffUserTypeEnum).describe("user type - Schema: { { k: defaultUser, v: 0, Description: Normal users. In systems where users are loaded from external system, they are loaded as defaultUser}, { k: localUser, v: 1, Description: The user is NOT administered by external system, the value is only enabled when there are no integration to external systems}, { k: builtInUser, v: 2, Description: this user is built in Staffplan user, which is used by supporters only}, { k: serviceUser, v: 3, Description: The user can be ONLY used to login webservices. Authentication is done via windows AD}, { k: kioskUser, v: 4, Description: Used to login to web applications that run in kiosk mode. These users will in general have access to a large set of orgunits, and cannot login to the client.} }") as unknown as z.ZodType<StaffUserTypeEnum>;


/** summary_statement status */
export enum StatementStatusEnum {
/** 1 : obsolete From an outdated import */
	statusObsolete = 1,
/** 2: latest Newest statement for period */
	statusNewest = 2,
}

export const StatementStatusSchema = enumSchema(StatementStatusEnum) as unknown as z.ZodType<StatementStatusEnum>;
export const StatementStatusJsonSchema = enumSchema(StatementStatusEnum).describe("summary_statement status - Schema: { { k: statusObsolete, v: 1, Description: 1 : obsolete From an outdated import}, { k: statusNewest, v: 2, Description: 2: latest Newest statement for period} }") as unknown as z.ZodType<StatementStatusEnum>;


/** Is a step percieved >= or > */
export enum StepRelationEnum {
	stepGeq = 1,
	stepGt = 2,
}

export const StepRelationSchema = enumSchema(StepRelationEnum) as unknown as z.ZodType<StepRelationEnum>;
export const StepRelationJsonSchema = enumSchema(StepRelationEnum).describe("Is a step percieved >= or > - Schema: { { k: stepGeq, v: 1, Description: <empty>}, { k: stepGt, v: 2, Description: <empty>} }") as unknown as z.ZodType<StepRelationEnum>;


/** Is the value kept, assumed, or specified. The functor Name is used/serialized directly in the substituteProperties */
export enum SubstitutionMethodEnum {
/** Keep ones own */
	keep = 0,
/** Assume the other persons */
	assume = 1,
/** Use the otherwise specified */
	specify = 2,
}

export const SubstitutionMethodSchema = enumSchema(SubstitutionMethodEnum) as unknown as z.ZodType<SubstitutionMethodEnum>;
export const SubstitutionMethodJsonSchema = enumSchema(SubstitutionMethodEnum).describe("Is the value kept, assumed, or specified. The functor Name is used/serialized directly in the substituteProperties - Schema: { { k: keep, v: 0, Description: Keep ones own}, { k: assume, v: 1, Description: Assume the other persons}, { k: specify, v: 2, Description: Use the otherwise specified} }") as unknown as z.ZodType<SubstitutionMethodEnum>;


/** Fields used to identify an employee impersonated by a supporter */
export enum SupporterLogonIdFieldEnum {
/** person1.personid */
	personId = 1,
/** person1.name */
	name = 2,
/** empuser.empusername */
	username = 3,
/** person1.validitystart/validityend */
	validAt = 4,
/** person1.salaryid */
	salaryId = 11,
/** person2.planningunitid (or ancestor) */
	institution = 12,
/** person2.planningunitid */
	department = 13,
/** person1.email */
	email = 21,
/** person1.cpr */
	cpr = 31,
/** person1.aux1 */
	aux1 = 41,
/** person1.aux2 */
	aux2 = 42,
/** person1.aux3 */
	aux3 = 43,
}

export const SupporterLogonIdFieldSchema = enumSchema(SupporterLogonIdFieldEnum) as unknown as z.ZodType<SupporterLogonIdFieldEnum>;
export const SupporterLogonIdFieldJsonSchema = enumSchema(SupporterLogonIdFieldEnum).describe("Fields used to identify an employee impersonated by a supporter - Schema: { { k: personId, v: 1, Description: person1.personid}, { k: name, v: 2, Description: person1.name}, { k: username, v: 3, Description: empuser.empusername}, { k: validAt, v: 4, Description: person1.validitystart/validityend}, { k: salaryId, v: 11, Description: person1.salaryid}, { k: institution, v: 12, Description: person2.planningunitid (or ancestor)}, { k: department, v: 13, Description: person2.planningunitid}, { k: email, v: 21, Description: person1.email}, { k: cpr, v: 31, Description: person1.cpr}, { k: aux1, v: 41, Description: person1.aux1}, { k: aux2, v: 42, Description: person1.aux2}, { k: aux3, v: 43, Description: person1.aux3} }") as unknown as z.ZodType<SupporterLogonIdFieldEnum>;


/** Whether swap and handoverrequests are used */
export enum SwapIsUsedEnum {
/** Swap and handoverrequests are not used anywhere */
	no = 0,
/** Swaps and handoverrequests can be used (and viewed in MyPlan) on persongroups with the shiftSwap property */
	onlySwapPg = 1,
/** Swaps can be used in on persongroups with the shiftSwap property. Handoverrequests can be used everywhere */
	everywhere = 2,
}

export const SwapIsUsedSchema = enumSchema(SwapIsUsedEnum) as unknown as z.ZodType<SwapIsUsedEnum>;
export const SwapIsUsedJsonSchema = enumSchema(SwapIsUsedEnum).describe("Whether swap and handoverrequests are used - Schema: { { k: no, v: 0, Description: Swap and handoverrequests are not used anywhere}, { k: onlySwapPg, v: 1, Description: Swaps and handoverrequests can be used (and viewed in MyPlan) on persongroups with the shiftSwap property}, { k: everywhere, v: 2, Description: Swaps can be used in on persongroups with the shiftSwap property. Handoverrequests can be used everywhere} }") as unknown as z.ZodType<SwapIsUsedEnum>;


/** Controls how system reacts to swap and offer requests given orgunit of ExchangeReg */
export enum SwapPolicyEnum {
	inheritFromHierarchy = 1,
	interveneNever = 2,
	interveneAlways = 3,
	interveneOnlyEmployeeRequests = 4,
}

export const SwapPolicySchema = enumSchema(SwapPolicyEnum) as unknown as z.ZodType<SwapPolicyEnum>;
export const SwapPolicyJsonSchema = enumSchema(SwapPolicyEnum).describe("Controls how system reacts to swap and offer requests given orgunit of ExchangeReg - Schema: { { k: inheritFromHierarchy, v: 1, Description: <empty>}, { k: interveneNever, v: 2, Description: <empty>}, { k: interveneAlways, v: 3, Description: <empty>}, { k: interveneOnlyEmployeeRequests, v: 4, Description: <empty>} }") as unknown as z.ZodType<SwapPolicyEnum>;


/** Only used by myPlan */
export enum SwapStartRuleEnumEnum {
/** Calculate it -> udbud morgen kan ses næste dag. Udbud aften kan ses i over morgen */
	nextDay = 1,
/** Use the value in setting SwapTimeBuffer */
	fixed = 2,
}

export const SwapStartRuleEnumSchema = enumSchema(SwapStartRuleEnumEnum) as unknown as z.ZodType<SwapStartRuleEnumEnum>;
export const SwapStartRuleEnumJsonSchema = enumSchema(SwapStartRuleEnumEnum).describe("Only used by myPlan - Schema: { { k: nextDay, v: 1, Description: Calculate it -> udbud morgen kan ses næste dag. Udbud aften kan ses i over morgen}, { k: fixed, v: 2, Description: Use the value in setting SwapTimeBuffer} }") as unknown as z.ZodType<SwapStartRuleEnumEnum>;


/** Only used by myplan.GetExchange_12 */
export enum SwapStatusEnum {
	undefined = 0,
/** the request and its offer is accepted */
	accomplished = 1,
/** awaits swappers / offers */
	awaitsAnswers = 2,
/** awaits planner approval (it might still be possible to come with more swapper offers) */
	awaitsPlanner = 3,
	awaitsYou = 4,
/** Cancelled by requester, swapper, planner, or another swapper (not the one in the offer element) */
	canceledBy = 5,
}

export const SwapStatusSchema = enumSchema(SwapStatusEnum) as unknown as z.ZodType<SwapStatusEnum>;
export const SwapStatusJsonSchema = enumSchema(SwapStatusEnum).describe("Only used by myplan.GetExchange_12 - Schema: { { k: undefined, v: 0, Description: <empty>}, { k: accomplished, v: 1, Description: the request and its offer is accepted}, { k: awaitsAnswers, v: 2, Description: awaits swappers / offers}, { k: awaitsPlanner, v: 3, Description: awaits planner approval (it might still be possible to come with more swapper offers)}, { k: awaitsYou, v: 4, Description: <empty>}, { k: canceledBy, v: 5, Description: Cancelled by requester, swapper, planner, or another swapper (not the one in the offer element)} }") as unknown as z.ZodType<SwapStatusEnum>;


/** Signals to presentation UI severness of warning/error in SynchronizationWarning field */
export enum SynchronizationWarningLevelEnum {
	noLevel = 1,
	informalLevel = 2,
	warningLevel = 3,
	errorLevel = 4,
}

export const SynchronizationWarningLevelSchema = enumSchema(SynchronizationWarningLevelEnum) as unknown as z.ZodType<SynchronizationWarningLevelEnum>;
export const SynchronizationWarningLevelJsonSchema = enumSchema(SynchronizationWarningLevelEnum).describe("Signals to presentation UI severness of warning/error in SynchronizationWarning field - Schema: { { k: noLevel, v: 1, Description: <empty>}, { k: informalLevel, v: 2, Description: <empty>}, { k: warningLevel, v: 3, Description: <empty>}, { k: errorLevel, v: 4, Description: <empty>} }") as unknown as z.ZodType<SynchronizationWarningLevelEnum>;


/** tableTypes */
export enum TableTypeEnum {
	databaseTable = 1,
/** metatable not directly from database table */
	baseTable = 2,
/** deriveTable */
	deriveTable = 3,
}

export const TableTypeSchema = enumSchema(TableTypeEnum) as unknown as z.ZodType<TableTypeEnum>;
export const TableTypeJsonSchema = enumSchema(TableTypeEnum).describe("tableTypes - Schema: { { k: databaseTable, v: 1, Description: <empty>}, { k: baseTable, v: 2, Description: metatable not directly from database table}, { k: deriveTable, v: 3, Description: deriveTable} }") as unknown as z.ZodType<TableTypeEnum>;


/** It should not be serialized into any tables or presented in any GUI, so the langauge keys do not matter. */
export enum TableWithShiftvaluesEnum {
	tShiftReg = 0,
	tAvailReg = 1,
	tPaidAllowance = 2,
}

export const TableWithShiftvaluesSchema = enumSchema(TableWithShiftvaluesEnum) as unknown as z.ZodType<TableWithShiftvaluesEnum>;
export const TableWithShiftvaluesJsonSchema = enumSchema(TableWithShiftvaluesEnum).describe("It should not be serialized into any tables or presented in any GUI, so the langauge keys do not matter. - Schema: { { k: tShiftReg, v: 0, Description: <empty>}, { k: tAvailReg, v: 1, Description: <empty>}, { k: tPaidAllowance, v: 2, Description: <empty>} }") as unknown as z.ZodType<TableWithShiftvaluesEnum>;


/** The type of alert */
export enum TaskAlertTextEnumEnum {
	unknownAlert = -1,
	illegalResourceAssignment_2 = 1,
	partiallyIllegalResourceAssignment_3 = 2,
	resourceUnavailable_2 = 3,
	resourceNotCheckedIn_2 = 4,
	resourceUsed_3 = 5,
	resourceOverloaded_5 = 6,
	resourceOutOfScope_1 = 7,
	resourceOutOfTaskScope_2 = 8,
	resourceUnavailablewForPayer_3 = 9,
	resourceReservedElseWhere_3 = 10,
	notAssigned_1 = 11,
	notFullyAssigned_1 = 12,
	underAssignedWorkload_3 = 13,
	overAssignedWorkload_3 = 14,
	equipQualConstraint_2 = 15,
	equipQualConstraint_3 = 16,
	flexDurationZero = 17,
	routeNotFound_2 = 18,
	routeDurationInsuffient_4 = 19,
	transportTime_UnknownPreviousLocation_2 = 20,
	transportTime_UnknownBaseLocation_1 = 21,
	transportTime_Insufficient_5 = 22,
	transportTime_RouteNotFound_2 = 23,
	transportTime_NoRouteMap_1 = 24,
	extOrderChangeCausedDifferentRulesToFire = 25,
	extOrderRepositionedButStatusFrozen_1 = 26,
	extResourceInvalid_2 = 27,
	extCriticalDurConstraintViolated = 28,
	extTimeConstraintViolated = 29,
	extTimeConstraintTaskMissing_1 = 30,
	extTimeRestrictedToOrderScope_1 = 31,
	resShareRule_3 = 32,
}

export const TaskAlertTextEnumSchema = enumSchema(TaskAlertTextEnumEnum) as unknown as z.ZodType<TaskAlertTextEnumEnum>;
export const TaskAlertTextEnumJsonSchema = enumSchema(TaskAlertTextEnumEnum).describe("The type of alert - Schema: { { k: unknownAlert, v: -1, Description: <empty>}, { k: illegalResourceAssignment_2, v: 1, Description: <empty>}, { k: partiallyIllegalResourceAssignment_3, v: 2, Description: <empty>}, { k: resourceUnavailable_2, v: 3, Description: <empty>}, { k: resourceNotCheckedIn_2, v: 4, Description: <empty>}, { k: resourceUsed_3, v: 5, Description: <empty>}, { k: resourceOverloaded_5, v: 6, Description: <empty>}, { k: resourceOutOfScope_1, v: 7, Description: <empty>}, { k: resourceOutOfTaskScope_2, v: 8, Description: <empty>}, { k: resourceUnavailablewForPayer_3, v: 9, Description: <empty>}, { k: resourceReservedElseWhere_3, v: 10, Description: <empty>}, { k: notAssigned_1, v: 11, Description: <empty>}, { k: notFullyAssigned_1, v: 12, Description: <empty>}, { k: underAssignedWorkload_3, v: 13, Description: <empty>}, { k: overAssignedWorkload_3, v: 14, Description: <empty>}, { k: equipQualConstraint_2, v: 15, Description: <empty>}, { k: equipQualConstraint_3, v: 16, Description: <empty>}, { k: flexDurationZero, v: 17, Description: <empty>}, { k: routeNotFound_2, v: 18, Description: <empty>}, { k: routeDurationInsuffient_4, v: 19, Description: <empty>}, { k: transportTime_UnknownPreviousLocation_2, v: 20, Description: <empty>}, { k: transportTime_UnknownBaseLocation_1, v: 21, Description: <empty>}, { k: transportTime_Insufficient_5, v: 22, Description: <empty>}, { k: transportTime_RouteNotFound_2, v: 23, Description: <empty>}, { k: transportTime_NoRouteMap_1, v: 24, Description: <empty>}, { k: extOrderChangeCausedDifferentRulesToFire, v: 25, Description: <empty>}, { k: extOrderRepositionedButStatusFrozen_1, v: 26, Description: <empty>}, { k: extResourceInvalid_2, v: 27, Description: <empty>}, { k: extCriticalDurConstraintViolated, v: 28, Description: <empty>}, { k: extTimeConstraintViolated, v: 29, Description: <empty>}, { k: extTimeConstraintTaskMissing_1, v: 30, Description: <empty>}, { k: extTimeRestrictedToOrderScope_1, v: 31, Description: <empty>}, { k: resShareRule_3, v: 32, Description: <empty>} }") as unknown as z.ZodType<TaskAlertTextEnumEnum>;


/** planned, released, acknowledged, started, cancelled, completed */
export enum TaskStatusEnum {
/** created */
	created = 0,
/** scheduled */
	scheduled = 2,
/** assigned */
	assigned = 3,
/** released */
	released = 4,
/** acknowledged */
	acknowledged = 5,
/** started */
	started = 6,
/** completed */
	completed = 7,
/** cancelled */
	cancelled = 8,
}

export const TaskStatusSchema = enumSchema(TaskStatusEnum) as unknown as z.ZodType<TaskStatusEnum>;
export const TaskStatusJsonSchema = enumSchema(TaskStatusEnum).describe("planned, released, acknowledged, started, cancelled, completed - Schema: { { k: created, v: 0, Description: created}, { k: scheduled, v: 2, Description: scheduled}, { k: assigned, v: 3, Description: assigned}, { k: released, v: 4, Description: released}, { k: acknowledged, v: 5, Description: acknowledged}, { k: started, v: 6, Description: started}, { k: completed, v: 7, Description: completed}, { k: cancelled, v: 8, Description: cancelled} }") as unknown as z.ZodType<TaskStatusEnum>;


/** Determines how Tasks are assigned to teams */
export enum TeamAssignStrategyEnum {
/** Team assignment is disallowed */
	noTeams = 1,
/** Team assignment is allowed, but only required resources from Team are booked */
	assignTeams = 2,
/** Team assignment is allowed and all members are always booked, ie members not explicitly required by Task will be booked anonymously without a RC */
	assignAlwaysFullTeams = 3,
}

export const TeamAssignStrategySchema = enumSchema(TeamAssignStrategyEnum) as unknown as z.ZodType<TeamAssignStrategyEnum>;
export const TeamAssignStrategyJsonSchema = enumSchema(TeamAssignStrategyEnum).describe("Determines how Tasks are assigned to teams - Schema: { { k: noTeams, v: 1, Description: Team assignment is disallowed}, { k: assignTeams, v: 2, Description: Team assignment is allowed, but only required resources from Team are booked}, { k: assignAlwaysFullTeams, v: 3, Description: Team assignment is allowed and all members are always booked, ie members not explicitly required by Task will be booked anonymously without a RC} }") as unknown as z.ZodType<TeamAssignStrategyEnum>;


/** Type of team position */
export enum TeamPositionTypeEnum {
/** lead */
	lead = 1,
/** 2nd in command */
	vice = 2,
/** normal */
	normal = 3,
/** consultant */
	consultant = 4,
/** trainee */
	trainee = 5,
}

export const TeamPositionTypeSchema = enumSchema(TeamPositionTypeEnum) as unknown as z.ZodType<TeamPositionTypeEnum>;
export const TeamPositionTypeJsonSchema = enumSchema(TeamPositionTypeEnum).describe("Type of team position - Schema: { { k: lead, v: 1, Description: lead}, { k: vice, v: 2, Description: 2nd in command}, { k: normal, v: 3, Description: normal}, { k: consultant, v: 4, Description: consultant}, { k: trainee, v: 5, Description: trainee} }") as unknown as z.ZodType<TeamPositionTypeEnum>;


/** synthetic status for shift reg */
export enum TeamShiftStatusEnum {
/** Arbejde med aktiviteter. original */
	planned = 1,
/** Kræver handling. absence registered, but not handled: the person is absent, has activites, and the shift has at least no corresponding copyrequest which are not cancelled */
	actionRequired = 2,
/** Fraværende. absent and no activities */
	absent = 3,
/** Udbudt. The person is absent, the shift has at least one corresponding copyrequest/swapoffer/swaprequest/handoverrequest which is not cancelled, and none of the requests are accepted or await planner approval */
	offered = 4,
/** Vikar Udbudt. The work shift has a deputy_request. Note, deputy_requests cannot be viewed or cancelled via TeamPlan at the moment (and they are always accepted automatically, even in StaffPlan) */
	deputyOffered = 10,
/** Erstattet. absent, no activities, and the shift has a corresponding copyrequest which is accepted (check excpangeRegParts) */
	replaced = 5,
/** Afløser. a substitute: the person is not absent, the shift has a corresponding copyrequest which is accepted (check the exchange_reg, not the exchangeRegParts) */
	substitute = 6,
/** Arbejde. No activities and not absent */
	noActivities = 7,
/** Vagtbytte. The shift has swapoffers or swaprequests that await planner approval */
	swapActionRequired = 8,
/** Vagtudbud. The shift has takeoffers that await planner approval */
	offerActionRequired = 9,
}

export const TeamShiftStatusSchema = enumSchema(TeamShiftStatusEnum) as unknown as z.ZodType<TeamShiftStatusEnum>;
export const TeamShiftStatusJsonSchema = enumSchema(TeamShiftStatusEnum).describe("synthetic status for shift reg - Schema: { { k: planned, v: 1, Description: Arbejde med aktiviteter. original}, { k: actionRequired, v: 2, Description: Kræver handling. absence registered, but not handled: the person is absent, has activites, and the shift has at least no corresponding copyrequest which are not cancelled}, { k: absent, v: 3, Description: Fraværende. absent and no activities}, { k: offered, v: 4, Description: Udbudt. The person is absent, the shift has at least one corresponding copyrequest/swapoffer/swaprequest/handoverrequest which is not cancelled, and none of the requests are accepted or await planner approval}, { k: deputyOffered, v: 10, Description: Vikar Udbudt. The work shift has a deputy_request. Note, deputy_requests cannot be viewed or cancelled via TeamPlan at the moment (and they are always accepted automatically, even in StaffPlan)}, { k: replaced, v: 5, Description: Erstattet. absent, no activities, and the shift has a corresponding copyrequest which is accepted (check excpangeRegParts)}, { k: substitute, v: 6, Description: Afløser. a substitute: the person is not absent, the shift has a corresponding copyrequest which is accepted (check the exchange_reg, not the exchangeRegParts)}, { k: noActivities, v: 7, Description: Arbejde. No activities and not absent}, { k: swapActionRequired, v: 8, Description: Vagtbytte. The shift has swapoffers or swaprequests that await planner approval}, { k: offerActionRequired, v: 9, Description: Vagtudbud. The shift has takeoffers that await planner approval} }") as unknown as z.ZodType<TeamShiftStatusEnum>;


/** Constrains how Teams are allowed utilized */
export enum TeamUsageConstraintEnum {
/** Team utilization is not restricted in any way. */
	noRestriction = 1,
/** If some team members are left idle while others are assigned, then this constraint is violated and Team alert issued */
	partialUsageNotAllowed = 2,
}

export const TeamUsageConstraintSchema = enumSchema(TeamUsageConstraintEnum) as unknown as z.ZodType<TeamUsageConstraintEnum>;
export const TeamUsageConstraintJsonSchema = enumSchema(TeamUsageConstraintEnum).describe("Constrains how Teams are allowed utilized - Schema: { { k: noRestriction, v: 1, Description: Team utilization is not restricted in any way.}, { k: partialUsageNotAllowed, v: 2, Description: If some team members are left idle while others are assigned, then this constraint is violated and Team alert issued} }") as unknown as z.ZodType<TeamUsageConstraintEnum>;


/** is the roster template individual or collective */
export enum TemplateTypeEnumEnum {
/** Individual/Personal roster */
	individual = 0,
/** Collective roster */
	collective = 1,
}

export const TemplateTypeEnumSchema = enumSchema(TemplateTypeEnumEnum) as unknown as z.ZodType<TemplateTypeEnumEnum>;
export const TemplateTypeEnumJsonSchema = enumSchema(TemplateTypeEnumEnum).describe("is the roster template individual or collective - Schema: { { k: individual, v: 0, Description: Individual/Personal roster}, { k: collective, v: 1, Description: Collective roster} }") as unknown as z.ZodType<TemplateTypeEnumEnum>;


/** Unsupported methods are set to `hide` */
export enum TerminalClockingTypeEnum {
/** Manual input of personId */
	personId = 1,
/** Manual input of salaryId */
	salaryId = 2,
/** Manual input of aux1 */
	aux1 = 3,
/** Manual input of aux2 */
	aux2 = 4,
/** Manual input of aux3 */
	aux3 = 5,
/** Ie. user clocks using pin 1234. */
	pinFourDigits = 104,
/** Ie. user clocks using pin 123456. */
	pinSixDigits = 106,
/** Barcode/QR code containing person id */
	qrPersonId = 201,
/** Barcode/QR code containing salary id */
	qrSalaryId = 202,
/** Barcode/QR code containing aux1 */
	qrAux1 = 203,
/** Barcode/QR code containing aux2 */
	qrAux2 = 204,
/** Barcode/QR code containing aux3 */
	qrAux3 = 205,
/** NFC containing person id */
	nfcPersonId = 301,
/** NFC containing salary id */
	nfcSalaryId = 302,
/** NFC containing aux1 */
	nfcAux1 = 303,
/** NFC containing aux2 */
	nfcAux2 = 304,
/** NFC containing aux3 */
	nfcAux3 = 305,
}

export const TerminalClockingTypeSchema = enumSchema(TerminalClockingTypeEnum) as unknown as z.ZodType<TerminalClockingTypeEnum>;
export const TerminalClockingTypeJsonSchema = enumSchema(TerminalClockingTypeEnum).describe("Unsupported methods are set to `hide` - Schema: { { k: personId, v: 1, Description: Manual input of personId}, { k: salaryId, v: 2, Description: Manual input of salaryId}, { k: aux1, v: 3, Description: Manual input of aux1}, { k: aux2, v: 4, Description: Manual input of aux2}, { k: aux3, v: 5, Description: Manual input of aux3}, { k: pinFourDigits, v: 104, Description: Ie. user clocks using pin 1234.}, { k: pinSixDigits, v: 106, Description: Ie. user clocks using pin 123456.}, { k: qrPersonId, v: 201, Description: Barcode/QR code containing person id}, { k: qrSalaryId, v: 202, Description: Barcode/QR code containing salary id}, { k: qrAux1, v: 203, Description: Barcode/QR code containing aux1}, { k: qrAux2, v: 204, Description: Barcode/QR code containing aux2}, { k: qrAux3, v: 205, Description: Barcode/QR code containing aux3}, { k: nfcPersonId, v: 301, Description: NFC containing person id}, { k: nfcSalaryId, v: 302, Description: NFC containing salary id}, { k: nfcAux1, v: 303, Description: NFC containing aux1}, { k: nfcAux2, v: 304, Description: NFC containing aux2}, { k: nfcAux3, v: 305, Description: NFC containing aux3} }") as unknown as z.ZodType<TerminalClockingTypeEnum>;


/** Parts in the tidyJob cycle */
export enum TidyJobPartsEnum {
/** start/default */
	tidyNothing = 0,
/** TransactionCommit table */
	tidyTransactionCommit = 10,
/** Timing tables */
	tidyTiming = 20,
/** ValidationResult table */
	tidyValidationResult = 30,
/** Invalidation tables in table name order */
	tidyInvalidation = 40,
/** lock_table drop expired hanging locks */
	tidyLocks = 50,
/** drop expired session_blacklist */
	tidyBlackList = 60,
/** drop old entries from table OpenIdToken */
	tidyOpenIdToken = 70,
/** Normalize logaudit.normalized=0 to the logauditdetails table */
	tidyNormalizeLogAudit = 80,
/** DatawarehouseLogFiles are stored in logMiscellaneous */
	tidyDatawarehouseLogFiles = 90,
}

export const TidyJobPartsSchema = enumSchema(TidyJobPartsEnum) as unknown as z.ZodType<TidyJobPartsEnum>;
export const TidyJobPartsJsonSchema = enumSchema(TidyJobPartsEnum).describe("Parts in the tidyJob cycle - Schema: { { k: tidyNothing, v: 0, Description: start/default}, { k: tidyTransactionCommit, v: 10, Description: TransactionCommit table}, { k: tidyTiming, v: 20, Description: Timing tables}, { k: tidyValidationResult, v: 30, Description: ValidationResult table}, { k: tidyInvalidation, v: 40, Description: Invalidation tables in table name order}, { k: tidyLocks, v: 50, Description: lock_table drop expired hanging locks}, { k: tidyBlackList, v: 60, Description: drop expired session_blacklist}, { k: tidyOpenIdToken, v: 70, Description: drop old entries from table OpenIdToken}, { k: tidyNormalizeLogAudit, v: 80, Description: Normalize logaudit.normalized=0 to the logauditdetails table}, { k: tidyDatawarehouseLogFiles, v: 90, Description: DatawarehouseLogFiles are stored in logMiscellaneous} }") as unknown as z.ZodType<TidyJobPartsEnum>;


/** union of different parts */
export enum TidyPartEnum {
	defaultPart = 1,
/** singleIndex content */
	details = 2,
}

export const TidyPartSchema = enumSchema(TidyPartEnum) as unknown as z.ZodType<TidyPartEnum>;
export const TidyPartJsonSchema = enumSchema(TidyPartEnum).describe("union of different parts - Schema: { { k: defaultPart, v: 1, Description: <empty>}, { k: details, v: 2, Description: singleIndex content} }") as unknown as z.ZodType<TidyPartEnum>;


/** Is the clocking done early or late */
export enum TimeAttendanceDeviationEnum {
/** Unplanned work */
	unplanned = 0,
/** Start before planned */
	startEarly = 1,
/** Start later than planned */
	startLate = 2,
/** End before planned */
	endEarly = 3,
/** End after planned */
	endLate = 4,
}

export const TimeAttendanceDeviationSchema = enumSchema(TimeAttendanceDeviationEnum) as unknown as z.ZodType<TimeAttendanceDeviationEnum>;
export const TimeAttendanceDeviationJsonSchema = enumSchema(TimeAttendanceDeviationEnum).describe("Is the clocking done early or late - Schema: { { k: unplanned, v: 0, Description: Unplanned work}, { k: startEarly, v: 1, Description: Start before planned}, { k: startLate, v: 2, Description: Start later than planned}, { k: endEarly, v: 3, Description: End before planned}, { k: endLate, v: 4, Description: End after planned} }") as unknown as z.ZodType<TimeAttendanceDeviationEnum>;


/** Which kind of reg. is this clocking intended to effect */
export enum TimeAttendanceRefTypeEnum {
/** It concerns a shift */
	shift = 0,
/** It concerns an absence */
	absence = 1,
/** It concerns an assignment to a task */
	empAssignment = 2,
/** It concerns an activity */
	activity = 3,
}

export const TimeAttendanceRefTypeSchema = enumSchema(TimeAttendanceRefTypeEnum) as unknown as z.ZodType<TimeAttendanceRefTypeEnum>;
export const TimeAttendanceRefTypeJsonSchema = enumSchema(TimeAttendanceRefTypeEnum).describe("Which kind of reg. is this clocking intended to effect - Schema: { { k: shift, v: 0, Description: It concerns a shift}, { k: absence, v: 1, Description: It concerns an absence}, { k: empAssignment, v: 2, Description: It concerns an assignment to a task}, { k: activity, v: 3, Description: It concerns an activity} }") as unknown as z.ZodType<TimeAttendanceRefTypeEnum>;


/** Is it a clockin or clockout */
export enum TimeAttendanceTypeEnum {
/** Clocked in */
	clockin = 0,
/** Clocked out */
	clockout = 1,
}

export const TimeAttendanceTypeSchema = enumSchema(TimeAttendanceTypeEnum) as unknown as z.ZodType<TimeAttendanceTypeEnum>;
export const TimeAttendanceTypeJsonSchema = enumSchema(TimeAttendanceTypeEnum).describe("Is it a clockin or clockout - Schema: { { k: clockin, v: 0, Description: Clocked in}, { k: clockout, v: 1, Description: Clocked out} }") as unknown as z.ZodType<TimeAttendanceTypeEnum>;


/** What kind of timing */
export enum TimingTypeEnum {
/** Timing Operation "recognized" by the end user */
	ui = 0,
/** Internal timing */
	detail = 1,
/** Timing of the entire program */
	fullProgram = 2,
/** webRequest to the appServer made by the staffweb */
	webRequest = 3,
/** Web Operation "recognized" by the end user */
	web = 4,
}

export const TimingTypeSchema = enumSchema(TimingTypeEnum) as unknown as z.ZodType<TimingTypeEnum>;
export const TimingTypeJsonSchema = enumSchema(TimingTypeEnum).describe("What kind of timing - Schema: { { k: ui, v: 0, Description: Timing Operation \"recognized\" by the end user}, { k: detail, v: 1, Description: Internal timing}, { k: fullProgram, v: 2, Description: Timing of the entire program}, { k: webRequest, v: 3, Description: webRequest to the appServer made by the staffweb}, { k: web, v: 4, Description: Web Operation \"recognized\" by the end user} }") as unknown as z.ZodType<TimingTypeEnum>;


/** Possible types of total columns */
export enum TotalColumnTypeEnum {
/** The column contains data used internally, and should not be shown */
	hiddenColumn = 0,
/** The column contains floating point number values, formatted as strings */
	numberColumn = 1,
/** The column contains string values */
	stringColumn = 2,
}

export const TotalColumnTypeSchema = enumSchema(TotalColumnTypeEnum) as unknown as z.ZodType<TotalColumnTypeEnum>;
export const TotalColumnTypeJsonSchema = enumSchema(TotalColumnTypeEnum).describe("Possible types of total columns - Schema: { { k: hiddenColumn, v: 0, Description: The column contains data used internally, and should not be shown}, { k: numberColumn, v: 1, Description: The column contains floating point number values, formatted as strings}, { k: stringColumn, v: 2, Description: The column contains string values} }") as unknown as z.ZodType<TotalColumnTypeEnum>;


/** used by myPlan */
export enum TotalSchemeEnum {
/** Old school Total tree */
	tree = 0,
/** Total trees, registrations and counters (orig. for TV2) */
	registrations = 1,
}

export const TotalSchemeSchema = enumSchema(TotalSchemeEnum) as unknown as z.ZodType<TotalSchemeEnum>;
export const TotalSchemeJsonSchema = enumSchema(TotalSchemeEnum).describe("used by myPlan - Schema: { { k: tree, v: 0, Description: Old school Total tree}, { k: registrations, v: 1, Description: Total trees, registrations and counters (orig. for TV2)} }") as unknown as z.ZodType<TotalSchemeEnum>;


/** at which */
export enum TotalScopeEnum {
	all = 1,
	iPhone = 2,
	mobile = 3,
	web = 4,
/** Check in via 3rd party tool. Terminal,... */
	checkInTerminal = 5,
/** For norm balance on request pages */
	mobileNorm = 6,
}

export const TotalScopeSchema = enumSchema(TotalScopeEnum) as unknown as z.ZodType<TotalScopeEnum>;
export const TotalScopeJsonSchema = enumSchema(TotalScopeEnum).describe("at which - Schema: { { k: all, v: 1, Description: <empty>}, { k: iPhone, v: 2, Description: <empty>}, { k: mobile, v: 3, Description: <empty>}, { k: web, v: 4, Description: <empty>}, { k: checkInTerminal, v: 5, Description: Check in via 3rd party tool. Terminal,...}, { k: mobileNorm, v: 6, Description: For norm balance on request pages} }") as unknown as z.ZodType<TotalScopeEnum>;


/** used by myPlan */
export enum TotalTreeNodeTypeEnum {
/** ? */
	undefined = -1,
/** A full treenode with type, label, date, value, precision, unit, Childrenlanel and children */
	treeNode = 0,
/** Section header with type,Label and children */
	sectionNode = 1,
/** Total header with totalid, period and children */
	totalNode = 2,
}

export const TotalTreeNodeTypeSchema = enumSchema(TotalTreeNodeTypeEnum) as unknown as z.ZodType<TotalTreeNodeTypeEnum>;
export const TotalTreeNodeTypeJsonSchema = enumSchema(TotalTreeNodeTypeEnum).describe("used by myPlan - Schema: { { k: undefined, v: -1, Description: ?}, { k: treeNode, v: 0, Description: A full treenode with type, label, date, value, precision, unit, Childrenlanel and children}, { k: sectionNode, v: 1, Description: Section header with type,Label and children}, { k: totalNode, v: 2, Description: Total header with totalid, period and children} }") as unknown as z.ZodType<TotalTreeNodeTypeEnum>;


/** how precise is the time */
export enum TransactionTimePrecisionEnum {
	minutePrecision = 60,
	dayPrecision = 1440,
	noPrecision = 9999,
}

export const TransactionTimePrecisionSchema = enumSchema(TransactionTimePrecisionEnum) as unknown as z.ZodType<TransactionTimePrecisionEnum>;
export const TransactionTimePrecisionJsonSchema = enumSchema(TransactionTimePrecisionEnum).describe("how precise is the time - Schema: { { k: minutePrecision, v: 60, Description: <empty>}, { k: dayPrecision, v: 1440, Description: <empty>}, { k: noPrecision, v: 9999, Description: <empty>} }") as unknown as z.ZodType<TransactionTimePrecisionEnum>;


/** transmit Period */
export enum TransmitPeriodEnum {
/** Transmit absence as one record per day */
	byDay = 0,
/** Transmit absence as one record per period */
	byPeriod = 1,
}

export const TransmitPeriodSchema = enumSchema(TransmitPeriodEnum) as unknown as z.ZodType<TransmitPeriodEnum>;
export const TransmitPeriodJsonSchema = enumSchema(TransmitPeriodEnum).describe("transmit Period - Schema: { { k: byDay, v: 0, Description: Transmit absence as one record per day}, { k: byPeriod, v: 1, Description: Transmit absence as one record per period} }") as unknown as z.ZodType<TransmitPeriodEnum>;


/** used to limit the user interface - when  changed $/Sprog/place.mdb must be updated */
export enum UiUserTypeEnum {
/** planner */
	planner = 0,
/** simple user */
	simple = 1,
/** advanced */
	advanced = 2,
}

export const UiUserTypeSchema = enumSchema(UiUserTypeEnum) as unknown as z.ZodType<UiUserTypeEnum>;
export const UiUserTypeJsonSchema = enumSchema(UiUserTypeEnum).describe("used to limit the user interface - when  changed $/Sprog/place.mdb must be updated - Schema: { { k: planner, v: 0, Description: planner}, { k: simple, v: 1, Description: simple user}, { k: advanced, v: 2, Description: advanced} }") as unknown as z.ZodType<UiUserTypeEnum>;


/** Fraværsgrader */
export enum UnavailabilityDegreeEnum {
	present = 0,
	callIn = 1,
	noCallIn = 2,
}

export const UnavailabilityDegreeSchema = enumSchema(UnavailabilityDegreeEnum) as unknown as z.ZodType<UnavailabilityDegreeEnum>;
export const UnavailabilityDegreeJsonSchema = enumSchema(UnavailabilityDegreeEnum).describe("Fraværsgrader - Schema: { { k: present, v: 0, Description: <empty>}, { k: callIn, v: 1, Description: <empty>}, { k: noCallIn, v: 2, Description: <empty>} }") as unknown as z.ZodType<UnavailabilityDegreeEnum>;


/** used by myPlan */
export enum UpdatePersonDataEnum {
/** person1.mobilphone */
	phone3 = 7,
/** person1.email */
	email = 8,
/** person1.relatives */
	relatives = 23,
}

export const UpdatePersonDataSchema = enumSchema(UpdatePersonDataEnum) as unknown as z.ZodType<UpdatePersonDataEnum>;
export const UpdatePersonDataJsonSchema = enumSchema(UpdatePersonDataEnum).describe("used by myPlan - Schema: { { k: phone3, v: 7, Description: person1.mobilphone}, { k: email, v: 8, Description: person1.email}, { k: relatives, v: 23, Description: person1.relatives} }") as unknown as z.ZodType<UpdatePersonDataEnum>;


/** semantics of the date time passed */
export enum UseDateTimeTypeEnum {
/** Tidspunktet skal fastholdes */
	frozenTime = 1,
/** Datoen skal fastholdes, tiden skal vedligeholdes */
	frozenDate = 2,
/** Tidspunktet skal vedligeholdes */
	unfrozen = 3,
}

export const UseDateTimeTypeSchema = enumSchema(UseDateTimeTypeEnum) as unknown as z.ZodType<UseDateTimeTypeEnum>;
export const UseDateTimeTypeJsonSchema = enumSchema(UseDateTimeTypeEnum).describe("semantics of the date time passed - Schema: { { k: frozenTime, v: 1, Description: Tidspunktet skal fastholdes}, { k: frozenDate, v: 2, Description: Datoen skal fastholdes, tiden skal vedligeholdes}, { k: unfrozen, v: 3, Description: Tidspunktet skal vedligeholdes} }") as unknown as z.ZodType<UseDateTimeTypeEnum>;


/** how is the data used in the web interface */
export enum UseInWebEnum {
/** Must not be used in web. (default) */
	notInUse = 0,
/** May be used in web. Depending on the item type, it is computed if the item has hours (valid HHmm.minuteoffset value 0-1439, or 9999 if empty) and if the user may edit them. not used by activity_period_def */
	inUseComputed = 1,
/** May be used in web. The user must not edit the hours. If there are no hours in the item definition (value 9999 in Start and End), registrations are stored with 0-24 but display as blank in the GUI. */
	inUseNoEdit = 2,
/** May be used in web. The user may edit the hours. If there are no hours in the item definition (value 9999 in Start and End), the user must supply the values. */
	inUseEdit = 3,
}

export const UseInWebSchema = enumSchema(UseInWebEnum) as unknown as z.ZodType<UseInWebEnum>;
export const UseInWebJsonSchema = enumSchema(UseInWebEnum).describe("how is the data used in the web interface - Schema: { { k: notInUse, v: 0, Description: Must not be used in web. (default)}, { k: inUseComputed, v: 1, Description: May be used in web. Depending on the item type, it is computed if the item has hours (valid HHmm.minuteoffset value 0-1439, or 9999 if empty) and if the user may edit them. not used by activity_period_def}, { k: inUseNoEdit, v: 2, Description: May be used in web. The user must not edit the hours. If there are no hours in the item definition (value 9999 in Start and End), registrations are stored with 0-24 but display as blank in the GUI.}, { k: inUseEdit, v: 3, Description: May be used in web. The user may edit the hours. If there are no hours in the item definition (value 9999 in Start and End), the user must supply the values.} }") as unknown as z.ZodType<UseInWebEnum>;


/** how is the data used in the web interface */
export enum UseInWebSelfPlanEnum {
/** Must not be used in web. (default) */
	notInUse = 0,
/** May be used in web. The user must not edit the hours. If there are no hours in the item definition (value 9999 in Start and End), registrations are stored with 0-24 but display as blank in the GUI. */
	inUseNoEdit = 1,
/** May be used in web. The user may edit the hours. If there are no hours in the item definition (value 9999 in Start and End), the user must supply the values. */
	inUseEdit = 2,
/** May be used in web, but only for persons explicitly mentioned in prd_task_def_person. The user may edit the hours. If there are no hours in the item definition (value 9999 in Start and End), the user must supply the values. */
	inUseEditOnlySelfPlan = 3,
}

export const UseInWebSelfPlanSchema = enumSchema(UseInWebSelfPlanEnum) as unknown as z.ZodType<UseInWebSelfPlanEnum>;
export const UseInWebSelfPlanJsonSchema = enumSchema(UseInWebSelfPlanEnum).describe("how is the data used in the web interface - Schema: { { k: notInUse, v: 0, Description: Must not be used in web. (default)}, { k: inUseNoEdit, v: 1, Description: May be used in web. The user must not edit the hours. If there are no hours in the item definition (value 9999 in Start and End), registrations are stored with 0-24 but display as blank in the GUI.}, { k: inUseEdit, v: 2, Description: May be used in web. The user may edit the hours. If there are no hours in the item definition (value 9999 in Start and End), the user must supply the values.}, { k: inUseEditOnlySelfPlan, v: 3, Description: May be used in web, but only for persons explicitly mentioned in prd_task_def_person. The user may edit the hours. If there are no hours in the item definition (value 9999 in Start and End), the user must supply the values.} }") as unknown as z.ZodType<UseInWebSelfPlanEnum>;


/** enum for setting setting_diff_department_all: which additional payers can you assign the person to assuming that you have write access to accountingOutside_AccessItem (or person3_AccessItem if accountingOutside_AccessItem is disabled in the installation) */
export enum UsePayersOutsideAccessEnum {
/** noOutsideAccess */
	noOutsideAccess = 0,
/** institutionAccess. Can give the person payers within the same institution (or every payer outside institutions, if the person has no institution) */
	institutionAccess = 1,
/** Can give the person any payer */
	fullAccess = 2,
}

export const UsePayersOutsideAccessSchema = enumSchema(UsePayersOutsideAccessEnum) as unknown as z.ZodType<UsePayersOutsideAccessEnum>;
export const UsePayersOutsideAccessJsonSchema = enumSchema(UsePayersOutsideAccessEnum).describe("enum for setting setting_diff_department_all: which additional payers can you assign the person to assuming that you have write access to accountingOutside_AccessItem (or person3_AccessItem if accountingOutside_AccessItem is disabled in the installation) - Schema: { { k: noOutsideAccess, v: 0, Description: noOutsideAccess}, { k: institutionAccess, v: 1, Description: institutionAccess. Can give the person payers within the same institution (or every payer outside institutions, if the person has no institution)}, { k: fullAccess, v: 2, Description: Can give the person any payer} }") as unknown as z.ZodType<UsePayersOutsideAccessEnum>;


/** userAccountStatus */
export enum UserAccountStatusEnum {
/** webuser currently not used */
	nil = 0,
/** OK */
	ok = 1,
	changePasswordOnNextLogin = 2,
	userLocked = 3,
	expired = 4,
}

export const UserAccountStatusSchema = enumSchema(UserAccountStatusEnum) as unknown as z.ZodType<UserAccountStatusEnum>;
export const UserAccountStatusJsonSchema = enumSchema(UserAccountStatusEnum).describe("userAccountStatus - Schema: { { k: nil, v: 0, Description: webuser currently not used}, { k: ok, v: 1, Description: OK}, { k: changePasswordOnNextLogin, v: 2, Description: <empty>}, { k: userLocked, v: 3, Description: <empty>}, { k: expired, v: 4, Description: <empty>} }") as unknown as z.ZodType<UserAccountStatusEnum>;


/** login kind */
export enum UserLoginTypeEnum {
/** person1 user */
	employee = 1,
/** staffuser user */
	planner = 2,
}

export const UserLoginTypeSchema = enumSchema(UserLoginTypeEnum) as unknown as z.ZodType<UserLoginTypeEnum>;
export const UserLoginTypeJsonSchema = enumSchema(UserLoginTypeEnum).describe("login kind - Schema: { { k: employee, v: 1, Description: person1 user}, { k: planner, v: 2, Description: staffuser user} }") as unknown as z.ZodType<UserLoginTypeEnum>;


/** login kind */
export enum UserLoginType_withNullEnum {
/** no user */
	nil = -1,
/** person1 user */
	employee = 1,
/** staffuser user */
	planner = 2,
}

export const UserLoginType_withNullSchema = enumSchema(UserLoginType_withNullEnum) as unknown as z.ZodType<UserLoginType_withNullEnum>;
export const UserLoginType_withNullJsonSchema = enumSchema(UserLoginType_withNullEnum).describe("login kind - Schema: { { k: nil, v: -1, Description: no user}, { k: employee, v: 1, Description: person1 user}, { k: planner, v: 2, Description: staffuser user} }") as unknown as z.ZodType<UserLoginType_withNullEnum>;


/** catalog of user types - not to be used */
export enum UserTypeCatalogEnum {
/** no user */
	nil = -1,
/** person1 user */
	employee = 1,
/** staffuser user */
	planner = 2,
/** type is planner ! builtin pdc/sd user  or supporter */
	supporter = 3,
/** auxPerson */
	auxPerson = 10,
/** External user via integration httpserver */
	external_ = 4,
/** Any staffuser user, used in msgParticipantType */
	plannerGroup = 30,
}

export const UserTypeCatalogSchema = enumSchema(UserTypeCatalogEnum) as unknown as z.ZodType<UserTypeCatalogEnum>;
export const UserTypeCatalogJsonSchema = enumSchema(UserTypeCatalogEnum).describe("catalog of user types - not to be used - Schema: { { k: nil, v: -1, Description: no user}, { k: employee, v: 1, Description: person1 user}, { k: planner, v: 2, Description: staffuser user}, { k: supporter, v: 3, Description: type is planner ! builtin pdc/sd user  or supporter}, { k: auxPerson, v: 10, Description: auxPerson}, { k: external_, v: 4, Description: External user via integration httpserver}, { k: plannerGroup, v: 30, Description: Any staffuser user, used in msgParticipantType} }") as unknown as z.ZodType<UserTypeCatalogEnum>;


/** validationFrequency */
export enum ValidationFrequencyEnum {
/** daily */
	validateDaily = 1,
/** Once */
	validateOnce = 99,
}

export const ValidationFrequencySchema = enumSchema(ValidationFrequencyEnum) as unknown as z.ZodType<ValidationFrequencyEnum>;
export const ValidationFrequencyJsonSchema = enumSchema(ValidationFrequencyEnum).describe("validationFrequency - Schema: { { k: validateDaily, v: 1, Description: daily}, { k: validateOnce, v: 99, Description: Once} }") as unknown as z.ZodType<ValidationFrequencyEnum>;


/** Validation function */
export enum ValidationFunctionEnum {
	nil = 0,
	agreement_consolidationOptions = 1,
	closedNow = 2,
	convert_preference_def = 3,
	costDetailsSetting = 4,
	costModuleConfig = 5,
	fullrelevance = 6,
	obsolete_accessitem = 7,
	orgunit_props_production = 8,
	orgunitProperty_accessitem = 9,
	orgunitProperty_notUsed = 10,
	orgunitProperty_dimensions = 11,
	pause = 12,
	personfind = 13,
	renamedFieldTableConfig = 14,
	roledefaccessitem = 15,
	salarysort_shared_fields = 16,
	salarysysValidator = 17,
	shifttypeDutyConversion = 18,
	staffinst_config = 19,
	staffinstMask = 20,
	standard_rulegroupname = 21,
	swapIsUsed = 22,
	tables_hide = 23,
	validateagreementstructure = 26,
	validateDefaultShifttypes = 27,
	validateTotalTrees = 28,
	workplanencoding = 29,
	shiftDef_duty = 30,
	oldUsageSetting = 31,
	accessItemMask = 32,
	passwordExpire = 33,
	availabilityAdjustValidator = 34,
	uniqueSalaryId = 35,
	registeredListResponder = 50,
	obsoleteShiftcounterrule = 54,
	databaseValidate = 60,
	dbsequences = 61,
	extendableFields = 62,
	sequenceLimitCheck = 63,
	listViewEntry = 80,
	settings = 81,
	ispwdcased = 82,
	orgunitProperty_dependency = 90,
	aiAgentWidgetConfig = 91,
}

export const ValidationFunctionSchema = enumSchema(ValidationFunctionEnum) as unknown as z.ZodType<ValidationFunctionEnum>;
export const ValidationFunctionJsonSchema = enumSchema(ValidationFunctionEnum).describe("Validation function - Schema: { { k: nil, v: 0, Description: <empty>}, { k: agreement_consolidationOptions, v: 1, Description: <empty>}, { k: closedNow, v: 2, Description: <empty>}, { k: convert_preference_def, v: 3, Description: <empty>}, { k: costDetailsSetting, v: 4, Description: <empty>}, { k: costModuleConfig, v: 5, Description: <empty>}, { k: fullrelevance, v: 6, Description: <empty>}, { k: obsolete_accessitem, v: 7, Description: <empty>}, { k: orgunit_props_production, v: 8, Description: <empty>}, { k: orgunitProperty_accessitem, v: 9, Description: <empty>}, { k: orgunitProperty_notUsed, v: 10, Description: <empty>}, { k: orgunitProperty_dimensions, v: 11, Description: <empty>}, { k: pause, v: 12, Description: <empty>}, { k: personfind, v: 13, Description: <empty>}, { k: renamedFieldTableConfig, v: 14, Description: <empty>}, { k: roledefaccessitem, v: 15, Description: <empty>}, { k: salarysort_shared_fields, v: 16, Description: <empty>}, { k: salarysysValidator, v: 17, Description: <empty>}, { k: shifttypeDutyConversion, v: 18, Description: <empty>}, { k: staffinst_config, v: 19, Description: <empty>}, { k: staffinstMask, v: 20, Description: <empty>}, { k: standard_rulegroupname, v: 21, Description: <empty>}, { k: swapIsUsed, v: 22, Description: <empty>}, { k: tables_hide, v: 23, Description: <empty>}, { k: validateagreementstructure, v: 26, Description: <empty>}, { k: validateDefaultShifttypes, v: 27, Description: <empty>}, { k: validateTotalTrees, v: 28, Description: <empty>}, { k: workplanencoding, v: 29, Description: <empty>}, { k: shiftDef_duty, v: 30, Description: <empty>}, { k: oldUsageSetting, v: 31, Description: <empty>}, { k: accessItemMask, v: 32, Description: <empty>}, { k: passwordExpire, v: 33, Description: <empty>}, { k: availabilityAdjustValidator, v: 34, Description: <empty>}, { k: uniqueSalaryId, v: 35, Description: <empty>}, { k: registeredListResponder, v: 50, Description: <empty>}, { k: obsoleteShiftcounterrule, v: 54, Description: <empty>}, { k: databaseValidate, v: 60, Description: <empty>}, { k: dbsequences, v: 61, Description: <empty>}, { k: extendableFields, v: 62, Description: <empty>}, { k: sequenceLimitCheck, v: 63, Description: <empty>}, { k: listViewEntry, v: 80, Description: <empty>}, { k: settings, v: 81, Description: <empty>}, { k: ispwdcased, v: 82, Description: <empty>}, { k: orgunitProperty_dependency, v: 90, Description: <empty>}, { k: aiAgentWidgetConfig, v: 91, Description: <empty>} }") as unknown as z.ZodType<ValidationFunctionEnum>;


/** database validation error types */
export enum ValidationResultEnum {
/** General installation info, nothing happens at login, but shown in reports */
	generalInfo = 10,
/** Supplemental info about the validation, nothing happens at login, but shown in reports */
	minorInfo = 20,
/** Everything is ok */
	validationOK = 0,
/** Validating is disabled - nothing happens at login */
	validationDisabled = 5,
/** Recommendations, nothing happens at login, but shown in reports */
	recommendation = 40,
/** Warnings, nothing happens at login, but shown in reports */
	validationWarning = 60,
/** Minor Error, program can run. The program gives administrators a warning at startup, and a report is shown */
	minorError = 100,
/** Severe error, the program stops, but administrators sees a report and may continue to fix the problems */
	severeModuleValidationError = 200,
/** Severe error in datamodel, the program stops, but administrators sees a report. Only pdc predefined administrators may continue */
	severeDataModelError = 300,
}

export const ValidationResultSchema = enumSchema(ValidationResultEnum) as unknown as z.ZodType<ValidationResultEnum>;
export const ValidationResultJsonSchema = enumSchema(ValidationResultEnum).describe("database validation error types - Schema: { { k: generalInfo, v: 10, Description: General installation info, nothing happens at login, but shown in reports}, { k: minorInfo, v: 20, Description: Supplemental info about the validation, nothing happens at login, but shown in reports}, { k: validationOK, v: 0, Description: Everything is ok}, { k: validationDisabled, v: 5, Description: Validating is disabled - nothing happens at login}, { k: recommendation, v: 40, Description: Recommendations, nothing happens at login, but shown in reports}, { k: validationWarning, v: 60, Description: Warnings, nothing happens at login, but shown in reports}, { k: minorError, v: 100, Description: Minor Error, program can run. The program gives administrators a warning at startup, and a report is shown}, { k: severeModuleValidationError, v: 200, Description: Severe error, the program stops, but administrators sees a report and may continue to fix the problems}, { k: severeDataModelError, v: 300, Description: Severe error in datamodel, the program stops, but administrators sees a report. Only pdc predefined administrators may continue} }") as unknown as z.ZodType<ValidationResultEnum>;


/** used metavaluetype */
export enum WebMetaTypeEnum {
	web_sortkey = 1,
	web_color = 2,
/** fraction size is parameter1 */
	web_float = 3,
	web_duration = 4,
/** enum name is parameter1 */
	web_enum = 5,
	web_boolean = 6,
/** length is parameter1 */
	web_text = 7,
/** start/end is parameter1, precision is parameter2: date/minut/second/msecond */
	web_date = 8,
/** just an integer */
	web_number = 9,
/** table is parameter1 */
	web_objectList = 20,
/** table is parameter1 */
	web_fieldReference = 30,
/** parameter1 is valuetype, parameter2 is metatype */
	web_unknown = 99,
}

export const WebMetaTypeSchema = enumSchema(WebMetaTypeEnum) as unknown as z.ZodType<WebMetaTypeEnum>;
export const WebMetaTypeJsonSchema = enumSchema(WebMetaTypeEnum).describe("used metavaluetype - Schema: { { k: web_sortkey, v: 1, Description: <empty>}, { k: web_color, v: 2, Description: <empty>}, { k: web_float, v: 3, Description: fraction size is parameter1}, { k: web_duration, v: 4, Description: <empty>}, { k: web_enum, v: 5, Description: enum name is parameter1}, { k: web_boolean, v: 6, Description: <empty>}, { k: web_text, v: 7, Description: length is parameter1}, { k: web_date, v: 8, Description: start/end is parameter1, precision is parameter2: date/minut/second/msecond}, { k: web_number, v: 9, Description: just an integer}, { k: web_objectList, v: 20, Description: table is parameter1}, { k: web_fieldReference, v: 30, Description: table is parameter1}, { k: web_unknown, v: 99, Description: parameter1 is valuetype, parameter2 is metatype} }") as unknown as z.ZodType<WebMetaTypeEnum>;


/** a dummy, introduced to comply with the datamodel webmethod API. */
export enum WebmethodVoidPlaceholderEnum {
/** When the datamodel requires something as return, but the business logic does not return anything (void), pass along this dummy value. It does not mean anything, it just "fills the void" {^_^} */
	voidDummy = 1,
/** Yes this is confusing. Sorry [-_-] */
	aDummy_IntroducedBecauseEpDefCannotHandleSingleElementDomains = 0,
}

export const WebmethodVoidPlaceholderSchema = enumSchema(WebmethodVoidPlaceholderEnum) as unknown as z.ZodType<WebmethodVoidPlaceholderEnum>;
export const WebmethodVoidPlaceholderJsonSchema = enumSchema(WebmethodVoidPlaceholderEnum).describe("a dummy, introduced to comply with the datamodel webmethod API. - Schema: { { k: voidDummy, v: 1, Description: When the datamodel requires something as return, but the business logic does not return anything (void), pass along this dummy value. It does not mean anything, it just \"fills the void\" {^_^}}, { k: aDummy_IntroducedBecauseEpDefCannotHandleSingleElementDomains, v: 0, Description: Yes this is confusing. Sorry [-_-]} }") as unknown as z.ZodType<WebmethodVoidPlaceholderEnum>;


/** used valuetype - enum is send as integer in this interface */
export enum WebSimpleTypeEnum {
	web_integer = 1,
	web_string = 2,
	web_real = 3,
	web_date = 4,
/** we send boolean as boolean - not integer */
	web_boolean = 5,
/** we objectlist as list of JSON objects */
	web_objectList = 20,
/** we send boolean as boolean - not integer */
	web_unknown = 99,
}

export const WebSimpleTypeSchema = enumSchema(WebSimpleTypeEnum) as unknown as z.ZodType<WebSimpleTypeEnum>;
export const WebSimpleTypeJsonSchema = enumSchema(WebSimpleTypeEnum).describe("used valuetype - enum is send as integer in this interface - Schema: { { k: web_integer, v: 1, Description: <empty>}, { k: web_string, v: 2, Description: <empty>}, { k: web_real, v: 3, Description: <empty>}, { k: web_date, v: 4, Description: <empty>}, { k: web_boolean, v: 5, Description: we send boolean as boolean - not integer}, { k: web_objectList, v: 20, Description: we objectlist as list of JSON objects}, { k: web_unknown, v: 99, Description: we send boolean as boolean - not integer} }") as unknown as z.ZodType<WebSimpleTypeEnum>;


/** Timing elements - what to time */
export enum WebTimingEntityEnum {
	timingWebservice = 1,
	timingWebMethod = 2,
}

export const WebTimingEntitySchema = enumSchema(WebTimingEntityEnum) as unknown as z.ZodType<WebTimingEntityEnum>;
export const WebTimingEntityJsonSchema = enumSchema(WebTimingEntityEnum).describe("Timing elements - what to time - Schema: { { k: timingWebservice, v: 1, Description: <empty>}, { k: timingWebMethod, v: 2, Description: <empty>} }") as unknown as z.ZodType<WebTimingEntityEnum>;


/** Which types of totals can be requested by a web application */
export enum WebTotalTypeEnum {
/** Only retrieve norms */
	norms = 1,
/** Retrieve norms, misc. days off */
	totals = 2,
/** Retrieve norms for roster templates */
	rosterTemplateNorms = 3,
}

export const WebTotalTypeSchema = enumSchema(WebTotalTypeEnum) as unknown as z.ZodType<WebTotalTypeEnum>;
export const WebTotalTypeJsonSchema = enumSchema(WebTotalTypeEnum).describe("Which types of totals can be requested by a web application - Schema: { { k: norms, v: 1, Description: Only retrieve norms}, { k: totals, v: 2, Description: Retrieve norms, misc. days off}, { k: rosterTemplateNorms, v: 3, Description: Retrieve norms for roster templates} }") as unknown as z.ZodType<WebTotalTypeEnum>;


/** Status of workdays - must be a proper subset of itemWorkdayStatus */
export enum WorkdayStatusEnum {
/** No emp-workday, and no workdaystatus. Means emp has never registered here. */
	noRegistrations = -1,
/** Registrations not processed (there is undeleted invalidation) (in db with no invalidation means unmergeable) */
	unprocessed = 0,
/** Registrations approved by planner */
	approved = 1,
/** Registrations approved by auto-consolidation (appserver) */
	preapproved = 2,
/** Registrations rejected by planner */
	rejected = 3,
/** Processing of workday failed. Cause of problem stated in remark field of workdayStatus_reg */
	error = 4,
/** Planner has finally approved availability request. Not applicable to Checkin regs */
	vacationApproved = 5,
/** Planner has previously approved availability request, but has now compromised day-off with planned work. Not applicable to Checkin regs */
	vacationConflict = 6,
/** Planner has revoked a previously approved availability request, because work is required after all. Not applicable to Checkin regs */
	vacationRevoked = 7,
}

export const WorkdayStatusSchema = enumSchema(WorkdayStatusEnum) as unknown as z.ZodType<WorkdayStatusEnum>;
export const WorkdayStatusJsonSchema = enumSchema(WorkdayStatusEnum).describe("Status of workdays - must be a proper subset of itemWorkdayStatus - Schema: { { k: noRegistrations, v: -1, Description: No emp-workday, and no workdaystatus. Means emp has never registered here.}, { k: unprocessed, v: 0, Description: Registrations not processed (there is undeleted invalidation) (in db with no invalidation means unmergeable)}, { k: approved, v: 1, Description: Registrations approved by planner}, { k: preapproved, v: 2, Description: Registrations approved by auto-consolidation (appserver)}, { k: rejected, v: 3, Description: Registrations rejected by planner}, { k: error, v: 4, Description: Processing of workday failed. Cause of problem stated in remark field of workdayStatus_reg}, { k: vacationApproved, v: 5, Description: Planner has finally approved availability request. Not applicable to Checkin regs}, { k: vacationConflict, v: 6, Description: Planner has previously approved availability request, but has now compromised day-off with planned work. Not applicable to Checkin regs}, { k: vacationRevoked, v: 7, Description: Planner has revoked a previously approved availability request, because work is required after all. Not applicable to Checkin regs} }") as unknown as z.ZodType<WorkdayStatusEnum>;


/** Kind of requested/check-in emp regs */
export enum WorkdayStatusRegKindEnum {
	nothing = 0,
	timeOff = 1,
	work = 2,
	both = 3,
}

export const WorkdayStatusRegKindSchema = enumSchema(WorkdayStatusRegKindEnum) as unknown as z.ZodType<WorkdayStatusRegKindEnum>;
export const WorkdayStatusRegKindJsonSchema = enumSchema(WorkdayStatusRegKindEnum).describe("Kind of requested/check-in emp regs - Schema: { { k: nothing, v: 0, Description: <empty>}, { k: timeOff, v: 1, Description: <empty>}, { k: work, v: 2, Description: <empty>}, { k: both, v: 3, Description: <empty>} }") as unknown as z.ZodType<WorkdayStatusRegKindEnum>;


/** add types for each implemenration */
export enum WorkplanQualityMeasureEnum {
/** workrule */
	workrules = 0,
/** keyfigure */
	keyfigure = 1,
}

export const WorkplanQualityMeasureSchema = enumSchema(WorkplanQualityMeasureEnum) as unknown as z.ZodType<WorkplanQualityMeasureEnum>;
export const WorkplanQualityMeasureJsonSchema = enumSchema(WorkplanQualityMeasureEnum).describe("add types for each implemenration - Schema: { { k: workrules, v: 0, Description: workrule}, { k: keyfigure, v: 1, Description: keyfigure} }") as unknown as z.ZodType<WorkplanQualityMeasureEnum>;


/** Workplan or template plantype */
export enum WorkplanShortTypeEnum {
/** Workplan */
	workplan = 0,
/** Roster template */
	template = 1,
}

export const WorkplanShortTypeSchema = enumSchema(WorkplanShortTypeEnum) as unknown as z.ZodType<WorkplanShortTypeEnum>;
export const WorkplanShortTypeJsonSchema = enumSchema(WorkplanShortTypeEnum).describe("Workplan or template plantype - Schema: { { k: workplan, v: 0, Description: Workplan}, { k: template, v: 1, Description: Roster template} }") as unknown as z.ZodType<WorkplanShortTypeEnum>;


/** Priority for max_workdays_per_week is a variable, It increases by the number of violating weeks */
export enum WorkruleEnumEnum {
	error = 0,
/** Priority for hour11_break1we is a variable, It increases by the count of violations */
	hour11_break1we = 1,
	hour11_break2day = 2,
/** Priority for hour11_break4we is a variable, It increases by the count of violations */
	hour11_break4we = 3,
	hour11_night_rule = 4,
	hour8_rule = 5,
	activity_max_length = 6,
	activity_min_length = 7,
/** Adjacent shifts are merged into one work period before the maximum length is checked, hence the rule needs all of the shifts */
	duty_length_rule = 8,
	free_weekend = 9,
	freeweekend_run_3week = 10,
/** Priority for too_many_hours is actually variable, it increases by 1 for every 10 hours over the norm */
	too_many_hours = 11,
	max_workdays_per_week = 12,
	overlappingPresenceShifts = 14,
	protected_freedays = 15,
	reg_freeperiod = 16,
	sameday_sameshift = 17,
	vacation_freeweekend = 18,
	workdays_freedays = 19,
/** Priority for calendarweek_freedays is a variable, It increases by the count of violations */
	calendarweek_freedays = 20,
	not_qualified_for_activity = 21,
	x_FreeDays_After_N_LongShifts = 22,
	x_FreeDays_After_N_DoubleShifts = 23,
	protected_From_To_DoubleShifts = 24,
	long_shift_def = 25,
	double_shift_def = 26,
	seafarer_dailyRest = 27,
	seafarer_weeklyRest = 28,
	rest_freedays = 29,
	hour11_break2day_excludingDoubleShifts = 30,
/** Priority for eu48_maxhours is actually variable, it increases by 1 for each hour over the limit */
	eu48_maxhours = 31,
	weeklyRestWithBiweeklyMinimum = 32,
	hour11_max_length = 33,
/** WI 165104 kompenserende hvileperiode - reduced daily rest compensated 1:1 on the next rest period */
	hour11_compensating_rest = 34,
}

export const WorkruleEnumSchema = enumSchema(WorkruleEnumEnum) as unknown as z.ZodType<WorkruleEnumEnum>;
export const WorkruleEnumJsonSchema = enumSchema(WorkruleEnumEnum).describe("Priority for max_workdays_per_week is a variable, It increases by the number of violating weeks - Schema: { { k: error, v: 0, Description: <empty>}, { k: hour11_break1we, v: 1, Description: Priority for hour11_break1we is a variable, It increases by the count of violations}, { k: hour11_break2day, v: 2, Description: <empty>}, { k: hour11_break4we, v: 3, Description: Priority for hour11_break4we is a variable, It increases by the count of violations}, { k: hour11_night_rule, v: 4, Description: <empty>}, { k: hour8_rule, v: 5, Description: <empty>}, { k: activity_max_length, v: 6, Description: <empty>}, { k: activity_min_length, v: 7, Description: <empty>}, { k: duty_length_rule, v: 8, Description: Adjacent shifts are merged into one work period before the maximum length is checked, hence the rule needs all of the shifts}, { k: free_weekend, v: 9, Description: <empty>}, { k: freeweekend_run_3week, v: 10, Description: <empty>}, { k: too_many_hours, v: 11, Description: Priority for too_many_hours is actually variable, it increases by 1 for every 10 hours over the norm}, { k: max_workdays_per_week, v: 12, Description: <empty>}, { k: overlappingPresenceShifts, v: 14, Description: <empty>}, { k: protected_freedays, v: 15, Description: <empty>}, { k: reg_freeperiod, v: 16, Description: <empty>}, { k: sameday_sameshift, v: 17, Description: <empty>}, { k: vacation_freeweekend, v: 18, Description: <empty>}, { k: workdays_freedays, v: 19, Description: <empty>}, { k: calendarweek_freedays, v: 20, Description: Priority for calendarweek_freedays is a variable, It increases by the count of violations}, { k: not_qualified_for_activity, v: 21, Description: <empty>}, { k: x_FreeDays_After_N_LongShifts, v: 22, Description: <empty>}, { k: x_FreeDays_After_N_DoubleShifts, v: 23, Description: <empty>}, { k: protected_From_To_DoubleShifts, v: 24, Description: <empty>}, { k: long_shift_def, v: 25, Description: <empty>}, { k: double_shift_def, v: 26, Description: <empty>}, { k: seafarer_dailyRest, v: 27, Description: <empty>}, { k: seafarer_weeklyRest, v: 28, Description: <empty>}, { k: rest_freedays, v: 29, Description: <empty>}, { k: hour11_break2day_excludingDoubleShifts, v: 30, Description: <empty>}, { k: eu48_maxhours, v: 31, Description: Priority for eu48_maxhours is actually variable, it increases by 1 for each hour over the limit}, { k: weeklyRestWithBiweeklyMinimum, v: 32, Description: <empty>}, { k: hour11_max_length, v: 33, Description: <empty>}, { k: hour11_compensating_rest, v: 34, Description: WI 165104 kompenserende hvileperiode - reduced daily rest compensated 1:1 on the next rest period} }") as unknown as z.ZodType<WorkruleEnumEnum>;


/** Within which period does the resting time need to be */
export enum Wr11hrRestOrigoEnum {
/** Need to be x straight hours of rest within the previous 24 hours */
	withinLast24Hours = 1,
/** Need to be x straight hours of rest before start of any shift */
	beforeShiftStart = 2,
}

export const Wr11hrRestOrigoSchema = enumSchema(Wr11hrRestOrigoEnum) as unknown as z.ZodType<Wr11hrRestOrigoEnum>;
export const Wr11hrRestOrigoJsonSchema = enumSchema(Wr11hrRestOrigoEnum).describe("Within which period does the resting time need to be - Schema: { { k: withinLast24Hours, v: 1, Description: Need to be x straight hours of rest within the previous 24 hours}, { k: beforeShiftStart, v: 2, Description: Need to be x straight hours of rest before start of any shift} }") as unknown as z.ZodType<Wr11hrRestOrigoEnum>;


/** wrCalculatedBy */
export enum WrCalculatedByEnum {
	shiftStartEndTime = 1,
	shiftStartEndDay = 2,
}

export const WrCalculatedBySchema = enumSchema(WrCalculatedByEnum) as unknown as z.ZodType<WrCalculatedByEnum>;
export const WrCalculatedByJsonSchema = enumSchema(WrCalculatedByEnum).describe("wrCalculatedBy - Schema: { { k: shiftStartEndTime, v: 1, Description: <empty>}, { k: shiftStartEndDay, v: 2, Description: <empty>} }") as unknown as z.ZodType<WrCalculatedByEnum>;


/** How to detect sufficient rest time */
export enum WrDayOffTypeEnum {
/** There just need to be sufficient rest. */
	anyRestTime = 1,
/** There need to be a dayOff-registration (BF) and sufficient rest. */
	dayOffRegistration = 2,
}

export const WrDayOffTypeSchema = enumSchema(WrDayOffTypeEnum) as unknown as z.ZodType<WrDayOffTypeEnum>;
export const WrDayOffTypeJsonSchema = enumSchema(WrDayOffTypeEnum).describe("How to detect sufficient rest time - Schema: { { k: anyRestTime, v: 1, Description: There just need to be sufficient rest.}, { k: dayOffRegistration, v: 2, Description: There need to be a dayOff-registration (BF) and sufficient rest.} }") as unknown as z.ZodType<WrDayOffTypeEnum>;


/** Query attendance by work or absence */
export enum WsAttendanceQueryTypeEnum {
/** only work */
	queryOnlyWork = 0,
/** work and absence */
	queryBothWorkAndAbsence = 1,
}

export const WsAttendanceQueryTypeSchema = enumSchema(WsAttendanceQueryTypeEnum) as unknown as z.ZodType<WsAttendanceQueryTypeEnum>;
export const WsAttendanceQueryTypeJsonSchema = enumSchema(WsAttendanceQueryTypeEnum).describe("Query attendance by work or absence - Schema: { { k: queryOnlyWork, v: 0, Description: only work}, { k: queryBothWorkAndAbsence, v: 1, Description: work and absence} }") as unknown as z.ZodType<WsAttendanceQueryTypeEnum>;


/** What type of operation to perform in time registration event */
export enum WsTimeRegEventTypeEnum {
/** Import clock-in and clock-out event in one transaction */
	create = 0,
/** Update clock-in and clock-out event in one transaction */
	update = 1,
/** Remove time registration and associated registrations (e.g. shift, availability). */
	delete = 2,
}

export const WsTimeRegEventTypeSchema = enumSchema(WsTimeRegEventTypeEnum) as unknown as z.ZodType<WsTimeRegEventTypeEnum>;
export const WsTimeRegEventTypeJsonSchema = enumSchema(WsTimeRegEventTypeEnum).describe("What type of operation to perform in time registration event - Schema: { { k: create, v: 0, Description: Import clock-in and clock-out event in one transaction}, { k: update, v: 1, Description: Update clock-in and clock-out event in one transaction}, { k: delete, v: 2, Description: Remove time registration and associated registrations (e.g. shift, availability).} }") as unknown as z.ZodType<WsTimeRegEventTypeEnum>;


/** Quarters of the year */
export enum YearQuarterEnum {
	quarter1 = 1,
	quarter2 = 2,
	quarter3 = 3,
	quarter4 = 4,
}

export const YearQuarterSchema = enumSchema(YearQuarterEnum) as unknown as z.ZodType<YearQuarterEnum>;
export const YearQuarterJsonSchema = enumSchema(YearQuarterEnum).describe("Quarters of the year - Schema: { { k: quarter1, v: 1, Description: <empty>}, { k: quarter2, v: 2, Description: <empty>}, { k: quarter3, v: 3, Description: <empty>}, { k: quarter4, v: 4, Description: <empty>} }") as unknown as z.ZodType<YearQuarterEnum>;


